import arTranslations from "./assets/ar-2fe82e24.json";
import csTranslations from "./assets/cs-1b35c92d.json";
import daTranslations from "./assets/da-79c05cb7.json";
import deTranslations from "./assets/de-e0912968.json";
import enTranslations from "./assets/en-030d8074.json";
import esTranslations from "./assets/es-989602a9.json";
import filTranslations from "./assets/fil-084c692b.json";
import frTranslations from "./assets/fr-1ec55cb9.json";
import hiTranslations from "./assets/hi-cfe097be.json";
import idTranslations from "./assets/id-8f0d3cf0.json";
import itTranslations from "./assets/it-023649d5.json";
import koTranslations from "./assets/ko-a9cfb781.json";
import msTranslations from "./assets/ms-7d616f81.json";
import nlTranslations from "./assets/nl-05b63125.json";
import noTranslations from "./assets/no-f4e194e6.json";
import plTranslations from "./assets/pl-2957f5d1.json";
import ptTranslations from "./assets/pt-26c760b8.json";
import roTranslations from "./assets/ro-9a5cfe12.json";
import ruTranslations from "./assets/ru-6fab73e5.json";
import svTranslations from "./assets/sv-1b2dd200.json";
import thTranslations from "./assets/th-a98e5f7f.json";
import trTranslations from "./assets/tr-5596c4ca.json";
import viTranslations from "./assets/vi-2a4c78b1.json";
import zhTranslations from "./assets/zh-9f5f0109.json";

const keyWith = (keyField) => (o) => {
    return Object.freeze(Object.entries(o).reduce((acc, [key, value]) => ({
        ...acc,
        [key]: {
            ...value,
            [keyField]: key,
        },
    }), {}));
};

const ar = arTranslations;
const cs = csTranslations;
const da = daTranslations;
const de = deTranslations;
const en = enTranslations;
const es = esTranslations;
const ph = filTranslations;
const fr = frTranslations;
const hi = hiTranslations;
const id = idTranslations;
const it = itTranslations;
const ko = koTranslations;
const ms = msTranslations;
const nl = nlTranslations;
const no = noTranslations;
const pl = plTranslations;
const pt = ptTranslations;
const ro = roTranslations;
const ru = ruTranslations;
const sv = svTranslations;
const th = thTranslations;
const tr = trTranslations;
const vi = viTranslations;
const zh = zhTranslations;

var translations = /*#__PURE__*/Object.freeze({
  __proto__: null,
  ar: ar,
  cs: cs,
  da: da,
  de: de,
  en: en,
  es: es,
  ph: ph,
  fr: fr,
  hi: hi,
  id: id,
  it: it,
  ko: ko,
  ms: ms,
  nl: nl,
  no: no,
  pl: pl,
  pt: pt,
  ro: ro,
  ru: ru,
  sv: sv,
  th: th,
  tr: tr,
  vi: vi,
  zh: zh
});

function getTranslation(locale, id, defaultMessage, variables) {
    const translation = locale in translations && id in translations[locale] ? translations[locale][id] : defaultMessage;
    return Object.entries(variables ?? {}).reduce((message, [variable, value]) => message.replace(`{{${variable}}}`, value), translation);
}

const asEnum = (o) => keyWith('key')(o);
function asLocalizedEnum(name, o) {
    return Object.freeze(Object.entries(o).reduce((acc, [key, value]) => {
        const id = `enum.${name}.${key}`;
        const defaultMessage = value.label;
        const localization = Object.freeze({
            id,
            defaultMessage,
            t: (locale, variables) => getTranslation(locale, id, defaultMessage, variables),
        });
        return {
            ...acc,
            [key]: {
                ...value,
                key: key,
                localization,
            },
        };
    }, {}));
}

var LabelIndicator;
(function (LabelIndicator) {
    LabelIndicator["DEFAULT"] = "default";
    LabelIndicator["WARNING"] = "warning";
    LabelIndicator["SUCCESS"] = "success";
    LabelIndicator["ERROR"] = "error";
    LabelIndicator["INFO"] = "info";
})(LabelIndicator || (LabelIndicator = {}));
const viewerTypes = asEnum({
    user: {
        value: 'user',
        hasNumericId: true,
    },
    client: {
        value: 'client',
        hasNumericId: true,
    },
    apiUser: {
        value: 'apiUser',
        hasNumericId: false,
    },
    service: {
        value: 'service',
        hasNumericId: false,
    },
});
const yesNo = asEnum({
    yes: {
        value: 'yes',
        label: 'Yes',
        boolValue: true,
    },
    no: {
        value: 'no',
        label: 'No',
        boolValue: false,
    },
});
const genders = asEnum({
    male: {
        value: 'male',
        label: 'Male (m)',
    },
    female: {
        value: 'female',
        label: 'Female (f)',
    },
    other: {
        value: 'other',
        label: 'Other (o)',
    },
    preferNotToSay: {
        value: 'prefer_not_to_say',
        label: 'Prefer not to say (na)',
    },
});
const orderDirections = asEnum({
    ascending: {
        value: 'asc',
        label: 'Ascending',
    },
    descending: {
        value: 'desc',
        label: 'Descending',
    },
});
var OrderDirections;
(function (OrderDirections) {
    OrderDirections["asc"] = "ASC";
    OrderDirections["desc"] = "DESC";
})(OrderDirections || (OrderDirections = {}));
const unset = asEnum({
    unset: {
        value: 'unset',
    },
});
const checkTypes = asEnum({
    manual: {
        value: 'manual',
        label: 'Manual',
    },
    manualThirdParty: {
        value: 'manual_third_party',
        label: 'Manual (Third Party)',
    },
    automated: {
        value: 'automated',
        label: 'Automated',
    },
    automatedThirdParty: {
        value: 'automated_third_party',
        label: 'Automated (Third Party)',
    },
});
const checkResultStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.INFO,
    },
    awaitingResponse: {
        value: 'awaiting_response',
        label: 'Awaiting Response',
        labelIndicator: LabelIndicator.WARNING,
    },
    failed: {
        value: 'failed',
        label: 'Failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    completed: {
        value: 'completed',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const individualVerificationMedium = asEnum({
    inPerson: {
        value: 'in_person',
        label: 'In-Person',
        labelIndicator: LabelIndicator.INFO,
    },
    correspondence: {
        value: 'correspondence',
        label: 'Correspondence',
        labelIndicator: LabelIndicator.INFO,
    },
    videoLink: {
        value: 'video_link',
        label: 'Video-Link',
        labelIndicator: LabelIndicator.INFO,
    },
});
const internationalCurrencies = asEnum({
    AUD: {
        value: 'AUD',
        label: 'AUD',
    },
    CAD: {
        value: 'CAD',
        label: 'CAD',
    },
    CHF: {
        value: 'CHF',
        label: 'CHF',
    },
    EUR: {
        value: 'EUR',
        label: 'EUR',
    },
    GBP: {
        value: 'GBP',
        label: 'GBP',
    },
    JPY: {
        value: 'JPY',
        label: 'JPY',
    },
    NOK: {
        value: 'NOK',
        label: 'NOK',
    },
    NZD: {
        value: 'NZD',
        label: 'NZD',
    },
    SEK: {
        value: 'SEK',
        label: 'SEK',
    },
    USD: {
        value: 'USD',
        label: 'USD',
    },
});
const securityTokenTypes = asEnum({
    passwordReset: {
        value: 'password_reset',
    },
    emailConfirmation: {
        value: 'email_confirmation',
    },
    trustDevice: {
        value: 'trust_device',
    },
});
const whitelabels = asEnum({
    cxpay: {
        value: 'cxpay',
        label: 'Cellxpay',
        brandLabel: 'Cellxpay',
        domain: 'cellxpay.com',
        tradingName: 'Cellxpay',
        trademark: 'Cellxpay',
        emailDomain: 'cellxpay.com',
        portalDomain: 'cellxpay.com',
    },
});
const cardProductTypes = asEnum({
    standard: {
        label: 'VISA Business Standard Debit',
        value: 'standard',
        currencies: ['EUR'],
    },
    platinum: {
        label: 'VISA Business Platinum',
        value: 'platinum',
        currencies: ['USD'],
    },
});
const UBOStakeTypes = asEnum({
    percent25OrMore: {
        value: 'percent_25_or_more',
        label: 'Controlling 25% or more',
    },
    percent25OrMoreViaPoA: {
        value: 'percent_25_or_more_via_poa',
        label: 'Controlling 25% or more via Trust',
    },
    managingDirector: {
        value: 'managing_director',
        label: 'Controlling as Managing Director',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
});
const fileBasedPainStatuses = asEnum({
    active: {
        value: 'active',
        label: 'Active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    inactive: {
        value: 'inactive',
        label: 'In-Active',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const fileBasedPainChannels = asEnum({
    swift: {
        value: 'swift',
        label: 'Swift',
    },
    sftp: {
        value: 'sftp',
        label: 'SFTP',
    },
});
const flowDirection = asEnum({
    outbound: {
        value: 'outbound',
        label: 'Outbound',
    },
    inbound: {
        value: 'inbound',
        label: 'Inbound',
    },
});

const accountTypes = asLocalizedEnum('accountTypes', {
    standardCurrent: {
        label: 'Standard Current',
        value: 'standard_current',
        labelIndicator: LabelIndicator.INFO,
    },
    introducerReference: {
        label: 'Introducer Reference',
        value: 'introducer_reference',
        labelIndicator: LabelIndicator.WARNING,
    },
    depositGuaranteed: {
        label: 'Deposit Guaranteed',
        value: 'deposit_guaranteed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const accountStatuses = asEnum({
    active: {
        label: 'Active',
        value: 'active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    pendingClosureSignatures: {
        label: 'Pending Closure Signatures',
        value: 'pending_closure_signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingOpeningSignatures: {
        label: 'Pending Opening Signatures',
        value: 'pending_opening_signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingApproval: {
        label: 'Pending Approval',
        value: 'pending_approval',
        labelIndicator: LabelIndicator.INFO,
    },
    suspended: {
        label: 'Suspended',
        value: 'suspended',
        labelIndicator: LabelIndicator.ERROR,
    },
    monitoring: {
        label: 'Active Monitoring',
        value: 'monitoring',
        labelIndicator: LabelIndicator.WARNING,
    },
    rejected: {
        label: 'Rejected',
        value: 'rejected',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    closed: {
        label: 'Closed',
        value: 'closed',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    pendingIncomingPayment: {
        label: 'Pending Incoming Payment',
        value: 'pending_incoming_payment',
        labelIndicator: LabelIndicator.WARNING,
    },
    frozen: {
        label: 'Frozen',
        value: 'frozen',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const accountClosureReasons = asLocalizedEnum('accountClosureReasons', {
    nonCompliance: {
        value: 'non_compliance',
        label: 'Non-compliance or non-receipt of required documents / information',
    },
    underagedClient: {
        value: 'underaged_client',
        label: 'Underaged client',
    },
    nonAcceptableCountry: {
        value: 'non_acceptable_country',
        label: 'Non-acceptable country of domicile',
    },
    clientRequest: {
        value: 'client_request',
        label: 'As per your request',
    },
    duplicateAccount: {
        value: 'duplicate_account',
        label: 'Duplicate account',
    },
    missingKycDoc: {
        value: 'missing_kyc_doc',
        label: 'Due to missing KYC documentation',
    },
    missingProofAddress: {
        value: 'missing_proof_address',
        label: 'Due to missing Proof of Address',
    },
    missingProofOfId: {
        value: 'missing_proof_of_id',
        label: 'Due to missing Proof of Identification',
    },
    missingProofOfPayment: {
        value: 'missing_proof_of_payment',
        label: 'Due to missing Proof of Payment (i.e. card copies/bank statement)',
    },
    thirdPartyTransaction: {
        value: 'third_party_transaction',
        label: 'Third party transaction/s',
    },
    duplicateProfile: {
        value: 'duplicate_profile',
        label: 'Duplicate profile/s',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
    declaredPep: {
        value: 'declared_pep',
        label: 'As you have declared to be Politically Exposed Person',
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
    },
});
const accountStatementTypes = asEnum({
    pdf: {
        label: 'PDF',
        value: 'pdf',
    },
    csv: {
        label: 'CSV',
        value: 'csv',
    },
    mt940: {
        label: 'MT940',
        value: 'mt940',
    },
    mt940Download: {
        label: 'MT940 Download',
        value: 'mt940Download',
    },
});
const fundTypes = asEnum({
    operational: {
        label: 'Operational',
        value: 'operational',
    },
    clientFunds: {
        label: 'ClientFunds',
        value: 'clientFunds',
    },
    depositGuaranteed: {
        label: 'Deposit Guaranteed',
        value: 'depositGuaranteed',
    },
    crypto: {
        label: 'Wallet',
        value: 'crypto',
    },
});
const accountQRBillTypes = asEnum({
    pdf: {
        label: 'PDF',
        value: 'pdf',
    },
    svg: {
        label: 'SVG',
        value: 'svg',
    },
});
const spendingLimitStatuses = asEnum({
    active: {
        label: 'Active',
        value: 'active',
    },
    pending: {
        label: 'Pending',
        value: 'pending',
    },
    rejected: {
        label: 'Rejected',
        value: 'rejected',
    },
});
const spendingLimitIntervals = asEnum({
    single: {
        label: 'Single',
        value: 'single',
    },
    daily: {
        label: 'Daily',
        value: 'daily',
    },
    monthly: {
        label: 'Monthly',
        value: 'monthly',
    },
});
const spendingLimitTypes = asEnum({
    sdd: {
        label: 'SEPA Direct Debit',
        value: 'sdd',
        clientCanManage: true,
    },
    sddCredit: {
        label: 'SEPA Direct Debit Credit',
        value: 'sdd_credit',
        clientCanManage: false,
    },
});
const accountNoTypes = asLocalizedEnum('accountNoTypes', {
    checking: {
        label: 'Checking',
        value: 'CACC',
    },
    saving: {
        label: 'Saving',
        value: 'SVGS',
    },
    iban: {
        label: 'IBAN',
        value: 'iban',
    },
    walletId: {
        label: 'Wallet ID',
        value: 'walletId',
    },
    cardNo: {
        label: 'Card No.',
        value: 'cardNo',
    },
    accountNumber: {
        label: 'Card No.',
        value: 'accountNumber',
    },
});

const activityLogObjectTypes = asEnum({
    transaction: {
        value: 'transaction',
        label: 'Transaction',
        model: 'Transaction',
    },
    standingOrder: {
        value: 'standing_order',
        label: 'Standing Order',
        model: 'StandingOrder',
    },
    ledger: {
        value: 'ledger',
        label: 'Ledger',
        model: 'Ledger',
    },
    ledgerTransaction: {
        value: 'ledger_transaction',
        label: 'Ledger Transaction',
        model: 'LedgerTransaction',
    },
    document: {
        value: 'document',
        label: 'Document',
        model: 'Document',
    },
    profileChange: {
        value: 'profile_change',
        label: 'Profile Change',
        model: 'ProfileChange',
    },
    user: {
        value: 'user',
        label: 'User',
        model: 'User',
    },
    account: {
        value: 'account',
        label: 'Account',
        model: 'Account',
    },
    blacklist: {
        value: 'blacklist',
        label: 'Blacklist',
        model: 'Blacklist',
    },
    dueDiligence: {
        value: 'due_diligence',
        label: 'Due Diligence',
        model: 'DueDiligence',
    },
    individual: {
        value: 'individual',
        label: 'Individual',
        model: 'Individual',
    },
    contractInformationRequest: {
        value: 'contract_information_request',
        label: 'ContractInformationRequest',
        model: 'ContractInformationRequest',
    },
    directDebitMandate: {
        value: 'direct_debit_mandate',
        label: 'Direct Debit Mandate',
        model: 'DirectDebitMandate',
    },
    feeGroup: {
        value: 'fee_group',
        label: 'FeeGroup',
        model: 'FeeGroup',
    },
    transactionRequest: {
        value: 'transaction_request',
        label: 'Transaction Request',
        model: 'TransactionRequest',
    },
    paymentRailConfig: {
        value: 'payment_rail_config',
        label: 'Payment Rail',
        model: 'PaymentRail',
    },
    paymentRailRouteConfig: {
        value: 'payment_rail_route_config',
        label: 'Payment Rail Route Config',
        model: 'PaymentRailRouteConfig',
    },
});
const activityLogOrigins = asEnum({
    individual: {
        value: 'individual',
        label: 'Individual',
    },
    user: {
        value: 'user',
        label: 'User',
    },
    apiUser: {
        value: 'api_user',
        label: 'API User',
    },
});
const activityLogGraphqlTypes = asEnum({
    genericLog: {
        name: 'GenericLog',
        value: 'genericLog',
    },
    withReasonLog: {
        name: 'WithReasonLog',
        value: 'withReasonLog',
    },
    note: {
        name: 'Note',
        value: 'note',
    },
    kycStatusLog: {
        name: 'KycStatusLog',
        value: 'kycStatusLog',
    },
    agentLog: {
        name: 'AgentLog',
        value: 'agentLog',
    },
    complianceLog: {
        name: 'ComplianceLog',
        value: 'complianceLog',
    },
    diffLog: {
        name: 'DiffLog',
        value: 'diffLog',
    },
    underMonitoringLog: {
        name: 'UnderMonitoringLog',
        value: 'underMonitoringLog',
    },
    accountCheckLog: {
        name: 'AccountCheckLog',
        value: 'accountCheckLog',
    },
    docTranslationsLog: {
        name: 'DocumentTranslationsLog',
        value: 'docTranslationsLog',
    },
    userActionLog: {
        name: 'UserActionLog',
        value: 'userActionLog',
    },
    accountLog: {
        name: 'AccountLog',
        value: 'accountLog',
    },
    contractLog: {
        name: 'ContractLog',
        value: 'contractLog',
    },
    actionLog: {
        name: 'ActionLog',
        value: 'actionLog',
    },
    transactionLog: {
        name: 'TransactionLog',
        value: 'transactionLog',
    },
    ledgerTransactionLog: {
        name: 'LedgerTransactionLog',
        value: 'ledgerTransactionLog',
    },
    ledgerLog: {
        name: 'LedgerLog',
        value: 'ledgerLog',
    },
    directDebitMandateLog: {
        name: 'DirectDebitMandateLog',
        value: 'directDebitMandateLog',
    },
    feeGroupLog: {
        name: 'FeeGroupLog',
        value: 'feeGroupLog',
    },
});
const activityLogTypes = asEnum({
    bookedIncomingSwiftToLedger: {
        value: 'booked_incoming_swift_trx_to_ledger',
        label: 'Booking Incoming Swift Message To Ledger',
        activityLogMessage: 'Booking Incoming Swift Message To Ledger',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    incomingTransactionNameMismatch: {
        value: 'incoming_trx_name_mismatch',
        label: 'Incoming Transaction Debtor Name Mismatch',
        activityLogMessage: 'Incoming Transaction #{transactionId} Name Mismatch\nActual({actual}) vs Incoming({incoming}) score={similarityScore}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    incomingTransactionCreditorNameMismatch: {
        value: 'incoming_trx_creditor_name_mismatch',
        label: 'Incoming Transaction Creditor Name Mismatch',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    acceptedIncomingTransactionCreditorNameMismatch: {
        value: 'accepted_incoming_trx_creditor_name_mismatch',
        label: 'Accepted Incoming Transaction Creditor Name Mismatch',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    transactionValueUpdated: {
        value: 'transaction_value_updated',
        label: 'Transaction value Updated',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionCounterPartyAddressModified: {
        value: 'transaction_counter_party_addr_modified',
        label: 'Transaction Counter Party Address Modified',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    resolveIncomingTransactionNameMismatch: {
        value: 'incoming_trx_name_mismatch_resolved',
        label: 'Incoming Transaction Name Mismatch',
        activityLogMessage: 'Incoming Transaction #{transactionId} Name Mismatch Resolved\nResolution={resolution}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    creditedIncomingSwiftTransactionToAccount: {
        value: 'credited_incoming_swift_trx_to_account',
        label: 'Credited Incoming Swift Trx To Account',
        activityLogMessage: 'Credited Incoming Swift Trx To Account',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    addedTransactionSupportingDocument: {
        value: 'added_trx_supporting_document',
        label: 'Added Transaction Supporting Document',
        activityLogMessage: 'Added Transaction Supporting Document',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionAuthorizedForFX: {
        value: 'authorized_trx_for_fx',
        label: 'Authorized Transaction For FX',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionFXExecuted: {
        value: 'executed_trx_fx',
        label: 'Executed Transaction FX',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    changeTransactionRecurringMarker: {
        value: 'changed_trx_recurring_marker',
        label: 'Changed Transaction Recurring Marker',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    incomingTransactionFlaggedForAMLReview: {
        value: 'incoming_transaction_flagged_for_aml',
        label: 'Incoming Transaction Flagged For AML',
        activityLogMessage: 'Incoming Transaction Flagged For AML',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    addedContractPaymentRecipient: {
        value: 'added_contract_payment_recipient',
        label: 'Added Contract Payment Recipient',
        activityLogMessage: 'Added Contract Payment Recipient',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedContractPaymentRecipient: {
        value: 'updated_contract_payment_recipient',
        label: 'Updated Contract Payment Recipient',
        activityLogMessage: 'Updated Contract Payment Recipient ',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedContractKeyInformation: {
        value: 'updated_contract_key_information',
        label: 'Updated Contract Key Information',
        activityLogMessage: 'Updated Contract Key Information from "{old}" to "{new}"',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removedContractPaymentRecipient: {
        value: 'removed_contract_payment_recipient',
        label: 'Removed Contract Payment Recipient',
        activityLogMessage: 'Removed Contract Payment Recipient',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    transactionCancellationRejected: {
        value: 'trx_cancellation_rejected',
        label: 'Transaction Cancellation Rejected',
        activityLogMessage: 'Transaction Cancellation Rejected #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionCancelled: {
        value: 'trx_cancelled',
        label: 'Transaction Cancelled',
        activityLogMessage: 'Transaction Cancelled #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionReturned: {
        value: 'trx_returned',
        label: 'Transaction Returned',
        activityLogMessage: 'Transaction #{transaction} Returned, #{reasonCode}/{reasonDescription}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionClearedForAML: {
        value: 'trx_cleared_for_aml',
        label: 'Transaction Message Cleared For AML',
        activityLogMessage: 'Transaction Cleared For AML #{transaction} \n {note}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionSentForAML: {
        value: 'trx_sent_for_aml',
        label: 'Transaction Sent For AML Checks',
        activityLogMessage: 'Transaction Sent For AML Checks #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionFlaggedForAMLReview: {
        value: 'trx_flagged_for_aml_review',
        label: 'Transaction Message Flagged For AML Review',
        activityLogMessage: 'Transaction Message Flagged For AML Review #{transaction} \n {note}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionMessageAccepted: {
        value: 'trx_msg_accepted',
        label: 'Transaction Message Accepted By Correspondent',
        activityLogMessage: 'Transaction Message Accepted By Correspondent #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionCorrespondentInfoUpdated: {
        value: 'trx_intermediary_info_updated',
        label: 'Transaction Correspondent Info Updated',
        activityLogMessage: 'Transaction Correspondent Info Updated on #{transaction} \n Bank: {bankName}, BIC: {bic} ',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionPendingPayout: {
        value: 'trx_pending_payout',
        label: 'Transaction Pending Payout',
        activityLogMessage: 'Transaction Pending Payout #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    resolvedTransactionDestination: {
        value: 'trx_destination_resolved',
        label: 'Transaction Destination Resolved',
        activityLogMessage: 'Transaction Destination Resolved #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionPayoutStatusChanged: {
        value: 'trx_payout_status_changed',
        label: 'Transaction Payout Status Changed',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionReturnRequestProcessed: {
        value: 'trx_return_request_processed',
        label: 'Transaction Recall Processed',
        activityLogMessage: 'Transaction Recall Request Processed With Response {response}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionReturnProcessed: {
        value: 'trx_return_processed',
        label: 'Transaction Return Processed',
        activityLogMessage: 'Transaction Return Processed With Response {response}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionMessageRejected: {
        value: 'trx_msg_rejected',
        label: 'Transaction Message Returned By Correspondent',
        activityLogMessage: 'Transaction Message Rejected By Correspondent #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionMessageReturned: {
        value: 'trx_msg_returned',
        label: 'Transaction  Message Returned By Correspondent',
        activityLogMessage: 'Transaction Message Returned By Correspondent  #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionReturnedRequested: {
        value: 'trx_return_requested',
        label: 'Transaction Return Requested',
        activityLogMessage: 'Transaction Return Requested With Msg  #{messageId}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionMessageSent: {
        value: 'trx_msg_sent',
        label: 'Transaction Message Sent To Correspondent',
        activityLogMessage: 'Transaction Message Sent To Correspondent #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    reset2FaAttempts: {
        value: 'reset_2fa_attempts',
        label: 'Reset 2FA Attempts',
        activityLogMessage: 'Reset 2FA Attempts',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdTransaction: {
        value: 'created_transaction',
        label: 'Created Transaction',
        activityLogMessage: 'Created a new {entryType} Transaction #{transaction} \n {reason}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cancelledTransaction: {
        value: 'cancelled_transaction',
        label: 'Cancelled Transaction',
        activityLogMessage: 'Cancelled Transaction #{transaction} \n {reason}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    returnedTransaction: {
        value: 'returned_transaction',
        label: 'Returned Transaction',
        activityLogMessage: 'Returned Transaction #{transaction} \n {reason}{reasonCode}{reasonCodeDescription}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    executedTransaction: {
        value: 'executed_transaction',
        label: 'Executed Transaction',
        activityLogMessage: 'Executed Transaction #{transaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    bookedLedgerTransaction: {
        value: 'booked_ledger_transaction',
        label: 'Booked Ledger Transaction',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    returnLedgerTransaction: {
        value: 'returned_ledger_transaction',
        label: 'Returned Ledger Transaction',
        activityLogMessage: 'Returned Ledger Transaction #{incomingLedgerTransaction} with #{outgoingLedgerTransaction} \n {reason}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    resendReturnLedgerTransactionMessage: {
        value: 'resend_return_ledger_transaction_message',
        label: 'Resend Return Ledger Transaction Message',
        activityLogMessage: 'Resend Returned Ledger Transaction Message For #{outgoingLedgerTransaction} \n {reason}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    revertedLedgerTransaction: {
        value: 'reverted_ledger_transaction',
        label: 'Reverted Ledger Transaction',
        activityLogMessage: 'Reverted Ledger Transaction #{transactionId} {reason}',
        graphqlType: activityLogGraphqlTypes.ledgerTransactionLog,
    },
    createdSwiftMessage: {
        value: 'created_swift_message',
        label: 'Created Swift Message',
        activityLogMessage: "Created Swift Message '{messageType}' {messageLink}",
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    sentSEPAClaimNoReceiptMessage: {
        value: 'sent_sepa_claim_non_receipt',
        label: 'Sent SEPA Claim Non Receipt',
        activityLogMessage: 'Sent SEPA Claim Non Receipt(CAMT.027)\n{messageId}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    note: {
        value: 'note',
        label: 'Created Note',
        activityLogMessage: 'Created Note',
        graphqlType: activityLogGraphqlTypes.note,
    },
    createDocument: {
        value: 'create_document',
        label: 'Create Document',
        activityLogMessage: 'Created Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateDocument: {
        value: 'update_document',
        label: 'Update Document',
        activityLogMessage: 'Updated Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveDocument: {
        value: 'approve_document',
        label: 'Approve Document',
        activityLogMessage: 'Approved Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectDocument: {
        value: 'reject_document',
        label: 'Reject Document',
        activityLogMessage: 'Rejected Document',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    revertDocument: {
        value: 'revert_document',
        label: 'Revert Document',
        activityLogMessage: 'Reverted Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    documentSigningComplete: {
        value: 'document_signing_complete',
        label: 'Document Signing Complete',
        activityLogMessage: 'Document Signing Complete',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    resetClientPassword: {
        value: 'reset_client_password',
        label: 'Reset Client Password',
        activityLogMessage: "Reset Individual's password",
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateClientDetails: {
        value: 'update_client_details',
        label: 'Update Client Details',
        activityLogMessage: "Updated Individual's Details",
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ranElectronicIdVerificationCheck: {
        value: 'ran_eidv_checks',
        label: 'Ran Account eIDV Checks',
        activityLogMessage: 'Ran account eIDV checks',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approveProfileChange: {
        value: 'approve_profile_change',
        label: 'Approve Profile Change',
        activityLogMessage: 'Approved Profile Changes',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectProfileChange: {
        value: 'reject_profile_change',
        label: 'Reject Profile Change',
        activityLogMessage: 'Rejected Profile Change',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    underReviewProfileChange: {
        value: 'under_review_profile_change',
        label: 'Under Review Profile Change',
        activityLogMessage: 'Placed Profile Change Under Review',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    setClientKycStatus: {
        value: 'set_kyc_status',
        label: 'Set KYC Status',
        activityLogMessage: "Changed KYC status to '{kycStatus}'",
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.kycStatusLog,
    },
    setContractStatus: {
        value: 'set_contract_status',
        label: 'Set Contract Status',
        activityLogMessage: "Changed Contract status to '{contractStatus}' \n {statusReason}",
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changedContractFundFlowDescription: {
        value: 'changed_contract_fund_flow_desc',
        label: 'Changed Contract Fund Flow Description',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    setContractRiskProfile: {
        value: 'set_contract_risk_profile',
        label: 'Set Contract Risk Profile',
        activityLogMessage: "Changed Contract Risk Profile to '{riskProfile}'${oldRiskProfileMessage}",
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    setupFileBasedPainAccess: {
        value: 'setup_file_based_pain_access',
        label: 'Set-Up Contract File Based PAIN Access',
        activityLogMessage: 'Set-Up Contract File Based PAIN Access\n{message}',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    modifiedFileBasedPainAccess: {
        value: 'modified_file_based_pain_access',
        label: 'Modified Contract File Based PAIN Access',
        activityLogMessage: "Modified Contract File Based PAIN Access\nfrom '{oldValues}' \nto '{newValues}'",
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    assignClientAgent: {
        value: 'assign_client_agent',
        label: 'Assign Client Agent',
        activityLogMessage: 'Assigned {agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    unassignClientAgent: {
        value: 'unassign_client_agent',
        label: 'Unassign Client Agent',
        activityLogMessage: 'Unassigned {agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    claimClientAgent: {
        value: 'claim_client_agent',
        label: 'Claim Client Agent',
        activityLogMessage: 'Claimed {agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    unclaimClientAgent: {
        value: 'unclaim_client_agent',
        label: 'Unclaim Client Agent',
        activityLogMessage: 'Unclaimed {agentType} agent',
        graphqlType: activityLogGraphqlTypes.agentLog,
    },
    call: {
        value: 'call',
        label: 'Call',
        activityLogMessage: 'Called Individual',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnDetails: {
        value: 'client_update_own_details',
        label: 'Client Update Own Details',
        activityLogMessage: 'Updated their own details',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnEmail: {
        value: 'client_update_own_email',
        label: 'Client Update Own Email',
        activityLogMessage: 'Updated their own email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    confirmOwnEmail: {
        value: 'client_confirm_own_email',
        label: 'Client Confirm Own Email',
        activityLogMessage: 'Confirmed their own email',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateOwnPassword: {
        value: 'client_update_own_password',
        label: 'Client Updated Password',
        activityLogMessage: 'Changed their password',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createOwnDocument: {
        value: 'client_create_own_document',
        label: 'Client Create Document',
        activityLogMessage: 'Created own document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createContractDocument: {
        value: 'client_create_contract_document',
        label: 'Client Created Contract Document',
        activityLogMessage: 'Created contract document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdBankableEntityContract: {
        value: 'created_bankable_entity_contract',
        label: 'Created Bankable Entity Contract',
        activityLogMessage: 'Created new Bankable Entity Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedBankableEntityContract: {
        value: 'updated_bankable_entity_contract',
        label: 'Updated Bankable Entity Contract',
        activityLogMessage: 'Updated Bankable Entity Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedSignatureSpecimen: {
        value: 'added_signature_specimen',
        label: 'Added Signature Specimen',
        activityLogMessage: 'Added Signature Specimen',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    replacedSignatureSpecimen: {
        value: 'replaced_signature_specimen',
        label: 'Replaced Signature Specimen',
        activityLogMessage: 'Replaced Signature Specimen',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    submittedBankableEntityContract: {
        value: 'submitted_bankable_entity_contract',
        label: 'Submitted Bankable Entity Contract For Approval',
        activityLogMessage: 'Submitted Bankable Entity Contract For Approval',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removedBankableEntityContract: {
        value: 'removed_bankable_entity_contract',
        label: 'Removed Bankable Entity Contract',
        activityLogMessage: 'Removed Bankable Entity Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedBankableEntityAuthControllingPerson: {
        value: 'added_bankable_entity_auth_contr_person',
        label: 'Added Authorized Person To Contract',
        activityLogMessage: 'Added Authorized Person ({individualName}) To Contract with Status ({status})',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedBankableEntityAuthControllingPerson: {
        value: 'updated_bankable_entity_auth_contr_person',
        label: 'Updated Authorized Person on Contract',
        activityLogMessage: 'Updated Authorized Person on Contract\n{updates}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removedBankableEntityAuthControllingPerson: {
        value: 'removed_bankable_entity_auth_contr_person',
        label: 'Removed Authorized Person from Contract',
        activityLogMessage: 'Removed Authorized Person from Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removedUboOwner: {
        value: 'removed_ubo_owner',
        label: 'Removed UBO Owner',
        activityLogMessage: 'Removed Owner From UBO',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedUboOwner: {
        value: 'added_ubo_owner',
        label: 'Added Owner To UBO',
        activityLogMessage: 'Added Owner To UBO',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedUboOwner: {
        value: 'updated_ubo_owner',
        label: 'Updated UBO Owner',
        activityLogMessage: 'Updated UBO Owner',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removedBankableEntityUbo: {
        value: 'removed_bankable_entity_ubo',
        label: 'Removed UBO from Contract',
        activityLogMessage: 'Removed UBO from Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedBankableEntityUbo: {
        value: 'updated_bankable_entity_ubo',
        label: 'Updated UBO on Contract',
        activityLogMessage: 'Updated UBO on Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedBankableEntityUbo: {
        value: 'added_bankable_entity_ubo',
        label: 'Added UBO to Contract',
        activityLogMessage: 'Added UBO ({entityName}) to Contract',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedContractAuthPersonStatus: {
        value: 'changed_contract_auth_person_status',
        label: 'Change Contract Authorized Person Status',
        activityLogMessage: 'Change Authorized Person ({individualName}) status from "{oldStatus}" to "{newStatus}"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userPerformedCheck: {
        value: 'user_performed_check',
        label: 'User Performed Check',
        activityLogMessage: 'User Performed Check "{checkName}" with status "{newStatus}" \n {note}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedCheckResult: {
        value: 'user_updated_check_result',
        label: 'User Updated Check Result',
        activityLogMessage: 'User Updated Check "{checkName}" Result to status "{newStatus}"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userUpdatedCheck: {
        value: 'user_updated_check',
        label: 'User Updated Check Settings',
        activityLogMessage: 'User Updated Check Settings',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userAddedCheck: {
        value: 'user_added_check',
        label: 'User Added New Check Settings',
        activityLogMessage: 'User Added New Check Settings',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    userDeletedCheck: {
        value: 'user_deleted_check',
        label: 'User Deleted Check Settings',
        activityLogMessage: 'User Deleted Check Settings',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientHasDifferentIpCountry: {
        value: 'client_has_different_ip_country',
        label: 'Client Has Different IP Country',
        activityLogMessage: 'Has different IP country',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    clientHasSamePhoneNumber: {
        value: 'client_has_same_phone_number',
        label: 'Client Has Same Phone Number',
        activityLogMessage: 'Has same phone number as {otherUsersCount} other user(s):',
        graphqlType: activityLogGraphqlTypes.complianceLog,
        isNotification: true,
    },
    clientHasSameLastnameAndDob: {
        value: 'client_has_same_lastname_and_date_of_birth',
        label: 'Individual Has Same Last Name And Date Of Birth',
        activityLogMessage: 'Has same last name and date of birth as {otherUsersCount} other user(s):',
        graphqlType: activityLogGraphqlTypes.complianceLog,
        isNotification: true,
    },
    createdAccount: {
        value: 'client_created_account',
        label: 'Client Create Account',
        activityLogMessage: 'Created {accountType} Account \n{accountLabel}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    userCreatedAccount: {
        value: 'user_created_account',
        label: 'User Create Account',
        activityLogMessage: "Created account '{accountLabel}'",
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    deletedAccount: {
        value: 'user_deleted_account',
        label: 'User Delete Account',
        activityLogMessage: "Delete {accountType} Account '{accountLabel}'",
        graphqlType: activityLogGraphqlTypes.accountLog,
        activityLogShowReason: true,
    },
    requestedPhoneVerificationCode: {
        value: 'client_requested_phone_verification_code',
        label: 'Client Requested Phone Verification Code',
        activityLogMessage: 'Requested Phone Verification Code',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    requestedVideoVerificationUrl: {
        value: 'client_requested_video_verification_url',
        label: 'Client Requested Video Verification Url',
        activityLogMessage: 'Requested Video Verification Url',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientVideoVerificationCompleted: {
        value: 'client_video_verification_completed',
        label: 'Client Video Verification Completed',
        activityLogMessage: 'Client Video Verification Completed With Status {status}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    verifiedPhone: {
        value: 'client_verified_phone',
        label: 'Client Verified Phone',
        activityLogMessage: 'Verified Phone',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    registered: {
        value: 'client_registered',
        label: 'Client Registered',
        activityLogMessage: 'Registered a new profile',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changeSettings: {
        value: 'change_settings',
        label: 'Change System Settings',
        activityLogMessage: 'Changed settings',
        graphqlType: activityLogGraphqlTypes.diffLog,
    },
    setOptinMarketing: {
        value: 'client_set_optin_marketing',
        label: 'Changed optin marketing preference',
        activityLogMessage: 'Opted {marketingInOut} marketing',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    sendClientSecurityCode: {
        value: 'send_client_security_code',
        label: 'Sent Client Support Security Code',
        activityLogMessage: 'Support Security Code Sent',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removeDocument: {
        value: 'remove_document',
        label: 'Remove Document',
        activityLogMessage: 'Removed Document',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setOptInSms: {
        value: 'client_set_opt_in_sms',
        label: 'Changed opt in SMS preference',
        activityLogMessage: 'Opted {smsInOut} SMS',
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    editedAccount: {
        value: 'user_edited_account',
        label: 'User Edit Account',
        activityLogMessage: "Edited account '{accountLabel} - {remoteId}'",
        graphqlType: activityLogGraphqlTypes.complianceLog,
    },
    toggleIsPhoneVerified: {
        value: 'toggle_is_phone_verified',
        label: 'Toggle Phone Verified',
        activityLogMessage: 'Phone {toggleIsPhoneVerified} Verified',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleIndividualVerified: {
        value: 'toggle_is_individual_verified',
        label: 'Toggle Individual Verified',
        activityLogMessage: 'Individual verification set to {isVerified}. {medium}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAccountHidden: {
        value: 'toggle_account_hidden',
        label: 'Toggle Account Hidden',
        activityLogMessage: 'Account Hidden set to {hidden}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAccountUseFItoFI: {
        value: 'toogle_account_use_fi_to_fi',
        label: 'Toogle Account Use FI to FI',
        activityLogMessage: 'Account Use FI to FI for outbound set to {hidden}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleEmailConfirmed: {
        value: 'toggle_email_confirmed',
        label: 'Toggle Email Confirmed',
        activityLogMessage: 'Email {toggleEmailConfirmed} Confirmed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    assigneeDocument: {
        value: 'assignee_document',
        label: 'Assign Document',
        activityLogMessage: 'Assigned to {assignee}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    clientLoginSuccess: {
        value: 'client_login_success',
        label: 'Client Login Success',
        activityLogMessage: 'Client login successfully',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addUser: {
        value: 'add_user',
        label: 'Add User in CRM',
        activityLogMessage: 'Added User {fullName}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    editUserInfo: {
        value: 'edit_user_info',
        label: 'Edit User Info',
        activityLogMessage: 'Edited User Info for {fullName}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    initiatedAction: {
        value: 'initiated_action',
        label: 'Initiated Action',
        activityLogMessage: 'Initiated {type} Action',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    signedAction: {
        value: 'signed_action',
        label: 'Signed Action',
        activityLogMessage: 'Signed {type} Action {message}',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    requestedActionSigningCode: {
        value: 'request_action_signing_code',
        label: 'Requested Action Signing Code',
        activityLogMessage: 'Requested Action Signing Code',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    executedAction: {
        value: 'executed_action',
        label: 'Executed Action',
        activityLogMessage: 'Executed {type} Action',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    rejectedAction: {
        value: 'rejected_action',
        label: 'Rejected Action',
        activityLogMessage: 'Rejected {type} Action',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    acceptedAction: {
        value: 'accepted_action',
        label: 'Accepted Action',
        activityLogMessage: 'Accepted {type} Action',
        graphqlType: activityLogGraphqlTypes.actionLog,
    },
    updateAccountStatus: {
        value: 'updated_account_status',
        label: 'Updated Account Status',
        activityLogMessage: 'Updated Account Status To {status}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    closedAccount: {
        value: 'closed_account',
        label: 'Closed Account',
        activityLogMessage: 'Closed Account Status with Reason {closureReason}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    requestedAccountClosure: {
        value: 'requested_account_closure',
        label: 'Requested Account Closure',
        activityLogMessage: 'Requested Closure of {account}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    contractChangeRequested: {
        value: 'contract_change_requested',
        label: 'Contract Change Requested',
        activityLogMessage: 'Contract Change Requested {contract}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    contractSuspiciousActivityReported: {
        value: 'contract_suspicious_activity_reported',
        label: 'Contract Suspicious Activity Reported',
        activityLogMessage: 'Contract Suspicious Activity Reported',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    requestCard: {
        value: 'card_issue_request',
        label: 'Card Issue Requested',
        activityLogMessage: 'Card Issue Requested',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    addCard: {
        value: 'add_card',
        label: 'Add Card',
        activityLogMessage: 'Added Card {name}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    spendingLimitRequest: {
        value: 'requested_spending_limit_update',
        label: 'Requested Spending Limit Update',
        activityLogMessage: 'Requested Spending Limit Update',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    addedContractAuthorizedPersonRequest: {
        value: 'requested_adding_contract_authorized_person',
        label: 'Requested Adding Contract Authorized Person',
        activityLogMessage: 'Requested Adding Authorized Person ({individualName})',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    user2FaEnabled: {
        value: 'user2FaEnabled',
        label: '2fa is enabled',
        activityLogMessage: '2fa is enabled',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    approveCardTransaction: {
        value: 'approve_card_transaction',
        label: 'Approve Card Transaction',
        activityLogMessage: 'Approve Card Transaction',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    declineCardTransaction: {
        value: 'decline_card_transaction',
        label: 'Decline Card Transaction',
        activityLogMessage: 'Card Transaction #{transaction} is declined on Card {card}. \n Reason: {reason}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    modifyAuthorizedCardTransaction: {
        value: 'modify_authorized_card_transaction',
        label: 'Modify Card Authorized Transaction',
        activityLogMessage: 'Authorized Transaction #{transaction}, Amount is modified from {originalAmount} to {usedAmount} on Card {card}. FullyReversed={isFullReversal}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cardTransactionReturned: {
        value: 'card_transaction_return',
        label: 'Card Authorized/Cleared Transaction Returned',
        activityLogMessage: 'Card Transaction #{transaction} has been returned by {merchant} with new transaction #{newTransaction}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cardCreditVoucherTransaction: {
        value: 'card_credit_voucher_transaction',
        label: 'Card Credit Voucher Transaction Returned',
        activityLogMessage: 'Card Transaction #{transaction} credited by {merchant} as credit/voucher',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cardTransactionCleared: {
        value: 'card_transaction_cleared',
        label: 'Card Transaction Cleared',
        activityLogMessage: 'Card Transaction Cleared',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    erroneousCancelledCardTransactionCleared: {
        value: 'erroneous_cancelled_card_transaction_cleared',
        label: 'Erroneously Cancelled Card Transaction Cleared',
        activityLogMessage: 'Erroneously cancelled transaction #{transactionId} cleared',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    transactionReverted: {
        value: 'transaction_reverted',
        label: 'Transaction Reverted',
        activityLogMessage: 'Transaction #{transaction} is reverted by #{revertedBy} \n{reason}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    setCardLimits: {
        value: 'set_card_limits',
        label: 'Set Card limits',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    changedContractFeeGroup: {
        value: 'changed_contract_fee_group',
        label: 'Changed Contract FeeGroup',
        activityLogMessage: 'Changed Contract Fee Group from {oldFeeGroupName} to {newFeeGroupName}',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdCustomerSupportRequest: {
        value: 'created_customer_support_request',
        label: 'Created Customer Support Request',
        activityLogMessage: 'Created Customer Support Request \n#{ticketId}',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    chargeManualFee: {
        value: 'charge_manual_fee',
        label: 'Charge Manual Fee',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    chargeFee: {
        value: 'charge_fee',
        label: 'Charge Fee',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    payCommission: {
        value: 'pay_commission',
        label: 'Pay Commission',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    payCashback: {
        value: 'pay_cashback',
        label: 'Pay Cashback',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    freezeCard: {
        value: 'freeze_card',
        label: 'Freeze Card',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    unFreezeCard: {
        value: 'unfreeze_card',
        label: 'Unfreeze Card',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    viewCardSensitiveInfo: {
        value: 'view_card_sensitive_info',
        label: 'View Card Sensitive Info',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    cardTerminated: {
        value: 'card_terminated',
        label: 'Card Terminated',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    cardUpdated: {
        value: 'card_updated',
        label: 'Card Updated',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    batchPaymentCreated: {
        value: 'batch_payment_created',
        label: 'Batch Payment Created',
        activityLogMessage: 'Batch Payment Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    batchPaymentExecuted: {
        value: 'batch_payment_executed',
        label: 'Batch Payment Executed',
        activityLogMessage: 'Batch Payment Executed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cardTransactionCancelled: {
        value: 'card|_transaction_cancelled',
        label: 'Card Transaction Cancelled',
        activityLogMessage: 'Transaction #{transactionId} Authorization is Cancelled',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cardTransactionCancellationReverted: {
        value: 'card|_transaction_cancellation_reverted',
        label: 'Card Transaction Cancellation Reverted',
        activityLogMessage: 'Cancellation of Authorized Transaction #{transactionId} is Reverted',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    updatedCard3DSSetting: {
        value: 'updated_card_3DS_setting',
        label: 'Updated Card 3DS Setting',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    activatedCard: {
        value: 'activated_card',
        label: 'Activated Card',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    viewCard3dsPassword: {
        value: 'view_card_3ds_password',
        label: 'View Card 3DS Password',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    toggleEconomicProfile: {
        value: 'toggle_economic_profile',
        label: 'Toggle Economic Profile',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    deactivateAuthorizedPersonRequest: {
        value: 'deactivate_authorized_person_request',
        label: 'Deactivate Authorized Person Request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    deactivateAuthorizedPerson: {
        value: 'deactivate_authorized_person',
        label: 'Deactivated Authorized Person',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    toggleAuthorizedPersonSignOwnActions: {
        value: 'toggle_auth_person_sign_own_actions',
        label: 'Toggle Authorized Person Sign Own Actions',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    toggleIntroducingPartner: {
        value: 'toggle_introducing_partner',
        label: 'Toggle Introducing Partner',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    sendVerificationInvitation: {
        value: 'send_verification_invitation',
        label: 'Sent Verification Invitation To AP',
        activityLogMessage: 'Sent Verification Invitation To AP ({name})',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    createdApiUser: {
        value: 'created_api_user',
        label: 'Created API User',
        activityLogMessage: 'Created API User "{name}" with allowed Ips "{allowedIps}"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedApiUserAllowedIps: {
        value: 'updated_api_user_allowed_ips',
        label: 'Updated API User allowed IPs',
        activityLogMessage: 'Updated API User "{name}" allowed Ips \n"{oldAllowedIps}" to "{newAllowedIps}"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedApiUserStatus: {
        value: 'updated_api_user_status',
        label: 'Updated API User Status',
        activityLogMessage: 'Updated API User "{name}" status \n"{oldStatus}" to "{newStatus}"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedApiUserSecret: {
        value: 'updated_api_user_secret',
        label: 'Updated API User Secret',
        activityLogMessage: 'Updated API User Secret key"',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedPaymentRailConfig: {
        value: 'updated_payment_rail_config',
        label: 'Update Payment Rail Config',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createPaymentRailConfig: {
        value: 'created_payment_rail_config',
        label: 'Created Payment Rail Config',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdPaymentRailRouteConfig: {
        value: 'created_payment_rail_route_config',
        label: 'Create Payment Rail Route Config',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    deletedPaymentRailRouteConfig: {
        value: 'deleted_payment_rail_route_config',
        label: 'Deleted Payment Rail Route Config',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedPaymentRailRouteConfig: {
        value: 'updated_payment_rail_route_config',
        label: 'Updates Payment Rail Route Config',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedContractCommisionSettings: {
        value: 'updated_contract_commission_settings',
        label: 'Updated Contract Commission Settings',
        activityLogMessage: 'Updated Contract Commission Settings',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateProfileEmailCategoriesSettings: {
        value: 'update_profile_email_categories_settings',
        label: 'Update Profile Email Categories Settings',
        activityLogMessage: 'Updated Email Category ({categoryName}) Preference Enabled to {active}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateProfileSMSCategoriesSettings: {
        value: 'update_profile_sms_categories_settings',
        label: 'Update Profile SMS Categories Settings',
        activityLogMessage: 'Updated SMS Category ({categoryName}) Preference Enabled to {active}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedContractPeriodicReview: {
        value: 'added_contract_periodic_review',
        label: 'Added Contract Periodic Review',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    updatedReferrer: {
        value: 'updated_referrer',
        label: 'Updated Contract Referrer',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    associateIndividuals: {
        value: 'associate_individuals',
        label: 'Associate Individuals',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    dissociateIndividuals: {
        value: 'dissociate_individuals',
        label: 'Dissociate Individuals',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    createCustomerRequestForTransaction: {
        value: 'create_customer_request_for_transaction',
        label: 'Create Customer Request for Transaction',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    allowVbanCreation: {
        value: 'allow_vban_creation',
        label: 'Allow vban creation',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changeContractGeneralNote: {
        value: 'change_contract_general_note',
        label: 'Change Contract General Note',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    contractTerminated: {
        value: 'contract_terminated',
        label: 'Contract Terminated',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    contractTerminationPending: {
        value: 'contract_termination_pending',
        label: 'Contract Termination Pending',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    contractTerminationRequestRejected: {
        value: 'contract_termination_request_rejected',
        label: 'Contract Termination Request Rejected',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    contractTerminationRequest: {
        value: 'contract_termination_request',
        label: 'Contract Termination Request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    associateContracts: {
        value: 'associate_contracts',
        label: 'Associate Contracts',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    dissociateContracts: {
        value: 'dissociate_contracts',
        label: 'Dissociate Contracts',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    addedContractCorrespondenceEmail: {
        value: 'added_contract_correspondence_email',
        label: 'Added Contract Correspondence Email',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changeIndividualGeneralNote: {
        value: 'change_individual_general_note',
        label: 'Change Individual General Note',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    setActionSignaturesToExpired: {
        value: 'set_action_signatures_to_expired',
        label: 'Set action signatures to expired',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    createdIntroducerReferenceContract: {
        value: 'created_introducer_referenceContract',
        label: 'Created Introducer reference Contract',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    updatedPreassessment: {
        value: 'updated_preassessment',
        label: 'Updated Preassessment',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.userActionLog,
    },
    getAccountStatement: {
        value: 'get_account_statement',
        label: 'Get Account Statement',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    getAccountCancellationReport: {
        value: 'get_account_cancellation_report',
        label: 'Get Account Cancellation Report',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    coveredNegativeBalance: {
        value: 'covered_negative_balance',
        label: 'Covered Negative Balance',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    initiatedTOTPSetup: {
        value: 'initiated_totp_setup',
        label: 'Initiated TOTP setup',
        activityLogMessage: 'Initiated TOPT Setup, Reset={isReset}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedPrimary2FAMethod: {
        value: 'changed_primary_2fa_method',
        label: 'Changed Primary 2FA method',
        activityLogMessage: 'Changed {type} #{typeId} Primary 2FA method to {method}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    finalizedTOTPSetup: {
        value: 'finalized_totp_setup',
        label: 'Finalized TOTP setup/reset',
        activityLogMessage: 'Finalized TOTP setup/reset',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    setFeeGroupForAccount: {
        value: 'set_fee_group_for_account',
        label: 'Set fee group for account',
        activityLogMessage: 'Set fee group for account from {oldFeeGroup} to {newFeeGroup}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    acceptApprovalRequest: {
        value: 'accept_approval_request',
        label: 'Accept Approval Request',
        activityLogMessage: 'Accept Approval Request',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectApprovalRequest: {
        value: 'reject_approval_request',
        label: 'Reject Approval Request',
        activityLogMessage: 'Reject Approval Request',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleExemptFromNbc: {
        value: 'toogle_exempt_from_nbc',
        label: 'Toggle Contract for exemption from Negative Balance Cover',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    vibanNameMismatchResolved: {
        value: 'viban_name_mismatch_revolved',
        label: 'Viban name mismatch revolved',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    createdAccountClosureFinalRemittanceApprovalRequest: {
        value: 'created_account_closure_final_remittance_approval_request',
        label: 'Created account closure final remittance approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approvedAccountClosureFinalRemittanceApprovalRequest: {
        value: 'approved_account_closure_final_remittance_approval_request',
        label: 'Approved account closure final remittance approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectedAccountClosureFinalRemittanceApprovalRequest: {
        value: 'rejected_account_closure_final_remittance_approval_request',
        label: 'Rejected account closure final remittance approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdManualAccountBookingApprovalRequest: {
        value: 'created_manual_account_booking_approval_request',
        label: 'Created manual account booking approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdCardAdjustmentTransactionApprovalRequest: {
        value: 'created_card_adj_transaction_approval_request',
        label: 'Created card adjustment transaction approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    executedCardAdjustmentTransactionApprovalRequest: {
        value: 'executed_card_adj_transaction_approval_request',
        label: 'Executed card adjustment transaction approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    approvedManualAccountBookingApprovalRequest: {
        value: 'approved_manual_account_booking_approval_request',
        label: 'Approved manual account booking approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectedManualAccountBookingApprovalRequest: {
        value: 'rejected_manual_account_booking_approval_request',
        label: 'Rejected manual account booking approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setHasPendingInvestigation: {
        value: 'set_has_pending_investigation',
        label: 'Flag a transaction for a pending AML investigation',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    changeIsSubjectToPrudentialRegulation: {
        value: 'change_is_subject_to_prudential_regulation',
        label: 'Change subject to prudential regulation',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changeHasProfessionalTreasuryDepartment: {
        value: 'change_has_professional_treasury_department',
        label: 'Change has professional treasury department',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    setDesignatedFeeAccount: {
        value: 'set_designated_fee_Account',
        label: 'Set Designated Fee Account',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changedContractRiskCategory: {
        value: 'changed_contract_risk_category',
        label: 'Changed Contract Risk Category',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    logUserLoggedIn: {
        value: 'log_user_logged_in',
        label: 'User logged in',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleTransactionReview: {
        value: 'toggle_transaction_review',
        label: 'Toggle Transaction Review',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    toggleForceHold: {
        value: 'toggle_force_hold',
        label: 'Toggle Force Hold',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    toggleClientSafeguardAccount: {
        value: 'toggle_client_safeguard_account',
        label: 'Toggle Client Safeguard Account',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    setUpLedgerDrain: {
        value: 'set_up_ledger_drain',
        label: 'Set up Ledger Drain',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    drainLedgerOnDemandDrain: {
        value: 'drain_ledger_on_demand',
        label: 'Set up Drain On Demand',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ledgerDrained: {
        value: 'ledger_drained',
        label: 'Ledger Drained',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleEntityReputationalRisk: {
        value: 'toggle_entity_reputational_risk',
        label: 'Toggle Reputational Risk',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    pinDocument: {
        value: 'pin_document',
        label: 'Pin Document',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    unPinDocument: {
        value: 'unpin_document',
        label: 'Unpin Document',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    transactionAdditionalInfoUpdated: {
        value: 'trx_additional_info_updated',
        label: 'Transaction Additional Info Updated',
        activityLogMessage: 'Additional Info Updated on #{transaction} \n Info: {additionalInfo}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    toggleEntityPublicInfo: {
        value: 'toggle_entity_public_info',
        label: 'Toggle Public Info',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    lockUnlockDocument: {
        value: 'lock_unlock_document',
        label: 'Lock Unlock Document',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createNewContractInformationRequest: {
        value: 'create_new_contract_information_request',
        label: 'New Contract Request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updatedContractInformationRequest: {
        value: 'update_contract_information_request',
        label: 'Contract Request Updated',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removedContractInformationRequest: {
        value: 'remove_contract_information_request',
        label: 'Contract Request Removed',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    markedUnMarkedContractAsKey: {
        value: 'mark_contract_as_key',
        label: 'Marked/Unmarked contract as key',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changedContractProducts: {
        value: 'changed_contract_products',
        label: 'Changed Contract Products',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedContractFinancialStatements: {
        value: 'changed_contract_financial_statements',
        label: 'Changed Contract Financial Statements',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedContracKycMeasures: {
        value: 'changed_contract_kyc_measures',
        label: 'Changed Contract KYC Measures',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateDedicatedAccountManager: {
        value: 'update_dedicated_account_manager',
        label: 'Updated Dedicated Account Manager',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    upsertContractContact: {
        value: 'upsert_contract_contact',
        label: 'Upsert Contract Contact',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    deleteContractContact: {
        value: 'delete_contract_contact',
        label: 'Delete Contract Contact',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    communicationStatusChanged: {
        value: 'communication_status_changed',
        label: 'Communication Status Changed',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    updateFundsType: {
        value: 'update_funds_type',
        label: 'Update funds type',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    addedLegalEntityDirector: {
        value: 'added_legal_entity_director',
        label: 'Added Legal Entity Director',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    updatedLegalEntityDirector: {
        value: 'updated_legal_entity_director',
        label: 'Updated Legal Entity Director',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removedLegalEntityDirector: {
        value: 'removed_legal_entity_director',
        label: 'Removed Legal Entity Director',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    upsertTag: {
        value: 'upsert_tag',
        label: 'Upsert Tag',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removeTag: {
        value: 'remove_tag',
        label: 'Remove Tag',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    upsertMinimumTurnover: {
        value: 'upsert_minimum_turnover',
        label: 'Modified minimum turnover',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removeMinimumTurnover: {
        value: 'remove_minimum_turnover',
        label: 'Removed minimum turnover',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    changeVerifiedPhone: {
        value: 'change_verified_phone',
        label: 'Change Verified Phone',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changeVerifiedEmail: {
        value: 'change_verified_email',
        label: 'Change Verified Email',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleOTPViaApi: {
        value: 'toggle_otp_via_api',
        label: 'toggle OTP Via Api',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    editContractTechnicalProperties: {
        value: 'edit_contract_technical_properties',
        label: 'Edit Contract Technical Properties',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    addContractTechnicalProperties: {
        value: 'add_contract_technical_properties',
        label: 'Add Contract Technical Properties',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    requestedTransferContractOwnership: {
        value: 'requested_transfer_contract_ownership',
        label: 'Requested Transfer Contract Ownership',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    processedTransferContractOwnership: {
        value: 'processed_transfer_contract_ownership',
        label: 'Processed Transfer Contract Ownership',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    toggleCrsReportable: {
        value: 'toggle_crs_reportable',
        label: 'Toggle CRS Reportable',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleFatcaReportable: {
        value: 'toggle_fatca_reportable',
        label: 'Toggle FATCA Reportable',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    editDocumentDetails: {
        value: 'edit_document_details',
        label: 'Edit Document Details',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdFeeReversalApprovalRequest: {
        value: 'created_fee_reversal_approval_request',
        label: 'Created fee reversal approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    createdVoidTransactionApprovalRequest: {
        value: 'created_void_trx_approval_request',
        label: 'Created void transaction approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    executedVoidTransactionApprovalRequest: {
        value: 'executed_void_trx_approval_request',
        label: 'Executed void transaction approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    executedFeeReversalApprovalRequest: {
        value: 'executed_fee_reversal_approval_request',
        label: 'Executed fee reversal approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    rejectedFeeReversalApprovalRequest: {
        value: 'rejected_fee_reversal_approval_request',
        label: 'Rejected fee reversal approval request',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    restrictAuthorizedPersonToAccounts: {
        value: 'restrictAuthorizedPersonToAccounts',
        label: 'Restrict Authorized Person To Accounts',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    removeRestrictAuthorizedPersonToAccounts: {
        value: 'removeRestrictAuthorizedPersonToAccounts',
        label: 'Remove Restrict Authorized Person To Accounts',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectDirectDebit: {
        value: 'reject_direct_debit',
        label: 'Reject Direct Debit',
        activityLogMessage: 'Rejected Direct Debit',
        activityLogShowReason: true,
        graphqlType: activityLogGraphqlTypes.withReasonLog,
    },
    createStandingOrder: {
        value: 'createStandingOrder',
        label: 'Create Standing Order',
        activityLogMessage: 'Create standing order',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cancelStandingOrder: {
        value: 'cancelStandingOrder',
        label: 'Cancel Standing Order',
        activityLogMessage: 'Cancel standing order',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cancelStandingOrderRejected: {
        value: 'cancel_standing_order_rejected',
        label: 'Cancel Standing Order Rejected',
        activityLogMessage: 'Cancellation of standing order was rejected',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createdQRBill: {
        value: 'created_QR_bill',
        label: 'Created QR bill',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    updatedSuccessFeePayout: {
        value: 'updated_success_fee_payout',
        label: 'Updated Success Fee Payout',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    executedSuccessFeePayout: {
        value: 'executed_success_fee_payout',
        label: 'Executed Success Fee Payout',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    rejectedSuccessFeePayout: {
        value: 'rejected_success_fee_payout',
        label: 'Rejected Success Fee Payout',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    recalculateContractSuccessFees: {
        value: 'recalculate_contract_success_fees',
        label: 'Recalculate Contract Success Fees',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toogleIsPep: {
        value: 'toogle_is_pep',
        label: 'Toggle is Pep',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changedTransactionCumulativeReviewStatus: {
        value: 'changed_trx_cumulative_review_status',
        label: 'Changed Transaction Cumulative Review Status',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    addIssueForAMLO: {
        value: 'addIssueForAMLO',
        label: 'Add Issue for AMLO check',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    markDocumentAsInternal: {
        value: 'mark_document_as_internal',
        label: 'Mark document as internal',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    unMarkDocumentAsInternal: {
        value: 'unmark_document_as_internal',
        label: 'Unmark document as internal',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setContractStatementDeliveryBic: {
        value: 'set_contract_statement_delivery_bic',
        label: 'Set Contract Statement Delivery BIC',
        activityLogMessage: "Changed Contract Statement Delivery BIC to '{bic}'",
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    setAccountDailyStatement: {
        value: 'set_account_daily_statement',
        label: 'Set Account Daily Statement',
        activityLogMessage: '{action} Account Daily Statement',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    pinnedAccount: {
        value: 'pinned_account',
        label: 'Pinned Account',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    unpinnedAccount: {
        value: 'unpinned_account',
        label: 'Unpinned Account',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    editPaymentCredentials: {
        value: 'edit_payment_credentials',
        label: 'Edit Payment Credentials',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    setDesignatedNbcAccount: {
        value: 'set_designated_nbc_account',
        label: 'Set Designated NBC Account',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    updateSpendingLimit: {
        value: 'update_spending_limit',
        label: 'Update Spending Limit',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    disputeDirectDebit: {
        value: 'dispute_direct_debit',
        label: 'Dispute Direct Debit',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    approvedDirectDebitDispute: {
        value: 'approved_direct_debit_dispute',
        label: 'Direct Debit Dispute Approved',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    rejectedDirectDebitDispute: {
        value: 'rejected_direct_debit_dispute',
        label: 'Direct Debit Dispute Rejected',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    completedSuccessFeePayout: {
        value: 'completed_success_fee_payout',
        label: 'Completed Success Fee Payout',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toogleAcknowledgedExpiredDocument: {
        value: 'toogle_acknowledged_expired_document',
        label: 'Toogle Acknowledged Expired Document',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    editedFeeGroup: {
        value: 'edited_fee_group',
        label: 'Edited Fee Group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.feeGroupLog,
    },
    clonedFeeGroup: {
        value: 'cloned_fee_group',
        label: 'Cloned Fee Group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.feeGroupLog,
    },
    updatedFeeGroupSetting: {
        value: 'updated_fee_group_setting',
        label: 'Updated Fee Group Setting',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.feeGroupLog,
    },
    directDebitBatchPaymentCreated: {
        value: 'direct_debit_batch_payment_created',
        label: 'Direct Debit Batch Created',
        activityLogMessage: 'Direct Debit Batch Created',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    directDebitBaymentExecuted: {
        value: 'direct_debit_batch_payment_executed',
        label: 'Direct Debit Batch Executed',
        activityLogMessage: 'Direct Debit Batch Executed',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    directDebitRevertRequest: {
        value: 'direct_debit_revert_request',
        label: 'Direct Debit Revert Request',
        activityLogMessage: 'Direct Debit Revert Request',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    changeSwiftConversationGeneralNote: {
        value: 'change_swift_conversation_general_note',
        label: 'Change Swift Conversation General Note',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateSwiftMessageAckStatus: {
        value: 'update_swift_message_ack_status',
        label: 'Update Swift Message Ack. Status',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    ipSrcTrackingInformation: {
        value: 'ip_src_tracking_information',
        label: 'IP Source tracking information',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    submitForPreAssessment: {
        value: 'submit_for_pre_assessment',
        label: 'Submit For Pre Assessment',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addEntityReminder: {
        value: 'add_entity_reminder',
        label: 'Add entity reminder',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    deleteEntityReminder: {
        value: 'delete_entity_reminder',
        label: 'Delete entity reminder',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleAllowInternalOnly: {
        value: 'toggle_allow_internal_only',
        label: 'Toggle Allow Internal Only',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    downloadIbanCertificate: {
        value: 'download_iban_certificate',
        label: 'Download IBAN Certificate',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    trustedDevice: {
        value: 'trusted_device',
        label: 'Client trusted new device',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    cryptoWalletLinkedToContract: {
        value: 'crypto_wallet_linked_to_contract',
        label: 'Crypto Wallet Linked To Contract',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    updatedCryptoWallet: {
        value: 'updated_crypto_wallet',
        label: 'Updated Crypto Wallet',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    userUpdatedCryptoWallet: {
        value: 'user_updated_crypto_wallet',
        label: 'User Updated Crypto Wallet',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    executedCryptoTransaction: {
        value: 'executed_crypto_transaction',
        label: 'Executed Crypto Transaction',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    cryptoTransactionConfirmed: {
        value: 'crypto_transaction_confirmed',
        label: 'Crypto Transaction Confirmed',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    exchangedCryptoTransaction: {
        value: 'exchanged_crypto_transaction',
        label: 'Exchanged Crypto Transaction',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    toggleCryptoPayments: {
        value: 'toggle_crypto_payments',
        label: 'Toggle Crypto Payments',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    generateContractAccountsConfirmation: {
        value: 'generate_contract_account_confirmation',
        label: 'Generate Contract Accounts Confirmation',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    transactionRequestClearedForAML: {
        value: 'trx_request_cleared_for_aml',
        label: 'Transaction Request Cleared For AML',
        activityLogMessage: 'Transaction Request Cleared For AML #{transaction} \n {note}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    createCustomerRequestForWallet: {
        value: 'create_customer_request_for_wallet',
        label: 'Create Customer Request for Wallet',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    transactionRequestRejected: {
        value: 'trx_request_rejected',
        label: 'Transaction Request Rejected',
        activityLogMessage: 'Transaction Request #{transaction} Rejected \n {note}',
        graphqlType: activityLogGraphqlTypes.transactionLog,
    },
    addedAccountBundle: {
        value: 'added_account_bundle',
        label: 'Added account bundle',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removedAccountBundle: {
        value: 'removed_account_bundle',
        label: 'Removed account bundle',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    renamedAccountBundle: {
        value: 'renamed_account_bundle',
        label: 'Renamed account bundle',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    addedAccountToBundle: {
        value: 'added_account_to_bundle',
        label: 'Added account to bundle',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    removedAccountFromBundle: {
        value: 'removed_account_from_bundle',
        label: 'Removed account from bundle',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.accountLog,
    },
    toggleCcDedicatedAcm: {
        value: 'toggle_cc_dedicated_acm',
        label: 'Toggle CC Dedicated Acm in Email Requests',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addIssueForPeriodicReview: {
        value: 'add_issue_for_periodic_review',
        label: 'Add Issue for Periodic Review check',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    addedContractGroup: {
        value: 'added_contract_group',
        label: 'Added contract group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    updatedContractGroup: {
        value: 'updated_contract_group',
        label: 'Updated contract group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removedContractGroup: {
        value: 'removed_contract_group',
        label: 'Removed contract group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    removedContractFromGroup: {
        value: 'removed_contract_from_group',
        label: 'Removed contract from contract group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    addContractToGroup: {
        value: 'add_contract_to_group',
        label: 'Add contract to contract group',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.contractLog,
    },
    approvalRequestRejected: {
        value: 'approval_request_rejected',
        label: 'Approval Request Rejected',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createCustomerRequestForAccountOpening: {
        value: 'create_customer_request_for_account_opening',
        label: 'Create Customer Request for Account Opening',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createCustomerRequestForSwiftThread: {
        value: 'create_customer_request_for_swift_thread',
        label: 'Create Customer Request for Swift Thread',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    setContractAutoApprovalCheckStatuses: {
        value: 'set_contract_auto_approval_check_statuses',
        label: 'Set Contract Auto Approval Check Statuses',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    mobileLogin: {
        value: 'mobile_login',
        label: 'Mobile Login',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    mobileActivateDevice: {
        value: 'mobile_activate_device',
        label: 'Mobile Activate Device',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    mobileDeleteDevice: {
        value: 'mobile_delete_device',
        label: 'Mobile Delete Device',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    toggleMobilePreferences: {
        value: 'toggle_mobile_preferences',
        label: 'Toggle Mobile Preferences',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    createCustomerRequestForPendingInvitation: {
        value: 'create_customer_request_for_pending_nvitation',
        label: 'Create Customer Request for Pending Invitation',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
    updateFCMToken: {
        value: 'update_fcm_token',
        label: 'Update FCM Token',
        activityLogMessage: '{message}',
        graphqlType: activityLogGraphqlTypes.genericLog,
    },
});

const monitoringAlertStatuses = asEnum({
    closedAsFalsePositive: {
        label: 'Closed as False Positive',
        value: 'CLOSED_AS_FALSE_POSITIVE',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    truePositive: {
        label: 'True Positive',
        value: 'TRUE_POSITIVE',
        labelIndicator: LabelIndicator.ERROR,
    },
    closedAsTruePositive: {
        label: 'Closed as True Positive',
        value: 'CLOSED_AS_TRUE_POSITIVE',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    escalated: {
        label: 'Escalated',
        value: 'ESCALATED',
        labelIndicator: LabelIndicator.ERROR,
    },
    filtered: {
        label: 'Filtered',
        value: 'FILTERED',
        labelIndicator: LabelIndicator.WARNING,
    },
    inspection: {
        label: 'Inspection',
        value: 'INSPECTION',
        labelIndicator: LabelIndicator.WARNING,
    },
    new: {
        label: 'New',
        value: 'NEW',
        labelIndicator: LabelIndicator.INFO,
    },
    sanctionNotApplicable: {
        label: 'Sanction Not Applicable',
        value: 'SANCTION_NOT_APPLICABLE',
        labelIndicator: LabelIndicator.INFO,
    },
    pending: {
        label: 'Pending',
        value: 'PENDING',
        labelIndicator: LabelIndicator.WARNING,
    },
});
const monitoringAlertPriorities = asEnum({
    none: {
        label: 'None',
        value: 'NONE',
        labelIndicator: LabelIndicator.INFO,
    },
    low: {
        label: 'Low',
        value: 'LOW',
        labelIndicator: LabelIndicator.INFO,
    },
    normal: {
        label: 'Normal',
        value: 'NORMAL',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    high: {
        label: 'High',
        value: 'HIGH',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const monitoringAlertScenarios = asEnum({
    online: {
        label: 'Online',
        value: 'ONLINE',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    offline: {
        label: 'Offline',
        value: 'OFFLINE',
        labelIndicator: LabelIndicator.WARNING,
    },
    periodic: {
        label: 'Periodic',
        value: 'PERIODIC',
        labelIndicator: LabelIndicator.INFO,
    },
});
const salvStatuses = asEnum({
    none: {
        label: 'None',
        value: 'NONE',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    new: {
        label: 'New',
        value: 'NEW',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    monitoring: {
        label: 'Monitoring',
        value: 'MONITORING',
        labelIndicator: LabelIndicator.WARNING,
    },
    reviewed: {
        label: 'Reviewed',
        value: 'REVIEWED',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    suspended: {
        label: 'Suspended',
        value: 'SUSPENDED',
        labelIndicator: LabelIndicator.ERROR,
    },
    suspendedAndReported: {
        label: 'Suspended and Reported',
        value: 'SUSPENDED_AND_REPORTED',
        labelIndicator: LabelIndicator.ERROR,
    },
    terminated: {
        label: 'Terminated',
        value: 'TERMINATED',
        labelIndicator: LabelIndicator.ERROR,
    },
    terminatedAndReported: {
        label: 'Terminated And Reported',
        value: 'TERMINATED_AND_REPORTED',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});

const businessTypeRiskCategories = asLocalizedEnum('businessTypeRiskCategories', {
    low: {
        value: 'low',
        label: 'Low',
    },
    normal: {
        value: 'normal',
        label: 'Normal',
    },
    high: {
        value: 'high',
        label: 'High',
    },
    reject: {
        value: 'reject',
        label: 'UH-Reject',
    },
});
const industries = asLocalizedEnum('industries', {
    AccountingBookkeepingServices: {
        value: 'accounting_bookkeeping_services',
        label: 'Accounting/Bookkeeping Services',
    },
    AdultContent: {
        value: 'adult_content',
        label: 'Adult Content',
    },
    AdvertisingServices: {
        value: 'advertising_services',
        label: 'Advertising Services',
    },
    BettingCasinoGambling: {
        value: 'betting_casino_gambling',
        label: 'Betting/Casino Gambling',
    },
    Charity: {
        value: 'charity',
        label: 'Charitable and Social Service Organizations',
    },
    ComputerProgramming: {
        value: 'computer_programming',
        label: 'Computer Programming',
    },
    DatingServices: {
        value: 'dating_services',
        label: 'Dating Platform',
    },
    EscortServices: {
        value: 'escort_services',
        label: 'Escort Services',
    },
    DigitalGoodsGames: {
        value: 'digital_goods_games',
        label: 'Digital Goods - Games',
    },
    DrugStoresPharmacies: {
        value: 'drug_stores_pharmacies',
        label: 'Drug Stores and Pharmacies',
    },
    EducationalServices: {
        value: 'educational_services',
        label: 'Educational Services',
    },
    EmploymentTempAgencies: {
        value: 'employment_emp_agencies',
        label: 'Employment Temp Agencies',
    },
    FinancialInstitution: {
        value: 'financial_institution',
        label: 'Financial institution',
    },
    OnlineMerchants: {
        value: 'online_merchants',
        label: 'Online Merchants',
    },
    PaymentManagementServices: {
        value: 'payment_management_services',
        label: 'Payment management services',
    },
    ProfessionalServices: {
        value: 'professional_services',
        label: 'Professional Services',
    },
    Recreational: {
        value: 'recreational',
        label: 'Recreational',
    },
});
const sanctionedIndustries = asEnum({
    weaponsAndDefense: {
        value: 'weaponsAndDefense',
        label: 'Weapons and Defense',
    },
    airAndSpace: {
        value: 'airAndSpace',
        label: 'Air and Space',
    },
    highSeaNavigation: {
        value: 'highSeaNavigation',
        label: 'High Sea Navigation',
    },
    oilAndEnergy: {
        value: 'oilAndEnergy',
        label: 'Oil and Energy',
    },
    luxuryAndHighValueGoods: {
        value: 'luxuryAndHighValueGoods',
        label: 'Luxury and High-Value Goods',
    },
    cryptocurrencyAndVirtualAssets: {
        value: 'cryptocurrencyAndVirtualAssets',
        label: 'Cryptocurrency and Virtual Assets',
    },
    militarySecurityAndPoliceRelatedBusinesses: {
        value: 'militarySecurityAndPoliceRelatedBusinesses',
        label: 'Military, Security, and Police-Related Businesses',
    },
    advancedICT: {
        value: 'advancedICT',
        label: 'Advanced ICT',
    },
    culturalHistoricalAndArchaeologicalArtifacts: {
        value: 'culturalHistoricalAndArchaeologicalArtifacts',
        label: 'Cultural, Historical, and Archaeological Artifacts',
    },
    intellectualProperty: {
        value: 'intellectualProperty',
        label: 'Intellectual Property',
    },
    marketing: {
        value: 'marketing',
        label: 'Marketing',
    },
    notApplicable: {
        value: 'notApplicable',
        label: 'Not Applicable',
    },
    financialInstruments: {
        value: 'financialInstruments',
        label: 'High-Risk Financial Instruments and Investments',
    },
});
const businessCategoriesTypes = asLocalizedEnum('businessCategoriesTypes', {
    VirtualAssetsCryptoCurrencies: {
        value: 'virtual_assets_crypto_currencies',
        label: 'Virtual Currency / Crypto Assets provider',
        merchantCategoryCode: 6051,
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
        sanctionedIndustry: sanctionedIndustries.cryptocurrencyAndVirtualAssets,
    },
    AcRefrigerationRepair: {
        value: 'ac_refrigeration_repair',
        label: 'A/C, Refrigeration Repair',
        merchantCategoryCode: 7623,
        available: false,
    },
    AccountingBookkeepingServices: {
        value: 'accounting_bookkeeping_services',
        label: 'Accounting/Bookkeeping Services',
        merchantCategoryCode: 8931,
        available: true,
        industry: industries.AccountingBookkeepingServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    AdultContent: {
        value: 'adult_content',
        label: 'Adult Content',
        merchantCategoryCode: 7273,
        available: true,
        industry: industries.AdultContent,
        riskCategory: businessTypeRiskCategories.high,
    },
    AdvertisingServices: {
        value: 'advertising_services',
        label: 'Advertising platforms',
        merchantCategoryCode: 7311,
        available: true,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.low,
        sanctionedIndustry: sanctionedIndustries.marketing,
    },
    AgriculturalCooperative: {
        value: 'agricultural_cooperative',
        label: 'Agricultural Cooperative',
        merchantCategoryCode: 763,
        available: false,
    },
    AirlinesAirCarriers: {
        value: 'airlines_air_carriers',
        label: 'Airlines: Air Carriers',
        merchantCategoryCode: 4511,
        available: false,
    },
    AirportsFlyingFields: {
        value: 'airports_flying_fields',
        label: 'Airports: Flying Fields',
        merchantCategoryCode: 4582,
        available: false,
    },
    AmbulanceServices: {
        value: 'ambulance_services',
        label: 'Ambulance Services',
        merchantCategoryCode: 4119,
        available: false,
    },
    AmusementParksCarnivals: {
        value: 'amusement_parks_carnivals',
        label: 'Amusement Parks/Carnivals',
        merchantCategoryCode: 7996,
        available: false,
    },
    AntiqueReproductions: {
        value: 'antique_reproductions',
        label: 'Antique Reproductions',
        merchantCategoryCode: 5937,
        available: false,
    },
    AntiqueShops: {
        value: 'antique_shops',
        label: 'Antique Shops',
        merchantCategoryCode: 5932,
        available: false,
    },
    Aquariums: {
        value: 'aquariums',
        label: 'Aquariums',
        merchantCategoryCode: 7998,
        available: false,
    },
    ArchitecturalSurveyingServices: {
        value: 'architectural_surveying_services',
        label: 'Architectural/Surveying Services',
        merchantCategoryCode: 8911,
        available: false,
    },
    ArtDealersAndGalleries: {
        value: 'art_dealers_and_galleries',
        label: 'Art Dealers and Galleries',
        merchantCategoryCode: 5971,
        available: false,
    },
    ArtistsSupplyAndCraftShops: {
        value: 'artists_supply_and_craft_shops',
        label: 'Artists Supply and Craft Shops',
        merchantCategoryCode: 5970,
        available: false,
    },
    AutoBodyRepairShops: {
        value: 'auto_body_repair_shops',
        label: 'Auto Body Repair Shops',
        merchantCategoryCode: 7531,
        available: false,
    },
    AutoPaintShops: {
        value: 'auto_paint_shops',
        label: 'Auto Paint Shops',
        merchantCategoryCode: 7535,
        available: false,
    },
    AutoServiceShops: {
        value: 'auto_service_shops',
        label: 'Auto Service Shops',
        merchantCategoryCode: 7538,
        available: false,
    },
    AutoAndHomeSupplyStores: {
        value: 'auto_and_home_supply_stores',
        label: 'Auto and Home Supply Stores',
        merchantCategoryCode: 5531,
        available: false,
    },
    AutomatedCashDisburse: {
        value: 'automated_cash_disburse',
        label: 'Automated Cash Disburse',
        merchantCategoryCode: 6011,
        available: false,
    },
    AutomatedFuelDispensers: {
        value: 'automated_fuel_dispensers',
        label: 'Automated Fuel Dispensers',
        merchantCategoryCode: 5542,
        available: false,
    },
    AutomobileAssociations: {
        value: 'automobile_associations',
        label: 'Automobile Associations',
        merchantCategoryCode: 8675,
        available: false,
    },
    AutomotivePartsAndAccessoriesStores: {
        value: 'automotive_parts_and_accessories_stores',
        label: 'Automotive Parts and Accessories Stores',
        merchantCategoryCode: 5533,
        available: false,
    },
    AutomotiveTireStores: {
        value: 'automotive_tire_stores',
        label: 'Automotive Tire Stores',
        merchantCategoryCode: 5532,
        available: false,
    },
    BailAndBondPayments: {
        value: 'bail_and_bond_payments',
        label: 'Bail and Bond Payments (payment to the surety for the bond: not the actual bond paid to the government agency)',
        merchantCategoryCode: 9223,
        available: false,
    },
    Bakeries: {
        value: 'bakeries',
        label: 'Bakeries',
        merchantCategoryCode: 5462,
        available: false,
    },
    BandsOrchestras: {
        value: 'bands_orchestras',
        label: 'Bands: Orchestras',
        merchantCategoryCode: 7929,
        available: false,
    },
    BarberAndBeautyShops: {
        value: 'barber_and_beauty_shops',
        label: 'Barber and Beauty Shops',
        merchantCategoryCode: 7230,
        available: false,
    },
    BettingCasinoGambling: {
        value: 'betting_casino_gambling',
        label: 'Betting/Casino Gambling',
        merchantCategoryCode: 7995,
        available: false,
    },
    BicycleShops: {
        value: 'bicycle_shops',
        label: 'Bicycle Shops',
        merchantCategoryCode: 5940,
        available: false,
    },
    BilliardPoolEstablishments: {
        value: 'billiard_pool_establishments',
        label: 'Billiard/Pool Establishments',
        merchantCategoryCode: 7932,
        available: false,
    },
    BoatDealers: {
        value: 'boat_dealers',
        label: 'Boat Dealers',
        merchantCategoryCode: 5551,
        available: false,
    },
    BoatRentalsAndLeases: {
        value: 'boat_rentals_and_leases',
        label: 'Boat Rentals and Leases',
        merchantCategoryCode: 4457,
        available: false,
    },
    BookStores: {
        value: 'book_stores',
        label: 'Book Stores',
        merchantCategoryCode: 5942,
        available: false,
    },
    BooksPeriodicalsAndNewspapers: {
        value: 'books_periodicals_and_newspapers',
        label: 'Books: Periodicals: and Newspapers',
        merchantCategoryCode: 5192,
        available: false,
    },
    BowlingAlleys: {
        value: 'bowling_alleys',
        label: 'Bowling Alleys',
        merchantCategoryCode: 7933,
        available: false,
    },
    BusLines: {
        value: 'bus_lines',
        label: 'Bus Lines',
        merchantCategoryCode: 4131,
        available: false,
    },
    BusinessSecretarialSchools: {
        value: 'business_secretarial_schools',
        label: 'Business/Secretarial Schools',
        merchantCategoryCode: 8244,
        available: false,
    },
    BuyingShoppingServices: {
        value: 'buying_shopping_services',
        label: 'Buying/Shopping Services',
        merchantCategoryCode: 7278,
        available: false,
    },
    CableSatelliteAndOtherPayTelevisionAndRadio: {
        value: 'cable_satellite_and_other_pay_television_and_radio',
        label: 'Cable: Satellite: and Other Pay Television and Radio',
        merchantCategoryCode: 4899,
        available: false,
    },
    CameraAndPhotographicSupplyStores: {
        value: 'camera_and_photographic_supply_stores',
        label: 'Camera and Photographic Supply Stores',
        merchantCategoryCode: 5946,
        available: false,
    },
    CandyNutAndConfectioneryStores: {
        value: 'candy_nut_and_confectionery_stores',
        label: 'Candy: Nut: and Confectionery Stores',
        merchantCategoryCode: 5441,
        available: false,
    },
    CarRentalAgencies: {
        value: 'car_rental_agencies',
        label: 'Car Rental Agencies',
        merchantCategoryCode: 7512,
        available: false,
    },
    CarWashes: {
        value: 'car_washes',
        label: 'Car Washes',
        merchantCategoryCode: 7542,
        available: false,
    },
    CarAndTruckDealersNewUsed: {
        value: 'car_and_truck_dealers_new_used',
        label: 'Car and Truck Dealers (New & Used) Sales: Service: Repairs Parts and Leasing',
        merchantCategoryCode: 5511,
        available: false,
    },
    CarAndTruckDealersUsedOnly: {
        value: 'car_and_truck_dealers_used_only',
        label: 'Car and Truck Dealers (Used Only) Sales: Service: Repairs Parts and Leasing',
        merchantCategoryCode: 5521,
        available: false,
    },
    CarpentryServices: {
        value: 'carpentry_services',
        label: 'Carpentry Services',
        merchantCategoryCode: 1750,
        available: false,
    },
    CarpetUpholsteryCleaning: {
        value: 'carpet_upholstery_cleaning',
        label: 'Carpet/Upholstery Cleaning',
        merchantCategoryCode: 7217,
        available: false,
    },
    Caterers: {
        value: 'caterers',
        label: 'Caterers',
        merchantCategoryCode: 5811,
        available: false,
    },
    CharitableAndSocialServiceOrganizationsFundraising: {
        value: 'charitable_and_social_service_organizations_fundraising',
        label: 'Charitable and Social Service Organizations - Fundraising',
        merchantCategoryCode: 8398,
        available: false,
    },
    ChemicalsAndAlliedProducts: {
        value: 'chemicals_and_allied_products',
        label: 'Chemicals and Allied Products (Not Elsewhere Classified)',
        merchantCategoryCode: 5169,
        available: false,
    },
    ChildCareServices: {
        value: 'child_care_services',
        label: 'Child Care Services',
        merchantCategoryCode: 8351,
        available: false,
    },
    ChildrensAndInfantsWearStores: {
        value: 'childrens_and_infants_wear_stores',
        label: 'Childrens and Infants Wear Stores',
        merchantCategoryCode: 5641,
        available: false,
    },
    ChiropodistsPodiatrists: {
        value: 'chiropodists_podiatrists',
        label: 'Chiropodists: Podiatrists',
        merchantCategoryCode: 8049,
        available: false,
    },
    Chiropractors: {
        value: 'chiropractors',
        label: 'Chiropractors',
        merchantCategoryCode: 8041,
        available: false,
    },
    CigarStoresAndStands: {
        value: 'cigar_stores_and_stands',
        label: 'Cigar Stores and Stands',
        merchantCategoryCode: 5993,
        available: false,
    },
    CivicSocialFraternalAssociations: {
        value: 'civic_social_fraternal_associations',
        label: 'Civic: Social: Fraternal Associations',
        merchantCategoryCode: 8641,
        available: false,
    },
    CleaningAndMaintenance: {
        value: 'cleaning_and_maintenance',
        label: 'Cleaning and Maintenance',
        merchantCategoryCode: 7349,
        available: false,
    },
    ClothingRental: {
        value: 'clothing_rental',
        label: 'Clothing Rental',
        merchantCategoryCode: 7296,
        available: false,
    },
    CollegesUniversities: {
        value: 'colleges_universities',
        label: 'Colleges: Universities',
        merchantCategoryCode: 8220,
        available: false,
    },
    CommercialEquipment: {
        value: 'commercial_equipment',
        label: 'Commercial Equipment (Not Elsewhere Classified)',
        merchantCategoryCode: 5046,
        available: false,
    },
    CommercialFootwear: {
        value: 'commercial_footwear',
        label: 'Commercial Footwear',
        merchantCategoryCode: 5139,
        available: false,
    },
    CommercialPhotographyArtAndGraphics: {
        value: 'commercial_photography_art_and_graphics',
        label: 'Commercial Photography: Art and Graphics',
        merchantCategoryCode: 7333,
        available: false,
    },
    CommuterTransportAndFerries: {
        value: 'commuter_transport_and_ferries',
        label: 'Commuter Transport: Ferries',
        merchantCategoryCode: 4111,
        available: false,
    },
    ComputerNetworkServices: {
        value: 'computer_network_services',
        label: 'Computer Network Services',
        merchantCategoryCode: 4816,
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.high,
    },
    ComputerProgramming: {
        value: 'computer_programming',
        label: 'Computer Programming',
        merchantCategoryCode: 7372,
        available: false,
    },
    ComputerRepair: {
        value: 'computer_repair',
        label: 'Computer Repair',
        merchantCategoryCode: 7379,
        available: false,
    },
    ComputerSoftwareStores: {
        value: 'computer_software_stores',
        label: 'Computer Software Stores',
        merchantCategoryCode: 5734,
        available: false,
    },
    ComputersPeripheralsAndSoftware: {
        value: 'computers_peripherals_and_software',
        label: 'Computers: Peripherals: and Software',
        merchantCategoryCode: 5045,
        available: false,
    },
    ConcreteWorkServices: {
        value: 'concrete_work_services',
        label: 'Concrete Work Services',
        merchantCategoryCode: 1771,
        available: false,
    },
    ConstructionMaterials: {
        value: 'construction_materials',
        label: 'Construction Materials (Not Elsewhere Classified)',
        merchantCategoryCode: 5039,
        available: false,
    },
    ConsultingPublicRelations: {
        value: 'consulting_public_relations',
        label: 'Public Relations Services',
        merchantCategoryCode: 7392,
        available: true,
        industry: industries.AdvertisingServices,
    },
    CorrespondenceSchools: {
        value: 'correspondence_schools',
        label: 'Correspondence Schools',
        merchantCategoryCode: 8241,
        available: false,
    },
    CosmeticStores: {
        value: 'cosmetic_stores',
        label: 'Cosmetic Stores',
        merchantCategoryCode: 5977,
        available: false,
    },
    CounselingServices: {
        value: 'counseling_services',
        label: 'Counseling Services',
        merchantCategoryCode: 7277,
        available: false,
    },
    CountryClubs: {
        value: 'country_clubs',
        label: 'Country Clubs',
        merchantCategoryCode: 7997,
        available: false,
    },
    CourierServices: {
        value: 'courier_services',
        label: 'Logistics/ courier services',
        merchantCategoryCode: 4215,
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.normal,
    },
    CourtCosts: {
        value: 'court_costs',
        label: 'Court Costs: Including Alimony and Child Support - Courts of Law',
        merchantCategoryCode: 9211,
        available: false,
    },
    CreditReportingAgencies: {
        value: 'credit_reporting_agencies',
        label: 'Credit Reporting Agencies',
        merchantCategoryCode: 7321,
        available: false,
    },
    CruiseLines: {
        value: 'cruise_lines',
        label: 'Cruise Lines',
        merchantCategoryCode: 4411,
        available: false,
    },
    DairyProductsStores: {
        value: 'dairy_products_stores',
        label: 'Dairy Products Stores',
        merchantCategoryCode: 5451,
        available: false,
    },
    DanceHallStudiosSchools: {
        value: 'dance_hall_studios_schools',
        label: 'Dance Hall: Studios: Schools',
        merchantCategoryCode: 7911,
        available: false,
    },
    DatingEscortServices: {
        value: 'dating_escort_services',
        label: 'Dating Platforms',
        merchantCategoryCode: 7273,
        available: false,
    },
    EscortServices: {
        value: 'escort_services',
        label: 'Escort Services',
        merchantCategoryCode: 7273,
        available: false,
    },
    DentistsOrthodontists: {
        value: 'dentists_orthodontists',
        label: 'Dentists: Orthodontists',
        merchantCategoryCode: 8021,
        available: false,
    },
    DepartmentStores: {
        value: 'department_stores',
        label: 'Department Stores',
        merchantCategoryCode: 5311,
        available: false,
    },
    DetectiveAgencies: {
        value: 'detective_agencies',
        label: 'Detective Agencies',
        merchantCategoryCode: 7393,
        available: false,
    },
    DigitalGoodsMedia: {
        value: 'digital_goods_media',
        label: 'Digital Goods Media – Books: Movies: Music',
        merchantCategoryCode: 5815,
        available: false,
    },
    DigitalGoodsApplications: {
        value: 'digital_goods_applications',
        label: 'Digital Goods – Applications (Excludes Games)',
        merchantCategoryCode: 5817,
        available: false,
    },
    DigitalGoodsGames: {
        value: 'digital_goods_games',
        label: 'Digital Goods – Games',
        merchantCategoryCode: 5816,
        available: false,
    },
    DigitalGoodsLargeVolume: {
        value: 'digital_goods_large_volume',
        label: 'Digital Goods – Large Digital Goods Merchant',
        merchantCategoryCode: 5818,
        available: false,
    },
    DirectMarketingCatalogMerchant: {
        value: 'direct_marketing_catalog_merchant',
        label: 'Direct Marketing - Catalog Merchant',
        merchantCategoryCode: 5964,
        available: false,
    },
    DirectMarketingCombinationCatalogAndRetailMerchant: {
        value: 'direct_marketing_combination_catalog_and_retail_merchant',
        label: 'Direct Marketing - Combination Catalog and Retail Merchant',
        merchantCategoryCode: 5965,
        available: false,
    },
    DirectMarketingInboundTelemarketing: {
        value: 'direct_marketing_inbound_telemarketing',
        label: 'Direct Marketing - Inbound Telemarketing',
        merchantCategoryCode: 5967,
        available: false,
    },
    DirectMarketingInsuranceServices: {
        value: 'direct_marketing_insurance_services',
        label: 'Direct Marketing - Insurance Services',
        merchantCategoryCode: 5960,
        available: false,
    },
    DirectMarketingOther: {
        value: 'direct_marketing_other',
        label: 'Direct Marketing - Other',
        merchantCategoryCode: 5969,
        available: false,
    },
    DirectMarketingOutboundTelemarketing: {
        value: 'direct_marketing_outbound_telemarketing',
        label: 'Direct Marketing - Outbound Telemarketing',
        merchantCategoryCode: 5966,
        available: false,
    },
    DirectMarketingSubscription: {
        value: 'direct_marketing_subscription',
        label: 'Direct Marketing - Subscription',
        merchantCategoryCode: 5968,
        available: false,
    },
    DirectMarketingTravel: {
        value: 'direct_marketing_travel',
        label: 'Direct Marketing - Travel',
        merchantCategoryCode: 5962,
        available: false,
    },
    DiscountStores: {
        value: 'discount_stores',
        label: 'Discount Stores',
        merchantCategoryCode: 5310,
        available: false,
    },
    Doctors: {
        value: 'doctors',
        label: 'Doctors',
        merchantCategoryCode: 8011,
        available: false,
    },
    DoorToDoorSales: {
        value: 'door_to_door_sales',
        label: 'Door-To-Door Sales',
        merchantCategoryCode: 5963,
        available: false,
    },
    DraperyWindowCoveringAndUpholsteryStores: {
        value: 'drapery_window_covering_and_upholstery_stores',
        label: 'Drapery: Window Covering: and Upholstery Stores',
        merchantCategoryCode: 5714,
        available: false,
    },
    DrinkingPlaces: {
        value: 'drinking_places',
        label: 'Drinking Places',
        merchantCategoryCode: 5813,
        available: false,
    },
    DrugStoresAndPharmacies: {
        value: 'drug_stores_and_pharmacies',
        label: 'Drug Stores and Pharmacies',
        merchantCategoryCode: 5912,
        available: false,
    },
    DrugsDrugProprietariesAndDruggistSundries: {
        value: 'drugs_drug_proprietaries_and_druggist_sundries',
        label: 'Drugs: Drug Proprietaries: and Druggist Sundries',
        merchantCategoryCode: 5122,
        available: false,
    },
    DryCleaners: {
        value: 'dry_cleaners',
        label: 'Dry Cleaners',
        merchantCategoryCode: 7216,
        available: false,
    },
    DurableGoods: {
        value: 'durable_goods',
        label: 'Durable Goods (Not Elsewhere Classified)',
        merchantCategoryCode: 5099,
        available: false,
    },
    DutyFreeStores: {
        value: 'duty_free_stores',
        label: 'Duty Free Stores',
        merchantCategoryCode: 5309,
        available: false,
    },
    EatingPlacesRestaurants: {
        value: 'eating_places_restaurants',
        label: 'Eating Places: Restaurants',
        merchantCategoryCode: 5812,
        available: false,
    },
    EducationalServices: {
        value: 'educational_services',
        label: 'Educational Services',
        merchantCategoryCode: 8299,
        available: false,
    },
    ElectricRazorStores: {
        value: 'electric_razor_stores',
        label: 'Electric Razor Stores',
        merchantCategoryCode: 5997,
        available: false,
    },
    ElectricalPartsAndEquipment: {
        value: 'electrical_parts_and_equipment',
        label: 'Electrical Parts and Equipment',
        merchantCategoryCode: 5065,
        available: false,
    },
    ElectricalServices: {
        value: 'electrical_services',
        label: 'Electrical Services',
        merchantCategoryCode: 1731,
        available: false,
    },
    ElectronicsRepairShops: {
        value: 'electronics_repair_shops',
        label: 'Electronics Repair Shops',
        merchantCategoryCode: 7622,
        available: false,
    },
    ElectronicsStores: {
        value: 'electronics_stores',
        label: 'Electronics Stores',
        merchantCategoryCode: 5732,
        available: false,
    },
    ElementarySecondarySchools: {
        value: 'elementary_secondary_schools',
        label: 'Elementary: Secondary Schools',
        merchantCategoryCode: 8211,
        available: false,
    },
    EmploymentTempAgencies: {
        value: 'employment_temp_agencies',
        label: 'Employment/Temp Agencies',
        merchantCategoryCode: 7361,
        available: false,
    },
    EquipmentRental: {
        value: 'equipment_rental',
        label: 'Equipment Rental',
        merchantCategoryCode: 7394,
        available: false,
    },
    ExterminatingServices: {
        value: 'exterminating_services',
        label: 'Exterminating Services',
        merchantCategoryCode: 7342,
        available: false,
    },
    FamilyClothingStores: {
        value: 'family_clothing_stores',
        label: 'Family Clothing Stores',
        merchantCategoryCode: 5651,
        available: false,
    },
    FastFoodRestaurants: {
        value: 'fast_food_restaurants',
        label: 'Fast Food Restaurants',
        merchantCategoryCode: 5814,
        available: false,
    },
    FinancialInstitutions: {
        value: 'financial_institutions',
        label: 'Financial Institutions',
        merchantCategoryCode: 6012,
        available: false,
    },
    FinesGovernmentAdministrativeEntities: {
        value: 'fines_government_administrative_entities',
        label: 'Fines - Government Administrative Entities',
        merchantCategoryCode: 9222,
        available: false,
    },
    FireplaceFireplaceScreensAndAccessoriesStores: {
        value: 'fireplace_fireplace_screens_and_accessories_stores',
        label: 'Fireplace: Fireplace Screens: and Accessories Stores',
        merchantCategoryCode: 5718,
        available: false,
    },
    FloorCoveringStores: {
        value: 'floor_covering_stores',
        label: 'Floor Covering Stores',
        merchantCategoryCode: 5713,
        available: false,
    },
    Florists: {
        value: 'florists',
        label: 'Florists',
        merchantCategoryCode: 5992,
        available: false,
    },
    FloristsSuppliesNurseryStockAndFlowers: {
        value: 'florists_supplies_nursery_stock_and_flowers',
        label: 'Florists Supplies: Nursery Stock: and Flowers',
        merchantCategoryCode: 5193,
        available: false,
    },
    FreezerAndLockerMeatProvisioners: {
        value: 'freezer_and_locker_meat_provisioners',
        label: 'Freezer and Locker Meat Provisioners',
        merchantCategoryCode: 5422,
        available: false,
    },
    FuelDealersNonAutomotive: {
        value: 'fuel_dealers_non_automotive',
        label: 'Fuel Dealers (Non Automotive)',
        merchantCategoryCode: 5983,
        available: false,
    },
    FuneralServicesCrematories: {
        value: 'funeral_services_crematories',
        label: 'Funeral Services: Crematories',
        merchantCategoryCode: 7261,
        available: false,
    },
    FurnitureRepairRefinishing: {
        value: 'furniture_repair_refinishing',
        label: 'Furniture Repair: Refinishing',
        merchantCategoryCode: 7641,
        available: false,
    },
    FurnitureHomeFurnishingsAndEquipmentStoresExceptAppliances: {
        value: 'furniture_home_furnishings_and_equipment_stores_except_appliances',
        label: 'Furniture: Home Furnishings: and Equipment Stores: Except Appliances',
        merchantCategoryCode: 5712,
        available: false,
    },
    FurriersAndFurShops: {
        value: 'furriers_and_fur_shops',
        label: 'Furriers and Fur Shops',
        merchantCategoryCode: 5681,
        available: false,
    },
    GeneralServices: {
        value: 'general_services',
        label: 'General Services',
        merchantCategoryCode: 1520,
        available: false,
    },
    GiftCardNoveltyAndSouvenirShops: {
        value: 'gift_card_novelty_and_souvenir_shops',
        label: 'Gift: Card: Novelty: and Souvenir Shops',
        merchantCategoryCode: 5947,
        available: false,
    },
    GlassPaintAndWallpaperStores: {
        value: 'glass_paint_and_wallpaper_stores',
        label: 'Glass: Paint: and Wallpaper Stores',
        merchantCategoryCode: 5231,
        available: false,
    },
    GlasswareCrystalStores: {
        value: 'glassware_crystal_stores',
        label: 'Glassware: Crystal Stores',
        merchantCategoryCode: 5950,
        available: false,
    },
    GolfCoursesPublic: {
        value: 'golf_courses_public',
        label: 'Golf Courses - Public',
        merchantCategoryCode: 7992,
        available: false,
    },
    GovernmentServices: {
        value: 'government_services',
        label: 'Government Services (Not Elsewhere Classified)',
        merchantCategoryCode: 9399,
        available: false,
    },
    GroceryStoresSupermarkets: {
        value: 'grocery_stores_supermarkets',
        label: 'Grocery Stores: Supermarkets',
        merchantCategoryCode: 5411,
        available: false,
    },
    HardwareStores: {
        value: 'hardware_stores',
        label: 'Hardware Stores',
        merchantCategoryCode: 5251,
        available: false,
    },
    HardwareEquipmentAndSupplies: {
        value: 'hardware_equipment_and_supplies',
        label: 'Hardware: Equipment: and Supplies',
        merchantCategoryCode: 5072,
        available: false,
    },
    HealthAndBeautySpas: {
        value: 'health_and_beauty_spas',
        label: 'Health and Beauty Spas',
        merchantCategoryCode: 7298,
        available: false,
    },
    HearingAidsSalesAndSupplies: {
        value: 'hearing_aids_sales_and_supplies',
        label: 'Hearing Aids Sales and Supplies',
        merchantCategoryCode: 5975,
        available: false,
    },
    HeatingPlumbingAC: {
        value: 'heating_plumbing_a_c',
        label: 'Heating: Plumbing: A/C',
        merchantCategoryCode: 1711,
        available: false,
    },
    HobbyToyAndGameShops: {
        value: 'hobby_toy_and_game_shops',
        label: 'Hobby: Toy: and Game Shops',
        merchantCategoryCode: 5945,
        available: false,
    },
    HomeSupplyWarehouseStores: {
        value: 'home_supply_warehouse_stores',
        label: 'Home Supply Warehouse Stores',
        merchantCategoryCode: 5200,
        available: false,
    },
    Hospitals: {
        value: 'hospitals',
        label: 'Hospitals',
        merchantCategoryCode: 8062,
        available: false,
    },
    HotelsMotelsAndResorts: {
        value: 'hotels_motels_and_resorts',
        label: 'Hotels: Motels: and Resorts',
        merchantCategoryCode: 7011,
        available: false,
    },
    HouseholdApplianceStores: {
        value: 'household_appliance_stores',
        label: 'Household Appliance Stores',
        merchantCategoryCode: 5722,
        available: false,
    },
    IndustrialSupplies: {
        value: 'industrial_supplies',
        label: 'Industrial Supplies (Not Elsewhere Classified)',
        merchantCategoryCode: 5085,
        available: false,
    },
    InformationRetrievalServices: {
        value: 'information_retrieval_services',
        label: 'Information Retrieval Services',
        merchantCategoryCode: 7375,
        available: false,
    },
    InsuranceDefault: {
        value: 'insurance_default',
        label: 'Insurance Companies',
        merchantCategoryCode: 6399,
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    InsuranceUnderwritingPremiums: {
        value: 'insurance_underwriting_premiums',
        label: 'Insurance Underwriting: Premiums',
        merchantCategoryCode: 6300,
        available: false,
    },
    IntraCompanyPurchases: {
        value: 'intra_company_purchases',
        label: 'Intra-Company Purchases',
        merchantCategoryCode: 9950,
        available: false,
    },
    JewelryStoresWatchesClocksAndSilverwareStores: {
        value: 'jewelry_stores_watches_clocks_and_silverware_stores',
        label: 'Jewelry Stores: Watches: Clocks: and Silverware Stores',
        merchantCategoryCode: 5944,
        available: false,
    },
    LandscapingServices: {
        value: 'landscaping_services',
        label: 'Landscaping Services',
        merchantCategoryCode: 780,
        available: false,
    },
    Laundries: {
        value: 'laundries',
        label: 'Laundries',
        merchantCategoryCode: 7211,
        available: false,
    },
    LaundryCleaningServices: {
        value: 'laundry_cleaning_services',
        label: 'Laundry: Cleaning Services',
        merchantCategoryCode: 7210,
        available: false,
    },
    LegalServicesAttorneys: {
        value: 'legal_services_attorneys',
        label: 'Legal Services/ advisory',
        merchantCategoryCode: 8111,
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    LuggageAndLeatherGoodsStores: {
        value: 'luggage_and_leather_goods_stores',
        label: 'Luggage and Leather Goods Stores',
        merchantCategoryCode: 5948,
        available: false,
    },
    LumberBuildingMaterialsStores: {
        value: 'lumber_building_materials_stores',
        label: 'Lumber: Building Materials Stores',
        merchantCategoryCode: 5211,
        available: false,
    },
    ManualCashDisburse: {
        value: 'manual_cash_disburse',
        label: 'Manual Cash Disburse',
        merchantCategoryCode: 6010,
        available: false,
    },
    MarinasServiceAndSupplies: {
        value: 'marinas_service_and_supplies',
        label: 'Marinas: Service and Supplies',
        merchantCategoryCode: 4468,
        available: false,
    },
    MasonryStoneworkAndPlaster: {
        value: 'masonry_stonework_and_plaster',
        label: 'Masonry: Stonework: and Plaster',
        merchantCategoryCode: 1740,
        available: false,
    },
    MassageParlors: {
        value: 'massage_parlors',
        label: 'Massage Parlors',
        merchantCategoryCode: 7297,
        available: false,
    },
    MedicalServices: {
        value: 'medical_services',
        label: 'Medical Services',
        merchantCategoryCode: 8099,
        available: false,
    },
    MedicalAndDentalLabs: {
        value: 'medical_and_dental_labs',
        label: 'Medical and Dental Labs',
        merchantCategoryCode: 8071,
        available: false,
    },
    MedicalDentalOphthalmicAndHospitalEquipmentAndSupplies: {
        value: 'medical_dental_ophthalmic_and_hospital_equipment_and_supplies',
        label: 'Medical: Dental: Ophthalmic: and Hospital Equipment and Supplies',
        merchantCategoryCode: 5047,
        available: false,
    },
    MembershipOrganizations: {
        value: 'membership_organizations',
        label: 'Membership Organizations',
        merchantCategoryCode: 8699,
        available: false,
    },
    MensAndBoysClothingAndAccessoriesStores: {
        value: 'mens_and_boys_clothing_and_accessories_stores',
        label: 'Mens and Boys Clothing and Accessories Stores',
        merchantCategoryCode: 5611,
        available: false,
    },
    MensWomensClothingStores: {
        value: 'mens_womens_clothing_stores',
        label: 'Mens: Womens Clothing Stores',
        merchantCategoryCode: 5691,
        available: false,
    },
    MetalServiceCenters: {
        value: 'metal_service_centers',
        label: 'Metal Service Centers',
        merchantCategoryCode: 5051,
        available: false,
    },
    MiscellaneousApparelAndAccessoryShops: {
        value: 'miscellaneous_apparel_and_accessory_shops',
        label: 'Miscellaneous Apparel and Accessory Shops',
        merchantCategoryCode: 5699,
        available: false,
    },
    MiscellaneousAutoDealers: {
        value: 'miscellaneous_auto_dealers',
        label: 'Miscellaneous Auto Dealers',
        merchantCategoryCode: 5599,
        available: false,
    },
    MiscellaneousBusinessServices: {
        value: 'miscellaneous_business_services',
        label: 'Miscellaneous Business Services',
        merchantCategoryCode: 7399,
        available: false,
    },
    MiscellaneousFoodStores: {
        value: 'miscellaneous_food_stores',
        label: 'Miscellaneous Food Stores - Convenience Stores and Specialty Markets',
        merchantCategoryCode: 5499,
        available: false,
    },
    MiscellaneousGeneralMerchandise: {
        value: 'miscellaneous_general_merchandise',
        label: 'Miscellaneous General Merchandise',
        merchantCategoryCode: 5399,
        available: false,
    },
    MiscellaneousGeneralServices: {
        value: 'miscellaneous_general_services',
        label: 'Miscellaneous General Services',
        merchantCategoryCode: 7299,
        available: false,
    },
    MiscellaneousHomeFurnishingSpecialtyStores: {
        value: 'miscellaneous_home_furnishing_specialty_stores',
        label: 'Miscellaneous Home Furnishing Specialty Stores',
        merchantCategoryCode: 5719,
        available: false,
    },
    MiscellaneousPublishingAndPrinting: {
        value: 'miscellaneous_publishing_and_printing',
        label: 'Miscellaneous Publishing and Printing',
        merchantCategoryCode: 2741,
        available: false,
    },
    MiscellaneousRecreationServices: {
        value: 'miscellaneous_recreation_services',
        label: 'Miscellaneous Recreation Services',
        merchantCategoryCode: 7999,
        available: false,
    },
    MiscellaneousRepairShops: {
        value: 'miscellaneous_repair_shops',
        label: 'Miscellaneous Repair Shops',
        merchantCategoryCode: 7699,
        available: false,
    },
    MiscellaneousSpecialtyRetail: {
        value: 'miscellaneous_specialty_retail',
        label: 'Miscellaneous Specialty Retail',
        merchantCategoryCode: 5999,
        available: false,
    },
    MobileHomeDealers: {
        value: 'mobile_home_dealers',
        label: 'Mobile Home Dealers',
        merchantCategoryCode: 5271,
        available: false,
    },
    MotionPictureTheaters: {
        value: 'motion_picture_theaters',
        label: 'Motion Picture Theaters',
        merchantCategoryCode: 7832,
        available: false,
    },
    MotorFreightCarriersAndTrucking: {
        value: 'motor_freight_carriers_and_trucking',
        label: 'Motor Freight Carriers and Trucking - Local and Long Distance: Moving and Storage Companies: and Local Delivery Services',
        merchantCategoryCode: 4214,
        available: false,
    },
    MotorHomesDealers: {
        value: 'motor_homes_dealers',
        label: 'Motor Homes Dealers',
        merchantCategoryCode: 5592,
        available: false,
    },
    MotorVehicleSuppliesAndNewParts: {
        value: 'motor_vehicle_supplies_and_new_parts',
        label: 'Motor Vehicle Supplies and New Parts',
        merchantCategoryCode: 5013,
        available: false,
    },
    MotorcycleShopsAndDealers: {
        value: 'motorcycle_shops_and_dealers',
        label: 'Motorcycle Shops and Dealers',
        merchantCategoryCode: 5571,
        available: false,
    },
    MotorcycleShopsDealers: {
        value: 'motorcycle_shops_dealers',
        label: 'Motorcycle Shops: Dealers',
        merchantCategoryCode: 5561,
        available: false,
    },
    MusicStoresMusicalInstrumentsPianosAndSheetMusic: {
        value: 'music_stores_musical_instruments_pianos_and_sheet_music',
        label: 'Music Stores-Musical Instruments: Pianos: and Sheet Music',
        merchantCategoryCode: 5733,
        available: false,
    },
    NewsDealersAndNewsstands: {
        value: 'news_dealers_and_newsstands',
        label: 'News Dealers and Newsstands',
        merchantCategoryCode: 5994,
        available: false,
    },
    NonFiMoneyOrders: {
        value: 'non_fi_money_orders',
        label: 'Non-FI: Money Orders',
        merchantCategoryCode: 6051,
        available: false,
    },
    NonFiStoredValueCardPurchaseLoad: {
        value: 'non_fi_stored_value_card_purchase_load',
        label: 'Non-FI: Stored Value Card Purchase/Load',
        merchantCategoryCode: 6540,
        available: false,
    },
    NondurableGoods: {
        value: 'nondurable_goods',
        label: 'Nondurable Goods (Not Elsewhere Classified)',
        merchantCategoryCode: 5199,
        available: false,
    },
    NurseriesLawnAndGardenSupplyStores: {
        value: 'nurseries_lawn_and_garden_supply_stores',
        label: 'Nurseries: Lawn and Garden Supply Stores',
        merchantCategoryCode: 5261,
        available: false,
    },
    NursingPersonalCare: {
        value: 'nursing_personal_care',
        label: 'Nursing/Personal Care',
        merchantCategoryCode: 8050,
        available: false,
    },
    OfficeAndCommercialFurniture: {
        value: 'office_and_commercial_furniture',
        label: 'Office and Commercial Furniture',
        merchantCategoryCode: 5021,
        available: false,
    },
    OpticiansEyeglasses: {
        value: 'opticians_eyeglasses',
        label: 'Opticians: Eyeglasses',
        merchantCategoryCode: 8043,
        available: false,
    },
    OptometristsOphthalmologist: {
        value: 'optometrists_ophthalmologist',
        label: 'Optometrists: Ophthalmologist',
        merchantCategoryCode: 8042,
        available: false,
    },
    OrthopedicGoodsProstheticDevices: {
        value: 'orthopedic_goods_prosthetic_devices',
        label: 'Orthopedic Goods - Prosthetic Devices',
        merchantCategoryCode: 5976,
        available: false,
    },
    Osteopaths: {
        value: 'osteopaths',
        label: 'Osteopaths',
        merchantCategoryCode: 8031,
        available: false,
    },
    PackageStoresBeerWineAndLiquor: {
        value: 'package_stores_beer_wine_and_liquor',
        label: 'Package Stores-Beer: Wine: and Liquor',
        merchantCategoryCode: 5921,
        available: false,
    },
    PaintsVarnishesAndSupplies: {
        value: 'paints_varnishes_and_supplies',
        label: 'Paints: Varnishes: and Supplies',
        merchantCategoryCode: 5198,
        available: false,
    },
    ParkingLotsGarages: {
        value: 'parking_lots_garages',
        label: 'Parking Lots: Garages',
        merchantCategoryCode: 7523,
        available: false,
    },
    PassengerRailways: {
        value: 'passenger_railways',
        label: 'Passenger Railways',
        merchantCategoryCode: 4112,
        available: false,
    },
    PawnShops: {
        value: 'pawn_shops',
        label: 'Pawn Shops',
        merchantCategoryCode: 5933,
        available: false,
    },
    PetShopsPetFoodAndSupplies: {
        value: 'pet_shops_pet_food_and_supplies',
        label: 'Pet Shops: Pet Food: and Supplies',
        merchantCategoryCode: 5995,
        available: false,
    },
    PetroleumAndPetroleumProducts: {
        value: 'petroleum_and_petroleum_products',
        label: 'Petroleum and Petroleum Products',
        merchantCategoryCode: 5172,
        available: false,
    },
    PhotoDeveloping: {
        value: 'photo_developing',
        label: 'Photo Developing',
        merchantCategoryCode: 7395,
        available: false,
    },
    PhotographicStudios: {
        value: 'photographic_studios',
        label: 'Photographic Studios',
        merchantCategoryCode: 7221,
        available: false,
    },
    PhotographicPhotocopyMicrofilmEquipmentAndSupplies: {
        value: 'photographic_photocopy_microfilm_equipment_and_supplies',
        label: 'Photographic: Photocopy: Microfilm Equipment: and Supplies',
        merchantCategoryCode: 5044,
        available: false,
    },
    PictureVideoProduction: {
        value: 'picture_video_production',
        label: 'Picture/Video Production',
        merchantCategoryCode: 7829,
        available: false,
    },
    PieceGoodsNotionsAndOtherDryGoods: {
        value: 'piece_goods_notions_and_other_dry_goods',
        label: 'Piece Goods: Notions: and Other Dry Goods',
        merchantCategoryCode: 5131,
        available: false,
    },
    PlumbingHeatingEquipmentAndSupplies: {
        value: 'plumbing_heating_equipment_and_supplies',
        label: 'Plumbing: Heating Equipment: and Supplies',
        merchantCategoryCode: 5074,
        available: false,
    },
    PoliticalOrganizations: {
        value: 'political_organizations',
        label: 'Political Organizations',
        merchantCategoryCode: 8651,
        available: false,
    },
    PostalServicesGovernmentOnly: {
        value: 'postal_services_government_only',
        label: 'Postal Services - Government Only',
        merchantCategoryCode: 9402,
        available: false,
    },
    PreciousStonesAndMetalsWatchesAndJewelry: {
        value: 'precious_stones_and_metals_watches_and_jewelry',
        label: 'Precious Stones and Metals: Watches and Jewelry',
        merchantCategoryCode: 5094,
        available: false,
    },
    ProfessionalServices: {
        value: 'professional_services',
        label: 'Professional Services',
        merchantCategoryCode: 8999,
        available: false,
    },
    PublicWarehousingAndStorage: {
        value: 'public_warehousing_and_storage',
        label: 'Public Warehousing and Storage - Farm Products: Refrigerated Goods: Household Goods: and Storage',
        merchantCategoryCode: 4225,
        available: false,
    },
    QuickCopyReproAndBlueprint: {
        value: 'quick_copy_repro_and_blueprint',
        label: 'Quick Copy: Repro: and Blueprint',
        merchantCategoryCode: 7338,
        available: false,
    },
    Railroads: {
        value: 'railroads',
        label: 'Railroads',
        merchantCategoryCode: 4011,
        available: false,
    },
    RealEstateAgentsAndManagersRentals: {
        value: 'real_estate_agents_and_managers_rentals',
        label: 'Real Estate Agents and Managers - Rentals',
        merchantCategoryCode: 6513,
        available: false,
    },
    RecordStores: {
        value: 'record_stores',
        label: 'Record Stores',
        merchantCategoryCode: 5735,
        available: false,
    },
    RecreationalVehicleRentals: {
        value: 'recreational_vehicle_rentals',
        label: 'Recreational Vehicle Rentals',
        merchantCategoryCode: 7519,
        available: false,
    },
    ReligiousGoodsStores: {
        value: 'religious_goods_stores',
        label: 'Religious Goods Stores',
        merchantCategoryCode: 5973,
        available: false,
    },
    ReligiousOrganizations: {
        value: 'religious_organizations',
        label: 'Religious Organizations',
        merchantCategoryCode: 8661,
        available: false,
    },
    RoofingSidingSheetMetal: {
        value: 'roofing_siding_sheet_metal',
        label: 'Roofing/Siding: Sheet Metal',
        merchantCategoryCode: 1761,
        available: false,
    },
    SecretarialSupportServices: {
        value: 'secretarial_support_services',
        label: 'Secretarial Support Services',
        merchantCategoryCode: 7339,
        available: false,
    },
    SecurityBrokersDealers: {
        value: 'security_brokers_dealers',
        label: 'Security Brokers/Dealers',
        merchantCategoryCode: 6211,
        available: false,
    },
    ServiceStations: {
        value: 'service_stations',
        label: 'Service Stations',
        merchantCategoryCode: 5541,
        available: false,
    },
    SewingNeedleworkFabricAndPieceGoodsStores: {
        value: 'sewing_needlework_fabric_and_piece_goods_stores',
        label: 'Sewing: Needlework: Fabric: and Piece Goods Stores',
        merchantCategoryCode: 5949,
        available: false,
    },
    ShoeRepairHatCleaning: {
        value: 'shoe_repair_hat_cleaning',
        label: 'Shoe Repair/Hat Cleaning',
        merchantCategoryCode: 7251,
        available: false,
    },
    ShoeStores: {
        value: 'shoe_stores',
        label: 'Shoe Stores',
        merchantCategoryCode: 5661,
        available: false,
    },
    SmallApplianceRepair: {
        value: 'small_appliance_repair',
        label: 'Small Appliance Repair',
        merchantCategoryCode: 7629,
        available: false,
    },
    SnowmobileDealers: {
        value: 'snowmobile_dealers',
        label: 'Snowmobile Dealers',
        merchantCategoryCode: 5598,
        available: false,
    },
    SpecialTradeServices: {
        value: 'special_trade_services',
        label: 'Special Trade Services',
        merchantCategoryCode: 1799,
        available: false,
    },
    SpecialtyCleaning: {
        value: 'specialty_cleaning',
        label: 'Specialty Cleaning',
        merchantCategoryCode: 2842,
        available: false,
    },
    SportingGoodsStores: {
        value: 'sporting_goods_stores',
        label: 'Sporting Goods Stores',
        merchantCategoryCode: 5941,
        available: false,
    },
    SportingRecreationCamps: {
        value: 'sporting_recreation_camps',
        label: 'Sporting/Recreation Camps',
        merchantCategoryCode: 7032,
        available: false,
    },
    SportsClubsFields: {
        value: 'sports_clubs_fields',
        label: 'Sports Clubs/Fields',
        merchantCategoryCode: 7941,
        available: false,
    },
    SportsAndRidingApparelStores: {
        value: 'sports_and_riding_apparel_stores',
        label: 'Sports and Riding Apparel Stores',
        merchantCategoryCode: 5655,
        available: false,
    },
    StampAndCoinStores: {
        value: 'stamp_and_coin_stores',
        label: 'Stamp and Coin Stores',
        merchantCategoryCode: 5972,
        available: false,
    },
    StationaryOfficeSuppliesPrintingAndWritingPaper: {
        value: 'stationary_office_supplies_printing_and_writing_paper',
        label: 'Stationary: Office Supplies: Printing and Writing Paper',
        merchantCategoryCode: 5111,
        available: false,
    },
    StationeryStoresOfficeAndSchoolSupplyStores: {
        value: 'stationery_stores_office_and_school_supply_stores',
        label: 'Stationery Stores: Office: and School Supply Stores',
        merchantCategoryCode: 5943,
        available: false,
    },
    SwimmingPoolsSales: {
        value: 'swimming_pools_sales',
        label: 'Swimming Pools Sales',
        merchantCategoryCode: 5996,
        available: false,
    },
    TUiTravelGermany: {
        value: 't_ui_travel_germany',
        label: 'TUI Travel - Germany',
        merchantCategoryCode: 4723,
        available: false,
    },
    TailorsAlterations: {
        value: 'tailors_alterations',
        label: 'Tailors: Alterations',
        merchantCategoryCode: 5697,
        available: false,
    },
    TaxPaymentsGovernmentAgencies: {
        value: 'tax_payments_government_agencies',
        label: 'Tax Payments - Government Agencies',
        merchantCategoryCode: 9311,
        available: false,
    },
    TaxPreparationServices: {
        value: 'tax_preparation_services',
        label: 'Tax Preparation Services',
        merchantCategoryCode: 7276,
        available: false,
    },
    TaxicabsLimousines: {
        value: 'taxicabs_limousines',
        label: 'Taxicabs/Limousines',
        merchantCategoryCode: 4121,
        available: false,
    },
    TelecommunicationEquipmentAndTelephoneSales: {
        value: 'telecommunication_equipment_and_telephone_sales',
        label: 'Telecom Equipment & Sales',
        merchantCategoryCode: 4812,
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    TelecommunicationServices: {
        value: 'telecommunication_services',
        label: 'Telecom Services',
        merchantCategoryCode: 4814,
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.high,
    },
    TelegraphServices: {
        value: 'telegraph_services',
        label: 'Telegraph Services',
        merchantCategoryCode: 4821,
        available: false,
    },
    TentAndAwningShops: {
        value: 'tent_and_awning_shops',
        label: 'Tent and Awning Shops',
        merchantCategoryCode: 5998,
        available: false,
    },
    TestingLaboratories: {
        value: 'testing_laboratories',
        label: 'Testing Laboratories',
        merchantCategoryCode: 8734,
        available: false,
    },
    TheatricalTicketAgencies: {
        value: 'theatrical_ticket_agencies',
        label: 'Theatrical Ticket Agencies',
        merchantCategoryCode: 7922,
        available: false,
    },
    Timeshares: {
        value: 'timeshares',
        label: 'Timeshares',
        merchantCategoryCode: 7012,
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    TireRetreadingAndRepair: {
        value: 'tire_retreading_and_repair',
        label: 'Tire Retreading and Repair',
        merchantCategoryCode: 7534,
        available: false,
    },
    TollsBridgeFees: {
        value: 'tolls_bridge_fees',
        label: 'Tolls/Bridge Fees',
        merchantCategoryCode: 4784,
        available: false,
    },
    TouristAttractionsAndExhibits: {
        value: 'tourist_attractions_and_exhibits',
        label: 'Tourist Attractions and Exhibits',
        merchantCategoryCode: 7991,
        available: false,
    },
    TowingServices: {
        value: 'towing_services',
        label: 'Towing Services',
        merchantCategoryCode: 7549,
        available: false,
    },
    TrailerParksCampgrounds: {
        value: 'trailer_parks_campgrounds',
        label: 'Trailer Parks: Campgrounds',
        merchantCategoryCode: 7033,
        available: false,
    },
    TransportationServices: {
        value: 'transportation_services',
        label: 'Transportation Services (Not Elsewhere Classified)',
        merchantCategoryCode: 4789,
        available: false,
    },
    TravelAgenciesTourOperators: {
        value: 'travel_agencies_tour_operators',
        label: 'Travel Agencies / Hospitality (with online sales/booking platform)',
        merchantCategoryCode: 4722,
        available: true,
        industry: industries.Recreational,
    },
    TruckStopIteration: {
        value: 'truck_stop_iteration',
        label: 'Truck StopIteration',
        merchantCategoryCode: 7511,
        available: false,
    },
    TruckUtilityTrailerRentals: {
        value: 'truck_utility_trailer_rentals',
        label: 'Truck/Utility Trailer Rentals',
        merchantCategoryCode: 7513,
        available: false,
    },
    TypesettingPlateMakingAndRelatedServices: {
        value: 'typesetting_plate_making_and_related_services',
        label: 'Typesetting: Plate Making: and Related Services',
        merchantCategoryCode: 2791,
        available: false,
    },
    TypewriterStores: {
        value: 'typewriter_stores',
        label: 'Typewriter Stores',
        merchantCategoryCode: 5978,
        available: false,
    },
    USFederalGovernmentAgenciesOrDepartments: {
        value: 'u_s_federal_government_agencies_or_departments',
        label: 'U.S. Federal Government Agencies or Departments',
        merchantCategoryCode: 9405,
        available: false,
    },
    UniformsCommercialClothing: {
        value: 'uniforms_commercial_clothing',
        label: 'Uniforms: Commercial Clothing',
        merchantCategoryCode: 5137,
        available: false,
    },
    UsedMerchandiseAndSecondhandStores: {
        value: 'used_merchandise_and_secondhand_stores',
        label: 'Used Merchandise and Secondhand Stores',
        merchantCategoryCode: 5931,
        available: false,
    },
    Utilities: {
        value: 'utilities',
        label: 'Utilities',
        merchantCategoryCode: 4900,
        available: false,
    },
    VarietyStores: {
        value: 'variety_stores',
        label: 'Variety Stores',
        merchantCategoryCode: 5331,
        available: false,
    },
    VeterinaryServices: {
        value: 'veterinary_services',
        label: 'Veterinary Services',
        merchantCategoryCode: 742,
        available: false,
    },
    VideoAmusementGameSupplies: {
        value: 'video_amusement_game_supplies',
        label: 'Video Amusement Game Supplies',
        merchantCategoryCode: 7993,
        available: false,
    },
    VideoGameArcades: {
        value: 'video_game_arcades',
        label: 'Video Game Arcades',
        merchantCategoryCode: 7994,
        available: false,
    },
    VideoTapeRentalStores: {
        value: 'video_tape_rental_stores',
        label: 'Video Tape Rental Stores',
        merchantCategoryCode: 7841,
        available: false,
    },
    VocationalTradeSchools: {
        value: 'vocational_trade_schools',
        label: 'Vocational/Trade Schools',
        merchantCategoryCode: 8249,
        available: false,
    },
    WatchJewelryRepair: {
        value: 'watch_jewelry_repair',
        label: 'Watch/Jewelry Repair',
        merchantCategoryCode: 7631,
        available: false,
    },
    WeldingRepair: {
        value: 'welding_repair',
        label: 'Welding Repair',
        merchantCategoryCode: 7692,
        available: false,
    },
    WholesaleClubs: {
        value: 'wholesale_clubs',
        label: 'Wholesale Clubs',
        merchantCategoryCode: 5300,
        available: false,
    },
    WigAndToupeeStores: {
        value: 'wig_and_toupee_stores',
        label: 'Wig and Toupee Stores',
        merchantCategoryCode: 5698,
        available: false,
    },
    WiresMoneyOrders: {
        value: 'wires_money_orders',
        label: 'Wire Transfers and Money Orders',
        merchantCategoryCode: 4829,
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    WomensAccessoryAndSpecialtyShops: {
        value: 'womens_accessory_and_specialty_shops',
        label: 'Womens Accessory and Specialty Shops',
        merchantCategoryCode: 5631,
        available: false,
    },
    WomensReadyToWearStores: {
        value: 'womens_ready_to_wear_stores',
        label: 'Womens Ready-To-Wear Stores',
        merchantCategoryCode: 5621,
        available: false,
    },
    WreckingAndSalvageYards: {
        value: 'wrecking_and_salvage_yards',
        label: 'Wrecking and Salvage Yards',
        merchantCategoryCode: 5935,
        available: false,
    },
    WebpageAdministrators: {
        value: 'webpage_administrators',
        label: 'Webpage administrators',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    TrafficOptimization: {
        value: 'traffic_optimization',
        label: 'Traffic Optimization',
        available: true,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    SocialMediaInfluencers: {
        value: 'social_media_influencers',
        label: 'Social Media Influencers',
        available: true,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    PaymentInfrastructureProviders: {
        value: 'payment_infrastructure_providers',
        label: 'Payment infrastructure providers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineMarketingCampaigns: {
        value: 'online_marketing_campaigns',
        label: 'Online Marketing Campaigns',
        available: true,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    OnlineMediaArticles: {
        value: 'online_media_articles',
        label: 'Online Media Articles',
        available: true,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    OnlineBetting: {
        value: 'online_betting',
        label: 'Online betting',
        available: true,
        industry: industries.BettingCasinoGambling,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineCasinos: {
        value: 'online_casinos',
        label: 'Online casinos',
        available: true,
        industry: industries.BettingCasinoGambling,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineLotteries: {
        value: 'online_lotteries',
        label: 'Online lotteries',
        available: true,
        industry: industries.BettingCasinoGambling,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineSlotMachines: {
        value: 'online_slot_machines',
        label: 'Online slot machines',
        available: true,
        industry: industries.BettingCasinoGambling,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineCharities: {
        value: 'online_charities',
        label: 'Online Charities',
        available: true,
        industry: industries.Charity,
        riskCategory: businessTypeRiskCategories.high,
    },
    MobileAppDeveloper: {
        value: 'mobile_app_developer',
        label: 'Mobile App developer',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    InternetBusinessBackuppers: {
        value: 'internet_business_backuppers',
        label: 'Internet business back-uppers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    GameSkinProviders: {
        value: 'game_skin_providers',
        label: 'Game skin providers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    DatingNetworks: {
        value: 'dating_networks',
        label: 'Dating networks',
        available: true,
        industry: industries.DatingServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    CryptoCurrencyInfrastructureProviders: {
        value: 'Crypto_currency_infrastructure_providers',
        label: 'Crypto currency infrastructure providers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.high,
    },
    AdvertisingBinaryOptions: {
        value: 'advertising_binary_options',
        label: 'Advertising of Binary Options Products',
        merchantCategoryCode: 7311,
        available: false,
        industry: industries.AdvertisingServices,
        riskCategory: businessTypeRiskCategories.reject,
    },
    AffiliateMarketing: {
        value: 'affiliate_marketing',
        label: 'Affiliate Marketing',
        available: true,
        industry: industries.AdvertisingServices,
    },
    ITDevelopers: {
        value: 'it_developers',
        label: 'IT Developers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    ITOnlineGamblingBetting: {
        value: 'it_online_gambling_betting',
        label: 'IT for online gambling/betting',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.normal,
    },
    ITVirtualCurrencyBlockchain: {
        value: 'it_virtual_currency_blockchain',
        label: 'IT for Virtual Currency/Blockchain',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.high,
    },
    ITProductPublishers: {
        value: 'it_product_publishers',
        label: 'IT products publishers',
        available: true,
        industry: industries.ComputerProgramming,
        riskCategory: businessTypeRiskCategories.low,
    },
    PhysicallyPresentServices: {
        value: 'physically_present_services',
        label: 'Physically present services',
        available: false,
        industry: industries.DatingServices,
        riskCategory: businessTypeRiskCategories.reject,
    },
    ESports: {
        value: 'e_sports',
        label: 'E-sports',
        available: true,
        industry: industries.DigitalGoodsGames,
        riskCategory: businessTypeRiskCategories.low,
    },
    FantasySports: {
        value: 'fantasy_sports',
        label: 'Fantasy sports',
        available: true,
        industry: industries.DigitalGoodsGames,
        riskCategory: businessTypeRiskCategories.normal,
    },
    GamingWebsites: {
        value: 'gaming_websites',
        label: 'Gaming web sites',
        available: true,
        industry: industries.DigitalGoodsGames,
        riskCategory: businessTypeRiskCategories.low,
    },
    LicensedCannabidiolRelatedProducts: {
        value: 'licensed_cannabidiol_related_products',
        label: 'Licensed Cannabidiol Related Products',
        available: true,
        industry: industries.DrugStoresPharmacies,
        riskCategory: businessTypeRiskCategories.high,
    },
    Pharmaceuticals: {
        value: 'pharmaceuticals',
        label: 'Pharmaceuticals',
        available: true,
        industry: industries.DrugStoresPharmacies,
        riskCategory: businessTypeRiskCategories.high,
    },
    UnlicensedCannabidiolRelatedProducts: {
        value: 'unlicensed_cannabidiol_related_products',
        label: 'Unlicensed Cannabidiol Related Products',
        available: false,
        industry: industries.DrugStoresPharmacies,
        riskCategory: businessTypeRiskCategories.reject,
    },
    OnlineEducationalServices: {
        value: 'online_educational_services',
        label: 'Online Educational Services',
        available: true,
        industry: industries.EducationalServices,
        riskCategory: businessTypeRiskCategories.normal,
    },
    OnlineResourcesForScholars: {
        value: 'online_resources_for_scholars',
        label: 'Online resources for scholars',
        available: true,
        industry: industries.EducationalServices,
        riskCategory: businessTypeRiskCategories.normal,
    },
    RecruitmentServices: {
        value: 'recruitment_services',
        label: 'Recruitment Services',
        available: true,
        industry: industries.EmploymentTempAgencies,
        riskCategory: businessTypeRiskCategories.high,
    },
    BinaryOptionsBrokers: {
        value: 'binary_options_brokers',
        label: 'Binary Options Brokers',
        available: false,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.reject,
    },
    ConsumerLoanCompanies: {
        value: 'consumer_loan_companies',
        label: 'Consumer loan companies',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    CrowdFunding: {
        value: 'crowd_funding',
        label: 'Crowd funding (Licensed or License Exempt)',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    EWallet: {
        value: 'e_wallet',
        label: 'E-wallet',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.normal,
    },
    FactoringCompany: {
        value: 'factoring_company',
        label: 'Factoring company',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    ForexBrokers: {
        value: 'forex_brokers',
        label: 'Forex brokers',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    GetRichQuickSchemes: {
        value: 'get_rich_quick_schemes',
        label: 'Get Rich Quick Schemes',
        available: false,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.reject,
    },
    Hawala: {
        value: 'hawala',
        label: 'Hawala',
        available: false,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.reject,
    },
    LiquidityProvider: {
        value: 'liquidity_provider',
        label: 'Liquidity provider',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    OtherCFDMarginTradingBrokers: {
        value: 'other_cfd_margin_trading_brokers',
        label: 'Other CFD / margin trading brokers',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    PaymentFacilitatorServiceProvider: {
        value: 'payment_facilitator_service_rovider',
        label: 'Payment Facilitator/Service Provider',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.normal,
    },
    PaymentInstitution: {
        value: 'payment_institution',
        label: 'Payment institution',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.normal,
    },
    QuasiCash: {
        value: 'quasi_cash',
        label: 'Quasi cash',
        available: true,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.high,
    },
    ShellBanks: {
        value: 'shell_banks',
        label: 'Shell banks',
        available: false,
        industry: industries.FinancialInstitution,
        riskCategory: businessTypeRiskCategories.reject,
    },
    BiddingFeeAuction: {
        value: 'bidding_fee_auction',
        label: 'Bidding Fee Auction',
        available: false,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.reject,
    },
    CounterfeitGoods: {
        value: 'counterfeit_goods',
        label: 'Counterfeit Goods',
        available: false,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.reject,
    },
    DigitalGoods: {
        value: 'digital_goods',
        label: 'Digital goods',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.normal,
    },
    HighValueGoods: {
        value: 'high_value_goods',
        label: 'High-Value Goods',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    CashOnDeliveryCourierServices: {
        value: 'cash_on_delivery_courier_services',
        label: 'Cash on Delivery Courier Services',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    MultiLevelMarketing: {
        value: 'multi_level_marketing',
        label: 'Multi-level Marketing',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineMarketplaces: {
        value: 'online_marketplaces',
        label: 'Online Marketplaces',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineMembership: {
        value: 'online_membership',
        label: 'Online membership',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.normal,
    },
    OnlinePropertyRental: {
        value: 'online_property_rental',
        label: 'Online property rental',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.low,
    },
    PhysicalGoods: {
        value: 'physical_goods',
        label: 'Physical goods',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.low,
    },
    PiracyOrIllegalStreaming: {
        value: 'piracy_or_illegal_streaming',
        label: 'Piracy or Illegal Streaming',
        available: false,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.reject,
    },
    Sweepstakes: {
        value: 'sweepstakes',
        label: 'Sweepstakes',
        available: true,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.normal,
    },
    Weapons: {
        value: 'weapons',
        label: 'Weapons',
        available: false,
        industry: industries.OnlineMerchants,
        riskCategory: businessTypeRiskCategories.reject,
    },
    PaymentServiceProviders: {
        value: 'payment_service_providers',
        label: 'Payment service providers',
        available: false,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    HoldingCompanies: {
        value: 'holding_companies',
        label: 'Holding companies',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    InvestmentActivity: {
        value: 'investment_activity',
        label: 'Investment Activity',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    OtherFinancialIntermediaries: {
        value: 'other_financial_intermediaries',
        label: 'Other financial intermediaries',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    PaymentManagementServices: {
        value: 'payment_management_services',
        label: 'Payment management services',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    PaymentManagementServicesPsp: {
        value: 'payment_management_services_psp',
        label: 'Payment management services - for payment service providers',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    PaymentManagementServicesForex: {
        value: 'payment_management_services_forex',
        label: 'Payment management services - forex',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    PaymentManagementServicesOnlineGambling: {
        value: 'payment_management_services_online_gambling',
        label: 'Payment management services - online gambling',
        available: true,
        industry: industries.PaymentManagementServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    BusinessConsulting: {
        value: 'business_consulting',
        label: 'Business consulting',
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.normal,
    },
    CompanyFormation: {
        value: 'company_formation',
        label: 'Company formation',
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.normal,
    },
    ConsultancyServicesExternal: {
        value: 'consultancy_services_external',
        label: 'Consultancy services (External)',
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.normal,
    },
    ConsultancyServicesIntragroup: {
        value: 'consultancy_services_intragroup',
        label: 'Consultancy services (Intragroup)',
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.high,
    },
    OnlineTrainingEducation: {
        value: 'online_training_education',
        label: 'Online training / education',
        available: true,
        industry: industries.ProfessionalServices,
        riskCategory: businessTypeRiskCategories.low,
    },
    Other: {
        value: 'other',
        label: 'Other',
        merchantCategoryCode: 0,
        available: false,
    },
    MultimediaRental: {
        value: 'multimedia_rental',
        label: 'Multimedia rental',
        available: true,
    },
    SkillGames: {
        value: 'skill_games',
        label: 'Skill Games',
        available: true,
        industry: industries.OnlineMerchants,
    },
    EventPlanning: {
        value: 'skill_games',
        label: 'Event Planning',
        available: true,
        industry: industries.ProfessionalServices,
    },
    NonProfit: {
        value: 'non_profit',
        label: 'Non - Profit',
        available: true,
        industry: industries.Charity,
        riskCategory: businessTypeRiskCategories.high,
    },
    NonGovernmentalOrganisation: {
        value: 'non_governmental_organisation',
        label: 'Non Governmental Organisation',
        available: true,
        industry: industries.Charity,
        riskCategory: businessTypeRiskCategories.high,
    },
});
const businessCategoryQuestions = asLocalizedEnum('industries', {
    ConductingClientKYC: {
        value: 'conductingClientKYC',
        label: 'Do you conduct KYC on any of your customers?',
        type: 'dropdown',
        businessTypes: [
            { question: businessCategoriesTypes.DatingNetworks, required: true },
            { question: businessCategoriesTypes.VirtualAssetsCryptoCurrencies, required: true },
            { question: businessCategoriesTypes.InsuranceDefault, required: true },
            { question: businessCategoriesTypes.WiresMoneyOrders, required: true },
            { question: businessCategoriesTypes.BinaryOptionsBrokers, required: true },
            { question: businessCategoriesTypes.ConsumerLoanCompanies, required: true },
            { question: businessCategoriesTypes.CrowdFunding, required: true },
            { question: businessCategoriesTypes.EWallet, required: true },
            { question: businessCategoriesTypes.FactoringCompany, required: true },
            { question: businessCategoriesTypes.ForexBrokers, required: true },
            { question: businessCategoriesTypes.GetRichQuickSchemes, required: true },
            { question: businessCategoriesTypes.Hawala, required: true },
            { question: businessCategoriesTypes.LiquidityProvider, required: true },
            { question: businessCategoriesTypes.OtherCFDMarginTradingBrokers, required: true },
            { question: businessCategoriesTypes.PaymentFacilitatorServiceProvider, required: true },
            { question: businessCategoriesTypes.PaymentInstitution, required: true },
            { question: businessCategoriesTypes.QuasiCash, required: true },
            { question: businessCategoriesTypes.ShellBanks, required: true },
            { question: businessCategoriesTypes.PaymentServiceProviders, required: true },
            { question: businessCategoriesTypes.HoldingCompanies, required: true },
            { question: businessCategoriesTypes.InvestmentActivity, required: true },
            { question: businessCategoriesTypes.OtherFinancialIntermediaries, required: true },
            { question: businessCategoriesTypes.PaymentManagementServices, required: true },
            { question: businessCategoriesTypes.PaymentManagementServicesForex, required: true },
            { question: businessCategoriesTypes.PaymentManagementServicesOnlineGambling, required: true },
            { question: businessCategoriesTypes.LegalServicesAttorneys, required: true },
            { question: businessCategoriesTypes.BusinessConsulting, required: true },
            { question: businessCategoriesTypes.CompanyFormation, required: true },
            { question: businessCategoriesTypes.ConsultancyServicesExternal, required: true },
            { question: businessCategoriesTypes.ConsultancyServicesIntragroup, required: true },
            { question: businessCategoriesTypes.OnlineTrainingEducation, required: true },
            { question: businessCategoriesTypes.EventPlanning, required: true },
        ],
    },
    ConductingKYC: {
        value: 'conductingKYC',
        label: 'Do you conduct KYC on your content providers / publishers / advertisers?',
        type: 'dropdown',
        businessTypes: [
            { question: businessCategoriesTypes.AdultContent, required: true },
            { question: businessCategoriesTypes.AdvertisingServices, required: true },
            { question: businessCategoriesTypes.ConsultingPublicRelations, required: true },
            { question: businessCategoriesTypes.TrafficOptimization, required: true },
            { question: businessCategoriesTypes.SocialMediaInfluencers, required: true },
            { question: businessCategoriesTypes.OnlineMarketingCampaigns, required: true },
            { question: businessCategoriesTypes.OnlineMediaArticles, required: true },
            { question: businessCategoriesTypes.AdvertisingBinaryOptions, required: true },
            { question: businessCategoriesTypes.AffiliateMarketing, required: true },
        ],
    },
    ConductPublisherContentMonitoring: {
        value: 'conductPublisherContentMonitoring',
        label: 'Do you conduct Publisher content monitoring?',
        type: 'dropdown',
        businessTypes: [
            { question: businessCategoriesTypes.AdultContent, required: true },
            { question: businessCategoriesTypes.AdvertisingServices, required: true },
            { question: businessCategoriesTypes.ConsultingPublicRelations, required: true },
            { question: businessCategoriesTypes.TrafficOptimization, required: true },
            { question: businessCategoriesTypes.SocialMediaInfluencers, required: true },
            { question: businessCategoriesTypes.OnlineMarketingCampaigns, required: true },
            { question: businessCategoriesTypes.OnlineMediaArticles, required: true },
            { question: businessCategoriesTypes.AdvertisingBinaryOptions, required: true },
            { question: businessCategoriesTypes.AffiliateMarketing, required: true },
        ],
    },
    C2BPayments: {
        value: 'c2BPayments',
        label: 'Do you want to use Klarpay for C2B (Retail Customer to Business) payments?',
        type: 'dropdown',
        businessTypes: [],
    },
    ClientsYouWorkWith: {
        value: 'clientsYouWorkWith',
        label: 'Please list your underlying clients or the first Test Client you want to process with Bivial (Name and URL)',
        type: 'text',
        businessTypes: [
            { question: businessCategoriesTypes.VirtualAssetsCryptoCurrencies, required: true },
            { question: businessCategoriesTypes.InsuranceDefault, required: true },
            { question: businessCategoriesTypes.WiresMoneyOrders, required: true },
            { question: businessCategoriesTypes.BinaryOptionsBrokers, required: true },
            { question: businessCategoriesTypes.ConsumerLoanCompanies, required: true },
            { question: businessCategoriesTypes.CrowdFunding, required: true },
            { question: businessCategoriesTypes.EWallet, required: true },
            { question: businessCategoriesTypes.FactoringCompany, required: true },
            { question: businessCategoriesTypes.ForexBrokers, required: true },
            { question: businessCategoriesTypes.GetRichQuickSchemes, required: true },
            { question: businessCategoriesTypes.Hawala, required: true },
            { question: businessCategoriesTypes.LiquidityProvider, required: true },
            { question: businessCategoriesTypes.OtherCFDMarginTradingBrokers, required: true },
            { question: businessCategoriesTypes.PaymentFacilitatorServiceProvider, required: true },
            { question: businessCategoriesTypes.PaymentInstitution, required: true },
            { question: businessCategoriesTypes.QuasiCash, required: true },
            { question: businessCategoriesTypes.ShellBanks, required: true },
            { question: businessCategoriesTypes.PaymentServiceProviders, required: true },
            { question: businessCategoriesTypes.HoldingCompanies, required: true },
            { question: businessCategoriesTypes.InvestmentActivity, required: true },
            { question: businessCategoriesTypes.OtherFinancialIntermediaries, required: true },
            { question: businessCategoriesTypes.PaymentManagementServices, required: true },
            { question: businessCategoriesTypes.PaymentManagementServicesForex, required: true },
            { question: businessCategoriesTypes.PaymentManagementServicesOnlineGambling, required: true },
        ],
    },
});

const profileChangeStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.INFO,
    },
    pendingExecutionSignature: {
        value: 'pending_execution_signature',
        label: 'Pending Execution Signature',
        labelIndicator: LabelIndicator.WARNING,
    },
    approved: {
        value: 'approved',
        label: 'Approved',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    underReview: {
        value: 'under_review',
        label: 'Under review',
        labelIndicator: LabelIndicator.INFO,
    },
});
const processProfileChangeResults = asEnum({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
    underReview: {
        value: 'underReview',
        label: 'Place under review',
    },
});
const agentTypes = asEnum({
    salesAgent: {
        value: 'sales_agent',
        label: 'Sales Agent',
        claimPerm: 'client_sales_claim',
        assignedPerm: 'client_sales_assigned',
        foreignKeyColumn: 'sales_agent_id',
        metadataEmail: 'sales_email',
    },
    supportAgent: {
        value: 'support_agent',
        label: 'Support Agent',
        claimPerm: 'client_support_claim',
        assignedPerm: 'client_support_assigned',
        foreignKeyColumn: 'support_agent_id',
        metadataEmail: 'support_email',
    },
    externalAgent: {
        value: 'external_agent',
        label: 'External Agent',
        claimPerm: 'client_external_claim',
        assignedPerm: 'client_external_agent_assigned',
        foreignKeyColumn: 'external_agent_id',
        metadataEmail: 'external_agent_email',
    },
});
const contractClosureReasons = asLocalizedEnum('contractClosureReasons', {
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'As per your request',
        showReasonTextArea: false,
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: false,
    },
    missingKycDoc: {
        value: 'missingKycDoc',
        label: 'Due to missing KYC documentation',
        showReasonTextArea: false,
    },
    missingProofAddress: {
        value: 'missingProofAddress',
        label: 'Due to missing Proof of Address',
        showReasonTextArea: false,
    },
    missingProofOfId: {
        value: 'missingProofOfId',
        label: 'Due to missing Proof of Identification',
        showReasonTextArea: false,
    },
    missingProofOfPayment: {
        value: 'missingProofOfPayment',
        label: 'Due to missing Proof of Payment (i.e. card copies/bank statement)',
        showReasonTextArea: false,
    },
    thirdPartyTransaction: {
        value: 'thirdPartyTransaction',
        label: 'Third party transaction/s',
        showReasonTextArea: false,
    },
    duplicateProfile: {
        value: 'duplicateProfile',
        label: 'Duplicate profile/s',
        showReasonTextArea: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
    },
    chargebackCase: {
        value: 'chargebackCase',
        label: 'Chargeback case',
        showReasonTextArea: false,
    },
});
const kycRejectionReasons = asLocalizedEnum('kycRejectionReasons', {
    proofOfAddress: {
        value: 'proofOfAddress',
        label: 'Updated Proof of address is required',
        showReasonTextArea: false,
    },
    renewedProofOfIdentification: {
        value: 'renewedProofOfIdentification',
        label: 'Renewed Proof of Identification is required',
        showReasonTextArea: false,
    },
    updatedKycDocuments: {
        value: 'updatedKycDocuments',
        label: 'Updated KYC documents (Proof of Identity and Proof of address) are required',
        showReasonTextArea: false,
    },
    resubmissionOfAppTest: {
        value: 'resubmissionOfAppTest',
        label: 'Resubmission of Appropriateness test is required',
        showReasonTextArea: false,
    },
    additionalDocumentation: {
        value: 'additionalDocumentation',
        label: 'Additional documentation is required due to third party deposits',
        showReasonTextArea: false,
    },
    copiesOfCreditDebitCards: {
        value: 'copiesOfCreditDebitCards',
        label: 'Copies of the used credit/debit cards for verification of your deposits',
        showReasonTextArea: false,
    },
    bankStatement: {
        value: 'bankStatement',
        label: 'Bank statement or other relevant source of funds document must be provided',
        showReasonTextArea: false,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
    },
});
const suspendedContractStatusReasons = asLocalizedEnum('suspendedContractStatusReasons', {
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
    },
    missingKycDoc: {
        value: 'missingKycDoc',
        label: 'Due to missing KYC documentation',
        showReasonTextArea: false,
    },
    missingProofAddress: {
        value: 'missingProofAddress',
        label: 'Due to missing Proof of Address',
        showReasonTextArea: false,
    },
    missingProofOfId: {
        value: 'missingProofOfId',
        label: 'Due to missing Proof of Identification',
        showReasonTextArea: false,
    },
    missingProofOfPayment: {
        value: 'missingProofOfPayment',
        label: 'Due to missing Proof of Payment (i.e. card copies/bank statement)',
        showReasonTextArea: false,
    },
    thirdPartyTransaction: {
        value: 'thirdPartyTransaction',
        label: 'Third party transaction/s',
        showReasonTextArea: false,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
    },
    chargebackCase: {
        value: 'chargebackCase',
        label: 'Chargeback case',
        showReasonTextArea: false,
    },
});
const closedContractStatusReasons = asLocalizedEnum('closedContractStatusReasons', {
    nonComplOrReceipt: {
        value: 'nonComplOrReceipt',
        label: 'Non-compliance or non-receipt of required documents / information',
        showReasonTextArea: false,
    },
    underagedClient: {
        value: 'underagedClient',
        label: 'Underaged client',
        showReasonTextArea: false,
    },
    notAcceptableCountry: {
        value: 'notAcceptableCountry',
        label: 'Non-acceptable country of residence',
        showReasonTextArea: false,
    },
    clientRequest: {
        value: 'clientRequest',
        label: 'As per your request',
        showReasonTextArea: false,
    },
    duplicateAccount: {
        value: 'duplicateAccount',
        label: 'Duplicate account',
        showReasonTextArea: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
    },
    declaredPep: {
        value: 'declaredPep',
        label: 'As you have declared to be Politically Exposed Person',
        showReasonTextArea: false,
    },
    declaredUsCitizen: {
        value: 'declaredUsCitizen',
        label: 'As you have declared to be US resident / citizen for tax purposes',
        showReasonTextArea: false,
    },
    fraud: {
        value: 'fraud',
        label: 'Potential fraud',
        showReasonTextArea: false,
    },
});
const kycStatuses = asLocalizedEnum('kycStatuses', {
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.INFO,
    },
    approved: {
        value: 'approved',
        label: 'Approved',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    firstLine: {
        value: 'first_line',
        label: '1st Line',
        labelIndicator: LabelIndicator.INFO,
    },
    amlo: {
        value: 'amlo',
        label: 'AMLO',
        labelIndicator: LabelIndicator.WARNING,
    },
    management: {
        value: 'management_approval',
        label: 'Management Approval',
        labelIndicator: LabelIndicator.WARNING,
    },
    draft: {
        value: 'draft',
        label: 'Draft',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const contractStatuses = asLocalizedEnum('contractStatuses', {
    draft: {
        value: 'draft',
        label: 'Draft',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    firstLinePending: {
        value: 'first_line_pending',
        label: '1st Line Pending',
        labelIndicator: LabelIndicator.INFO,
    },
    amloPending: {
        value: 'amlo_pending',
        label: 'AMLO Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    managementPending: {
        value: 'management_approval_pending',
        label: 'Management Approval Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    active: {
        value: 'active',
        label: 'Active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    signaturesPending: {
        value: 'signatures_pending',
        label: 'Signatures Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    changeRequest: {
        value: 'change_requested',
        label: 'Changes Requested',
        labelIndicator: LabelIndicator.WARNING,
    },
    suspended: {
        value: 'suspended',
        label: 'Suspended',
        labelIndicator: LabelIndicator.ERROR,
    },
    terminated: {
        value: 'terminated',
        label: 'Terminated',
        labelIndicator: LabelIndicator.ERROR,
    },
    monitoring: {
        value: 'monitoring',
        label: 'Active Monitoring',
        labelIndicator: LabelIndicator.WARNING,
    },
    terminationPending: {
        value: 'termination_pending',
        label: 'Termination Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    preAssessment: {
        value: 'pre_assessment',
        label: 'Pre-Assessment',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    onboardingClosed: {
        value: 'onboarding_closed',
        label: 'Onboarding Closed',
        labelIndicator: LabelIndicator.ERROR,
    },
    managementConsideration: {
        value: 'management_consideration',
        label: 'Management Consideration',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    preAssessmentDraft: {
        value: 'pre_assessment_draft',
        label: 'Pre-Assessment Draft',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const clientCategories = asEnum({
    retail: {
        value: 'retail',
        label: 'Retail',
    },
    professional: {
        value: 'professional',
        label: 'Professional',
    },
    eligibleCounterParty: {
        value: 'eligible_counter_party',
        label: 'Eligible CounterParty',
    },
});
const clientGBGTypes = asEnum({
    pass: {
        value: 'pass',
        label: 'Pass',
        id3Value: 'PASS',
    },
    refer: {
        value: 'refer',
        label: 'Refer',
        id3Value: 'REFER',
    },
    alert: {
        value: 'alert',
        label: 'Alert',
        id3Value: 'ALERT',
    },
});
const conversionStatuses = asEnum({
    duplicate: {
        value: 'duplicate',
        label: 'Duplicate',
        userAssignable: true,
    },
    lead: {
        value: 'lead',
        label: 'Lead',
        userAssignable: true,
    },
    converted: {
        value: 'converted',
        label: 'Converted',
        userAssignable: true,
    },
    noAnswer: {
        value: 'no_answer',
        label: 'No Answer',
        userAssignable: true,
    },
    doNotCall: {
        value: 'do_not_call',
        label: 'Do Not Call',
        userAssignable: true,
    },
    callAgain: {
        value: 'call_again',
        label: 'Call Again',
        userAssignable: true,
    },
    checkNumber: {
        value: 'check_number',
        label: 'Check Number',
        userAssignable: true,
    },
    reassigned: {
        value: 'reassigned',
        label: 'Reassigned',
        userAssignable: true,
    },
    interested: {
        value: 'interested',
        label: 'Interested',
        userAssignable: true,
    },
    vipClient: {
        value: 'vip_client',
        label: 'VIP Client',
        userAssignable: true,
    },
    topVipClient: {
        value: 'top_vip_client',
        label: 'Top VIP Client',
        userAssignable: true,
    },
    unregisteredLead: {
        value: 'unregistered_lead',
        label: 'Unregistered Lead',
        userAssignable: false,
    },
    lead_language_barrier: {
        value: 'lead_language_barrier',
        label: 'Lead Language Barrier',
        userAssignable: true,
    },
    abusive: {
        value: 'abusive',
        label: 'Abusive Account',
        userAssignable: true,
    },
    mobile: {
        value: 'mobile',
        label: 'Mobile Reassigned',
        userAssignable: true,
    },
    onboarding: {
        value: 'onboarding',
        label: 'On Boarding',
        userAssignable: true,
    },
    churn: {
        value: 'churn',
        label: 'Churn',
        userAssignable: true,
    },
    nec60Days: {
        value: 'nec_60_days',
        label: 'No Effective Call For 60 Days',
        userAssignable: true,
    },
    notInterested: {
        value: 'notInterested',
        label: 'Not Interested',
        userAssignable: true,
    },
    emailContact: {
        value: 'emailContact',
        label: 'Email Contact',
        userAssignable: true,
    },
});
const clientTypes = asEnum({
    retail: {
        value: 'retail',
        label: 'Retail',
        isIndividual: true,
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate',
        isIndividual: true,
    },
    corporate: {
        value: 'corporate',
        label: 'Corporate',
        isIndividual: false,
    },
    affiliateCorporate: {
        value: 'affiliateCorporate',
        label: 'Affiliate Corporate',
        isIndividual: false,
    },
    jointAccount: {
        value: 'jointAccount',
        label: 'Joint Account',
        isIndividual: false,
    },
    testClient: {
        value: 'testClient',
        label: 'Test',
        isIndividual: true,
    },
    merchant: {
        value: 'merchant',
        label: 'Merchant',
        isIndividual: false,
    },
    professional: {
        value: 'professional',
        label: 'Professional',
        isIndividual: true,
    },
    eligibleCounterParty: {
        value: 'eligibleCounterParty',
        label: 'Eligible CounterParty',
        isIndividual: false,
    },
});
const clientNoticeTypes = asEnum({
    termsChange: {
        value: 'tc_change',
        label: 'Terms and Conditions Change Notice',
    },
    informative: {
        value: 'informative',
        label: 'Informative Notice',
    },
});
const clientNoticeAcknowledgementTypes = asEnum({
    seen: {
        value: 'seen',
        label: 'Seen',
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
    },
    dismissed: {
        value: 'dismissed',
        label: 'dismissed',
    },
    remindLater: {
        value: 'remind_later',
        label: 'Remind Later',
    },
    declined: {
        value: 'declined',
        label: 'Declined',
    },
});
const helpOptions = asLocalizedEnum('helpOptions', {
    general: {
        value: 'general',
        label: 'General',
        email: 'support@bivial.com',
    },
    deposits: {
        value: 'deposits',
        label: 'Deposits',
        email: 'funding@bivial.com',
    },
    withdrawals: {
        value: 'withdrawals',
        label: 'Withdrawals',
        email: 'funding@bivial.com',
    },
    kycDocuments: {
        value: 'kycDocuments',
        label: 'KYC Documents',
        email: 'backoffice@bivial.com',
    },
    mobileApp: {
        value: 'mobileApp',
        label: 'Mobile App',
        email: 'support@bivial.com',
    },
    forgotPassword: {
        value: 'forgotPassword',
        label: 'Forgot Password',
        email: 'support@bivial.com',
    },
    partnerships: {
        value: 'partnerships',
        label: 'Partnerships',
        email: 'partnership@bivial.com',
    },
});
const phoneTypes = asEnum({
    primary: {
        value: 'primary',
        label: 'Primary',
    },
    secondary: {
        value: 'secondary',
        label: 'Secondary',
    },
});
const underMonitoringReasons = asLocalizedEnum('underMonitoringReasons', {
    thirdPartyDeposits: {
        value: 'thirdPartyDeposits',
        label: 'Third party deposits',
        showReasonTextArea: false,
    },
    cardCopiesRequired: {
        value: 'cardCopiesRequired',
        label: 'Card copies required',
        showReasonTextArea: false,
    },
    numberFailedTransactions: {
        value: 'numberFailedTransactions',
        label: 'Due to number of failed transactions/ reason of the failed transaction',
        showReasonTextArea: false,
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
        showReasonTextArea: false,
    },
    pepOrUs: {
        value: 'pepOrUs',
        label: 'As you have declared to be a Politically exposed person / US Reportable client',
        showReasonTextArea: false,
    },
    sameDepositMethodForDifferentProfiles: {
        value: 'sameDepositMethodForDifferentProfiles',
        label: 'Same deposit method for different profiles',
        showReasonTextArea: false,
    },
    other: {
        value: 'other',
        label: 'Other',
        showReasonTextArea: true,
    },
});
const signableNotices = asEnum({
    generalCFDDisclaimer: {
        value: 'generalCFDDisclaimer',
        label: 'Spanish Disclaimer',
    },
});
const clientPotentialLevels = asEnum({
    lowPotential: {
        value: 'lowPotential',
        code: 'LOW',
        label: 'Low Potential',
    },
    mediumPotential: {
        value: 'mediumPotential',
        code: 'MEDIUM',
        label: 'Medium Potential',
    },
    highPotential: {
        value: 'highPotential',
        code: 'HIGH',
        label: 'High Potential',
    },
});
const phoneVerificationTypes = asEnum({
    sms: {
        value: 'sms',
        label: 'SMS',
    },
    textToSpeech: {
        value: 'textToSpeech',
        label: 'Text To Speech',
    },
});
const themePreferenceOptions = asEnum({
    light: {
        value: 'light',
        label: 'Light Theme',
    },
    dark: {
        value: 'dark',
        label: 'Dark Theme',
    },
});
const signatoryRights = asEnum({
    joint: {
        value: 'joint',
        label: 'Joint',
    },
    sole: {
        value: 'sole',
        label: 'Sole',
    },
    group: {
        value: 'group',
        label: 'Group',
    },
});
const limitedAccessRights = asEnum({
    viewOnly: {
        value: 'view_only',
        label: 'View Only',
    },
    viewDataEntry: {
        value: 'view_data_entry',
        label: 'View and Data Entry',
    },
    cardHolder: {
        value: 'card_holder',
        label: 'Card Holder',
    },
    paymentFacilitationView: {
        value: 'payment_facilitation_view',
        label: 'Payment Facilitation View',
    },
});
const uboStakeTypes = asEnum({
    percent25OrMore: {
        value: 'percent_25_or_more',
        label: 'Controlling 25% or more',
    },
    percent25OrMoreViaPoA: {
        value: 'percent_25_or_more_via_poa',
        label: 'Controlling 25% or more via Trust',
    },
    managingDirector: {
        value: 'managing_director',
        label: 'Controlling as Managing Director',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
    nominee: {
        value: 'nominee',
        label: 'Nominee',
    },
});
const uboTypes = asEnum({
    naturalPerson: {
        value: 'natural_person',
        label: 'Natural Person',
    },
    legalEntity: {
        value: 'legal_entity',
        label: 'Legal Entity',
    },
});
const uboLegalEntityTypes = asEnum({
    operatingNotQuotedStockExchange: {
        value: 'operating_not_quoted',
        label: 'Operating, not quoted on stock exchange',
    },
    operatingQuotedStockExchange: {
        value: 'operating_quoted',
        label: 'Operating, quoted on stock exchange',
    },
    domiciliaryHolding: {
        value: 'domiciliary_holding',
        label: 'Domiciliary / Passive Holding',
    },
    activeHolding: {
        value: 'active_holding',
        label: 'Active Holding',
    },
    associationCharity: {
        value: 'association_charity',
        label: 'Association (Charity)',
    },
    bank: {
        value: 'bank',
        label: 'Bank',
    },
    soleProprietor: {
        value: 'sole_proprietor',
        label: 'Sole proprietor',
    },
    foundation: {
        value: 'foundation',
        label: 'Foundation (as well as similar constructs)',
    },
    unknown: {
        value: 'unknown',
        label: 'Unknown',
    },
    trust: {
        value: 'trust',
        label: 'Trust',
    },
});
const authorizedPersonStatuses = asEnum({
    pendingInvitation: {
        value: 'pending_invitation',
        label: 'Pending Invitation',
    },
    pendingSignature: {
        value: 'pending_signature',
        label: 'Pending Signature',
    },
    pendingVerification: {
        value: 'pending_verification',
        label: 'Pending Verification',
    },
    invited: {
        value: 'invited',
        label: 'Invited',
    },
    activated: {
        value: 'activated',
        label: 'Activated',
    },
    deactivated: {
        value: 'deactivated',
        label: 'Deactivated',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
});
const individualContractRoles = asEnum({
    authorizedSignatory: {
        value: 'authorized_signatory',
        label: 'Authorized Signatory',
    },
    authorizedLimitedAccess: {
        value: 'authorized_limited_access',
        label: 'Authorized Limited Access',
    },
    creator: {
        value: 'creator',
        label: 'Contract Creator',
    },
    ubo: {
        value: 'ubo',
        label: 'UBO',
    },
});
const individualContractOnboardingRequiredChecks = asEnum({
    emailConfirmation: {
        value: 'email_confirmation',
        label: 'Email Confirmation',
    },
    phoneVerification: {
        value: 'phone_verification',
        label: 'Phone Verification',
    },
    videoVerification: {
        value: 'video_verification',
        label: 'Video Verification',
    },
});
const contractRiskProfiles = asEnum({
    reduced: {
        label: 'Reduced Risk',
        value: 'reduced_risk',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    normal: {
        label: 'Normal Risk',
        value: 'normal',
        labelIndicator: LabelIndicator.INFO,
    },
    elevatedRisk: {
        label: 'Elevated Risk',
        value: 'elevated_risk',
        labelIndicator: LabelIndicator.ERROR,
    },
    increasedRisk: {
        label: 'Increased Risk',
        value: 'increased_risk',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const contractTypes = asEnum({
    introducerReference: {
        value: 'introducer_reference',
        label: 'Introducer Reference',
        labelIndicator: LabelIndicator.WARNING,
    },
    regular: {
        value: 'regular',
        label: 'Regular',
        labelIndicator: LabelIndicator.INFO,
    },
    individual: {
        value: 'individual',
        label: 'Individual',
        labelIndicator: LabelIndicator.INFO,
    },
    corporate: {
        value: 'corporate',
        label: 'Corporate',
        labelIndicator: LabelIndicator.INFO,
    },
});
const contractInformationRequestTypes = asEnum({
    documentRequest: {
        value: 'document_request',
        label: 'Document request',
    },
    freeText: {
        value: 'free_text',
        label: 'Free text',
    },
});
const contractInformationRequestStatuses = asEnum({
    draft: {
        value: 'draft',
        label: 'Draft',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    open: {
        value: 'open',
        label: 'Open',
        labelIndicator: LabelIndicator.INFO,
    },
    underReview: {
        value: 'under_review',
        label: 'Under review',
        labelIndicator: LabelIndicator.WARNING,
    },
    completed: {
        value: 'completed',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const appointmentStatuses = asEnum({
    scheduled: {
        value: 'scheduled',
        label: 'Scheduled',
        labelIndicator: LabelIndicator.INFO,
    },
    rescheduled: {
        value: 'rescheduled',
        label: 'Rescheduled',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    canceled: {
        value: 'canceled',
        label: 'canceled',
        labelIndicator: LabelIndicator.ERROR,
    },
    missed: {
        value: 'missed',
        label: 'missed',
        labelIndicator: LabelIndicator.ERROR,
    },
    completed: {
        value: 'completed',
        label: 'completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const communicationStatuses = asEnum({
    active: {
        value: 'active',
        label: 'Active',
    },
    hold: {
        value: 'hold',
        label: 'Hold',
    },
    inactive: {
        value: 'inactive',
        label: 'Inactive',
    },
    closed: {
        value: 'closed',
        label: 'Closed',
    },
    waitingForClarifications: {
        value: 'waiting_for_clarifications',
        label: 'Waiting for Clarifications',
    },
    escalatedToACM: {
        value: 'escalatedToACM',
        label: 'Escalated to ACM',
    },
});
const contractContactTypes = asEnum({
    general: {
        value: 'general',
        label: 'General',
    },
    contractChanges: {
        value: 'contract_changes',
        label: 'Contract Changes',
    },
    transactions: {
        value: 'transactions',
        label: 'Transactions',
    },
});
const minimumTurnOverFeeTypes = asEnum({
    minimum_turnover: {
        value: 'minimum_turnover',
        label: 'Minimum Turnover',
    },
    minimum_turnover_month_1: {
        value: 'minimum_turnover_month_1',
        label: 'Minimum Turnover Month 1',
    },
    minimum_turnover_month_2: {
        value: 'minimum_turnover_month_2',
        label: 'Minimum Turnover Month 2',
    },
    minimum_turnover_month_3: {
        value: 'minimum_turnover_month_3',
        label: 'Minimum Turnover Month 3',
    },
});
const contractOwnershipTransferStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    completed: {
        value: 'completed',
        label: 'Completed',
    },
});
const contractTermStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
    },
});
const directorRoles = asEnum({
    executive: {
        value: 'executive',
        label: 'Executive',
    },
    nonExecutive: {
        value: 'non_executive',
        label: 'Non Executive',
    },
    managingDirector: {
        value: 'managing_director',
        label: 'Managing Director',
    },
});
const directorSigningRights = asEnum({
    sole: {
        value: 'sole',
        label: 'Sole',
    },
    joint: {
        value: 'joint',
        label: 'Joint',
    },
    group: {
        value: 'group',
        label: 'Group',
    },
    noSigningRights: {
        value: 'no_signing_rights',
        label: 'No Signing Rights',
    },
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$1() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$1;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$4(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$4;

var assocIndexOf$3 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$1(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$1;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$1(key) {
  var data = this.__data__,
      index = assocIndexOf$2(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$1;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$1(key) {
  return assocIndexOf$1(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$1;

var assocIndexOf = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$1(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$1;

var listCacheClear = _listCacheClear,
    listCacheDelete = _listCacheDelete,
    listCacheGet = _listCacheGet,
    listCacheHas = _listCacheHas,
    listCacheSet = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$4.prototype.clear = listCacheClear;
ListCache$4.prototype['delete'] = listCacheDelete;
ListCache$4.prototype.get = listCacheGet;
ListCache$4.prototype.has = listCacheHas;
ListCache$4.prototype.set = listCacheSet;

var _ListCache = ListCache$4;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$1() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$1;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$1(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$1;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$1(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$1;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$1(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$1;

/** Detect free variable `global` from Node.js. */

var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$1;

var freeGlobal = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$8 = freeGlobal || freeSelf || Function('return this')();

var _root = root$8;

var root$7 = _root;

/** Built-in value references. */
var Symbol$4 = root$7.Symbol;

var _Symbol = Symbol$4;

var Symbol$3 = _Symbol;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$3 ? Symbol$3.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$1(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

var _getRawTag = getRawTag$1;

/** Used for built-in method references. */

var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$1(value) {
  return nativeObjectToString.call(value);
}

var _objectToString = objectToString$1;

var Symbol$2 = _Symbol,
    getRawTag = _getRawTag,
    objectToString = _objectToString;

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$5(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

var _baseGetTag = baseGetTag$5;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$5(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$5;

var baseGetTag$4 = _baseGetTag,
    isObject$4 = isObject_1;

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$1 = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$2(value) {
  if (!isObject$4(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$1 || tag == genTag || tag == asyncTag || tag == proxyTag;
}

var isFunction_1 = isFunction$2;

var root$6 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$1 = root$6['__core-js_shared__'];

var _coreJsData = coreJsData$1;

var coreJsData = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$1(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

var _isMasked = isMasked$1;

/** Used for built-in method references. */

var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$2(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$2;

var isFunction$1 = isFunction_1,
    isMasked = _isMasked,
    isObject$3 = isObject_1,
    toSource$1 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$9).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$1(value) {
  if (!isObject$3(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource$1(value));
}

var _baseIsNative = baseIsNative$1;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$1(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$1;

var baseIsNative = _baseIsNative,
    getValue = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$7(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

var _getNative = getNative$7;

var getNative$6 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var Map$3 = getNative$6(root$5, 'Map');

var _Map = Map$3;

var getNative$5 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$4 = getNative$5(Object, 'create');

var _nativeCreate = nativeCreate$4;

var nativeCreate$3 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$1() {
  this.__data__ = nativeCreate$3 ? nativeCreate$3(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$1;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$1(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$1;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$a = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$1(key) {
  var data = this.__data__;
  if (nativeCreate$2) {
    var result = data[key];
    return result === HASH_UNDEFINED$2 ? undefined : result;
  }
  return hasOwnProperty$8.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$1;

var nativeCreate$1 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$1(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$7.call(data, key);
}

var _hashHas = hashHas$1;

var nativeCreate = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$1(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED$1 : value;
  return this;
}

var _hashSet = hashSet$1;

var hashClear = _hashClear,
    hashDelete = _hashDelete,
    hashGet = _hashGet,
    hashHas = _hashHas,
    hashSet = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$1(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$1.prototype.clear = hashClear;
Hash$1.prototype['delete'] = hashDelete;
Hash$1.prototype.get = hashGet;
Hash$1.prototype.has = hashHas;
Hash$1.prototype.set = hashSet;

var _Hash = Hash$1;

var Hash = _Hash,
    ListCache$2 = _ListCache,
    Map$2 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$1() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$2 || ListCache$2),
    'string': new Hash
  };
}

var _mapCacheClear = mapCacheClear$1;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$1(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$1;

var isKeyable = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$4(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$4;

var getMapData$3 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$1(key) {
  var result = getMapData$3(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$1;

var getMapData$2 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$1(key) {
  return getMapData$2(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$1;

var getMapData$1 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$1(key) {
  return getMapData$1(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$1;

var getMapData = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$1(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$1;

var mapCacheClear = _mapCacheClear,
    mapCacheDelete = _mapCacheDelete,
    mapCacheGet = _mapCacheGet,
    mapCacheHas = _mapCacheHas,
    mapCacheSet = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$3(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$3.prototype.clear = mapCacheClear;
MapCache$3.prototype['delete'] = mapCacheDelete;
MapCache$3.prototype.get = mapCacheGet;
MapCache$3.prototype.has = mapCacheHas;
MapCache$3.prototype.set = mapCacheSet;

var _MapCache = MapCache$3;

var ListCache$1 = _ListCache,
    Map$1 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$1(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$1) {
    var pairs = data.__data__;
    if (!Map$1 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$1;

var ListCache = _ListCache,
    stackClear = _stackClear,
    stackDelete = _stackDelete,
    stackGet = _stackGet,
    stackHas = _stackHas,
    stackSet = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$2(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$2.prototype.clear = stackClear;
Stack$2.prototype['delete'] = stackDelete;
Stack$2.prototype.get = stackGet;
Stack$2.prototype.has = stackHas;
Stack$2.prototype.set = stackSet;

var _Stack = Stack$2;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$4 = _root;

/** Built-in value references. */
var Uint8Array$1 = root$4.Uint8Array;

var _Uint8Array = Uint8Array$1;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$1 = _Symbol,
    Uint8Array = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    errorTag$1 = '[object Error]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$2 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$2:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$1:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag$1:
    case dateTag$1:
    case numberTag$1:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$1:
      return object.name == other.name && object.message == other.message;

    case regexpTag$1:
    case stringTag$1:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$2:
      var convert = mapToArray;

    case setTag$2:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$1:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$8 = Array.isArray;

var isArray_1 = isArray$8;

var arrayPush$1 = _arrayPush,
    isArray$7 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$7(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$1;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$8.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$2 = !nativeGetSymbols$1 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable$1.call(object, symbol);
  });
};

var _getSymbols = getSymbols$2;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$1(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$1;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$5(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$5;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$1(value) {
  return isObjectLike$4(value) && baseGetTag$3(value) == argsTag$2;
}

var _baseIsArguments = baseIsArguments$1;

var baseIsArguments = _baseIsArguments,
    isObjectLike$3 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$7.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$7.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$2 = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$6.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

var isArguments_1 = isArguments$2;

var isBuffer$2 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$2, isBuffer$2.exports));

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$3(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

var isLength_1 = isLength$3;

var baseGetTag$2 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag$1 = '[object Map]',
    numberTag = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag$1 = '[object Set]',
    stringTag = '[object String]',
    weakMapTag$1 = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag$1] = typedArrayTags[numberTag] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag] =
typedArrayTags[setTag$1] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag$1] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$1(value) {
  return isObjectLike$2(value) &&
    isLength$2(value.length) && !!typedArrayTags[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$1;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$1(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$1;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray = _baseIsTypedArray,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$2 = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray_1 = isTypedArray$2;

var baseTimes = _baseTimes,
    isArguments$1 = isArguments_1,
    isArray$6 = isArray_1,
    isBuffer$1 = isBuffer$2.exports,
    isIndex$2 = _isIndex,
    isTypedArray$1 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$6.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$6(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$5.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$2(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$5 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$5;

  return value === proto;
}

var _isPrototype = isPrototype$2;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$1 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$1;

var isPrototype$1 = _isPrototype,
    nativeKeys = _nativeKeys;

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$4.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$1(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$4.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$1;

var isFunction = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$2(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys(object);
}

var keys_1 = keys$2;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$1 = _getSymbols,
    keys$1 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$1(object) {
  return baseGetAllKeys$1(object, keys$1, getSymbols$1);
}

var _getAllKeys = getAllKeys$1;

var getAllKeys = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$3.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var DataView$1 = getNative$4(root$3, 'DataView');

var _DataView = DataView$1;

var getNative$3 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var Promise$2 = getNative$3(root$2, 'Promise');

var _Promise = Promise$2;

var getNative$2 = _getNative,
    root$1 = _root;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative$2(root$1, 'Set');

var _Set = Set$1;

var getNative$1 = _getNative,
    root = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative$1(root, 'WeakMap');

var _WeakMap = WeakMap$1;

var DataView = _DataView,
    Map = _Map,
    Promise$1 = _Promise,
    Set = _Set,
    WeakMap = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource = _toSource;

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise$1),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$1 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag$1(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag$1(new Map) != mapTag) ||
    (Promise$1 && getTag$1(Promise$1.resolve()) != promiseTag) ||
    (Set && getTag$1(new Set) != setTag) ||
    (WeakMap && getTag$1(new WeakMap) != weakMapTag)) {
  getTag$1 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

var _getTag = getTag$1;

var Stack$1 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag = _getTag,
    isArray$5 = isArray_1,
    isBuffer = isBuffer$2.exports,
    isTypedArray = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$5(object),
      othIsArr = isArray$5(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$1);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$2.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$2.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$1);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$1);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$1 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$1(value) && !isObjectLike$1(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$2 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$2(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$3(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

var isSymbol_1 = isSymbol$3;

var isArray$4 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$4(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$2(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

var MapCache = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$1(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$1.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize$1.Cache = MapCache;

var memoize_1 = memoize$1;

var memoize = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$1(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$1;

var memoizeCapped = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$1 = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$1;

var Symbol = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$3 = isArray_1,
    isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$1(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$3(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$1) + '';
  }
  if (isSymbol$1(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

var _baseToString = baseToString$1;

var baseToString = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$1(value) {
  return value == null ? '' : baseToString(value);
}

var toString_1 = toString$1;

var isArray$2 = isArray_1,
    isKey$2 = _isKey,
    stringToPath = _stringToPath,
    toString = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$4(value, object) {
  if (isArray$2(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath(toString(value));
}

var _castPath = castPath$4;

var isSymbol = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$3 = _castPath,
    toKey$4 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$3(object, path) {
  path = castPath$3(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$4(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$3;

var baseGet$2 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$2(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var castPath$2 = _castPath,
    isArguments = isArguments_1,
    isArray$1 = isArray_1,
    isIndex$1 = _isIndex,
    isLength = isLength_1,
    toKey$3 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$1(object, path, hasFunc) {
  path = castPath$2(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$3(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex$1(key, length) &&
    (isArray$1(object) || isArguments(object));
}

var _hasPath = hasPath$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}

var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet$1 = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet$1(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$1(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$1;

var getNative = _getNative;

var defineProperty$1 = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$1;

var defineProperty = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$1(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$1;

var baseAssignValue = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$1(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$1.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

var _assignValue = assignValue$1;

var assignValue = _assignValue,
    castPath$1 = _castPath,
    isIndex = _isIndex,
    isObject$1 = isObject_1,
    toKey = _toKey;

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet$1(object, path, value, customizer) {
  if (!isObject$1(object)) {
    return object;
  }
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject$1(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

var _baseSet = baseSet$1;

var baseGet = _baseGet,
    baseSet = _baseSet,
    castPath = _castPath;

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy$1(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

var _basePickBy = basePickBy$1;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$1 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$1;

var arrayPush = _arrayPush,
    getPrototype = _getPrototype,
    getSymbols = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$1 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject = isObject_1,
    isPrototype = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$1(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

var arrayMap = _arrayMap,
    baseIteratee = _baseIteratee,
    basePickBy = _basePickBy,
    getAllKeysIn = _getAllKeysIn;

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

var pickBy_1 = pickBy;

const currencies = asEnum({
    EUR: {
        value: 'EUR',
        label: 'EUR',
        symbol: '\u20ac',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key, fundTypes.depositGuaranteed.key],
        iconImage: 'EU',
    },
    USD: {
        value: 'USD',
        label: 'USD',
        symbol: '$',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key, fundTypes.depositGuaranteed.key],
        iconImage: 'US',
    },
    GBP: {
        value: 'GBP',
        label: 'GBP',
        symbol: '£',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'GB',
    },
    PLN: {
        value: 'PLN',
        label: 'PLN',
        symbol: 'PLN',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'PL',
    },
    CHF: {
        value: 'CHF',
        label: 'CHF',
        symbol: 'CHF',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key, fundTypes.depositGuaranteed.key],
        iconImage: 'CH',
    },
    SEK: {
        value: 'SEK',
        label: 'SEK',
        symbol: 'SEK',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'SE',
    },
    DKK: {
        value: 'DKK',
        label: 'DKK',
        symbol: 'DKK',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'DK',
    },
    NOK: {
        value: 'NOK',
        label: 'NOK',
        symbol: 'NOK',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'NO',
    },
    CAD: {
        value: 'CAD',
        label: 'CAD',
        symbol: 'CAD',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'CA',
    },
    AUD: {
        value: 'AUD',
        label: 'AUD',
        symbol: 'AUD',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'AU',
    },
    AED: {
        value: 'AED',
        label: 'AED',
        symbol: 'AED',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'AE',
    },
    HKD: {
        value: 'HKD',
        label: 'HKD',
        symbol: 'HKD',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'HK',
    },
    HUF: {
        value: 'HUF',
        label: 'HUF',
        symbol: 'HUF',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'HU',
    },
    JPY: {
        value: 'JPY',
        label: 'JPY',
        symbol: 'JPY',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'JP',
    },
    MXN: {
        value: 'MXN',
        label: 'MXN',
        symbol: 'MXN',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'MX',
    },
    TRY: {
        value: 'TRY',
        label: 'TRY',
        symbol: 'TRY',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'TR',
    },
    ZAR: {
        value: 'ZAR',
        label: 'ZAR',
        symbol: 'ZAR',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'ZA',
    },
    CZK: {
        value: 'CZK',
        label: 'CZK',
        symbol: 'Kč',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'CZ',
    },
    SGD: {
        value: 'SGD',
        label: 'SGD',
        symbol: 'S$',
        allowedNewAccounts: [fundTypes.clientFunds.key, fundTypes.operational.key],
        iconImage: 'SG',
    },
});
const newAccountCurrencies = pickBy_1(currencies, (currency) => currency.allowedNewAccounts.length > 0);

const companies = asEnum({
    bivial: {
        value: 'bivial',
        label: 'Bivial',
        brand: 'bivial',
        brandLabel: 'Bivial',
        domain: 'bivial.com',
        tradingName: 'Bivial AG',
        regulator: 'finma',
        trademark: 'Bivial AG',
        emailDomain: 'bivial.com',
        portalDomain: 'dashboard.bivial.com',
        requiresAPTest: false,
        requiresEP: false,
        sortIndex: 1,
        kycDeadline: 15,
        registrationSteps: ['step1'],
        accountVerification: {
            profile: '',
            economicProfile: 'FORCE_AFTER_LOGIN',
            kycStatus: '',
        },
        sendGridTemplate: 'bivial-generic',
        logo: 'https://media.bivial.com/logos/bivial.png',
        depositLimitWithoutKyc: 2000,
        depositLimitCurrency: currencies.EUR,
        strictVerificationRules: true,
    },
});
const companyTypes = asEnum({
    limitedLiabilityCompany: {
        label: 'Limited Liability Company',
    },
    jointStockCompany: {
        label: 'Joint Stock Company',
    },
    publicLimitedCompany: {
        label: 'Public Limited Company',
    },
});

const countrySupportedCurrencies = asEnum({
    ID: {
        value: 'ID',
        label: 'ID',
        currencies: ['IDR'],
    },
    DZ: {
        value: 'DZ',
        label: 'DZ',
        currencies: ['DZD'],
    },
    AO: {
        value: 'AO',
        label: 'AO',
        currencies: ['AOA'],
    },
    AR: {
        value: 'AR',
        label: 'AR',
        currencies: ['ARS'],
    },
    AU: {
        value: 'AU',
        label: 'AU',
        currencies: ['AUD'],
    },
    AT: {
        value: 'AT',
        label: 'AT',
        currencies: ['EUR'],
    },
    AZ: {
        value: 'AZ',
        label: 'AZ',
        currencies: ['AZN'],
    },
    BS: {
        value: 'BS',
        label: 'BS',
        currencies: ['BSD'],
    },
    BH: {
        value: 'BH',
        label: 'BH',
        currencies: ['BHD'],
    },
    BD: {
        value: 'BD',
        label: 'BD',
        currencies: ['BDT'],
    },
    BY: {
        value: 'BY',
        label: 'BY',
        currencies: ['BYN'],
    },
    BE: {
        value: 'BE',
        label: 'BE',
        currencies: ['EUR'],
    },
    BO: {
        value: 'BO',
        label: 'BO',
        currencies: ['BOB'],
    },
    BR: {
        value: 'BR',
        label: 'BR',
        currencies: ['BRL'],
    },
    BG: {
        value: 'BG',
        label: 'BG',
        currencies: ['EUR'],
    },
    KH: {
        value: 'KH',
        label: 'KH',
        currencies: ['KHR'],
    },
    CA: {
        value: 'CA',
        label: 'CA',
        currencies: ['KHR'],
    },
    KY: {
        value: 'KY',
        label: 'KY',
        currencies: ['KYD'],
    },
    CL: {
        value: 'CL',
        label: 'CL',
        currencies: ['CLP'],
    },
    CO: {
        value: 'CO',
        label: 'CO',
        currencies: ['COP'],
    },
    CR: {
        value: 'CR',
        label: 'CR',
        currencies: ['CRC'],
    },
    CI: {
        value: 'CI',
        label: 'CI',
        currencies: ['XOF'],
    },
    HR: {
        value: 'HR',
        label: 'HR',
        currencies: ['HRK'],
    },
    CW: {
        value: 'CW',
        label: 'CW',
        currencies: ['ANG'],
    },
    CZ: {
        value: 'CZ',
        label: 'CZ',
        currencies: ['CZK'],
    },
    DK: {
        value: 'DK',
        label: 'DK',
        currencies: ['DKK'],
    },
    DO: {
        value: 'DO',
        label: 'DO',
        currencies: ['DOP'],
    },
    EC: {
        value: 'EC',
        label: 'EC',
        currencies: ['USD'],
    },
    EG: {
        value: 'EG',
        label: 'EG',
        currencies: ['EGP'],
    },
    SV: {
        value: 'SV',
        label: 'SV',
        currencies: ['USD'],
    },
    EE: {
        value: 'EE',
        label: 'EE',
        currencies: ['EUR'],
    },
    FI: {
        value: 'FI',
        label: 'FI',
        currencies: ['EUR'],
    },
    FR: {
        value: 'FR',
        label: 'FR',
        currencies: ['EUR'],
    },
    GE: {
        value: 'GE',
        label: 'GE',
        currencies: ['GEL'],
    },
    DE: {
        value: 'DE',
        label: 'DE',
        currencies: ['EUR'],
    },
    GH: {
        value: 'GH',
        label: 'GH',
        currencies: ['GHS'],
    },
    GR: {
        value: 'GR',
        label: 'GR',
        currencies: ['EUR'],
    },
    GT: {
        value: 'GT',
        label: 'GT',
        currencies: ['GTQ'],
    },
    HT: {
        value: 'HT',
        label: 'HT',
        currencies: ['HTG'],
    },
    HN: {
        value: 'HN',
        label: 'HN',
        currencies: ['HNL'],
    },
    HK: {
        value: 'HK',
        label: 'HK',
        currencies: ['HKD'],
    },
    HU: {
        value: 'HU',
        label: 'HU',
        currencies: ['EUR', 'HUF'],
    },
    IE: {
        value: 'IE',
        label: 'IE',
        currencies: ['EUR'],
    },
    IL: {
        value: 'IL',
        label: 'IL',
        currencies: ['ILS'],
    },
    IT: {
        value: 'IT',
        label: 'IT',
        currencies: ['EUR'],
    },
    JP: {
        value: 'JP',
        label: 'JP',
        currencies: ['JPY'],
    },
    JO: {
        value: 'JO',
        label: 'JO',
        currencies: ['JOD'],
    },
    KZ: {
        value: 'KZ',
        label: 'KZ',
        currencies: ['KZT'],
    },
    KE: {
        value: 'KE',
        label: 'KE',
        currencies: ['KES'],
    },
    KW: {
        value: 'KW',
        label: 'KW',
        currencies: ['KWD'],
    },
    LA: {
        value: 'LA',
        label: 'LA',
        currencies: ['LAK'],
    },
    LV: {
        value: 'LV',
        label: 'LV',
        currencies: ['EUR'],
    },
    LB: {
        value: 'LB',
        label: 'LB',
        currencies: ['LBP'],
    },
    LT: {
        value: 'LT',
        label: 'LT',
        currencies: ['EUR'],
    },
    LU: {
        value: 'LU',
        label: 'LU',
        currencies: ['EUR'],
    },
    MT: {
        value: 'MT',
        label: 'MT',
        currencies: ['EUR'],
    },
    MU: {
        value: 'MU',
        label: 'MU',
        currencies: ['MUR'],
    },
    MX: {
        value: 'MX',
        label: 'MX',
        currencies: ['MXN'],
    },
    MN: {
        value: 'MN',
        label: 'MN',
        currencies: ['MNT'],
    },
    MA: {
        value: 'MA',
        label: 'MA',
        currencies: ['MAD'],
    },
    NL: {
        value: 'NL',
        label: 'NL',
        currencies: ['EUR'],
    },
    NZ: {
        value: 'NZ',
        label: 'NZ',
        currencies: ['NZD'],
    },
    NI: {
        value: 'NI',
        label: 'NI',
        currencies: ['NIO'],
    },
    NG: {
        value: 'NG',
        label: 'NG',
        currencies: ['NGN'],
    },
    NO: {
        value: 'NO',
        label: 'NO',
        currencies: ['NOK'],
    },
    OM: {
        value: 'OM',
        label: 'OM',
        currencies: ['OMR'],
    },
    PA: {
        value: 'PA',
        label: 'PA',
        currencies: ['PAB'],
    },
    PY: {
        value: 'PY',
        label: 'PY',
        currencies: ['PYG'],
    },
    PE: {
        value: 'PE',
        label: 'PE',
        currencies: ['PEN'],
    },
    PL: {
        value: 'PL',
        label: 'PL',
        currencies: ['PLN'],
    },
    PT: {
        value: 'PT',
        label: 'PT',
        currencies: ['EUR'],
    },
    PR: {
        value: 'PR',
        label: 'PR',
        currencies: ['USD'],
    },
    QA: {
        value: 'QA',
        label: 'QA',
        currencies: ['QAR'],
    },
    RO: {
        value: 'RO',
        label: 'RO',
        currencies: ['RON'],
    },
    SA: {
        value: 'SA',
        label: 'SA',
        currencies: ['SAR'],
    },
    SN: {
        value: 'SN',
        label: 'SN',
        currencies: ['XOF'],
    },
    RS: {
        value: 'RS',
        label: 'RS',
        currencies: ['RSD'],
    },
    SG: {
        value: 'SG',
        label: 'SG',
        currencies: ['SGD'],
    },
    SI: {
        value: 'SI',
        label: 'SI',
        currencies: ['EUR'],
    },
    ZA: {
        value: 'ZA',
        label: 'ZA',
        currencies: ['ZAR'],
    },
    KR: {
        value: 'KR',
        label: 'KR',
        currencies: ['KRW'],
    },
    ES: {
        value: 'ES',
        label: 'ES',
        currencies: ['EUR'],
    },
    LK: {
        value: 'LK',
        label: 'LK',
        currencies: ['LKR'],
    },
    SE: {
        value: 'SE',
        label: 'SE',
        currencies: ['SEK'],
    },
    CH: {
        value: 'CH',
        label: 'CH',
        currencies: ['CHF'],
    },
    TZ: {
        value: 'TZ',
        label: 'TZ',
        currencies: ['TZS'],
    },
    TH: {
        value: 'TH',
        label: 'TH',
        currencies: ['THB'],
    },
    TT: {
        value: 'TT',
        label: 'TT',
        currencies: ['TTD'],
    },
    TN: {
        value: 'TN',
        label: 'TN',
        currencies: ['TND'],
    },
    TR: {
        value: 'TR',
        label: 'TR',
        currencies: ['TRY'],
    },
    UG: {
        value: 'UG',
        label: 'UG',
        currencies: ['UGX'],
    },
    UA: {
        value: 'UA',
        label: 'UA',
        currencies: ['UAH'],
    },
    AE: {
        value: 'AE',
        label: 'AE',
        currencies: ['AED'],
    },
    GB: {
        value: 'GB',
        label: 'GB',
        currencies: ['GBP'],
    },
    US: {
        value: 'US',
        label: 'US',
        currencies: ['USD'],
    },
    UY: {
        value: 'UY',
        label: 'UY',
        currencies: ['UYU'],
    },
    AL: {
        value: 'AL',
        label: 'AL',
        currencies: ['ALL'],
    },
    AG: {
        value: 'AG',
        label: 'AG',
        currencies: ['XCD'],
    },
    BM: {
        value: 'BM',
        label: 'BM',
        currencies: ['BMD'],
    },
    BA: {
        value: 'BA',
        label: 'BA',
        currencies: ['BAM'],
    },
    VG: {
        value: 'VG',
        label: 'VG',
        currencies: ['USD'],
    },
    CY: {
        value: 'CY',
        label: 'CY',
        currencies: ['EUR'],
    },
    GY: {
        value: 'GY',
        label: 'GY',
        currencies: ['GYD'],
    },
    JM: {
        value: 'JM',
        label: 'JM',
        currencies: ['JMD'],
    },
    SK: {
        value: 'SK',
        label: 'SK',
        currencies: ['EUR'],
    },
});
const countries = asLocalizedEnum('countries', {
    af: {
        value: 'AF',
        label: 'Afghanistan',
        callingCode: '93',
        alpha3Code: 'AFG',
        forbidden: true,
        isoNumeric: 4,
    },
    ax: {
        value: 'AX',
        label: 'Aland Islands',
        callingCode: '358',
        alpha3Code: 'ALA',
        isoNumeric: 248,
    },
    al: {
        value: 'AL',
        label: 'Albania',
        callingCode: '355',
        alpha3Code: 'ALB',
        isoNumeric: 8,
    },
    dz: {
        value: 'DZ',
        label: 'Algeria',
        callingCode: '213',
        alpha3Code: 'DZA',
        isoNumeric: 12,
    },
    as: {
        value: 'AS',
        label: 'American Samoa',
        callingCode: '1684',
        alpha3Code: 'ASM',
        isoNumeric: 16,
    },
    ad: {
        value: 'AD',
        label: 'Andorra',
        callingCode: '376',
        alpha3Code: 'AND',
        isoNumeric: 20,
    },
    ao: {
        value: 'AO',
        label: 'Angola',
        callingCode: '244',
        alpha3Code: 'AGO',
        isoNumeric: 24,
    },
    ai: {
        value: 'AI',
        label: 'Anguilla',
        callingCode: '1264',
        alpha3Code: 'AIA',
        isoNumeric: 660,
    },
    aq: {
        value: 'AQ',
        label: 'Antarctica',
        callingCode: '672',
        alpha3Code: 'ATA',
        hidden: true,
        isoNumeric: 10,
    },
    ag: {
        value: 'AG',
        label: 'Antigua And Barbuda',
        callingCode: '1268',
        alpha3Code: 'ATG',
        isoNumeric: 28,
    },
    ar: {
        value: 'AR',
        label: 'Argentina',
        currency: 'ARS',
        callingCode: '54',
        alpha3Code: 'ARG',
        isoNumeric: 32,
    },
    am: {
        value: 'AM',
        label: 'Armenia',
        callingCode: '374',
        alpha3Code: 'ARM',
        isoNumeric: 51,
    },
    aw: {
        value: 'AW',
        label: 'Aruba',
        callingCode: '297',
        alpha3Code: 'ABW',
        isoNumeric: 533,
    },
    au: {
        value: 'AU',
        label: 'Australia',
        callingCode: '61',
        alpha3Code: 'AUS',
        isoNumeric: 36,
    },
    at: {
        value: 'AT',
        label: 'Austria',
        currency: 'EUR',
        callingCode: '43',
        isEU: true,
        alpha3Code: 'AUT',
        isoNumeric: 40,
    },
    az: {
        value: 'AZ',
        label: 'Azerbaijan',
        callingCode: '994',
        alpha3Code: 'AZE',
        isoNumeric: 31,
    },
    bs: {
        value: 'BS',
        label: 'Bahamas',
        callingCode: '1242',
        alpha3Code: 'BHS',
        isoNumeric: 44,
    },
    bh: {
        value: 'BH',
        label: 'Bahrain',
        callingCode: '973',
        alpha3Code: 'BHR',
        isoNumeric: 48,
    },
    bd: {
        value: 'BD',
        label: 'Bangladesh',
        callingCode: '880',
        alpha3Code: 'BGD',
        isoNumeric: 50,
    },
    bb: {
        value: 'BB',
        label: 'Barbados',
        callingCode: '1246',
        alpha3Code: 'BRB',
        isoNumeric: 52,
    },
    by: {
        value: 'BY',
        label: 'Belarus',
        callingCode: '375',
        alpha3Code: 'BLR',
        isoNumeric: 112,
    },
    be: {
        value: 'BE',
        label: 'Belgium',
        currency: 'EUR',
        callingCode: '32',
        isEU: true,
        alpha3Code: 'BEL',
        isoNumeric: 56,
    },
    bz: {
        value: 'BZ',
        label: 'Belize',
        callingCode: '501',
        alpha3Code: 'BLZ',
        isoNumeric: 84,
    },
    bj: {
        value: 'BJ',
        label: 'Benin',
        callingCode: '229',
        alpha3Code: 'BEN',
        isoNumeric: 204,
    },
    bm: {
        value: 'BM',
        label: 'Bermuda',
        callingCode: '1441',
        alpha3Code: 'BMU',
        isoNumeric: 60,
    },
    bt: {
        value: 'BT',
        label: 'Bhutan',
        callingCode: '975',
        alpha3Code: 'BTN',
        isoNumeric: 64,
    },
    bo: {
        value: 'BO',
        label: 'Bolivia',
        callingCode: '591',
        alpha3Code: 'BOL',
        isoNumeric: 68,
    },
    ba: {
        value: 'BA',
        label: 'Bosnia And Herzegovina',
        callingCode: '387',
        alpha3Code: 'BIH',
        isoNumeric: 70,
    },
    bw: {
        value: 'BW',
        label: 'Botswana',
        callingCode: '267',
        alpha3Code: 'BWA',
        isoNumeric: 72,
    },
    bv: {
        value: 'BV',
        label: 'Bouvet Island',
        alpha3Code: 'BVT',
        callingCode: '47',
        isoNumeric: 74,
    },
    br: {
        value: 'BR',
        label: 'Brazil',
        currency: 'BRL',
        callingCode: '55',
        alpha3Code: 'BRA',
        isoNumeric: 76,
    },
    io: {
        value: 'IO',
        label: 'British Indian Ocean Territory',
        callingCode: '246',
        alpha3Code: 'IOT',
        isoNumeric: 86,
    },
    bn: {
        value: 'BN',
        label: 'Brunei Darussalam',
        callingCode: '673',
        alpha3Code: 'BRN',
        isoNumeric: 96,
    },
    bg: {
        value: 'BG',
        label: 'Bulgaria',
        callingCode: '359',
        isEU: true,
        alpha3Code: 'BGR',
        isoNumeric: 100,
    },
    bf: {
        value: 'BF',
        label: 'Burkina Faso',
        callingCode: '226',
        alpha3Code: 'BFA',
        isoNumeric: 854,
    },
    bi: {
        value: 'BI',
        label: 'Burundi',
        callingCode: '257',
        alpha3Code: 'BDI',
        isoNumeric: 108,
    },
    kh: {
        value: 'KH',
        label: 'Cambodia',
        callingCode: '855',
        alpha3Code: 'KHM',
        isoNumeric: 116,
    },
    cm: {
        value: 'CM',
        label: 'Cameroon',
        callingCode: '237',
        alpha3Code: 'CMR',
        isoNumeric: 120,
    },
    ca: {
        value: 'CA',
        label: 'Canada',
        callingCode: '1',
        alpha3Code: 'CAN',
        isoNumeric: 124,
    },
    cv: {
        value: 'CV',
        label: 'Cape Verde',
        callingCode: '238',
        alpha3Code: 'CPV',
        isoNumeric: 132,
    },
    ky: {
        value: 'KY',
        label: 'Cayman Islands',
        callingCode: ' 345',
        alpha3Code: 'CYM',
        isoNumeric: 136,
    },
    cf: {
        value: 'CF',
        label: 'Central African Republic',
        callingCode: '236',
        alpha3Code: 'CAF',
        forbidden: true,
        isoNumeric: 140,
    },
    td: {
        value: 'TD',
        label: 'Chad',
        callingCode: '235',
        alpha3Code: 'TCD',
        isoNumeric: 148,
    },
    cl: {
        value: 'CL',
        label: 'Chile',
        currency: 'CLP',
        callingCode: '56',
        alpha3Code: 'CHL',
        isoNumeric: 152,
    },
    cn: {
        value: 'CN',
        label: 'China',
        currency: 'CNY',
        callingCode: '86',
        alpha3Code: 'CHN',
        forbidden: true,
        isoNumeric: 156,
    },
    cx: {
        value: 'CX',
        label: 'Christmas Island',
        callingCode: '61',
        alpha3Code: 'CXR',
        isoNumeric: 162,
    },
    cc: {
        value: 'CC',
        label: 'Cocos (Keeling) Islands',
        callingCode: '61',
        alpha3Code: 'CCK',
        isoNumeric: 166,
    },
    co: {
        value: 'CO',
        label: 'Colombia',
        currency: 'COP',
        callingCode: '57',
        alpha3Code: 'COL',
        isoNumeric: 170,
    },
    km: {
        value: 'KM',
        label: 'Comoros',
        callingCode: '269',
        alpha3Code: 'COM',
        isoNumeric: 174,
    },
    cg: {
        value: 'CG',
        label: 'Congo',
        callingCode: '242',
        alpha3Code: 'COG',
        isoNumeric: 178,
    },
    cd: {
        value: 'CD',
        label: 'Congo, Democratic Republic',
        callingCode: '243',
        alpha3Code: 'COD',
        isoNumeric: 180,
    },
    ck: {
        value: 'CK',
        label: 'Cook Islands',
        callingCode: '682',
        alpha3Code: 'COK',
        isoNumeric: 184,
    },
    cr: {
        value: 'CR',
        label: 'Costa Rica',
        callingCode: '506',
        alpha3Code: 'CRI',
        isoNumeric: 188,
    },
    ci: {
        value: 'CI',
        label: "Cote D'Ivoire",
        callingCode: '225',
        alpha3Code: 'CIV',
        isoNumeric: 384,
    },
    hr: {
        value: 'HR',
        label: 'Croatia',
        callingCode: '385',
        isEU: true,
        alpha3Code: 'HRV',
        isoNumeric: 191,
    },
    cu: {
        value: 'CU',
        label: 'Cuba',
        callingCode: '53',
        alpha3Code: 'CUB',
        isoNumeric: 192,
    },
    cy: {
        value: 'CY',
        label: 'Cyprus',
        currency: 'EUR',
        callingCode: '357',
        isEU: true,
        alpha3Code: 'CYP',
        isoNumeric: 196,
    },
    cz: {
        value: 'CZ',
        label: 'Czech Republic',
        callingCode: '420',
        isEU: true,
        alpha3Code: 'CZE',
        isoNumeric: 203,
    },
    dk: {
        value: 'DK',
        label: 'Denmark',
        callingCode: '45',
        isEU: true,
        alpha3Code: 'DNK',
        isoNumeric: 208,
    },
    dj: {
        value: 'DJ',
        label: 'Djibouti',
        callingCode: '253',
        alpha3Code: 'DJI',
        isoNumeric: 262,
    },
    dm: {
        value: 'DM',
        label: 'Dominica',
        callingCode: '1767',
        alpha3Code: 'DMA',
        isoNumeric: 212,
    },
    do: {
        value: 'DO',
        label: 'Dominican Republic',
        callingCode: '1849',
        alpha3Code: 'DOM',
        isoNumeric: 214,
    },
    ec: {
        value: 'EC',
        label: 'Ecuador',
        callingCode: '593',
        alpha3Code: 'ECU',
        isoNumeric: 218,
    },
    eg: {
        value: 'EG',
        label: 'Egypt',
        callingCode: '20',
        alpha3Code: 'EGY',
        isoNumeric: 818,
    },
    sv: {
        value: 'SV',
        label: 'El Salvador',
        callingCode: '503',
        alpha3Code: 'SLV',
        isoNumeric: 222,
    },
    gq: {
        value: 'GQ',
        label: 'Equatorial Guinea',
        callingCode: '240',
        alpha3Code: 'GNQ',
        isoNumeric: 226,
    },
    er: {
        value: 'ER',
        label: 'Eritrea',
        forbidden: true,
        callingCode: '291',
        alpha3Code: 'ERI',
        isoNumeric: 232,
    },
    ee: {
        value: 'EE',
        label: 'Estonia',
        currency: 'EUR',
        callingCode: '372',
        isEU: true,
        alpha3Code: 'EST',
        isoNumeric: 233,
    },
    et: {
        value: 'ET',
        label: 'Ethiopia',
        callingCode: '251',
        alpha3Code: 'ETH',
        isoNumeric: 231,
    },
    fk: {
        value: 'FK',
        label: 'Falkland Islands (Malvinas)',
        callingCode: '500',
        alpha3Code: 'FLK',
        isoNumeric: 238,
    },
    fo: {
        value: 'FO',
        label: 'Faroe Islands',
        callingCode: '298',
        alpha3Code: 'FRO',
        isoNumeric: 234,
    },
    fj: {
        value: 'FJ',
        label: 'Fiji',
        callingCode: '679',
        alpha3Code: 'FJI',
        isoNumeric: 242,
    },
    fi: {
        value: 'FI',
        label: 'Finland',
        currency: 'EUR',
        callingCode: '358',
        isEU: true,
        alpha3Code: 'FIN',
        isoNumeric: 246,
    },
    fr: {
        value: 'FR',
        label: 'France',
        currency: 'EUR',
        callingCode: '33',
        marketingCommunicationDisabled: true,
        isEU: true,
        alpha3Code: 'FRA',
        isoNumeric: 250,
    },
    gf: {
        value: 'GF',
        label: 'French Guiana',
        callingCode: '594',
        alpha3Code: 'GUF',
        isoNumeric: 254,
    },
    pf: {
        value: 'PF',
        label: 'French Polynesia',
        callingCode: '689',
        alpha3Code: 'PYF',
        isoNumeric: 258,
    },
    tf: {
        value: 'TF',
        label: 'French Southern Territories',
        alpha3Code: 'ATF',
        callingCode: '262',
        isoNumeric: 260,
    },
    ga: {
        value: 'GA',
        label: 'Gabon',
        callingCode: '241',
        alpha3Code: 'GAB',
        isoNumeric: 266,
    },
    gm: {
        value: 'GM',
        label: 'Gambia',
        callingCode: '220',
        alpha3Code: 'GMB',
        isoNumeric: 270,
    },
    ge: {
        value: 'GE',
        label: 'Georgia',
        callingCode: '995',
        alpha3Code: 'GEO',
        isoNumeric: 268,
    },
    de: {
        value: 'DE',
        label: 'Germany',
        currency: 'EUR',
        callingCode: '49',
        isEU: true,
        alpha3Code: 'DEU',
        isoNumeric: 276,
    },
    gh: {
        value: 'GH',
        label: 'Ghana',
        callingCode: '233',
        alpha3Code: 'GHA',
        isoNumeric: 288,
    },
    gi: {
        value: 'GI',
        label: 'Gibraltar',
        callingCode: '350',
        alpha3Code: 'GIB',
        isoNumeric: 292,
    },
    gr: {
        value: 'GR',
        label: 'Greece',
        currency: 'EUR',
        callingCode: '30',
        isEU: true,
        alpha3Code: 'GRC',
        isoNumeric: 300,
    },
    gl: {
        value: 'GL',
        label: 'Greenland',
        callingCode: '299',
        alpha3Code: 'GRL',
        isoNumeric: 304,
    },
    gd: {
        value: 'GD',
        label: 'Grenada',
        callingCode: '1473',
        alpha3Code: 'GRD',
        isoNumeric: 308,
    },
    gp: {
        value: 'GP',
        label: 'Guadeloupe',
        callingCode: '590',
        alpha3Code: 'GLP',
        isoNumeric: 312,
    },
    gu: {
        value: 'GU',
        label: 'Guam',
        callingCode: '1671',
        alpha3Code: 'GUM',
        isoNumeric: 316,
    },
    gt: {
        value: 'GT',
        label: 'Guatemala',
        callingCode: '502',
        alpha3Code: 'GTM',
        isoNumeric: 320,
    },
    gg: {
        value: 'GG',
        label: 'Guernsey',
        callingCode: '44',
        alpha3Code: 'GGY',
        isoNumeric: 831,
    },
    gn: {
        value: 'GN',
        label: 'Guinea',
        callingCode: '224',
        alpha3Code: 'GIN',
        isoNumeric: 324,
    },
    gw: {
        value: 'GW',
        label: 'Guinea-Bissau',
        callingCode: '245',
        alpha3Code: 'GNB',
        isoNumeric: 624,
    },
    gy: {
        value: 'GY',
        label: 'Guyana',
        callingCode: '592',
        alpha3Code: 'GUY',
        isoNumeric: 328,
    },
    ht: {
        value: 'HT',
        label: 'Haiti',
        callingCode: '509',
        alpha3Code: 'HTI',
        isoNumeric: 332,
    },
    hm: {
        value: 'HM',
        label: 'Heard Island & Mcdonald Islands',
        alpha3Code: 'HDM',
        callingCode: '672',
        isoNumeric: 334,
    },
    va: {
        value: 'VA',
        label: 'Holy See (Vatican City State)',
        callingCode: '379',
        alpha3Code: 'VAT',
        isoNumeric: 336,
    },
    hn: {
        value: 'HN',
        label: 'Honduras',
        callingCode: '504',
        alpha3Code: 'HND',
        isoNumeric: 340,
    },
    hk: {
        value: 'HK',
        label: 'Hong Kong',
        callingCode: '852',
        alpha3Code: 'HKG',
        isoNumeric: 344,
    },
    hu: {
        value: 'HU',
        label: 'Hungary',
        callingCode: '36',
        isEU: true,
        alpha3Code: 'HUN',
        isoNumeric: 348,
    },
    is: {
        value: 'IS',
        label: 'Iceland',
        callingCode: '354',
        alpha3Code: 'ISL',
        isoNumeric: 352,
    },
    in: {
        value: 'IN',
        label: 'India',
        callingCode: '91',
        alpha3Code: 'IND',
        isoNumeric: 356,
    },
    id: {
        value: 'ID',
        label: 'Indonesia',
        currency: 'IDR',
        callingCode: '62',
        alpha3Code: 'IDN',
        isoNumeric: 360,
    },
    ir: {
        value: 'IR',
        label: 'Iran, Islamic Republic Of',
        callingCode: '98',
        alpha3Code: 'IRN',
        forbidden: true,
        isoNumeric: 364,
    },
    iq: {
        value: 'IQ',
        label: 'Iraq',
        callingCode: '964',
        alpha3Code: 'IRQ',
        isoNumeric: 368,
    },
    ie: {
        value: 'IE',
        label: 'Ireland',
        currency: 'EUR',
        callingCode: '353',
        isEU: true,
        alpha3Code: 'IRL',
        isoNumeric: 372,
    },
    im: {
        value: 'IM',
        label: 'Isle Of Man',
        callingCode: '44',
        alpha3Code: 'IMN',
        isoNumeric: 833,
    },
    il: {
        value: 'IL',
        label: 'Israel',
        callingCode: '972',
        alpha3Code: 'ISR',
        isoNumeric: 376,
    },
    it: {
        value: 'IT',
        label: 'Italy',
        currency: 'EUR',
        callingCode: '39',
        isEU: true,
        alpha3Code: 'ITA',
        isoNumeric: 380,
    },
    jm: {
        value: 'JM',
        label: 'Jamaica',
        callingCode: '1876',
        alpha3Code: 'JAM',
        isoNumeric: 388,
    },
    jp: {
        value: 'JP',
        label: 'Japan',
        callingCode: '81',
        alpha3Code: 'JPN',
        isoNumeric: 392,
    },
    je: {
        value: 'JE',
        label: 'Jersey',
        callingCode: '44',
        alpha3Code: 'JEY',
        isoNumeric: 8,
    },
    jo: {
        value: 'JO',
        label: 'Jordan',
        callingCode: '962',
        alpha3Code: 'JOR',
        isoNumeric: 400,
    },
    kz: {
        value: 'KZ',
        label: 'Kazakhstan',
        callingCode: '7',
        alpha3Code: 'KAZ',
        isoNumeric: 398,
    },
    ke: {
        value: 'KE',
        label: 'Kenya',
        callingCode: '254',
        alpha3Code: 'KEN',
        isoNumeric: 404,
    },
    ki: {
        value: 'KI',
        label: 'Kiribati',
        callingCode: '686',
        alpha3Code: 'KIR',
        isoNumeric: 296,
    },
    kr: {
        value: 'KR',
        label: 'Korea, Republic Of',
        callingCode: '82',
        alpha3Code: 'KOR',
        isoNumeric: 410,
    },
    kp: {
        value: 'KP',
        label: 'Korea, North',
        forbidden: true,
        callingCode: '850',
        alpha3Code: 'PRK',
        isoNumeric: 408,
    },
    kv: {
        value: 'XK',
        label: 'Kosovo',
        alpha3Code: 'XKX',
        callingCode: '383',
        isoNumeric: 0,
    },
    kw: {
        value: 'KW',
        label: 'Kuwait',
        callingCode: '965',
        alpha3Code: 'KWT',
        isoNumeric: 414,
    },
    kg: {
        value: 'KG',
        label: 'Kyrgyzstan',
        callingCode: '996',
        alpha3Code: 'KGZ',
        isoNumeric: 417,
    },
    la: {
        value: 'LA',
        label: 'Laos',
        callingCode: '856',
        alpha3Code: 'LAO',
        isoNumeric: 418,
    },
    lv: {
        value: 'LV',
        label: 'Latvia',
        currency: 'EUR',
        callingCode: '371',
        isEU: true,
        alpha3Code: 'LVA',
        isoNumeric: 428,
    },
    lb: {
        value: 'LB',
        label: 'Lebanon',
        callingCode: '961',
        alpha3Code: 'LBN',
        isoNumeric: 422,
    },
    ls: {
        value: 'LS',
        label: 'Lesotho',
        callingCode: '266',
        alpha3Code: 'LSO',
        isoNumeric: 426,
    },
    lr: {
        value: 'LR',
        label: 'Liberia',
        callingCode: '231',
        alpha3Code: 'LBR',
        isoNumeric: 430,
    },
    ly: {
        value: 'LY',
        label: 'Libyan Arab Jamahiriya',
        forbidden: true,
        callingCode: '218',
        alpha3Code: 'LBY',
        isoNumeric: 434,
    },
    li: {
        value: 'LI',
        label: 'Liechtenstein',
        callingCode: '423',
        alpha3Code: 'LIE',
        isoNumeric: 438,
    },
    lt: {
        value: 'LT',
        label: 'Lithuania',
        currency: 'EUR',
        callingCode: '370',
        isEU: true,
        alpha3Code: 'LTU',
        isoNumeric: 440,
    },
    lu: {
        value: 'LU',
        label: 'Luxembourg',
        currency: 'EUR',
        callingCode: '352',
        isEU: true,
        alpha3Code: 'LUX',
        isoNumeric: 442,
    },
    mo: {
        value: 'MO',
        label: 'Macao',
        callingCode: '853',
        alpha3Code: 'MAC',
        isoNumeric: 446,
    },
    mk: {
        value: 'MK',
        label: 'North Macedonia',
        callingCode: '389',
        alpha3Code: 'MKD',
        isoNumeric: 807,
    },
    mg: {
        value: 'MG',
        label: 'Madagascar',
        callingCode: '261',
        alpha3Code: 'MDG',
        isoNumeric: 450,
    },
    mw: {
        value: 'MW',
        label: 'Malawi',
        callingCode: '265',
        alpha3Code: 'MWI',
        isoNumeric: 454,
    },
    my: {
        value: 'MY',
        label: 'Malaysia',
        currency: 'MYR',
        callingCode: '60',
        alpha3Code: 'MYS',
        isoNumeric: 458,
    },
    mv: {
        value: 'MV',
        label: 'Maldives',
        callingCode: '960',
        alpha3Code: 'MDV',
        isoNumeric: 462,
    },
    ml: {
        value: 'ML',
        label: 'Mali',
        callingCode: '223',
        alpha3Code: 'MLI',
        isoNumeric: 466,
    },
    mt: {
        value: 'MT',
        label: 'Malta',
        currency: 'EUR',
        callingCode: '356',
        isEU: true,
        alpha3Code: 'MLT',
        isoNumeric: 470,
    },
    mh: {
        value: 'MH',
        label: 'Marshall Islands',
        callingCode: '692',
        alpha3Code: 'MHL',
        isoNumeric: 584,
    },
    mq: {
        value: 'MQ',
        label: 'Martinique',
        callingCode: '596',
        alpha3Code: 'MTQ',
        isoNumeric: 474,
    },
    mr: {
        value: 'MR',
        label: 'Mauritania',
        callingCode: '222',
        alpha3Code: 'MRT',
        isoNumeric: 478,
    },
    mu: {
        value: 'MU',
        label: 'Mauritius',
        callingCode: '230',
        alpha3Code: 'MUS',
        isoNumeric: 480,
    },
    yt: {
        value: 'YT',
        label: 'Mayotte',
        callingCode: '262',
        alpha3Code: 'MYT',
        isoNumeric: 175,
    },
    mx: {
        value: 'MX',
        label: 'Mexico',
        currency: 'MXN',
        callingCode: '52',
        alpha3Code: 'MEX',
        isoNumeric: 484,
    },
    fm: {
        value: 'FM',
        label: 'Micronesia, Federated States Of',
        callingCode: '691',
        alpha3Code: 'FSM',
        isoNumeric: 583,
    },
    md: {
        value: 'MD',
        label: 'Moldova',
        callingCode: '373',
        alpha3Code: 'MDA',
        isoNumeric: 498,
    },
    mc: {
        value: 'MC',
        label: 'Monaco',
        callingCode: '377',
        alpha3Code: 'MCO',
        isoNumeric: 492,
    },
    mn: {
        value: 'MN',
        label: 'Mongolia',
        callingCode: '976',
        alpha3Code: 'MNG',
        isoNumeric: 496,
    },
    me: {
        value: 'ME',
        label: 'Montenegro',
        callingCode: '382',
        alpha3Code: 'MNE',
        isoNumeric: 499,
    },
    ms: {
        value: 'MS',
        label: 'Montserrat',
        callingCode: '1664',
        alpha3Code: 'MSR',
        isoNumeric: 500,
    },
    ma: {
        value: 'MA',
        label: 'Morocco',
        callingCode: '212',
        alpha3Code: 'MAR',
        isoNumeric: 504,
    },
    mz: {
        value: 'MZ',
        label: 'Mozambique',
        callingCode: '258',
        alpha3Code: 'MOZ',
        isoNumeric: 508,
    },
    mm: {
        value: 'MM',
        label: 'Myanmar',
        callingCode: '95',
        alpha3Code: 'MMR',
        forbidden: true,
        isoNumeric: 104,
    },
    na: {
        value: 'NA',
        label: 'Namibia',
        callingCode: '264',
        alpha3Code: 'NAM',
        isoNumeric: 516,
    },
    nr: {
        value: 'NR',
        label: 'Nauru',
        callingCode: '674',
        alpha3Code: 'NRU',
        isoNumeric: 520,
    },
    np: {
        value: 'NP',
        label: 'Nepal',
        callingCode: '977',
        alpha3Code: 'NPL',
        isoNumeric: 524,
    },
    nl: {
        value: 'NL',
        label: 'Netherlands',
        currency: 'EUR',
        callingCode: '31',
        isEU: true,
        alpha3Code: 'NLD',
        isoNumeric: 528,
    },
    an: {
        value: 'AN',
        label: 'Netherlands Antilles',
        callingCode: '599',
        alpha3Code: 'ANT',
        hidden: true,
        isoNumeric: 530,
    },
    nc: {
        value: 'NC',
        label: 'New Caledonia',
        callingCode: '687',
        alpha3Code: 'NCL',
        isoNumeric: 540,
    },
    nz: {
        value: 'NZ',
        label: 'New Zealand',
        callingCode: '64',
        alpha3Code: 'NZL',
        isoNumeric: 554,
    },
    ni: {
        value: 'NI',
        label: 'Nicaragua',
        callingCode: '505',
        alpha3Code: 'NIC',
        isoNumeric: 558,
    },
    ne: {
        value: 'NE',
        label: 'Niger',
        callingCode: '227',
        alpha3Code: 'NER',
        isoNumeric: 562,
    },
    ng: {
        value: 'NG',
        label: 'Nigeria',
        callingCode: '234',
        alpha3Code: 'NGA',
        isoNumeric: 566,
    },
    nu: {
        value: 'NU',
        label: 'Niue',
        callingCode: '683',
        alpha3Code: 'NIU',
        isoNumeric: 570,
    },
    nf: {
        value: 'NF',
        label: 'Norfolk Island',
        callingCode: '672',
        alpha3Code: 'NFK',
        isoNumeric: 574,
    },
    mp: {
        value: 'MP',
        label: 'Northern Mariana Islands',
        callingCode: '1670',
        alpha3Code: 'MNP',
        isoNumeric: 580,
    },
    no: {
        value: 'NO',
        label: 'Norway',
        callingCode: '47',
        alpha3Code: 'NOR',
        isEU: true,
        isoNumeric: 578,
    },
    om: {
        value: 'OM',
        label: 'Oman',
        callingCode: '968',
        alpha3Code: 'OMN',
        isoNumeric: 512,
    },
    pk: {
        value: 'PK',
        label: 'Pakistan',
        callingCode: '92',
        alpha3Code: 'PAK',
        forbidden: true,
        isoNumeric: 586,
    },
    pw: {
        value: 'PW',
        label: 'Palau',
        callingCode: '680',
        alpha3Code: 'PLW',
        isoNumeric: 585,
    },
    ps: {
        value: 'PS',
        label: 'Palestinian Territory, Occupied',
        callingCode: '970',
        alpha3Code: 'PSE',
        isoNumeric: 275,
    },
    pa: {
        value: 'PA',
        label: 'Panama',
        callingCode: '507',
        alpha3Code: 'PAN',
        isoNumeric: 591,
    },
    pg: {
        value: 'PG',
        label: 'Papua New Guinea',
        callingCode: '675',
        alpha3Code: 'PNG',
        isoNumeric: 598,
    },
    py: {
        value: 'PY',
        label: 'Paraguay',
        callingCode: '595',
        alpha3Code: 'PRY',
        isoNumeric: 600,
    },
    pe: {
        value: 'PE',
        label: 'Peru',
        currency: 'PEN',
        callingCode: '51',
        alpha3Code: 'PER',
        isoNumeric: 604,
    },
    ph: {
        value: 'PH',
        label: 'Philippines',
        currency: 'PHP',
        callingCode: '63',
        alpha3Code: 'PHL',
        isoNumeric: 608,
    },
    pn: {
        value: 'PN',
        label: 'Pitcairn',
        callingCode: '64',
        alpha3Code: 'PCN',
        isoNumeric: 612,
    },
    pl: {
        value: 'PL',
        label: 'Poland',
        callingCode: '48',
        isEU: true,
        alpha3Code: 'POL',
        currency: 'PLN',
        isoNumeric: 616,
    },
    pt: {
        value: 'PT',
        label: 'Portugal',
        currency: 'EUR',
        callingCode: '351',
        isEU: true,
        alpha3Code: 'PRT',
        isoNumeric: 620,
    },
    pr: {
        value: 'PR',
        label: 'Puerto Rico',
        callingCode: '1939',
        alpha3Code: 'PRI',
        isoNumeric: 630,
    },
    qa: {
        value: 'QA',
        label: 'Qatar',
        callingCode: '974',
        alpha3Code: 'QAT',
        isoNumeric: 634,
    },
    re: {
        value: 'RE',
        label: 'Reunion',
        callingCode: '262',
        alpha3Code: 'REU',
        isoNumeric: 638,
    },
    ro: {
        value: 'RO',
        label: 'Romania',
        callingCode: '40',
        isEU: true,
        alpha3Code: 'ROU',
        isoNumeric: 642,
    },
    ru: {
        value: 'RU',
        label: 'Russian Federation',
        callingCode: '7',
        alpha3Code: 'RUS',
        isoNumeric: 643,
    },
    rw: {
        value: 'RW',
        label: 'Rwanda',
        callingCode: '250',
        alpha3Code: 'RWA',
        isoNumeric: 646,
    },
    bl: {
        value: 'BL',
        label: 'Saint Barthelemy',
        callingCode: '590',
        alpha3Code: 'BLM',
        isoNumeric: 0,
    },
    sh: {
        value: 'SH',
        label: 'Saint Helena',
        callingCode: '290',
        alpha3Code: 'SHN',
        isoNumeric: 654,
    },
    kn: {
        value: 'KN',
        label: 'Saint Kitts And Nevis',
        callingCode: '1869',
        alpha3Code: 'KNA',
        isoNumeric: 659,
    },
    lc: {
        value: 'LC',
        label: 'Saint Lucia',
        callingCode: '1758',
        alpha3Code: 'LCA',
        isoNumeric: 662,
    },
    mf: {
        value: 'MF',
        label: 'Saint Martin',
        callingCode: '590',
        alpha3Code: 'MAF',
        isoNumeric: 0,
    },
    sx: {
        value: 'SX',
        label: 'Sint Maarten',
        callingCode: '1721',
        alpha3Code: 'SXM',
        isoNumeric: 534,
    },
    bq: {
        value: 'BQ',
        label: 'Bonaire, Saint Eustatius And Saba',
        callingCode: '599',
        alpha3Code: 'BES',
        isoNumeric: 535,
    },
    pm: {
        value: 'PM',
        label: 'Saint Pierre And Miquelon',
        callingCode: '508',
        alpha3Code: 'SPM',
        isoNumeric: 666,
    },
    vc: {
        value: 'VC',
        label: 'Saint Vincent And Grenadines',
        callingCode: '1784',
        alpha3Code: 'VCT',
        isoNumeric: 670,
    },
    ws: {
        value: 'WS',
        label: 'Samoa',
        callingCode: '685',
        alpha3Code: 'WSM',
        isoNumeric: 882,
    },
    sm: {
        value: 'SM',
        label: 'San Marino',
        callingCode: '378',
        alpha3Code: 'SMR',
        isoNumeric: 674,
    },
    st: {
        value: 'ST',
        label: 'Sao Tome And Principe',
        callingCode: '239',
        alpha3Code: 'STP',
        isoNumeric: 678,
    },
    sa: {
        value: 'SA',
        label: 'Saudi Arabia',
        callingCode: '966',
        alpha3Code: 'SAU',
        isoNumeric: 682,
    },
    sn: {
        value: 'SN',
        label: 'Senegal',
        callingCode: '221',
        alpha3Code: 'SEN',
        isoNumeric: 686,
    },
    rs: {
        value: 'RS',
        label: 'Serbia',
        callingCode: '381',
        alpha3Code: 'SRB',
        isoNumeric: 688,
    },
    sc: {
        value: 'SC',
        label: 'Seychelles',
        callingCode: '248',
        alpha3Code: 'SYC',
        isoNumeric: 690,
    },
    sl: {
        value: 'SL',
        label: 'Sierra Leone',
        callingCode: '232',
        alpha3Code: 'SLE',
        isoNumeric: 694,
    },
    sg: {
        value: 'SG',
        label: 'Singapore',
        currency: 'SGD',
        callingCode: '65',
        alpha3Code: 'SGP',
        isoNumeric: 702,
    },
    sk: {
        value: 'SK',
        label: 'Slovakia',
        currency: 'EUR',
        callingCode: '421',
        isEU: true,
        alpha3Code: 'SVK',
        isoNumeric: 703,
    },
    si: {
        value: 'SI',
        label: 'Slovenia',
        callingCode: '386',
        isEU: true,
        alpha3Code: 'SVN',
        isoNumeric: 705,
    },
    sb: {
        value: 'SB',
        label: 'Solomon Islands',
        callingCode: '677',
        alpha3Code: 'SLB',
        isoNumeric: 90,
    },
    so: {
        value: 'SO',
        label: 'Somalia',
        forbidden: true,
        callingCode: '252',
        alpha3Code: 'SOM',
        isoNumeric: 706,
    },
    za: {
        value: 'ZA',
        label: 'South Africa',
        callingCode: '27',
        alpha3Code: 'ZAF',
        isoNumeric: 710,
    },
    gs: {
        value: 'GS',
        label: 'South Georgia And Sandwich Isl.',
        callingCode: '500',
        alpha3Code: 'SGS',
        isoNumeric: 239,
    },
    es: {
        value: 'ES',
        label: 'Spain',
        currency: 'EUR',
        callingCode: '34',
        isEU: true,
        alpha3Code: 'ESP',
        isoNumeric: 724,
    },
    lk: {
        value: 'LK',
        label: 'Sri Lanka',
        callingCode: '94',
        alpha3Code: 'LKA',
        isoNumeric: 144,
    },
    sd: {
        value: 'SD',
        label: 'Sudan',
        forbidden: true,
        callingCode: '249',
        alpha3Code: 'SDN',
        isoNumeric: 736,
    },
    ss: {
        value: 'SS',
        label: 'South Sudan',
        forbidden: true,
        callingCode: '211',
        alpha3Code: 'SSD',
        isoNumeric: 728,
    },
    sr: {
        value: 'SR',
        label: 'Suriname',
        callingCode: '597',
        alpha3Code: 'SUR',
        isoNumeric: 740,
    },
    sj: {
        value: 'SJ',
        label: 'Svalbard And Jan Mayen',
        callingCode: '47',
        alpha3Code: 'SJM',
        isoNumeric: 744,
    },
    sz: {
        value: 'SZ',
        label: 'Swaziland',
        callingCode: '268',
        alpha3Code: 'SWZ',
        isoNumeric: 748,
    },
    se: {
        value: 'SE',
        label: 'Sweden',
        callingCode: '46',
        isEU: true,
        alpha3Code: 'SWE',
        isoNumeric: 752,
    },
    ch: {
        value: 'CH',
        label: 'Switzerland',
        callingCode: '41',
        isEU: true,
        alpha3Code: 'CHE',
        currency: 'CHF',
        isoNumeric: 756,
    },
    sy: {
        value: 'SY',
        label: 'Syrian Arab Republic',
        callingCode: '963',
        alpha3Code: 'SYR',
        forbidden: true,
        isoNumeric: 760,
    },
    tw: {
        value: 'TW',
        label: 'Taiwan',
        callingCode: '886',
        alpha3Code: 'TWN',
        isoNumeric: 158,
    },
    tj: {
        value: 'TJ',
        label: 'Tajikistan',
        callingCode: '992',
        alpha3Code: 'TJK',
        isoNumeric: 762,
    },
    tz: {
        value: 'TZ',
        label: 'Tanzania',
        callingCode: '255',
        alpha3Code: 'TZA',
        isoNumeric: 834,
    },
    th: {
        value: 'TH',
        label: 'Thailand',
        currency: 'THB',
        callingCode: '66',
        alpha3Code: 'THA',
        isoNumeric: 764,
    },
    tl: {
        value: 'TL',
        label: 'Timor-Leste',
        callingCode: '670',
        alpha3Code: 'TLS',
        isoNumeric: 626,
    },
    tg: {
        value: 'TG',
        label: 'Togo',
        callingCode: '228',
        alpha3Code: 'TGO',
        isoNumeric: 768,
    },
    tk: {
        value: 'TK',
        label: 'Tokelau',
        callingCode: '690',
        alpha3Code: 'TKL',
        isoNumeric: 772,
    },
    to: {
        value: 'TO',
        label: 'Tonga',
        callingCode: '676',
        alpha3Code: 'TON',
        isoNumeric: 776,
    },
    tt: {
        value: 'TT',
        label: 'Trinidad And Tobago',
        callingCode: '1868',
        alpha3Code: 'TTO',
        isoNumeric: 780,
    },
    tn: {
        value: 'TN',
        label: 'Tunisia',
        callingCode: '216',
        alpha3Code: 'TUN',
        isoNumeric: 788,
    },
    tr: {
        value: 'TR',
        label: 'Turkey',
        currency: 'TRY',
        callingCode: '90',
        alpha3Code: 'TUR',
        isoNumeric: 792,
    },
    tm: {
        value: 'TM',
        label: 'Turkmenistan',
        callingCode: '993',
        alpha3Code: 'TKM',
        isoNumeric: 795,
    },
    tc: {
        value: 'TC',
        label: 'Turks And Caicos Islands',
        callingCode: '1649',
        alpha3Code: 'TCA',
        isoNumeric: 796,
    },
    tv: {
        value: 'TV',
        label: 'Tuvalu',
        callingCode: '688',
        alpha3Code: 'TUV',
        isoNumeric: 798,
    },
    ug: {
        value: 'UG',
        label: 'Uganda',
        callingCode: '256',
        alpha3Code: 'UGA',
        isoNumeric: 800,
    },
    ua: {
        value: 'UA',
        label: 'Ukraine',
        callingCode: '380',
        alpha3Code: 'UKR',
        isoNumeric: 804,
    },
    ae: {
        value: 'AE',
        label: 'United Arab Emirates',
        callingCode: '971',
        alpha3Code: 'ARE',
        isoNumeric: 784,
    },
    gb: {
        value: 'GB',
        label: 'United Kingdom',
        callingCode: '44',
        isEU: true,
        currency: 'GBP',
        alpha3Code: 'GBR',
        isoNumeric: 826,
    },
    us: {
        value: 'US',
        label: 'United States',
        callingCode: '1',
        alpha3Code: 'USA',
        isoNumeric: 840,
    },
    um: {
        value: 'UM',
        label: 'United States Outlying Islands',
        callingCode: '1',
        alpha3Code: 'UMI',
        isoNumeric: 581,
    },
    uy: {
        value: 'UY',
        label: 'Uruguay',
        currency: 'UYU',
        callingCode: '598',
        alpha3Code: 'URY',
        isoNumeric: 858,
    },
    uz: {
        value: 'UZ',
        label: 'Uzbekistan',
        callingCode: '998',
        alpha3Code: 'UZB',
        isoNumeric: 860,
    },
    vu: {
        value: 'VU',
        label: 'Vanuatu',
        callingCode: '678',
        alpha3Code: 'VUT',
        isoNumeric: 548,
    },
    ve: {
        value: 'VE',
        label: 'Venezuela',
        callingCode: '58',
        alpha3Code: 'VEN',
        forbidden: true,
        isoNumeric: 862,
    },
    vn: {
        value: 'VN',
        label: 'Vietnam',
        callingCode: '84',
        alpha3Code: 'VNM',
        currency: 'VND',
        isoNumeric: 704,
    },
    vg: {
        value: 'VG',
        label: 'Virgin Islands, British',
        callingCode: '1284',
        alpha3Code: 'VGB',
        isoNumeric: 92,
    },
    vi: {
        value: 'VI',
        label: 'Virgin Islands, U.S.',
        callingCode: '1340',
        alpha3Code: 'VIR',
        isoNumeric: 850,
    },
    wf: {
        value: 'WF',
        label: 'Wallis And Futuna',
        callingCode: '681',
        alpha3Code: 'WLF',
        isoNumeric: 876,
    },
    eh: {
        value: 'EH',
        label: 'Western Sahara',
        alpha3Code: 'ESH',
        callingCode: '212',
        isoNumeric: 732,
    },
    ye: {
        value: 'YE',
        label: 'Yemen',
        callingCode: '967',
        alpha3Code: 'YEM',
        forbidden: true,
        isoNumeric: 887,
    },
    zm: {
        value: 'ZM',
        label: 'Zambia',
        callingCode: '260',
        alpha3Code: 'ZMB',
        isoNumeric: 894,
    },
    zw: {
        value: 'ZW',
        label: 'Zimbabwe',
        callingCode: '263',
        alpha3Code: 'ZWE',
        isoNumeric: 716,
    },
    cw: {
        value: 'CW',
        label: 'Curaçao',
        callingCode: '599',
        alpha3Code: 'CUW',
        isoNumeric: 531,
    },
});
const gdcNationalIDHints = asEnum({
    it: {
        sampleImageURL: 'https://klarpay-media.s3-eu-west-1.amazonaws.com/shared/nationalIdIT.jpg',
        hint: 'Il numero NID è il Codice fiscale, ovvero un codice di 16 caratteri alfanumerici che devono essere inseriti per intero',
        minLength: 16,
        maxLength: 16,
        numberOnly: false,
    },
    es: {
        sampleImageURL: 'https://klarpay-media.s3-eu-west-1.amazonaws.com/shared/nationalIdES.jpg',
        hint: 'El número NID corresponde al número NIF/NIE, que consiste de una secuencia alfanumérica de 8-9 cifras.',
        minLength: 8,
        maxLength: 9,
        numberOnly: false,
    },
    za: {
        sampleImageURL: 'https://klarpay-media.s3-eu-west-1.amazonaws.com/shared/nationalIdZA.png',
        hint: 'The NID number is the South African ID number - a 13-digit number which is defined by the following format: YYMMDDSSSSCAZ',
        minLength: 13,
        maxLength: 13,
        numberOnly: true,
    },
});
const regions = asEnum({
    worldwide: {
        value: 'worldwide',
        label: 'Worldwide',
        countries: [
            countries.af,
            countries.ax,
            countries.al,
            countries.dz,
            countries.as,
            countries.ad,
            countries.ao,
            countries.ai,
            countries.aq,
            countries.ag,
            countries.ar,
            countries.am,
            countries.aw,
            countries.au,
            countries.at,
            countries.az,
            countries.bs,
            countries.bh,
            countries.bd,
            countries.bb,
            countries.by,
            countries.be,
            countries.bz,
            countries.bj,
            countries.bm,
            countries.bt,
            countries.bo,
            countries.ba,
            countries.bw,
            countries.bv,
            countries.br,
            countries.io,
            countries.bn,
            countries.bg,
            countries.bf,
            countries.bi,
            countries.kh,
            countries.cm,
            countries.ca,
            countries.cv,
            countries.ky,
            countries.cf,
            countries.td,
            countries.cl,
            countries.cn,
            countries.cx,
            countries.cc,
            countries.co,
            countries.km,
            countries.cg,
            countries.cd,
            countries.ck,
            countries.cr,
            countries.ci,
            countries.hr,
            countries.cu,
            countries.cy,
            countries.cz,
            countries.dk,
            countries.dj,
            countries.dm,
            countries.do,
            countries.ec,
            countries.eg,
            countries.sv,
            countries.gq,
            countries.er,
            countries.ee,
            countries.et,
            countries.fk,
            countries.fo,
            countries.fj,
            countries.fi,
            countries.fr,
            countries.gf,
            countries.pf,
            countries.tf,
            countries.ga,
            countries.gm,
            countries.ge,
            countries.de,
            countries.gh,
            countries.gi,
            countries.gr,
            countries.gl,
            countries.gd,
            countries.gp,
            countries.gu,
            countries.gt,
            countries.gg,
            countries.gn,
            countries.gw,
            countries.gy,
            countries.ht,
            countries.hm,
            countries.va,
            countries.hn,
            countries.hk,
            countries.hu,
            countries.is,
            countries.in,
            countries.id,
            countries.ir,
            countries.iq,
            countries.ie,
            countries.im,
            countries.il,
            countries.it,
            countries.jm,
            countries.jp,
            countries.je,
            countries.jo,
            countries.kz,
            countries.ke,
            countries.ki,
            countries.kr,
            countries.kp,
            countries.kv,
            countries.kw,
            countries.kg,
            countries.la,
            countries.lv,
            countries.lb,
            countries.ls,
            countries.lr,
            countries.ly,
            countries.li,
            countries.lt,
            countries.lu,
            countries.mo,
            countries.mk,
            countries.mg,
            countries.mw,
            countries.my,
            countries.mv,
            countries.ml,
            countries.mt,
            countries.mh,
            countries.mq,
            countries.mr,
            countries.mu,
            countries.yt,
            countries.mx,
            countries.fm,
            countries.md,
            countries.mc,
            countries.mn,
            countries.me,
            countries.ms,
            countries.ma,
            countries.mz,
            countries.mm,
            countries.na,
            countries.nr,
            countries.np,
            countries.nl,
            countries.an,
            countries.nc,
            countries.nz,
            countries.ni,
            countries.ne,
            countries.ng,
            countries.nu,
            countries.nf,
            countries.mp,
            countries.no,
            countries.om,
            countries.pk,
            countries.pw,
            countries.ps,
            countries.pa,
            countries.pg,
            countries.py,
            countries.pe,
            countries.ph,
            countries.pn,
            countries.pl,
            countries.pt,
            countries.pr,
            countries.qa,
            countries.re,
            countries.ro,
            countries.ru,
            countries.rw,
            countries.bl,
            countries.sh,
            countries.kn,
            countries.lc,
            countries.mf,
            countries.pm,
            countries.vc,
            countries.ws,
            countries.sm,
            countries.st,
            countries.sa,
            countries.sn,
            countries.rs,
            countries.sc,
            countries.sl,
            countries.sg,
            countries.sk,
            countries.si,
            countries.sb,
            countries.so,
            countries.za,
            countries.gs,
            countries.es,
            countries.lk,
            countries.sd,
            countries.ss,
            countries.sr,
            countries.sj,
            countries.sz,
            countries.se,
            countries.ch,
            countries.sy,
            countries.tw,
            countries.tj,
            countries.tz,
            countries.th,
            countries.tl,
            countries.tg,
            countries.tk,
            countries.to,
            countries.tt,
            countries.tn,
            countries.tr,
            countries.tm,
            countries.tc,
            countries.tv,
            countries.ug,
            countries.ua,
            countries.ae,
            countries.gb,
            countries.us,
            countries.um,
            countries.uy,
            countries.uz,
            countries.vu,
            countries.ve,
            countries.vn,
            countries.vg,
            countries.vi,
            countries.wf,
            countries.eh,
            countries.ye,
            countries.zm,
            countries.zw,
            countries.cw,
        ],
    },
    europe: {
        value: 'europe',
        label: 'Europe',
        countries: [
            countries.ax,
            countries.al,
            countries.ad,
            countries.am,
            countries.at,
            countries.by,
            countries.be,
            countries.ba,
            countries.bg,
            countries.hr,
            countries.cy,
            countries.cz,
            countries.dk,
            countries.ee,
            countries.fo,
            countries.fi,
            countries.fr,
            countries.ge,
            countries.de,
            countries.gi,
            countries.gr,
            countries.gl,
            countries.gg,
            countries.va,
            countries.hu,
            countries.is,
            countries.ie,
            countries.im,
            countries.it,
            countries.je,
            countries.lv,
            countries.li,
            countries.lt,
            countries.lu,
            countries.mk,
            countries.md,
            countries.mt,
            countries.mc,
            countries.me,
            countries.nl,
            countries.no,
            countries.pl,
            countries.pt,
            countries.ro,
            countries.ru,
            countries.sm,
            countries.rs,
            countries.sk,
            countries.si,
            countries.es,
            countries.sj,
            countries.se,
            countries.ch,
            countries.tr,
            countries.ua,
            countries.gb,
            countries.kv,
        ],
    },
    northAmerica: {
        value: 'northAmerica',
        label: 'North America',
        countries: [countries.ca, countries.pm, countries.us],
    },
    africa: {
        value: 'africa',
        label: 'Africa',
        countries: [
            countries.ao,
            countries.bj,
            countries.bw,
            countries.bf,
            countries.bi,
            countries.cm,
            countries.cv,
            countries.cf,
            countries.td,
            countries.cg,
            countries.cd,
            countries.ci,
            countries.gq,
            countries.er,
            countries.et,
            countries.ga,
            countries.gm,
            countries.gh,
            countries.gn,
            countries.gw,
            countries.ke,
            countries.ls,
            countries.lr,
            countries.mg,
            countries.mw,
            countries.ml,
            countries.mu,
            countries.yt,
            countries.mz,
            countries.na,
            countries.ne,
            countries.ng,
            countries.rw,
            countries.sh,
            countries.st,
            countries.sn,
            countries.sc,
            countries.sl,
            countries.za,
            countries.ss,
            countries.sz,
            countries.tz,
            countries.ug,
            countries.eh,
            countries.zm,
            countries.zw,
            countries.dz,
            countries.km,
            countries.dj,
            countries.mr,
            countries.ma,
            countries.so,
            countries.sd,
            countries.tn,
            countries.ly,
        ],
    },
    middleEast: {
        value: 'middleEast',
        label: 'Middle East',
        countries: [
            countries.eg,
            countries.lb,
            countries.om,
            countries.qa,
            countries.sa,
            countries.ae,
            countries.ye,
            countries.ir,
            countries.iq,
            countries.il,
            countries.jo,
            countries.ps,
            countries.kw,
        ],
    },
    asiaPacific: {
        value: 'asiaPacific',
        label: 'Asia-Pacific',
        countries: [
            countries.af,
            countries.as,
            countries.aq,
            countries.au,
            countries.az,
            countries.bd,
            countries.bt,
            countries.io,
            countries.bn,
            countries.kh,
            countries.cn,
            countries.cx,
            countries.cc,
            countries.ck,
            countries.fj,
            countries.pf,
            countries.tf,
            countries.gu,
            countries.hm,
            countries.hk,
            countries.in,
            countries.id,
            countries.jp,
            countries.kz,
            countries.ki,
            countries.kr,
            countries.kp,
            countries.kg,
            countries.my,
            countries.mv,
            countries.mh,
            countries.fm,
            countries.mn,
            countries.mm,
            countries.nr,
            countries.np,
            countries.nc,
            countries.nz,
            countries.nu,
            countries.nf,
            countries.mp,
            countries.pk,
            countries.pw,
            countries.pg,
            countries.ph,
            countries.pn,
            countries.re,
            countries.ws,
            countries.sg,
            countries.sb,
            countries.lk,
            countries.sy,
            countries.tw,
            countries.tj,
            countries.th,
            countries.tl,
            countries.tg,
            countries.tk,
            countries.to,
            countries.tm,
            countries.tv,
            countries.um,
            countries.uz,
            countries.vu,
            countries.vn,
            countries.wf,
            countries.bh,
            countries.la,
            countries.mo,
        ],
    },
    latinAmerica: {
        value: 'latinAmerica',
        label: 'Latin America',
        countries: [
            countries.ai,
            countries.ag,
            countries.ar,
            countries.aw,
            countries.bs,
            countries.bb,
            countries.bz,
            countries.bm,
            countries.bo,
            countries.bv,
            countries.br,
            countries.ky,
            countries.cl,
            countries.co,
            countries.cr,
            countries.cu,
            countries.dm,
            countries.do,
            countries.ec,
            countries.sv,
            countries.fk,
            countries.gf,
            countries.gd,
            countries.gp,
            countries.gt,
            countries.gy,
            countries.ht,
            countries.hn,
            countries.jm,
            countries.mq,
            countries.mx,
            countries.ms,
            countries.an,
            countries.pa,
            countries.py,
            countries.pe,
            countries.pr,
            countries.bl,
            countries.kn,
            countries.lc,
            countries.mf,
            countries.vc,
            countries.gs,
            countries.sr,
            countries.tt,
            countries.tc,
            countries.uy,
            countries.ve,
            countries.vg,
            countries.vi,
            countries.ni,
        ],
    },
});

const fundingCategories = asLocalizedEnum('fundingCategories', {
    card: {
        value: 'card',
        label: 'Credit/Debit Card',
    },
    bankWire: {
        value: 'bankWire',
        label: 'Bank Wire',
    },
    onlineBanking: {
        value: 'onlineBanking',
        label: 'Online Banking',
    },
    eWallet: {
        value: 'eWallet',
        label: 'E-Wallet',
    },
    crypto: {
        value: 'crypto',
        label: 'Crypto',
    },
    onlineDeposit: {
        value: 'onlineDeposit',
        label: 'Online Deposit',
    },
});
const documentRejectionReasons = asLocalizedEnum('documentRejectionReasons', {
    duplicateDocument: {
        label: 'Duplicate document',
        showReasonTextArea: false,
    },
    failedVerification: {
        label: 'Failed verification process (Unable to accept)',
        showReasonTextArea: false,
    },
    notAcceptableDocType: {
        label: 'Not acceptable document type',
        showReasonTextArea: true,
    },
    expiredDoc: {
        label: 'Expired/ outdated document',
        showReasonTextArea: false,
    },
    unclearDoc: {
        label: 'Unclear document',
        showReasonTextArea: false,
    },
    notAcceptableInfo: {
        label: 'Not acceptable as necessary information are covered',
        showReasonTextArea: true,
    },
    notFullPageOfDoc: {
        label: 'Not full page of the document',
        showReasonTextArea: false,
    },
    nameMismatch: {
        label: 'Name on document does not match profile name',
        showReasonTextArea: false,
    },
    other: {
        label: 'Other',
        showReasonTextArea: true,
    },
});
const documentStatuses = asLocalizedEnum('documentStatuses', {
    notProcessed: {
        value: 'none',
        label: 'Not Processed',
        userUpdatable: true,
    },
    autoVerificationSent: {
        value: 'auto_verification_sent',
        label: 'Sent For Auto Verification',
        userUpdatable: true,
    },
    autoVerificationReceived: {
        value: 'auto_verification_received',
        label: 'Auto Verification Result Received',
        userUpdatable: true,
    },
    autoVerificationRejected: {
        value: 'auto_verification_rejected',
        label: 'Auto Verification Rejected',
        userUpdatable: true,
    },
    autoVerificationAccepted: {
        value: 'auto_verification_accepted',
        label: 'Auto Verification Accepted',
    },
    autoVerificationError: {
        value: 'auto_verification_error',
        label: 'Auto Verification Failed',
        userUpdatable: true,
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    pending: {
        value: 'pending',
        label: 'Pending',
        userUpdatable: true,
    },
    pendingSignatures: {
        value: 'pending_signatures',
        label: 'Pending Signatures',
        userUpdatable: true,
    },
    signed: {
        value: 'signed',
        label: 'Signed',
        userUpdatable: true,
    },
    pendingTranslation: {
        value: 'pending_translation',
        label: 'Pending Translation',
    },
});
const _documentTypes = {
    id: {
        value: 'id',
        label: 'ID',
        category: 'POI',
        subCategories: ['POI-F'],
        doubleSided: true,
        groupName: 'id',
        autoVerifiable: true,
    },
    idFront: {
        value: 'doc_id_front',
        label: 'ID Front',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Front',
        doubleSided: true,
        groupName: 'id',
        autoVerifiable: true,
        deprecationReason: 'deprecated use id type instead',
    },
    idBack: {
        value: 'doc_id_back',
        label: 'ID Back',
        category: 'POI',
        subCategories: ['POI-B'],
        sideName: 'Back',
        doubleSided: true,
        groupName: 'id',
        autoVerifiable: true,
        deprecationReason: 'deprecated use id type instead',
    },
    idTranslation: {
        value: 'doc_id_translation',
        label: 'ID Translation',
        deprecationReason: 'deprecated',
    },
    proofOfAddressTranslation: {
        value: 'doc_por_translation',
        label: 'POR Translation',
        deprecationReason: 'deprecated',
    },
    bankStatement: {
        value: 'doc_bank_statement',
        label: 'Bank Statement',
        category: 'POF',
        subCategories: ['POF-Business'],
    },
    address: {
        value: 'doc_address',
        label: 'Proof of Residence',
        disabled: true,
    },
    passport: {
        value: 'doc_passport',
        label: 'Passport',
        category: 'POI',
        subCategories: ['POI-F', 'POI-B'],
        autoVerifiable: true,
    },
    contractTerms: {
        value: 'contract_terms',
        label: 'General Terms and Conditions',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    feeSchedule: {
        value: 'fee_schedule',
        label: 'Fee Schedule',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    debitCardTerms: {
        value: 'debit_card_terms',
        label: 'Debit Card Terms',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    crsFacta: {
        value: 'crs_facta_form',
        label: 'CRS and FACTA Form',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    uboDeclarationFormA: {
        value: 'ubo_declaration_form_a',
        label: 'UBO Declaration Form A',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    uboDeclarationFormK: {
        value: 'ubo_declaration_form_k',
        label: 'UBO Declaration Form K',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    uboDeclarationFormS: {
        value: 'ubo_declaration_form_s',
        label: 'UBO Declaration Form S',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    uboDeclarationFormT: {
        value: 'ubo_declaration_form_t',
        label: 'UBO Declaration Form T',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    dueDiligence: {
        value: 'doc_due_diligence',
        label: 'Due Diligence',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    proofOfSignature: {
        value: 'doc_proof_of_signature',
        label: 'Proof of Signature',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    approvalRejectionForm: {
        value: 'doc_approval_rejection_form',
        label: 'Approval Rejection Form',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    certificateOfGoodStanding: {
        value: 'doc_certificate_of_good_standing',
        label: 'Certificate of good standing',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    certificateOfIncorporation: {
        value: 'doc_certificate_of_incorporation',
        label: 'Certificate of Incorporation',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    certificateOfShareholders: {
        value: 'doc_certificate_of_shareholders',
        label: 'Certificate of Shareholders',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    memorandumArticlesOfAssociation: {
        value: 'doc_memorandum_and_articles_of_association',
        label: 'Memorandum & Articles of association',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    specialPowerOfAttorney: {
        value: 'doc_special_power_of_attorney',
        label: 'Special power of attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    limitedPowerOfAttorney: {
        value: 'doc_limited_power_of_attorney',
        label: 'Limited power of attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    revocationOfPoaSpoa: {
        value: 'doc_revocation_of_poa_spoa',
        label: 'Revocation of Power of Attorney / Special Power of Attorney',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    thirdPartyAuthorizationLetter: {
        value: 'doc_third_party_authorization_letter',
        label: '3rd party authorization letter',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    thirdPartyIdPassport: {
        value: 'doc_third_party_id_passport',
        label: '3rd party ID/Passport',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    drivingLicense: {
        value: 'doc_driving_license',
        label: 'Driving licence',
        category: 'POI',
        subCategories: ['POI-F'],
        doubleSided: true,
        groupName: 'drivingLicense',
        autoVerifiable: true,
    },
    drivingLicenseFront: {
        value: 'doc_driving_license_front',
        label: 'Driving licence (front)',
        category: 'POI',
        subCategories: ['POI-F'],
        sideName: 'Front',
        doubleSided: true,
        groupName: 'drivingLicense',
        autoVerifiable: true,
        deprecationReason: 'deprecated use drivingLicenceType instead',
    },
    drivingLicenseBack: {
        value: 'doc_driving_license_back',
        label: 'Driving licence (back)',
        category: 'POI',
        subCategories: ['POI-B'],
        sideName: 'Back',
        doubleSided: true,
        groupName: 'drivingLicense',
        autoVerifiable: true,
        deprecationReason: 'deprecated use drivingLicenceType instead',
    },
    residencePermitVisa: {
        value: 'doc_residence_permit_visa',
        label: 'Residence permit/visa',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    utilityBill: {
        value: 'doc_utility_bill',
        label: 'Utility Bill',
        category: 'POR',
        subCategories: ['POR'],
    },
    proofOfResidence: {
        value: 'doc_por',
        label: 'Proof of Residence',
        category: 'POR',
        subCategories: ['POR'],
    },
    bankStatementPOR: {
        value: 'doc_bank_statement_por',
        label: 'Bank Statement',
        category: 'POR',
        subCategories: ['POR'],
    },
    cardCopies: {
        value: 'doc_card_copies',
        label: 'Credit/Debit Card Copy',
        doubleSided: true,
        groupName: 'card',
        sideName: 'Front',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        fundingCategories: ['card'],
    },
    cardStatement: {
        value: 'doc_card_statement',
        label: 'Card Statement',
        category: 'POF',
        subCategories: ['POF-F'],
        fundingCategories: ['card'],
    },
    bankStatementPOF: {
        value: 'doc_bank_statement_pof',
        label: 'Bank Statement',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        fundingCategories: ['card', 'eWallet', 'bankWire', 'onlineBanking'],
    },
    swiftCopyPaymentAdvice: {
        value: 'doc_swift_copy_payment_advice',
        label: 'Swift Copy/Payment Advice',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        fundingCategories: ['card', 'bankWire', 'onlineBanking'],
    },
    worldcheckResults: {
        value: 'doc_worldcheck_results',
        label: 'Worldcheck Results',
        category: 'internal',
        subCategories: ['internal'],
    },
    virtualCard: {
        value: 'virtual_card',
        label: 'Virtual card',
        category: 'POF',
        subCategories: ['POF-F', 'POF-B'],
        fundingCategories: ['card'],
    },
    bankCard: {
        value: 'bank_card',
        label: 'Bank card',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    coinbasePop: {
        value: 'coinbase_pop',
        label: 'Coinbase POP',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    taxStatement: {
        value: 'tax_statement',
        label: 'Tax Statement',
        category: 'internal',
        subCategories: ['internal'],
    },
    payslip: {
        value: 'payslip',
        label: 'Payslip/Payroll',
        category: 'internal',
        subCategories: ['internal'],
    },
    jointAccountForm: {
        value: 'joint_account_form',
        label: 'Joint Account Form',
        category: 'internal',
        subCategories: ['internal'],
    },
    bankPaymentDetails: {
        value: 'bank_payment_details',
        label: 'Bank/Payment details',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    companiesRegistryExtract: {
        value: 'companies_registry_extract',
        label: 'Companies registry extract',
        category: 'internal',
        subCategories: ['internal'],
    },
    businessLicense: {
        value: 'businessLicense',
        label: 'Business License',
        category: 'general',
        subCategories: ['general'],
    },
    professionalApplication: {
        value: 'professionalApplication',
        label: 'Professional Application',
        category: 'internal',
        subCategories: ['internal'],
    },
    thirdPartyWc: {
        value: 'third_party_wc',
        label: '3rd Party WC',
        category: 'internal',
        subCategories: ['internal', 'POF'],
    },
    other: {
        value: 'doc_other',
        label: 'Other',
        category: 'internal',
        subCategories: ['internal'],
    },
    otherPOF: {
        value: 'doc_other_pof',
        label: 'Other POF',
        category: 'POF',
        subCategories: ['POF-F', 'POF-Business', 'POF-Account'],
        fundingCategories: ['card', 'bankWire', 'crypto', 'eWallet', 'onlineBanking', 'onlineDeposit'],
    },
    bankAccountStatements: {
        value: 'bank_account_statements',
        label: 'Bank Account Statement',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    auditedFinancialStatements: {
        value: 'audited_financial_statements',
        label: 'Audited financial statements',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    invoicesIssuedToCustomers: {
        value: 'invoices_issued_to_customers',
        label: 'Invoices issued to customers',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    invoicesIssuedToTheClient: {
        value: 'invoices_issued_to_the_client',
        label: 'Invoices issued to the client',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    aggreementsContracts: {
        value: 'aggreements_contracts',
        label: 'Agreements/Contracts',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    loanAgreements: {
        value: 'loan_agreements',
        label: 'Loan Agreements',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    investmentStatementProofOfDividedPayment: {
        value: 'investment_statement_proof_of_divided_payment',
        label: 'Investment statement / proof of dividend payment',
        category: 'POF',
        subCategories: ['POF-Account'],
    },
    proofOfSalary: {
        value: 'proof_of_salary',
        label: 'Proof of Salary – payslip or employee contract, tax return, employer confirmation letter',
        category: 'POF',
        subCategories: ['POF-Business'],
    },
    investmentCertificates: {
        value: 'investment_certificates',
        label: 'Investment certificates, contract notes, or statements',
        category: 'POF',
        subCategories: ['POF-Business'],
    },
    proofOfInheritance: {
        value: 'proof_of_inheritance',
        label: 'Proof of Inheritance – A copy of the will, a grant of probate, a letter from the solicitor',
        category: 'POF',
        subCategories: ['POF-Business'],
    },
    proofOfPropertySale: {
        value: 'proof_of_propertySale',
        label: 'Proof of Property Sale – A solicitor letter, a copy of the signed sales contract, extracts from the property registry',
        category: 'POF',
        subCategories: ['POF-Business'],
    },
    introducerAgreement: {
        value: 'introducer_agreement',
        label: 'Introducer Agreement',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    questionnaire: {
        value: 'questionnaire',
        label: 'Questionnaire',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    verificationDocuments: {
        value: 'verificationDocuments',
        label: 'Verification Documents',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    contract: {
        value: 'contract',
        label: 'Contract',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    corporateDocument: {
        value: 'corporateDocument',
        label: 'Corporate Document',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    invoice: {
        value: 'invoice',
        label: 'Invoice',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    order: {
        value: 'order',
        label: 'Order',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    payroll: {
        value: 'payroll',
        label: 'Payroll',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    transactionIncludedInReview: {
        value: 'transactionIncludedInReview',
        label: 'Transaction Include in Review',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    checkListForReviewConclusion: {
        value: 'checkListForReviewConclusion',
        label: 'CheckList for Review Conclusion',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    reviewerSignOff: {
        value: 'reviewerSignOff',
        label: 'Reviewer Sign Off',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    dateOfSignOff: {
        value: 'dateOfSignOff',
        label: 'Date of Sign Off',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    supportAttachment: {
        value: 'supportAttachment',
        label: 'Support Attachment',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    certicateOfDirectors: {
        value: 'certicateOfDirectors',
        label: 'Certificate of Directors',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    aeoi: {
        value: 'aeoi',
        label: 'AEOI',
        category: 'internal',
        subCategories: ['internal'],
    },
    accountDetailsConfirmationRequest: {
        value: 'accountDetailsConfirmationRequest',
        label: 'Account Details Confirmation Letter',
        category: 'general',
        subCategories: ['general'],
    },
    contractTerminationLetter: {
        value: 'contractTerminationLetter',
        label: 'Contract Termination Letter',
        category: 'general',
        subCategories: ['general'],
    },
    referenceLetter: {
        value: 'referenceLetter',
        label: 'Reference Letter',
        category: 'general',
        subCategories: ['general'],
    },
    bankConfirmationLetterOnAuditorsRequest: {
        value: 'bankConfirmationLetterOnAuditorsRequest',
        label: 'Bank Confirmation Letter On Auditors Request',
        category: 'general',
        subCategories: ['general'],
    },
    swiftConfirmation: {
        value: 'swiftConfirmation',
        label: 'Swift Confirmation',
        category: 'general',
        subCategories: ['general'],
    },
    preAssessmentQuestionnaire: {
        value: 'preAssessmentQuestionnaire',
        label: 'Pre Assessment Questionnaire',
        category: 'general',
        subCategories: ['general'],
    },
    amlManual: {
        value: 'amlManual',
        label: 'AML Manual',
        category: 'general',
        subCategories: ['general'],
    },
    eddQuestionnaire: {
        value: 'eddQuestionnaire',
        label: 'EDD Questionnaire',
        category: 'general',
        subCategories: ['general'],
    },
    certificateOfIncumbency: {
        value: 'certificateOfIncumbency',
        label: 'Certificate Of Incumbency',
        category: 'general',
        subCategories: ['general'],
    },
    boardOfDirectorsResolution: {
        value: 'boardOfDirectorsResolution',
        label: 'Board of Directors Resolution',
        category: 'general',
        subCategories: ['general'],
    },
    declarationOfTrust: {
        value: 'declarationOfTrust',
        label: 'Declaration of trust',
        category: 'general',
        subCategories: ['general'],
    },
    managementAccounts: {
        value: 'managementAccounts',
        label: 'Management Accounts',
        category: 'general',
        subCategories: ['general'],
    },
    bankOrStateSupervisionAssessment: {
        value: 'bankOrStateSupervisionAssessment',
        label: 'Bank or State Supervision Assessment',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    professionalTreasuryAssessment: {
        value: 'professionalTreasuryAssessment',
        label: 'Professional Treasury Assessment',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    bankOfficeOnboardingReviewForm: {
        value: 'bankOfficeOnboardingReviewForm',
        label: 'Bank Office Onboarding Review Form',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    bankOfficeAnnualReview: {
        value: 'bankOfficeAnnualReview',
        label: 'Bank Office Annual Review',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    preassessmentHistoryStatementOfCurrentFormerProcessor: {
        value: 'preassessmentHistoryStatementOfCurrentFormerProcessor',
        label: 'History Statement of Current/Former Processor',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    successFeePayoutStatement: {
        value: 'successFeePayoutStatement',
        label: 'Success Fee Statement',
        category: 'internal',
        subCategories: ['internal'],
    },
    organisationalChart: {
        value: 'organisationalChart',
        label: 'Organisational Chart',
        category: 'general',
        subCategories: ['general'],
    },
    fundFlowChart: {
        value: 'fundFlowChart',
        label: 'Fund flow chart',
        category: 'general',
        subCategories: ['general'],
    },
    groupStructure: {
        value: 'groupStructure',
        label: 'Group Structure',
        category: 'general',
        subCategories: ['general'],
    },
    businessPlan: {
        value: 'businessPlan',
        label: 'Business Plan',
        category: 'general',
        subCategories: ['general'],
    },
    kycPolicy: {
        value: 'kycPolicy',
        label: 'KYC Policy',
        category: 'general',
        subCategories: ['general'],
    },
    serviceContracts: {
        value: 'serviceContracts',
        label: 'Service Contracts (with suppliers/clients)',
        category: 'general',
        subCategories: ['general'],
    },
    contentModerationPolicy: {
        value: 'contentModerationPolicy',
        label: 'Content Moderation Policy',
        category: 'general',
        subCategories: ['general'],
    },
    cvResume: {
        value: 'cvResume',
        label: 'CV/Resume',
        category: 'general',
        subCategories: ['general'],
    },
    annualReport: {
        value: 'annualReport',
        label: 'Annual Report',
        category: 'general',
        subCategories: ['general'],
    },
    feeRefundRequest: {
        value: 'feeRefundRequest',
        label: 'Fee Refund Request',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    directDebitMandate: {
        value: 'directDebitMandate',
        label: 'Direct Debit Mandate',
        category: 'internal',
        subCategories: ['internal', 'internal'],
    },
    sar: {
        value: 'sar',
        label: 'SAR',
        category: 'internal',
        subCategories: ['internal'],
    },
    feeGroupDocument: {
        value: 'feeGroupDocument',
        label: 'Fees, Charges and Limits',
        category: 'internal',
        subCategories: ['internal'],
    },
    financialServicesFirmsUseOfKlarpayAccounts: {
        value: 'financial_services_firms_use_of_klarpay_accounts',
        label: 'Financial Services Firms Use of Klarpay Accounts',
        category: 'internal',
        subCategories: ['internal'],
    },
    merchant_processing_request_form: {
        value: 'merchant_processing_request_form',
        label: 'Merchant Processing Request Form',
        category: 'general',
        subCategories: ['general'],
    },
};
const documentTypes = asEnum(_documentTypes);
const documentTranslationTypes = asEnum({
    porTranslation: {
        value: 'porTranslation',
        label: 'POR Translation',
        documentTypes: [
            'proofOfResidence',
            'utilityBill',
            'bankStatementPOR',
            'bankStatementPOF',
            'proofOfAddressTranslation',
            'bankStatement',
            'taxStatement',
            'payslip',
        ],
    },
    poiTranslation: {
        value: 'poiTranslation',
        label: 'POI Translation',
        documentTypes: [
            'idFront',
            'idBack',
            'id',
            'passport',
            'drivingLicense',
            'drivingLicenseFront',
            'drivingLicenseBack',
            'idTranslation',
        ],
    },
    corporateTranslation: {
        value: 'corporateTranslation',
        label: 'Corporate Translation',
        documentTypes: [
            'cardStatement',
            'cardCopies',
            'certificateOfGoodStanding',
            'certificateOfShareholders',
            'certificateOfIncorporation',
            'memorandumArticlesOfAssociation',
        ],
    },
    otherTranslation: {
        value: 'otherTranslation',
        label: 'Other Translation',
        documentTypes: [
            'other',
            'dueDiligence',
            'proofOfSignature',
            'approvalRejectionForm',
            'specialPowerOfAttorney',
            'revocationOfPoaSpoa',
            'thirdPartyAuthorizationLetter',
            'thirdPartyIdPassport',
            'residencePermitVisa',
            'address',
            'limitedPowerOfAttorney',
            'worldcheckResults',
            'swiftCopyPaymentAdvice',
            'virtualCard',
            'bankCard',
            'coinbasePop',
            'jointAccountForm',
            'bankPaymentDetails',
            'companiesRegistryExtract',
            'businessLicense',
            'professionalApplication',
            'thirdPartyWc',
            'otherPOF',
        ],
    },
});
documentTranslationTypes.porTranslation.documentTypes[0];
const proofOfResidencyDocumentTypes = pickBy_1(documentTypes, (type) => type.category === 'POR' && !type.deprecationReason);
const proofOfIdentityDocumentTypes = pickBy_1(documentTypes, (type) => type.category === 'POI' && !type.deprecationReason);
const proofOfFundsDocumentTypes = pickBy_1(documentTypes, (type) => type.category === 'POF' && !type.deprecationReason);
const internalDocumentTypes = pickBy_1(documentTypes, (type) => type.category === 'internal' && !type.deprecationReason);
const generalDocumentTypes = pickBy_1(documentTypes, (type) => type.category === 'general' && !type.deprecationReason);
const dashboardDocumentTypes = pickBy_1(documentTypes, (type) => type.category !== 'internal');
const processDocumentResults = asEnum({
    approve: {
        value: 'approve',
        label: 'Accept',
    },
    reject: {
        value: 'reject',
        label: 'Reject',
    },
});
const documentRelatedEntityTypes = asEnum({
    legalEntity: {
        value: 'legal_entity',
        label: 'Legal Entity',
    },
    individual: {
        value: 'individual',
        label: 'Individual',
    },
    transaction: {
        value: 'transaction',
        label: 'Transaction',
    },
    account: {
        value: 'account',
        label: 'Account',
    },
    mandate: {
        value: 'mandate',
        label: 'Mandate',
    },
    standingOrder: {
        value: 'standing_order',
        label: 'Standing Order',
    },
    wallet: {
        value: 'wallet',
        label: 'Wallet',
    },
    transactionRequest: {
        value: 'transaction_request',
        label: 'Transaction Request',
    },
});
const documentUserFilters = asEnum({
    uploadedByUser: {
        label: 'uploadedByUser',
        value: 'uploadedByUser',
    },
    uploadedByIndividual: {
        label: 'uploadedByIndividual',
        value: 'uploadedByIndividual',
    },
    uploadedByApiUser: {
        label: 'uploadedByApiUser',
        value: 'uploadedByApiUser',
    },
});
const documentOrigins = asEnum({
    dashboard: {
        value: 'dashboard',
        label: 'Dashboard',
    },
    crm: {
        value: 'crm',
        label: 'CRM',
    },
    api: {
        value: 'api',
        label: 'API',
    },
});

const errors = asEnum({
    campaignDoesNotExist: {
        label: 'Campaign ${campaignId} does not exist.',
    },
    bannerDoesNotExist: {
        label: 'Banner ${bannerId} does not exist.',
    },
    clientDoesNotExist: {
        label: 'Client ${clientId} does not exist.',
    },
    permissionDenied: {
        label: 'Logged user does not have right to see this page.',
    },
});
const passwordErrors = asLocalizedEnum('passwordErrors', {
    isRequired: {
        message: 'Password is required',
        label: 'Field is required!',
    },
    isLessThan5Chars: {
        message: 'Password must have at least 5 characters',
        label: 'Password length has to be between 5 to 128 characters.',
    },
    isMoreThan128Chars: {
        message: 'Password may have at most 128 characters',
        label: 'Password length has to be between 5 to 128 characters.',
    },
    noLowerCaseLetter: {
        message: 'Password must contain at least one lower case letter',
        label: 'Password must contain at least one lower case letter, one upper case letter and one digit.',
    },
    noUpperCaseLetter: {
        message: 'Password must contain at least one upper case letter',
        label: 'Password must contain at least one lower case letter, one upper case letter and one digit.',
    },
    noAnyLetter: {
        message: 'Password must contain at least one letter',
        label: 'Password must contain at least one letter.',
    },
    noDigit: {
        message: 'Password must contain at least one digit',
        label: 'Password must contain at least one digit.',
    },
});
const apiErrors = asLocalizedEnum('apiErrors', {
    ErrorInvalidCredentials: {
        label: 'Invalid email or password.',
    },
    ErrorAccountClosed: {
        label: 'Your account was closed. Please contact support.',
    },
    ErrorInvalidSocialCredentials: {
        label: 'Invalid account.',
    },
    ErrorSocialAccountExists: {
        label: 'Account already exists.',
    },
    UnauthorizedAccess: {
        label: 'Unauthorized Access',
    },
});

const backgroundJobs = {
    processPayment: 'PROCESS_PAYMENT',
    dormantFee: 'PROCESS_DORMANT_FEE',
    elasticSearchIndex: 'ELASTIC_SEARCH_INDEX',
    reassignAgentClients: 'REASSIGN_AGENT_CLIENTS',
    sendDocumentForVerification: 'SEND_DOC_FOR_VERIFICATION',
    scheduledNotifications: 'SCHEDULED_NOTIFICATIONS',
    postDepositAlertChecks: 'POST_DEPOSIT_ALERT_CHECKS',
    postClientSignUpActions: 'POST_CLIENT_SIGNUP_ACTIONS',
    createAlert: 'CREATE_ALERT',
    gdpr: 'GDPR',
    kyc: 'KYC',
    kycBlaclistedClients: 'KYC_BLACKLISTED_CLIENTS',
    reactivatePostponedAlerts: 'REACTIVATE_POSTPONED_ALERTS',
    notifyMerchant: 'NOTIFY_MERCHANT',
    pushNotifications: 'PUSH_NOTIFICATIONS',
    affiliateCommissions: 'PROCESS_AFFILIATE_COMMISSIONS',
};
const jobStatuses = asEnum({
    queued: {
        value: 'queued',
        label: 'Queued',
    },
    running: {
        value: 'running',
        label: 'Running',
    },
    completed: {
        value: 'completed',
        label: 'Completed',
    },
    completedWithError: {
        value: 'completed_with_error',
        label: 'Completed With Error',
    },
    stopped: {
        value: 'stopped',
        label: 'Stopped',
    },
});
const jobTypes = asEnum({
    dormantFee: {
        value: 'dormantFee',
        label: 'Dormant Fee',
        backgroundType: backgroundJobs.dormantFee,
    },
});
const jobActions = asEnum({
    apply: {
        value: 'apply',
        label: 'Apply',
    },
    revert: {
        value: 'revert',
        label: 'Revert',
    },
});
const inactivityFeeTypes = asEnum({
    dormant: {
        value: 'dormant',
        label: 'Dormant',
    },
    maintenance: {
        value: 'maintenance',
        label: 'Maintenance',
    },
});

const baselanguages = {
    aa: {
        value: 'aa',
        label: 'Afar',
        native: 'Afaraf',
        flag: 'et',
    },
    ab: {
        value: 'ab',
        label: 'Abkhazian',
        native: 'Аҧсуа',
        flag: 'ge',
    },
    af: {
        value: 'af',
        label: 'Afrikaans',
        native: 'Afrikaans',
        flag: 'za',
    },
    ak: {
        value: 'ak',
        label: 'Akan',
        native: 'Akana',
        flag: 'gh',
    },
    am: {
        value: 'am',
        label: 'Amharic',
        native: 'አማርኛ',
        flag: 'et',
    },
    an: {
        value: 'an',
        label: 'Aragonese',
        native: 'Aragonés',
        flag: 'es',
    },
    ar: {
        value: 'ar',
        label: 'Arabic',
        native: 'العربية',
        flag: 'sa',
    },
    as: {
        value: 'as',
        label: 'Assamese',
        native: 'অসমীয়া',
    },
    av: {
        value: 'av',
        label: 'Avar',
        native: 'Авар',
    },
    ay: {
        value: 'ay',
        label: 'Aymara',
        native: 'Aymar',
    },
    az: {
        value: 'az',
        label: 'Azerbaijani',
        native: 'آذربايجان',
        flag: 'az',
    },
    ba: {
        value: 'ba',
        label: 'Bashkir',
        native: 'Башҡорт',
    },
    be: {
        value: 'be',
        label: 'Belarusian',
        native: 'Беларуская',
        flag: 'by',
    },
    bg: {
        value: 'bg',
        label: 'Bulgarian',
        native: 'Български',
        flag: 'bg',
    },
    bh: {
        value: 'bh',
        label: 'Bihari',
        native: 'भोजपुरी',
    },
    bi: {
        value: 'bi',
        label: 'Bislama',
        native: 'Bislama',
        flag: 'vu',
    },
    bm: {
        value: 'bm',
        label: 'Bambara',
        native: 'Bamanankan',
        flag: 'ml',
    },
    bn: {
        value: 'bn',
        label: 'Bengali',
        native: 'বাংলা',
        flag: 'bd',
    },
    br: {
        value: 'br',
        label: 'Breton',
        native: 'Brezhoneg',
    },
    bs: {
        value: 'bs',
        label: 'Bosnian',
        native: 'Bosanski',
        flag: 'ba',
    },
    ca: {
        value: 'ca',
        label: 'Catalan',
        native: 'Català',
    },
    ce: {
        value: 'ce',
        label: 'Chechen',
        native: 'Нохчийн',
    },
    ch: {
        value: 'ch',
        label: 'Chamorro',
        native: 'Chamoru',
        flag: 'gu',
    },
    co: {
        value: 'co',
        label: 'Corsican',
        native: 'Corsu',
    },
    cr: {
        value: 'cr',
        label: 'Cree',
        native: 'ᓀᐦᐃᔭᐍᐏᐣ',
    },
    cs: {
        value: 'cs',
        label: 'Czech',
        native: 'Čeština',
        flag: 'cz',
    },
    cv: {
        value: 'cv',
        label: 'Chuvash',
        native: 'чӑваш чӗлхи',
    },
    cy: {
        value: 'cy',
        label: 'Welsh',
        native: 'Cymraeg',
    },
    da: {
        value: 'da',
        label: 'Danish',
        native: 'Dansk',
        flag: 'dk',
    },
    de: {
        value: 'de',
        label: 'German',
        native: 'Deutsch',
        flag: 'de',
    },
    dv: {
        value: 'dv',
        label: 'Divehi',
        native: 'ދިވެހިބަސް,',
        flag: 'mv',
    },
    dz: {
        value: 'dz',
        label: 'Dzongkha',
        native: 'ཇོང་ཁ',
    },
    ee: {
        value: 'ee',
        label: 'Ewe',
        native: 'Eʋegbe',
    },
    el: {
        value: 'el',
        label: 'Greek',
        native: 'Ελληνικά',
        flag: 'gr',
    },
    en: {
        value: 'en',
        label: 'English',
        native: 'English',
        variations: ['GB', 'US', 'AU', 'CA'],
        flag: 'gb',
    },
    eo: {
        value: 'eo',
        label: 'Esperanto',
        native: 'Esperanto',
    },
    es: {
        value: 'es',
        label: 'Spanish',
        native: 'Español',
        flag: 'es',
    },
    et: {
        value: 'et',
        label: 'Estonian',
        native: 'Eesti',
        flag: 'ee',
    },
    eu: {
        value: 'eu',
        label: 'Basque',
        native: 'Euskara',
    },
    fa: {
        value: 'fa',
        label: 'Persian',
        native: 'فارسی',
        flag: 'ir',
    },
    ff: {
        value: 'ff',
        label: 'Peul',
        native: 'Fulfulde',
    },
    fi: {
        value: 'fi',
        label: 'Finnish',
        native: 'Suomi',
        flag: 'fi',
    },
    fj: {
        value: 'fj',
        label: 'Fijian',
        native: 'Na Vosa Vakaviti',
        flag: 'fj',
    },
    fo: {
        value: 'fo',
        label: 'Faroese',
        native: 'Føroyskt',
        flag: 'fo',
    },
    fr: {
        value: 'fr',
        label: 'French',
        native: 'Français',
        flag: 'fr',
    },
    fy: {
        value: 'fy',
        label: 'West Frisian',
        native: 'Frysk',
    },
    ga: {
        value: 'ga',
        label: 'Irish',
        native: 'Gaeilge',
    },
    gd: {
        value: 'gd',
        label: 'Scottish Gaelic',
        native: 'Gàidhlig',
    },
    gl: {
        value: 'gl',
        label: 'Galician',
        native: 'Galego',
    },
    gn: {
        value: 'gn',
        label: 'Guarani',
        native: 'Avañe&#39;ẽ',
        flag: 'py',
    },
    gu: {
        value: 'gu',
        label: 'Gujarati',
        native: 'ગુજરાતી',
    },
    gv: {
        value: 'gv',
        label: 'Manx',
        native: 'Gaelg',
        flag: 'im',
    },
    ha: {
        value: 'ha',
        label: 'Hausa',
        native: 'هَوُسَ',
    },
    he: {
        value: 'he',
        label: 'Hebrew',
        native: 'עברית',
        flag: 'il',
    },
    hi: {
        value: 'hi',
        label: 'Hindi',
        native: 'हिन्दी, हिंदी',
        flag: 'in',
    },
    ho: {
        value: 'ho',
        label: 'Hiri Motu',
        native: 'Hiri Motu',
    },
    hr: {
        value: 'hr',
        label: 'Croatian',
        native: 'Hrvatski',
        flag: 'hr',
    },
    ht: {
        value: 'ht',
        label: 'Haitian',
        native: 'Krèyol ayisyen',
        flag: 'ht',
    },
    hu: {
        value: 'hu',
        label: 'Hungarian',
        native: 'Magyar',
        flag: 'hu',
    },
    hy: {
        value: 'hy',
        label: 'Armenian',
        native: 'Հայերեն',
        flag: 'am',
    },
    hz: {
        value: 'hz',
        label: 'Herero',
        native: 'Otsiherero',
    },
    id: {
        value: 'id',
        label: 'Indonesian',
        native: 'Bahasa Indonesia',
        flag: 'id',
    },
    ig: {
        value: 'ig',
        label: 'Igbo',
        native: 'Igbo',
    },
    ii: {
        value: 'ii',
        label: 'Sichuan Yi',
        native: 'Nuosuhxop',
    },
    ik: {
        value: 'ik',
        label: 'Inupiak',
        native: 'Iñupiak',
    },
    io: {
        value: 'io',
        label: 'Ido',
        native: 'Ido',
    },
    is: {
        value: 'is',
        label: 'Icelandic',
        native: 'Íslenska',
        flag: 'is',
    },
    it: {
        value: 'it',
        label: 'Italian',
        native: 'Italiano',
        flag: 'it',
    },
    iu: {
        value: 'iu',
        label: 'Inuktitut',
        native: 'ᐃᓄᒃᑎᑐᑦ',
    },
    ja: {
        value: 'ja',
        label: 'Japanese',
        native: '日本語',
        flag: 'jp',
    },
    jv: {
        value: 'jv',
        label: 'Javanese',
        native: 'Basa Jawa',
    },
    ka: {
        value: 'ka',
        label: 'Georgian',
        native: 'ქართული',
        flag: 'ge',
    },
    kg: {
        value: 'kg',
        label: 'Kongo',
        native: 'KiKongo',
    },
    ki: {
        value: 'ki',
        label: 'Kikuyu',
        native: 'Gĩkũyũ',
    },
    kj: {
        value: 'kj',
        label: 'Kuanyama',
        native: 'Kuanyama',
    },
    kk: {
        value: 'kk',
        label: 'Kazakh',
        native: 'Қазақша',
        flag: 'kz',
    },
    kl: {
        value: 'kl',
        label: 'Greenlandic',
        native: 'Kalaallisut',
        flag: 'gl',
    },
    km: {
        value: 'km',
        label: 'Cambodian',
        native: 'ភាសាខ្មែរ',
        flag: 'kh',
    },
    kn: {
        value: 'kn',
        label: 'Kannada',
        native: 'Kannada',
    },
    ko: {
        value: 'ko',
        label: 'Korean',
        native: '한국어',
        flag: 'kr',
    },
    kr: {
        value: 'kr',
        label: 'Kanuri',
        native: 'Kanuri',
    },
    ks: {
        value: 'ks',
        label: 'Kashmiri',
        native: 'कश्मीरी / كشميري',
    },
    ku: {
        value: 'ku',
        label: 'Kurdish',
        native: 'Kurdî / كوردی',
    },
    kv: {
        value: 'kv',
        label: 'Komi',
        native: 'Коми',
    },
    kw: {
        value: 'kw',
        label: 'Cornish',
        native: 'Kernewek',
    },
    ky: {
        value: 'ky',
        label: 'Kirghiz',
        native: 'Kırgızca / Кыргызча',
        flag: 'kg',
    },
    la: {
        value: 'la',
        label: 'Latin',
        native: 'Latina',
    },
    lb: {
        value: 'lb',
        label: 'Luxembourgish',
        native: 'Lëtzebuergesch',
        flag: 'lu',
    },
    lg: {
        value: 'lg',
        label: 'Ganda',
        native: 'Luganda',
        flag: 'ug',
    },
    li: {
        value: 'li',
        label: 'Limburgian',
        native: 'Limburgs',
    },
    ln: {
        value: 'ln',
        label: 'Lingala',
        native: 'Lingála',
    },
    lo: {
        value: 'lo',
        label: 'Laotian',
        native: 'ລາວ / Pha xa lao',
    },
    lt: {
        value: 'lt',
        label: 'Lithuanian',
        native: 'Lietuvių',
        flag: 'lt',
    },
    lv: {
        value: 'lv',
        label: 'Latvian',
        native: 'Latviešu',
        flag: 'lv',
    },
    mg: {
        value: 'mg',
        label: 'Malagasy',
        native: 'Malagasy',
        flag: 'mg',
    },
    mh: {
        value: 'mh',
        label: 'Marshallese',
        native: 'Kajin Majel / Ebon',
    },
    mi: {
        value: 'mi',
        label: 'Maori',
        native: 'Māori',
        flag: 'nz',
    },
    mk: {
        value: 'mk',
        label: 'Macedonian',
        native: 'Македонски',
        flag: 'mk',
    },
    ml: {
        value: 'ml',
        label: 'Malayalam',
        native: 'മലയാളം',
    },
    mn: {
        value: 'mn',
        label: 'Mongolian',
        native: 'Монгол',
        flag: 'mn',
    },
    mo: {
        value: 'mo',
        label: 'Moldovan',
        native: 'Moldovenească',
        flag: 'md',
    },
    mr: {
        value: 'mr',
        label: 'Marathi',
        native: 'मराठी',
    },
    ms: {
        value: 'ms',
        label: 'Malay',
        native: 'Bahasa Melayu',
        flag: 'my',
    },
    mt: {
        value: 'mt',
        label: 'Maltese',
        native: 'Malti',
        flag: 'mt',
    },
    my: {
        value: 'my',
        label: 'Burmese',
        native: 'Myanmasa',
        flag: 'mm',
    },
    na: {
        value: 'na',
        label: 'Nauruan',
        native: 'Dorerin Naoero',
    },
    nd: {
        value: 'nd',
        label: 'North Ndebele',
        native: 'Sindebele',
    },
    ne: {
        value: 'ne',
        label: 'Nepali',
        native: 'नेपाली',
        flag: 'np',
    },
    ng: {
        value: 'ng',
        label: 'Ndonga',
        native: 'Oshiwambo',
    },
    nl: {
        value: 'nl',
        label: 'Dutch',
        native: 'Nederlands',
        flag: 'nl',
    },
    no: {
        value: 'no',
        label: 'Norwegian',
        native: 'Norsk',
        flag: 'no',
    },
    nb: {
        value: 'nb',
        label: 'Norwegian Bokmål',
        native: 'Norsk bokmål',
    },
    nr: {
        value: 'nr',
        label: 'South Ndebele',
        native: 'isiNdebele',
    },
    nv: {
        value: 'nv',
        label: 'Navajo',
        native: 'Diné bizaad',
    },
    ny: {
        value: 'ny',
        label: 'Chichewa',
        native: 'Chi-Chewa',
    },
    oc: {
        value: 'oc',
        label: 'Occitan',
        native: 'Occitan',
    },
    oj: {
        value: 'oj',
        label: 'Ojibwa',
        native: 'ᐊᓂᔑᓈᐯᒧᐎᓐ / Anishinaabemowin',
    },
    om: {
        value: 'om',
        label: 'Oromo',
        native: 'Oromoo',
    },
    or: {
        value: 'or',
        label: 'Oriya',
        native: 'ଓଡ଼ିଆ',
    },
    os: {
        value: 'os',
        label: 'Ossetian / Ossetic',
        native: 'Иронау',
        flag: 'ir',
    },
    pa: {
        value: 'pa',
        label: 'Panjabi / Punjabi',
        native: 'ਪੰਜਾਬੀ / पंजाबी / پنجابي',
        flag: 'in',
    },
    ph: {
        value: 'ph',
        label: 'Filipino',
        native: 'Filipino',
        flag: 'ph',
    },
    pi: {
        value: 'pi',
        label: 'Pali',
        native: 'Pāli / पाऴि',
    },
    pl: {
        value: 'pl',
        label: 'Polish',
        native: 'Polski',
        flag: 'pl',
    },
    ps: {
        value: 'ps',
        label: 'Pashto',
        native: 'پښتو',
    },
    pt: {
        value: 'pt',
        label: 'Portuguese',
        native: 'Português',
        flag: 'pt',
    },
    qu: {
        value: 'qu',
        label: 'Quechua',
        native: 'Runa Simi',
    },
    rn: {
        value: 'rn',
        label: 'Kirundi',
        native: 'Kirundi',
        flag: 'bi',
    },
    ro: {
        value: 'ro',
        label: 'Romanian',
        native: 'Română',
        flag: 'ro',
    },
    ru: {
        value: 'ru',
        label: 'Russian',
        native: 'Русский',
        flag: 'ru',
    },
    rw: {
        value: 'rw',
        label: 'Rwandi',
        native: 'Kinyarwandi',
        flag: 'rw',
    },
    sa: {
        value: 'sa',
        label: 'Sanskrit',
        native: 'संस्कृतम्',
    },
    sc: {
        value: 'sc',
        label: 'Sardinian',
        native: 'Sardu',
    },
    sd: {
        value: 'sd',
        label: 'Sindhi',
        native: 'सिनधि',
    },
    se: {
        value: 'se',
        label: 'Northern Sami',
        native: 'Davvisámegiella',
    },
    sg: {
        value: 'sg',
        label: 'Sango',
        native: 'Sängö',
        flag: 'cf',
    },
    sh: {
        value: 'sh',
        label: 'Serbo-Croatian',
        native: 'Srpskohrvatski / Српскохрватски',
    },
    si: {
        value: 'si',
        label: 'Sinhalese',
        native: 'සිංහල',
        flag: 'lk',
    },
    sk: {
        value: 'sk',
        label: 'Slovak',
        native: 'Slovenčina',
        flag: 'sk',
    },
    sl: {
        value: 'sl',
        label: 'Slovenian',
        native: 'Slovenščina',
        flag: 'si',
    },
    sm: {
        value: 'sm',
        label: 'Samoan',
        native: 'Gagana Samoa',
        flag: 'as',
    },
    sn: {
        value: 'sn',
        label: 'Shona',
        native: 'chiShona',
        flag: '',
    },
    so: {
        value: 'so',
        label: 'Somalia',
        native: 'Soomaaliga',
        flag: 'so',
    },
    sq: {
        value: 'sq',
        label: 'Albanian',
        native: 'Shqip',
        flag: 'al',
    },
    sr: {
        value: 'sr',
        label: 'Serbian',
        native: 'Српски',
        flag: 'rs',
    },
    ss: {
        value: 'ss',
        label: 'Swati',
        native: 'SiSwati',
    },
    st: {
        value: 'st',
        label: 'Southern Sotho',
        native: 'Sesotho',
        flag: 'ls',
    },
    su: {
        value: 'su',
        label: 'Sundanese',
        native: 'Basa Sunda',
    },
    sv: {
        value: 'sv',
        label: 'Swedish',
        native: 'Svenska',
        flag: 'se',
    },
    sw: {
        value: 'sw',
        label: 'Swahili',
        native: 'Kiswahili',
    },
    ta: {
        value: 'ta',
        label: 'Tamil',
        native: 'தமிழ்',
        flag: 'lk',
    },
    tg: {
        value: 'tg',
        label: 'Tajik',
        native: 'Тоҷикӣ',
        flag: 'tj',
    },
    th: {
        value: 'th',
        label: 'Thai',
        native: 'ไทย',
        flag: 'th',
    },
    ti: {
        value: 'ti',
        label: 'Tigrinya',
        native: 'ትግርኛ',
    },
    tk: {
        value: 'tk',
        label: 'Turkmen',
        native: 'Туркмен / تركمن',
        flag: 'tm',
    },
    tn: {
        value: 'tn',
        label: 'Tswana',
        native: 'Setswana',
    },
    to: {
        value: 'to',
        label: 'Tonga',
        native: 'Lea Faka-Tonga',
        flag: 'to',
    },
    tr: {
        value: 'tr',
        label: 'Turkish',
        native: 'Türkçe',
        flag: 'tr',
    },
    ts: {
        value: 'ts',
        label: 'Tsonga',
        native: 'Xitsonga',
    },
    tt: {
        value: 'tt',
        label: 'Tatar',
        native: 'Tatarça',
    },
    tw: {
        value: 'tw',
        label: 'Twi',
        native: 'Twi',
        flag: '',
    },
    ty: {
        value: 'ty',
        label: 'Tahitian',
        native: 'Reo Mā`ohi',
        flag: '',
    },
    ug: {
        value: 'ug',
        label: 'Uyghur',
        native: 'Uyƣurqə / ئۇيغۇرچە',
        flag: '',
    },
    uk: {
        value: 'uk',
        label: 'Ukrainian',
        native: 'Українська',
        flag: 'ua',
    },
    ur: {
        value: 'ur',
        label: 'Urdu',
        native: 'اردو',
        flag: 'pk',
    },
    uz: {
        value: 'uz',
        label: 'Uzbek',
        native: 'Ўзбек',
        flag: 'uz',
    },
    ve: {
        value: 've',
        label: 'Venda',
        native: 'Tshivenḓa',
        flag: 'za',
    },
    vi: {
        value: 'vi',
        label: 'Vietnamese',
        native: 'Việt Nam',
        flag: 'vn',
    },
    vo: {
        value: 'vo',
        label: 'Volapük',
        native: 'Volapük',
    },
    wa: {
        value: 'wa',
        label: 'Walloon',
        native: 'Walon',
    },
    wo: {
        value: 'wo',
        label: 'Wolof',
        native: 'Wollof',
    },
    xh: {
        value: 'xh',
        label: 'Xhosa',
        native: 'isiXhosa',
    },
    yi: {
        value: 'yi',
        label: 'Yiddish',
        native: 'ייִדיש',
    },
    yo: {
        value: 'yo',
        label: 'Yoruba',
        native: 'Yorùbá',
        flag: 'ng',
    },
    za: {
        value: 'za',
        label: 'Zhuang',
        native: 'Cuengh / Tôô / 壮语',
        flag: 'cn',
    },
    zh: {
        value: 'zh',
        label: 'Chinese',
        native: '中文',
        flag: 'cn',
    },
    zu: {
        value: 'zu',
        label: 'Zulu',
        native: 'isiZulu',
    },
};
const languages = asEnum(baselanguages);
const generateLanguagesWithVariations = (inLanguages) => {
    return Object.entries(inLanguages)
        .filter((l) => l[1].variations)
        .reduce((acc, [key, l]) => {
        const append = l.variations?.reduce((acc, v) => {
            const id = `${key}${v}`;
            return {
                ...acc,
                [id]: { ...l, value: `${key}-${v}`, label: `${l.label}-${v}` },
            };
        }, {});
        return {
            ...acc,
            ...append,
        };
    }, inLanguages);
};
const languagesWithVariation = asEnum(generateLanguagesWithVariations(baselanguages));

const locales = asEnum({
    ar: { value: 'ar', label: 'ar' },
    cs: { value: 'cs', label: 'cs' },
    da: { value: 'da', label: 'da' },
    de: { value: 'de', label: 'de' },
    el: { value: 'el', label: 'el' },
    en: { value: 'en', label: 'en' },
    es: { value: 'es', label: 'es' },
    fi: { value: 'fi', label: 'fi' },
    fr: { value: 'fr', label: 'fr' },
    hi: { value: 'hi', label: 'hi' },
    id: { value: 'id', label: 'id' },
    it: { value: 'it', label: 'it' },
    ko: { value: 'ko', label: 'ko' },
    ms: { value: 'ms', label: 'ms' },
    nl: { value: 'nl', label: 'nl' },
    no: { value: 'no', label: 'no' },
    ph: { value: 'ph', label: 'ph' },
    pl: { value: 'pl', label: 'pl' },
    pt: { value: 'pt', label: 'pt' },
    ro: { value: 'ro', label: 'ro' },
    ru: { value: 'ru', label: 'ru' },
    sv: { value: 'sv', label: 'sv' },
    th: { value: 'th', label: 'th' },
    tr: { value: 'tr', label: 'tr' },
    vi: { value: 'vi', label: 'vi' },
    zh: { value: 'zh', label: 'zh' },
});

const _nationalities = {
    afghan: {
        value: 'Afghan',
        label: 'Afghan',
        alpha3Code: 'AFG',
        country: countries.af,
    },
    alandish: {
        value: 'Ålandish',
        label: 'Ålandish',
        alpha3Code: 'ALA',
        country: countries.ax,
    },
    albanian: {
        value: 'Albanian',
        label: 'Albanian',
        alpha3Code: 'ALB',
        country: countries.al,
    },
    algerian: {
        value: 'Algerian',
        label: 'Algerian',
        alpha3Code: 'DZA',
        country: countries.dz,
    },
    anguillan: {
        value: 'Anguillan',
        label: 'Anguillan',
        alpha3Code: 'AIA',
        country: countries.ai,
    },
    americanSamoan: {
        value: 'American Samoan',
        label: 'American Samoan',
        alpha3Code: 'ASM',
        country: countries.as,
    },
    american: {
        value: 'American',
        label: 'American',
        alpha3Code: 'USA',
        country: countries.us,
    },
    andorran: {
        value: 'Andorran',
        label: 'Andorran',
        alpha3Code: 'AND',
        country: countries.ad,
    },
    angolan: {
        value: 'Angolan',
        label: 'Angolan',
        alpha3Code: 'AGO',
        country: countries.ao,
    },
    antarctic: {
        value: 'Antarctic',
        label: 'Antarctic',
        alpha3Code: 'ATA',
        hidden: true,
        country: countries.aq,
    },
    antiguanBarbudan: {
        value: 'Antiguan, Barbudan',
        label: 'Antiguan, Barbudan',
        alpha3Code: 'ATG',
        country: countries.ag,
    },
    argentinean: {
        value: 'Argentinean',
        label: 'Argentinean',
        alpha3Code: 'ARG',
        country: countries.ar,
    },
    armenian: {
        value: 'Armenian',
        label: 'Armenian',
        alpha3Code: 'ARM',
        country: countries.am,
    },
    aruban: {
        value: 'Aruban',
        label: 'Aruban',
        alpha3Code: 'ABW',
        country: countries.aw,
    },
    australian: {
        value: 'Australian',
        label: 'Australian',
        alpha3Code: 'AUS',
        country: countries.au,
    },
    austrian: {
        value: 'Austrian',
        label: 'Austrian',
        alpha3Code: 'AUT',
        country: countries.at,
    },
    azerbaijani: {
        value: 'Azerbaijani',
        label: 'Azerbaijani',
        alpha3Code: 'AZE',
        country: countries.az,
    },
    bahamian: {
        value: 'Bahamian',
        label: 'Bahamian',
        alpha3Code: 'BHS',
        country: countries.bs,
    },
    bahraini: {
        value: 'Bahraini',
        label: 'Bahraini',
        alpha3Code: 'BHR',
        country: countries.bh,
    },
    bangladeshi: {
        value: 'Bangladeshi',
        label: 'Bangladeshi',
        alpha3Code: 'BGD',
        country: countries.bd,
    },
    barbadian: {
        value: 'Barbadian',
        label: 'Barbadian',
        alpha3Code: 'BRB',
        country: countries.bb,
    },
    belarusian: {
        value: 'Belarusian',
        label: 'Belarusian',
        alpha3Code: 'BLR',
        country: countries.by,
    },
    belgian: {
        value: 'Belgian',
        label: 'Belgian',
        alpha3Code: 'BEL',
        country: countries.be,
    },
    belizean: {
        value: 'Belizean',
        label: 'Belizean',
        alpha3Code: 'BLZ',
        country: countries.bz,
    },
    bhutanese: {
        value: 'Bhutanese',
        label: 'Bhutanese',
        alpha3Code: 'BTN',
        country: countries.bt,
    },
    bolivian: {
        value: 'Bolivian',
        label: 'Bolivian',
        alpha3Code: 'BOL',
        country: countries.bo,
    },
    bosnianHerzegovinian: {
        value: 'Bosnian, Herzegovinian',
        label: 'Bosnian, Herzegovinian',
        alpha3Code: 'BIH',
        country: countries.ba,
    },
    brazilian: {
        value: 'Brazilian',
        label: 'Brazilian',
        alpha3Code: 'BRA',
        country: countries.br,
    },
    british: {
        value: 'British',
        label: 'British',
        alpha3Code: 'GBR',
        country: countries.gb,
    },
    bulgarian: {
        value: 'Bulgarian',
        label: 'Bulgarian',
        alpha3Code: 'BGR',
        country: countries.bg,
    },
    burundian: {
        value: 'Burundian',
        label: 'Burundian',
        alpha3Code: 'BDI',
        country: countries.bi,
    },
    beninese: {
        value: 'Beninese',
        label: 'Beninese',
        alpha3Code: 'BEN',
        country: countries.bj,
    },
    bermudan: {
        value: 'Bermudan',
        label: 'Bermudan',
        alpha3Code: 'BMU',
        country: countries.bm,
    },
    bruneian: {
        value: 'Bruneian',
        label: 'Bruneian',
        alpha3Code: 'BRN',
        country: countries.bn,
    },
    burkinabe: {
        value: 'Burkinabe',
        label: 'Burkinabe',
        alpha3Code: 'BFA',
        country: countries.bf,
    },
    cambodian: {
        value: 'Cambodian',
        label: 'Cambodian',
        alpha3Code: 'KHM',
        country: countries.kh,
    },
    cameroonian: {
        value: 'Cameroonian',
        label: 'Cameroonian',
        alpha3Code: 'CMR',
        country: countries.cm,
    },
    canadian: {
        value: 'Canadian',
        label: 'Canadian',
        alpha3Code: 'CAN',
        country: countries.ca,
    },
    caymanian: {
        value: 'Caymanian',
        label: 'Caymanian',
        alpha3Code: 'CYM',
        country: countries.ky,
    },
    capeVerdian: {
        value: 'Cape Verdian',
        label: 'Cape Verdian',
        alpha3Code: 'CPV',
        country: countries.cv,
    },
    chadian: {
        value: 'Chadian',
        label: 'Chadian',
        alpha3Code: 'TCD',
        country: countries.td,
    },
    chilean: {
        value: 'Chilean',
        label: 'Chilean',
        alpha3Code: 'CHL',
        country: countries.cl,
    },
    chinese: {
        value: 'Chinese',
        label: 'Chinese',
        alpha3Code: 'CHN',
        country: countries.cn,
    },
    curacaoan: {
        value: 'Curacaoan',
        label: 'Curaçaoan',
        alpha3Code: 'CUW',
        country: countries.cw,
    },
    christmasIsland: {
        value: 'Christmas Island',
        label: 'Christmas Island',
        alpha3Code: 'CXR',
        country: countries.cx,
    },
    cocossian: {
        value: 'Cocossian',
        label: 'Cocossian',
        alpha3Code: 'CCK',
        country: countries.cc,
    },
    colombian: {
        value: 'Colombian',
        label: 'Colombian',
        alpha3Code: 'COL',
        country: countries.co,
    },
    comoran: {
        value: 'Comoran',
        label: 'Comoran',
        alpha3Code: 'COM',
        country: countries.km,
    },
    centralAfrican: {
        value: 'Central African',
        label: 'Central African',
        alpha3Code: 'CAF',
        country: countries.cf,
    },
    cookIslander: {
        value: 'Cook Islander',
        label: 'Cook Islander',
        alpha3Code: 'COK',
        country: countries.ck,
    },
    congolese: {
        value: 'Congolese',
        label: 'Congolese',
        alpha3Code: 'COD',
        country: countries.cd,
    },
    costaRican: {
        value: 'Costa Rican',
        label: 'Costa Rican',
        alpha3Code: 'CRI',
        country: countries.cr,
    },
    croatian: {
        value: 'Croatian',
        label: 'Croatian',
        alpha3Code: 'HRV',
        country: countries.hr,
    },
    cuban: {
        value: 'Cuban',
        label: 'Cuban',
        alpha3Code: 'CUB',
        country: countries.cu,
    },
    cypriot: {
        value: 'Cypriot',
        label: 'Cypriot',
        alpha3Code: 'CYP',
        country: countries.cy,
    },
    czech: {
        value: 'Czech',
        label: 'Czech',
        alpha3Code: 'CZE',
        country: countries.cz,
    },
    danish: {
        value: 'Danish',
        label: 'Danish',
        alpha3Code: 'DNK',
        country: countries.dk,
    },
    djibouti: {
        value: 'Djibouti',
        label: 'Djibouti',
        alpha3Code: 'DJI',
        country: countries.dj,
    },
    dominican: {
        value: 'Dominican',
        label: 'Dominican',
        alpha3Code: 'DOM',
        country: countries.dm,
    },
    dutch: {
        value: 'Dutch',
        label: 'Dutch',
        alpha3Code: 'NLD',
        country: countries.nl,
    },
    ecuadorean: {
        value: 'Ecuadorean',
        label: 'Ecuadorean',
        alpha3Code: 'ECU',
        country: countries.ec,
    },
    egyptian: {
        value: 'Egyptian',
        label: 'Egyptian',
        alpha3Code: 'EGY',
        country: countries.eg,
    },
    emirian: {
        value: 'Emirian',
        label: 'Emirian',
        alpha3Code: 'ARE',
        country: countries.ae,
    },
    eritrean: {
        value: 'Eritrean',
        label: 'Eritrean',
        alpha3Code: 'ERI',
        country: countries.er,
    },
    estonian: {
        value: 'Estonian',
        label: 'Estonian',
        alpha3Code: 'EST',
        country: countries.ee,
    },
    ethiopian: {
        value: 'Ethiopian',
        label: 'Ethiopian',
        alpha3Code: 'ETH',
        country: countries.et,
    },
    equatorialGuinean: {
        value: 'Equatorial Guinean',
        label: 'Equatorial Guinean',
        alpha3Code: 'GNQ',
        country: countries.gq,
    },
    falklandIslander: {
        value: 'Falkland Islander',
        label: 'Falkland Islander',
        alpha3Code: 'FLK',
        country: countries.fk,
    },
    fijian: {
        value: 'Fijian',
        label: 'Fijian',
        alpha3Code: 'FJI',
        country: countries.fj,
    },
    filipino: {
        value: 'Filipino',
        label: 'Filipino',
        alpha3Code: 'PHL',
        country: countries.ph,
    },
    finnish: {
        value: 'Finnish',
        label: 'Finnish',
        alpha3Code: 'FIN',
        country: countries.fi,
    },
    frenchPolynesian: {
        value: 'French Polynesian',
        label: 'French Polynesian',
        alpha3Code: 'PYF',
        country: countries.pf,
    },
    french: {
        value: 'French',
        label: 'French',
        alpha3Code: 'FRA',
        country: countries.fr,
    },
    frenchGuianese: {
        value: 'French Guianese',
        label: 'French Guianese',
        alpha3Code: 'GUF',
        country: countries.gf,
    },
    Faroese: {
        value: 'Faroese',
        label: 'Faroese',
        alpha3Code: 'FRO',
        country: countries.fo,
    },
    gabonese: {
        value: 'Gabonese',
        label: 'Gabonese',
        alpha3Code: 'GAB',
        country: countries.ga,
    },
    gambian: {
        value: 'Gambian',
        label: 'Gambian',
        alpha3Code: 'GMB',
        country: countries.gm,
    },
    georgian: {
        value: 'Georgian',
        label: 'Georgian',
        alpha3Code: 'GEO',
        country: countries.ge,
    },
    german: {
        value: 'German',
        label: 'German',
        alpha3Code: 'DEU',
        country: countries.de,
    },
    ghanaian: {
        value: 'Ghanaian',
        label: 'Ghanaian',
        alpha3Code: 'GHA',
        country: countries.gh,
    },
    greek: {
        value: 'Greek',
        label: 'Greek',
        alpha3Code: 'GRC',
        country: countries.gr,
    },
    grenadian: {
        value: 'Grenadian',
        label: 'Grenadian',
        alpha3Code: 'GRD',
        country: countries.gd,
    },
    greenlander: {
        value: 'Greenlander',
        label: 'Greenlander',
        alpha3Code: 'GRL',
        country: countries.gl,
    },
    guamanian: {
        value: 'Guamanian',
        label: 'Guamanian',
        alpha3Code: 'GUM',
        country: countries.gu,
    },
    guatemalan: {
        value: 'Guatemalan',
        label: 'Guatemalan',
        alpha3Code: 'GTM',
        country: countries.gt,
    },
    guadeloupean: {
        value: 'Guadeloupean',
        label: 'Guadeloupean',
        alpha3Code: 'GLP',
        country: countries.gp,
    },
    guyanese: {
        value: 'Guyanese',
        label: 'Guyanese',
        alpha3Code: 'GUY',
        country: countries.gy,
    },
    haitian: {
        value: 'Haitian',
        label: 'Haitian',
        alpha3Code: 'HTI',
        country: countries.ht,
    },
    heardAndMcDonaldIslander: {
        value: 'Heard and McDonald Islander',
        label: 'Heard and McDonald Islander',
        alpha3Code: 'HMD',
        country: countries.hm,
    },
    honduran: {
        value: 'Honduran',
        label: 'Honduran',
        alpha3Code: 'HND',
        country: countries.hn,
    },
    hungarian: {
        value: 'Hungarian',
        label: 'Hungarian',
        alpha3Code: 'HUN',
        country: countries.hu,
    },
    hongKonger: {
        value: 'Hong Konger',
        label: 'Hong Konger',
        alpha3Code: 'HKG',
        country: countries.hk,
    },
    icelander: {
        value: 'Icelander',
        label: 'Icelander',
        alpha3Code: 'ISL',
        country: countries.is,
    },
    indian: {
        value: 'Indian',
        label: 'Indian',
        alpha3Code: 'IND',
        country: countries.in,
    },
    indonesian: {
        value: 'Indonesian',
        label: 'Indonesian',
        alpha3Code: 'IDN',
        country: countries.id,
    },
    iranian: {
        value: 'Iranian',
        label: 'Iranian',
        alpha3Code: 'IRN',
        country: countries.ir,
    },
    iraqi: {
        value: 'Iraqi',
        label: 'Iraqi',
        alpha3Code: 'IRQ',
        country: countries.iq,
    },
    irish: {
        value: 'Irish',
        label: 'Irish',
        alpha3Code: 'IRL',
        country: countries.ie,
    },
    israeli: {
        value: 'Israeli',
        label: 'Israeli',
        alpha3Code: 'ISR',
        country: countries.il,
    },
    italian: {
        value: 'Italian',
        label: 'Italian',
        alpha3Code: 'ITA',
        country: countries.it,
    },
    ivorian: {
        value: 'Ivorian',
        label: 'Ivorian',
        alpha3Code: 'CIV',
        country: countries.ci,
    },
    jamaican: {
        value: 'Jamaican',
        label: 'Jamaican',
        alpha3Code: 'JAM',
        country: countries.jm,
    },
    japanese: {
        value: 'Japanese',
        label: 'Japanese',
        alpha3Code: 'JPN',
        country: countries.jp,
    },
    jordanian: {
        value: 'Jordanian',
        label: 'Jordanian',
        alpha3Code: 'JOR',
        country: countries.jo,
    },
    kazakhstani: {
        value: 'Kazakhstani',
        label: 'Kazakhstani',
        alpha3Code: 'KAZ',
        country: countries.kz,
    },
    kenyan: {
        value: 'Kenyan',
        label: 'Kenyan',
        alpha3Code: 'KEN',
        country: countries.ke,
    },
    kirghiz: {
        value: 'Kirghiz',
        label: 'Kirghiz',
        alpha3Code: 'KGZ',
        country: countries.kg,
    },
    kiribati: {
        value: 'Kiribati',
        label: 'Kiribati',
        alpha3Code: 'KIR',
        country: countries.ki,
    },
    kittianNevisian: {
        value: 'Kittian	Nevisian',
        label: 'Kittian Nevisian',
        alpha3Code: 'KNA',
        country: countries.kn,
    },
    kosovar: {
        value: 'Kosovar',
        label: 'Kosovar',
        alpha3Code: 'XKX',
        country: countries.kv,
    },
    kuwaiti: {
        value: 'Kuwaiti',
        label: 'Kuwaiti',
        alpha3Code: 'KWT',
        country: countries.kw,
    },
    latvian: {
        value: 'Latvian',
        label: 'Latvian',
        alpha3Code: 'LVA',
        country: countries.lv,
    },
    laotian: {
        value: 'Laotian',
        label: 'Laotian',
        alpha3Code: 'LAO',
        country: countries.la,
    },
    lebanese: {
        value: 'Lebanese',
        label: 'Lebanese',
        alpha3Code: 'LBN',
        country: countries.lb,
    },
    libyan: {
        value: 'Libyan',
        label: 'Libyan',
        alpha3Code: 'LBY',
        country: countries.ly,
    },
    liechtensteiner: {
        value: 'Liechtensteiner',
        label: 'Liechtensteiner',
        alpha3Code: 'LIE',
        country: countries.li,
    },
    lithuanian: {
        value: 'Lithuanian',
        label: 'Lithuanian',
        alpha3Code: 'LTU',
        country: countries.lt,
    },
    liberian: {
        value: 'Liberian',
        label: 'Liberian',
        alpha3Code: 'LBR',
        country: countries.lr,
    },
    luxembourger: {
        value: 'Luxembourger',
        label: 'Luxembourger',
        alpha3Code: 'LUX',
        country: countries.lu,
    },
    macanese: {
        value: 'Macanese',
        label: 'Macanese',
        alpha3Code: 'MAC',
        country: countries.mo,
    },
    macedonian: {
        value: 'Macedonian',
        label: 'Macedonian',
        alpha3Code: 'MKD',
        country: countries.mk,
    },
    mahoran: {
        value: 'Mahoran',
        label: 'Mahoran',
        alpha3Code: 'MYT',
        country: countries.yt,
    },
    malagasy: {
        value: 'Malagasy',
        label: 'Malagasy',
        alpha3Code: 'MDG',
        country: countries.mg,
    },
    malaysian: {
        value: 'Malaysian',
        label: 'Malaysian',
        alpha3Code: 'MYS',
        country: countries.my,
    },
    malawian: {
        value: 'Malawian',
        label: 'Malawian',
        alpha3Code: 'MWI',
        country: countries.mw,
    },
    maldivan: {
        value: 'Maldivan',
        label: 'Maldivan',
        alpha3Code: 'MDV',
        country: countries.mv,
    },
    malian: {
        value: 'Malian',
        label: 'Malian',
        alpha3Code: 'MLI',
        country: countries.ml,
    },
    maltese: {
        value: 'Maltese',
        label: 'Maltese',
        alpha3Code: 'MLT',
        country: countries.mt,
    },
    marshallese: {
        value: 'Marshallese',
        label: 'Marshallese',
        alpha3Code: 'MHL',
        country: countries.mh,
    },
    mariana: {
        value: 'Northern Mariana Islander',
        label: 'Northern Mariana Islander',
        alpha3Code: 'MNP',
        country: countries.mp,
    },
    martinican: {
        value: 'Martinican',
        label: 'Martinican',
        alpha3Code: 'MTQ',
        country: countries.mq,
    },
    montserratian: {
        value: 'Montserratian',
        label: 'Montserratian',
        alpha3Code: 'MSR',
        country: countries.ms,
    },
    manx: {
        value: 'Manx',
        label: 'Manx',
        alpha3Code: 'IMN',
        country: countries.im,
    },
    mauritanian: {
        value: 'Mauritanian',
        label: 'Mauritanian',
        alpha3Code: 'MRT',
        country: countries.mr,
    },
    mauritian: {
        value: 'Mauritian',
        label: 'Mauritian',
        alpha3Code: 'MUS',
        country: countries.mu,
    },
    mexican: {
        value: 'Mexican',
        label: 'Mexican',
        alpha3Code: 'MEX',
        country: countries.mx,
    },
    micronesian: {
        value: 'Micronesian',
        label: 'Micronesian',
        alpha3Code: 'FSM',
        country: countries.fm,
    },
    moldovan: {
        value: 'Moldovan',
        label: 'Moldovan',
        alpha3Code: 'MDA',
        country: countries.md,
    },
    monacan: {
        value: 'Monacan',
        label: 'Monacan',
        alpha3Code: 'MCO',
        country: countries.mc,
    },
    mongolian: {
        value: 'Mongolian',
        label: 'Mongolian',
        alpha3Code: 'MNG',
        country: countries.mn,
    },
    montenegrin: {
        value: 'Montenegrin',
        label: 'Montenegrin',
        alpha3Code: 'MNE',
        country: countries.me,
    },
    moroccan: {
        value: 'Moroccan',
        label: 'Moroccan',
        alpha3Code: 'MAR',
        country: countries.ma,
    },
    motswana: {
        value: 'Motswana',
        label: 'Motswana',
        alpha3Code: 'BWA',
        country: countries.bw,
    },
    mozambican: {
        value: 'Mozambican',
        label: 'Mozambican',
        alpha3Code: 'MOZ',
        country: countries.mz,
    },
    myanmarese: {
        value: 'Myanmarese',
        label: 'Myanmarese',
        alpha3Code: 'MMR',
        country: countries.mm,
    },
    namibian: {
        value: 'Namibian',
        label: 'Namibian',
        alpha3Code: 'NAM',
        country: countries.na,
    },
    nauruan: {
        value: 'Nauruan',
        label: 'Nauruan',
        alpha3Code: 'NRU',
        country: countries.nr,
    },
    nepalese: {
        value: 'Nepalese',
        label: 'Nepalese',
        alpha3Code: 'NPL',
        country: countries.np,
    },
    newCaledonian: {
        value: 'New Caledonian',
        label: 'New Caledonian',
        alpha3Code: 'NCL',
        country: countries.nc,
    },
    newZealander: {
        value: 'New Zealander',
        label: 'New Zealander',
        alpha3Code: 'NZL',
        country: countries.nz,
    },
    nicaraguan: {
        value: 'Nicaraguan',
        label: 'Nicaraguan',
        alpha3Code: 'NIC',
        country: countries.ni,
    },
    nigerian: {
        value: 'Nigerian',
        label: 'Nigerian (Nigeria)',
        alpha3Code: 'NGA',
        country: countries.ng,
    },
    nigerien: {
        value: 'Nigerien',
        label: 'Nigerien (Niger)',
        alpha3Code: 'NER',
        country: countries.ne,
    },
    niuean: {
        value: 'Niuean',
        label: 'Niuean',
        alpha3Code: 'NIU',
        country: countries.nu,
    },
    norfolkIslander: {
        value: 'Norfolk Islander',
        label: 'Norfolk Islander',
        alpha3Code: 'NFK',
        country: countries.nf,
    },
    northKorean: {
        value: 'North Korean',
        label: 'North Korean',
        alpha3Code: 'PRK',
        country: countries.kp,
    },
    norwegian: {
        value: 'Norwegian',
        label: 'Norwegian',
        alpha3Code: 'NOR',
        country: countries.no,
    },
    omani: {
        value: 'Omani',
        label: 'Omani',
        alpha3Code: 'OMN',
        country: countries.om,
    },
    pakistani: {
        value: 'Pakistani',
        label: 'Pakistani',
        alpha3Code: 'PAK',
        country: countries.pk,
    },
    palauan: {
        value: 'Palauan',
        label: 'Palauan',
        alpha3Code: 'PLW',
        country: countries.pw,
    },
    palestinian: {
        value: 'Palestinian',
        label: 'Palestinian',
        alpha3Code: 'PSE',
        country: countries.ps,
    },
    panamanian: {
        value: 'Panamanian',
        label: 'Panamanian',
        alpha3Code: 'PAN',
        country: countries.pa,
    },
    papuaNewGuinean: {
        value: 'Papua New Guinean',
        label: 'Papua New Guinean',
        alpha3Code: 'PNG',
        country: countries.pg,
    },
    paraguayan: {
        value: 'Paraguayan',
        label: 'Paraguayan',
        alpha3Code: 'PRY',
        country: countries.py,
    },
    peruvian: {
        value: 'Peruvian',
        label: 'Peruvian',
        alpha3Code: 'PER',
        country: countries.pe,
    },
    polish: {
        value: 'Polish',
        label: 'Polish',
        alpha3Code: 'POL',
        country: countries.pl,
    },
    portuguese: {
        value: 'Portuguese',
        label: 'Portuguese',
        alpha3Code: 'PRT',
        country: countries.pt,
    },
    puertoRican: {
        value: 'Puerto Rican',
        label: 'Puerto Rican',
        alpha3Code: 'PRI',
        country: countries.pr,
    },
    pitcairnIslander: {
        value: 'Pitcairn Islander',
        label: 'Pitcairn Islander',
        alpha3Code: 'PCN',
        country: countries.pn,
    },
    qatari: {
        value: 'Qatari',
        label: 'Qatari',
        alpha3Code: 'QAT',
        country: countries.qa,
    },
    romanian: {
        value: 'Romanian',
        label: 'Romanian',
        alpha3Code: 'ROU',
        country: countries.ro,
    },
    russian: {
        value: 'Russian',
        label: 'Russian',
        alpha3Code: 'RUS',
        country: countries.ru,
    },
    rwandan: {
        value: 'Rwandan',
        label: 'Rwandan',
        alpha3Code: 'RWA',
        country: countries.rw,
    },
    saintHelenian: {
        value: 'Saint Helenian',
        label: 'Saint Helenian',
        alpha3Code: 'SHN',
        country: countries.sh,
    },
    saintLucian: {
        value: 'Saint Lucian',
        label: 'Saint Lucian',
        alpha3Code: 'LCA',
        country: countries.lc,
    },
    saintMartinIslander: {
        value: 'Saint Martin Islander',
        label: 'Saint Martin Islander',
        alpha3Code: 'MAF',
        country: countries.mf,
    },
    saintPierrais: {
        value: 'Saint Pierrais',
        label: 'Saint-Pierrais',
        alpha3Code: 'SPM',
        country: countries.pm,
    },
    saintVincentian: {
        value: 'Saint Vincentian',
        label: 'Saint Vincentian',
        alpha3Code: 'VCT',
        country: countries.vc,
    },
    salvadoran: {
        value: 'Salvadoran',
        label: 'Salvadoran',
        alpha3Code: 'SLV',
        country: countries.sv,
    },
    sammarinese: {
        value: 'Sammarinese',
        label: 'Sammarinese',
        alpha3Code: 'SMR',
        country: countries.sm,
    },
    samoan: {
        value: 'Samoan',
        label: 'Samoan',
        alpha3Code: 'WSM',
        country: countries.ws,
    },
    saoTomean: {
        value: 'Sao Tomean',
        label: 'Sao Tomean',
        alpha3Code: 'STP',
        country: countries.st,
    },
    saudiArabian: {
        value: 'Saudi Arabian',
        label: 'Saudi Arabian',
        alpha3Code: 'SAU',
        country: countries.sa,
    },
    sahrawi: {
        value: 'Sahrawi',
        label: 'Sahrawi',
        alpha3Code: 'ESH',
        country: countries.eh,
    },
    senegalese: {
        value: 'Senegalese',
        label: 'Senegalese',
        alpha3Code: 'SEN',
        country: countries.sn,
    },
    serbian: {
        value: 'Serbian',
        label: 'Serbian',
        alpha3Code: 'SRB',
        country: countries.rs,
    },
    seychellois: {
        value: 'Seychellois',
        label: 'Seychellois',
        alpha3Code: 'SYC',
        country: countries.sc,
    },
    singaporean: {
        value: 'Singaporean',
        label: 'Singaporean',
        alpha3Code: 'SGP',
        country: countries.sg,
    },
    sierraLeonean: {
        value: 'Sierra Leonean',
        label: 'Sierra Leonean',
        alpha3Code: 'SLE',
        country: countries.sl,
    },
    slovak: {
        value: 'Slovak',
        label: 'Slovak',
        alpha3Code: 'SVK',
        country: countries.sk,
    },
    slovene: {
        value: 'Slovene',
        label: 'Slovene',
        alpha3Code: 'SVN',
        country: countries.si,
    },
    somali: {
        value: 'Somali',
        label: 'Somali',
        alpha3Code: 'SOM',
        country: countries.so,
    },
    southAfrican: {
        value: 'South African',
        label: 'South African',
        alpha3Code: 'ZAF',
        country: countries.za,
    },
    southKorean: {
        value: 'South Korean',
        label: 'South Korean',
        alpha3Code: 'KOR',
        country: countries.kr,
    },
    southSudanese: {
        value: 'South Sudanese',
        label: 'South Sudanese',
        alpha3Code: 'SSD',
        country: countries.sg,
    },
    solomonIslander: {
        value: 'Solomon Islander',
        label: 'Solomon Islander',
        alpha3Code: 'SLB',
        country: countries.sb,
    },
    spanish: {
        value: 'Spanish',
        label: 'Spanish',
        alpha3Code: 'ESP',
        country: countries.es,
    },
    sriLankan: {
        value: 'Sri Lankan',
        label: 'Sri Lankan',
        alpha3Code: 'LKA',
        country: countries.lk,
    },
    sudanese: {
        value: 'Sudanese',
        label: 'Sudanese',
        alpha3Code: 'SDN',
        country: countries.sd,
    },
    surinamer: {
        value: 'Surinamer',
        label: 'Surinamer',
        alpha3Code: 'SUR',
        country: countries.sr,
    },
    swazi: {
        value: 'Swazi',
        label: 'Swazi',
        alpha3Code: 'SWZ',
        country: countries.sz,
    },
    swedish: {
        value: 'Swedish',
        label: 'Swedish',
        alpha3Code: 'SWE',
        country: countries.se,
    },
    swiss: {
        value: 'Swiss',
        label: 'Swiss',
        alpha3Code: 'CHE',
        country: countries.ch,
    },
    syrian: {
        value: 'Syrian',
        label: 'Syrian',
        alpha3Code: 'SYR',
        country: countries.sy,
    },
    taiwanese: {
        value: 'Taiwanese',
        label: 'Taiwanese',
        alpha3Code: 'TWN',
        country: countries.tw,
    },
    tajikistani: {
        value: 'Tajikistani',
        label: 'Tajikistani',
        alpha3Code: 'TJK',
        country: countries.tj,
    },
    tanzanian: {
        value: 'Tanzanian',
        label: 'Tanzanian',
        alpha3Code: 'TZA',
        country: countries.tz,
    },
    thai: {
        value: 'Thai',
        label: 'Thai',
        alpha3Code: 'THA',
        country: countries.th,
    },
    togolese: {
        value: 'Togolese',
        label: 'Togolese',
        alpha3Code: 'TGO',
        country: countries.tg,
    },
    tokelauan: {
        value: 'Tokelauan',
        label: 'Tokelauan',
        alpha3Code: 'TKL',
        country: countries.tk,
    },
    tongan: {
        value: 'Tongan',
        label: 'Tongan',
        alpha3Code: 'TON',
        country: countries.to,
    },
    timorese: {
        value: 'Timorese',
        label: 'Timorese',
        alpha3Code: 'TLS',
        country: countries.tl,
    },
    trinidadian: {
        value: 'Trinidadian',
        label: 'Trinidadian',
        alpha3Code: 'TTO',
        country: countries.tt,
    },
    tunisian: {
        value: 'Tunisian',
        label: 'Tunisian',
        alpha3Code: 'TUN',
        country: countries.tn,
    },
    turkmen: {
        value: 'Turkmen',
        label: 'Turkmen',
        alpha3Code: 'TKM',
        country: countries.tm,
    },
    turkish: {
        value: 'Turkish',
        label: 'Turkish',
        alpha3Code: 'TUR',
        country: countries.tr,
    },
    tuvaluan: {
        value: 'Tuvaluan',
        label: 'Tuvaluan',
        alpha3Code: 'TUV',
        country: countries.tv,
    },
    ugandan: {
        value: 'Ugandan',
        label: 'Ugandan',
        alpha3Code: 'UGA',
        country: countries.ug,
    },
    ukrainian: {
        value: 'Ukrainian',
        label: 'Ukrainian',
        alpha3Code: 'UKR',
        country: countries.ua,
    },
    uruguayan: {
        value: 'Uruguayan',
        label: 'Uruguayan',
        alpha3Code: 'URY',
        country: countries.uy,
    },
    uzbekistani: {
        value: 'Uzbekistani',
        label: 'Uzbekistani',
        alpha3Code: 'UZB',
        country: countries.uz,
    },
    venezuelan: {
        value: 'Venezuelan',
        label: 'Venezuelan',
        alpha3Code: 'VEN',
        country: countries.ve,
    },
    vietnamese: {
        value: 'Vietnamese',
        label: 'Vietnamese',
        alpha3Code: 'VNM',
        country: countries.vn,
    },
    vatican: {
        value: 'Vatican',
        label: 'Vatican',
        alpha3Code: 'VAT',
        country: countries.va,
    },
    vanuatu: { value: 'Vanuatuan', label: 'Vanuatuan', alpha3Code: 'VUT', country: countries.vu },
    yemeni: {
        value: 'Yemeni',
        label: 'Yemeni',
        alpha3Code: 'YEM',
        country: countries.ye,
    },
    willisFutuna: {
        value: 'Willisian Futunan',
        label: 'Willisian Futunan',
        alpha3Code: 'WLF',
        country: countries.wf,
    },
    zambian: {
        value: 'Zambian',
        label: 'Zambian',
        alpha3Code: 'ZMB',
        country: countries.zm,
    },
    zimbabwean: {
        value: 'Zimbabwean',
        label: 'Zimbabwean',
        alpha3Code: 'ZWE',
        country: countries.zw,
    },
};
const nationalities = asLocalizedEnum('nationalities', _nationalities);

const riskCategories = asEnum({
    low: {
        value: 'low',
        label: 'Low',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
    },
    normal: {
        value: 'normal',
        label: 'Normal',
    },
    high: {
        value: 'high',
        label: 'High',
    },
});
const riskSubCategories = asEnum({
    low: {
        value: 'low',
        label: 'Low',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
    },
    high: {
        value: 'high',
        label: 'High',
    },
});

const userDepartments = asEnum({
    system: {
        value: 'system',
        label: 'System',
    },
    backOffice: {
        value: 'backOffice',
        label: 'Back office',
    },
    marketing: {
        value: 'marketing',
        label: 'Marketing',
    },
    compliance: {
        value: 'compliance',
        label: 'Compliance',
    },
    sales: {
        value: 'sales',
        label: 'Sales',
    },
    support: {
        value: 'support',
        label: 'Support',
    },
    development: {
        value: 'development',
        label: 'Development/IT',
    },
    accounting: {
        value: 'accounting',
        label: 'Accounting',
    },
    humanResources: {
        value: 'humanResources',
        label: 'HR',
    },
    businessIntelligence: {
        value: 'businessIntelligence',
        label: 'Business Intelligence',
    },
    projectManagement: {
        value: 'projectManagement',
        label: 'Project Management',
    },
    office: {
        value: 'office',
        label: 'Office',
    },
    management: {
        value: 'management',
        label: 'Management',
    },
    seniorManagement: {
        value: 'seniorManagement',
        label: 'Senior Management',
    },
    shareholder: {
        value: 'shareholder',
        label: 'Shareholder',
    },
    directorOfOperations: {
        value: 'directorOfOperations',
        label: 'Director of Operations',
    },
    administration: {
        value: 'administration',
        label: 'Administration',
    },
    affiliate: {
        value: 'affiliate',
        label: 'Affiliate',
    },
    callMonitoring: {
        value: 'callMonitoring',
        label: 'Call Monitoring',
    },
    customerRelations: {
        value: 'customerRelations',
        label: 'Customer Relations',
    },
    contractor: {
        value: 'contractor',
        label: 'Contractor',
    },
    it: {
        value: 'it',
        label: 'IT',
    },
    businessDevelopment: {
        value: 'businessDevelopment',
        label: 'Business Development',
    },
    paymentSolutions: {
        value: 'paymentSolutions',
        label: 'Payment Solutions',
    },
    portfolio: {
        value: 'portfolio',
        label: 'Portfolio Management',
    },
    reception: {
        value: 'reception',
        label: 'Reception and Transmission',
    },
    risk: {
        value: 'risk',
        label: 'Risk Management',
    },
    retention: {
        value: 'retention',
        label: 'Retention',
    },
    investment: {
        value: 'investment',
        label: 'Investment Research',
    },
    clientRelationsTraining: {
        value: 'clientRelationsTraining',
        label: 'Client Relations Training',
    },
});
const videoVerificationStatuses = asEnum({
    dataRetrievedStatus: {
        value: 'data-retrieved-status',
        label: 'Fully-Verified successfully retrieved verification data at customer_data_url',
    },
    queuedStatus: {
        value: 'queued-status',
        label: 'Verification process of Self-Verify verification case started',
    },
    collectingDataFinished: {
        value: 'normal',
        label: 'Verification process of Self-Verify verification case has been completed',
    },
    startedStatus: {
        value: 'started-status',
        label: 'Verification process of Live-Verify verification case started',
    },
    verifiedStatus: {
        value: 'verified-status',
        label: 'Verification completed successfully',
    },
    rejectedStatus: {
        value: 'rejected-status',
        label: 'Verification completed with negative result',
    },
    unverifiedStatus: {
        value: 'unverified-status',
        label: 'Verification completed with negative result',
    },
    mediaOrdered: {
        value: 'media-ordered',
        label: 'Video processing started',
    },
    mediaRemoteInProgress: {
        value: 'media-remote-in-progress',
        label: 'Preparing video in progress',
    },
    mediaRemoteReady: {
        value: 'media-remote-ready',
        label: 'Video ready to download',
    },
    mediaRemoteFailed: {
        value: 'media-remote-failed',
        label: 'Error preparing video',
    },
    pending: {
        value: 'pending',
        label: 'pending',
    },
});

const signatureStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    accept: {
        value: 'accept',
        label: 'Accept',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    reject: {
        value: 'reject',
        label: 'Reject',
        labelIndicator: LabelIndicator.ERROR,
    },
    expired: {
        value: 'expired',
        label: 'Expired',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const actionTypes = asEnum({
    documentSigning: {
        value: 'document_signing',
        label: 'Document Signing',
    },
    transactionSigning: {
        value: 'transaction_signing',
        label: 'Transaction Signing',
    },
    contractDetailChangeSigning: {
        value: 'contract_detail_change_signing',
        label: 'Contract Detail Change Signing',
    },
    accountOpeningSigning: {
        value: 'account_opening_signing',
        label: 'Account Opening Signing',
    },
    accountClosureSigning: {
        value: 'account_closure_signing',
        label: 'Account Closure Signing',
    },
    cardIssueRequest: {
        value: 'card_issue_request',
        label: 'Cards Issue Request',
    },
    spendingLimitRequest: {
        value: 'spending_limit_request',
        label: 'Spending Limit Request',
    },
    contractAuthorizedPersonRequest: {
        value: 'contract_authorized_person_request',
        label: 'Contract Authorized Person Request',
    },
    batchPayment: {
        value: 'batch_payment',
        label: 'Batch Payment',
    },
    contractAuthorizedPersonDeactivation: {
        value: 'contract_authorized_person_deactivation',
        label: 'Contract Authorized Person Deactivation',
    },
    contractTerminationRequest: {
        value: 'contract_termination_request',
        label: 'Contract Termination Request',
    },
    vibanNameMismatch: {
        value: 'viban_name_mismatch',
        label: 'VIBAN Name Mismatch',
        executeOnPartialSignature: true,
    },
    activateStandingOrder: {
        value: 'activate_standing_order',
        label: 'Activate Standing Order',
    },
    cancelStandingOrder: {
        value: 'cancel_standing_order',
        label: 'Cancel Standing Order',
    },
    rejectDirectDebit: {
        value: 'reject_direct_debit',
        label: 'Reject Direct Debit',
    },
    preapproveDirectDebit: {
        value: 'preapprove_direct_debit',
        label: 'Preapprove Direct Debit',
    },
    revertDirectDebitRequest: {
        value: 'revert_direct_debit_request',
        label: 'Revert Direct Debit Request',
    },
    changeAccountAlternativeAccountDetailsRequest: {
        value: 'change_account_alternative_account_details_request',
        label: 'Change Alternative Account Details Request',
    },
    updateSpendingLimit: {
        value: 'update_spending_limit',
        label: 'Update Spending Limit',
    },
    disputeDirectDebit: {
        value: 'dispute_direct_debit',
        label: 'Dispute Direct Debit',
    },
    approveDirectDebitB2BDebitMandate: {
        value: 'approve_direct_debit_b2b_debit_mandate',
        label: 'Approve Direct Debit B2B Mandate',
    },
    approveDirectDebitCreditMandate: {
        value: 'approve_direct_debit_credit_mandate',
        label: 'Approve Direct Debit Credit Mandate',
    },
    termsAndConditionsSigning: {
        value: 'terms_and_conditions_signing',
        label: 'Terms and Conditions Signing',
    },
    paymentRefundRequest: {
        value: 'payment_refund_request',
        label: 'Payment Refund Request',
    },
    directDebitBatchRequest: {
        value: 'direct_debit_batch_request',
        label: 'Direct Debit Batch Request',
    },
    walletSigning: {
        value: 'wallet_signing',
        label: 'Crypto wallet connection',
    },
    cryptoTransactionSigning: {
        value: 'crypto_transaction_signing',
        label: 'Crypto transaction signing',
    },
});
const actionRejectionReasons = asEnum({
    notEnoughSignatures: {
        value: 'not_enough_signatures',
        label: 'Not Enough Signatures',
    },
    noSignatories: {
        value: 'no_signatories',
        label: 'No Signatories',
    },
    cancelled: {
        value: 'cancelled',
        label: 'Cancelled',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
    inactivity: {
        value: 'inactivity',
        label: 'Inactive For Long Time',
    },
});
const actionStatuses = asEnum({
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    executed: {
        value: 'executed',
        label: 'Executed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    signaturesQuorumReached: {
        value: 'signatures_quorum_reached',
        label: 'Signatures Quorum Reached',
        labelIndicator: LabelIndicator.INFO,
    },
    pendingSignatures: {
        value: 'pending_signatures',
        label: 'Pending Signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
});

const gpiTransactionStatus = asEnum({
    RJCT: {
        value: 'RJCT',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    ACSP: {
        value: 'ACSP',
        label: 'In progress',
        labelIndicator: LabelIndicator.WARNING,
    },
    ACCC: {
        value: 'ACCC',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["RJCT"] = "RJCT";
    TransactionStatus["ACSP"] = "ACSP";
    TransactionStatus["ACCC"] = "ACCC";
})(TransactionStatus || (TransactionStatus = {}));
var PaymentScenario;
(function (PaymentScenario) {
    PaymentScenario["CCTR"] = "CCTR";
    PaymentScenario["RCCT"] = "RCCT";
})(PaymentScenario || (PaymentScenario = {}));
var TransactionStatusReason;
(function (TransactionStatusReason) {
    TransactionStatusReason["G000"] = "G000";
    TransactionStatusReason["G001"] = "G001";
    TransactionStatusReason["G002"] = "G002";
    TransactionStatusReason["G003"] = "G003";
    TransactionStatusReason["G004"] = "G004";
})(TransactionStatusReason || (TransactionStatusReason = {}));
var RejectReturnReason;
(function (RejectReturnReason) {
    RejectReturnReason["AM06"] = "AM06";
    RejectReturnReason["RC01"] = "RC01";
    RejectReturnReason["AC06"] = "AC06";
    RejectReturnReason["AM07"] = "AM07";
    RejectReturnReason["AC04"] = "AC04";
    RejectReturnReason["AC07"] = "AC07";
    RejectReturnReason["G004"] = "G004";
    RejectReturnReason["DUPL"] = "DUPL";
    RejectReturnReason["ERIN"] = "ERIN";
    RejectReturnReason["FOCR"] = "FOCR";
    RejectReturnReason["FR01"] = "FR01";
    RejectReturnReason["BE01"] = "BE01";
    RejectReturnReason["AC01"] = "AC01";
    RejectReturnReason["AGNT"] = "AGNT";
    RejectReturnReason["CURR"] = "CURR";
    RejectReturnReason["AM04"] = "AM04";
    RejectReturnReason["FF06"] = "FF06";
    RejectReturnReason["RC08"] = "RC08";
    RejectReturnReason["RC04"] = "RC04";
    RejectReturnReason["AC02"] = "AC02";
    RejectReturnReason["AC13"] = "AC13";
    RejectReturnReason["RR11"] = "RR11";
    RejectReturnReason["RC03"] = "RC03";
    RejectReturnReason["RC11"] = "RC11";
    RejectReturnReason["FF05"] = "FF05";
    RejectReturnReason["RR12"] = "RR12";
    RejectReturnReason["FF03"] = "FF03";
    RejectReturnReason["FF07"] = "FF07";
    RejectReturnReason["FF04"] = "FF04";
    RejectReturnReason["RR09"] = "RR09";
    RejectReturnReason["BE04"] = "BE04";
    RejectReturnReason["RR03"] = "RR03";
    RejectReturnReason["RR01"] = "RR01";
    RejectReturnReason["BE07"] = "BE07";
    RejectReturnReason["RR02"] = "RR02";
    RejectReturnReason["NOAS"] = "NOAS";
    RejectReturnReason["AM02"] = "AM02";
    RejectReturnReason["AM03"] = "AM03";
    RejectReturnReason["NOCM"] = "NOCM";
    RejectReturnReason["MS03"] = "MS03";
    RejectReturnReason["MS02"] = "MS02";
    RejectReturnReason["RR05"] = "RR05";
    RejectReturnReason["RR04"] = "RR04";
    RejectReturnReason["RR07"] = "RR07";
    RejectReturnReason["RR08"] = "RR08";
    RejectReturnReason["CUST"] = "CUST";
    RejectReturnReason["RR06"] = "RR06";
    RejectReturnReason["UPAY"] = "UPAY";
    RejectReturnReason["BE05"] = "BE05";
    RejectReturnReason["AM09"] = "AM09";
    RejectReturnReason["RUTA"] = "RUTA";
})(RejectReturnReason || (RejectReturnReason = {}));
var SettlementMethod;
(function (SettlementMethod) {
    SettlementMethod["INDA"] = "INDA";
    SettlementMethod["INGA"] = "INGA";
    SettlementMethod["COVE"] = "COVE";
    SettlementMethod["CLRG"] = "CLRG";
})(SettlementMethod || (SettlementMethod = {}));
var ChargeBearer;
(function (ChargeBearer) {
    ChargeBearer["SHAR"] = "SHAR";
    ChargeBearer["DEBT"] = "DEBT";
    ChargeBearer["CRED"] = "CRED";
})(ChargeBearer || (ChargeBearer = {}));
var TrackerEvent;
(function (TrackerEvent) {
    TrackerEvent["COPT"] = "COPT";
    TrackerEvent["CTCA"] = "CTCA";
    TrackerEvent["CTTS"] = "CTTS";
    TrackerEvent["CTCR"] = "CTCR";
    TrackerEvent["FTCA"] = "FTCA";
    TrackerEvent["FTTS"] = "FTTS";
    TrackerEvent["FTCR"] = "FTCR";
    TrackerEvent["CTPT"] = "CTPT";
    TrackerEvent["FTPT"] = "FTPT";
    TrackerEvent["COSU"] = "COSU";
    TrackerEvent["CTSU"] = "CTSU";
    TrackerEvent["FTSU"] = "FTSU";
    TrackerEvent["RCTP"] = "RCTP";
    TrackerEvent["RCOP"] = "RCOP";
    TrackerEvent["RFTP"] = "RFTP";
    TrackerEvent["RCOS"] = "RCOS";
    TrackerEvent["RCTS"] = "RCTS";
    TrackerEvent["CFPT"] = "CFPT";
    TrackerEvent["RCFP"] = "RCFP";
    TrackerEvent["CFSU"] = "CFSU";
    TrackerEvent["RCFS"] = "RCFS";
})(TrackerEvent || (TrackerEvent = {}));

const ledgerTypes = asEnum({
    holding: {
        label: 'Holding',
        value: 'holding',
    },
    cardAuth: {
        label: 'Card Authorized',
        value: 'card_auth',
    },
    cardCleared: {
        label: 'Card Cleared',
        value: 'card_cleared',
    },
    cardAuthIndividual: {
        label: 'Card Authorized (Individual)',
        value: 'card_auth_individual',
    },
    cardClearedIndividual: {
        label: 'Card Cleared (Individual)',
        value: 'card_cleared_individual',
    },
    cardTopUp: {
        label: 'Card Top Up',
        value: 'card_top_up',
    },
    fee: {
        label: 'Fee',
        value: 'fee',
    },
    fx: {
        label: 'FX',
        value: 'fx',
    },
    fxSettlement: {
        label: 'FX Settlement',
        value: 'fx_settlement',
    },
    commission: {
        label: 'COMMISSION',
        value: 'commission',
    },
    cashback: {
        label: 'Cashback',
        value: 'cashback',
    },
    visaB2B: {
        label: 'Visa B2B',
        value: 'visa_b2b',
    },
    visaDA: {
        label: 'Visa DA',
        value: 'visa_da',
    },
    interest: {
        label: 'Interest',
        value: 'interest',
    },
    guaranteedAccounts: {
        label: 'Guaranteed Accounts',
        value: 'guaranteed_accounts',
    },
    miscGains: {
        label: 'Misc Gains',
        value: 'misc_gains',
    },
    directDebitRefunds: {
        label: 'Direct debit refunds',
        value: 'direct_debit_refunds',
    },
    directDebit: {
        label: 'Direct Debit',
        value: 'direct_debit',
    },
    terrapay: {
        label: 'Terrapay',
        value: 'terrapay',
    },
    crypto: {
        label: 'Wallet',
        value: 'crypto',
    },
});
const ledgerTransactionTypes = asEnum({
    fee: {
        label: 'Fee',
        value: 'fee',
    },
    commission: {
        label: 'Commission',
        value: 'commission',
    },
    fx: {
        label: 'FX',
        value: 'fx',
    },
    transfer: {
        label: 'Transfer',
        value: 'transfer',
    },
    crossLedgerTransfer: {
        label: 'Cross Ledger Transfer',
        value: 'cross_ledger_transfer',
    },
    swift: {
        label: 'Swift CST Payment',
        value: 'swift',
    },
    swiftInstitutional: {
        label: 'Swift FInst Payment',
        value: 'swift_institutional',
    },
    manualBooking: {
        label: 'Manual Booking',
        value: 'manual_booking',
    },
    cashback: {
        label: 'Cashback',
        value: 'cashback',
    },
});
const transactionTypes = asEnum({
    fee: {
        label: 'Fee',
        value: 'fee',
    },
    fx: {
        label: 'FX',
        value: 'fx',
    },
    transferInternal: {
        label: 'Internal Transfer',
        value: 'transfer_internal',
    },
    transferSwift: {
        label: 'Swift Transfer',
        value: 'transfer_swift',
    },
    manualBooking: {
        label: 'Manual Booking',
        value: 'manual_booking',
    },
    card: {
        label: 'Card',
        value: 'card',
    },
    cardReversal: {
        label: 'Card Reversal',
        value: 'card_reversal',
    },
    commission: {
        label: 'Commission',
        value: 'commission',
    },
    cashback: {
        label: 'Cashback',
        value: 'cashback',
    },
    negativeBalanceCover: {
        label: 'Negative Balance Cover',
        value: 'negative_balance_cover',
    },
    transferCrypto: {
        label: 'Wallet Transfer',
        value: 'transfer_crypto',
    },
});
const transactionEntryTypes = asEnum({
    debit: {
        label: 'Debit',
        value: 'debit',
        labelIndicator: LabelIndicator.INFO,
    },
    credit: {
        label: 'Credit',
        value: 'credit',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const transactionStatuses = asEnum({
    pendingExecutionSignatures: {
        label: 'Pending Execution Signatures',
        value: 'pending_execution_signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    beneficiaryNameMismatch: {
        label: 'Beneficiary Name Mismatch',
        value: 'beneficiary_name_mismatch',
        labelIndicator: LabelIndicator.ERROR,
    },
    pendingCancellationSignatures: {
        label: 'Pending Cancellation Signatures',
        value: 'pending_cancellation_signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    cancelled: {
        label: 'Cancelled',
        value: 'cancelled',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    authorized: {
        label: 'Authorized',
        value: 'authorized',
        labelIndicator: LabelIndicator.INFO,
    },
    authorizedFX: {
        label: 'Authorized For FX',
        value: 'authorized_fx',
        labelIndicator: LabelIndicator.INFO,
    },
    completed: {
        label: 'Completed',
        value: 'completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    completedManually: {
        label: 'Completed Manually',
        value: 'completed_manually',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    pendingAml: {
        label: 'Pending AML',
        value: 'pending_aml',
        labelIndicator: LabelIndicator.WARNING,
    },
    reverted: {
        label: 'Reverted',
        value: 'reverted',
        labelIndicator: LabelIndicator.ERROR,
    },
    declined: {
        label: 'Declined',
        value: 'declined',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    scheduled: {
        label: 'Scheduled',
        value: 'scheduled',
        labelIndicator: LabelIndicator.INFO,
    },
});
const ledgerTransactionStatuses = asEnum({
    pending: {
        label: 'Pending',
        value: 'pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingNostroCheck: {
        label: 'Pending Nostro Check',
        value: 'pending_nostro_check',
        labelIndicator: LabelIndicator.WARNING,
    },
    queuedForPayout: {
        label: 'Queued For Payout',
        value: 'queued_for_payout',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingPayoutAck: {
        label: 'Pending Payout Acknowledgement',
        value: 'pending_payout_ack',
        labelIndicator: LabelIndicator.WARNING,
    },
    completed: {
        label: 'Completed',
        value: 'completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    completedManually: {
        label: 'Completed Manually',
        value: 'completed_manually',
        labelIndicator: LabelIndicator.INFO,
    },
    payoutFailed: {
        label: 'Payout Failed',
        value: 'payout_failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    destinationCurrencyMismatch: {
        label: 'Inbound Destination Currency Mismatch',
        value: 'destination_currency_mismatch',
        labelIndicator: LabelIndicator.WARNING,
    },
    destinationNotResolved: {
        label: 'Inbound Destination Not Resolved',
        value: 'destination_not_resolved',
        labelIndicator: LabelIndicator.WARNING,
    },
    outboundDestinationNotResolved: {
        label: 'Outbound Destination Not Resolved',
        value: 'outbound_destination_not_resolved',
        labelIndicator: LabelIndicator.WARNING,
    },
    payoutInfoMissing: {
        label: 'Missing Additional Payout Info',
        value: 'payout_info_missing',
        labelIndicator: LabelIndicator.WARNING,
    },
    incomingCreditorNameMismatch: {
        label: 'Incoming Creditor Name Mismatch',
        value: 'incoming_creditor_name_mismatch',
        labelIndicator: LabelIndicator.WARNING,
    },
});
const swiftTransferRecipientTypes = asEnum({
    individual: {
        label: 'Individual',
        value: 'individual',
    },
    company: {
        label: 'Company',
        value: 'company',
    },
});
const transactionExecutionTypes = asEnum({
    instant: {
        label: 'Instant',
        value: 'instant',
    },
    delayed: {
        label: 'Delayed',
        value: 'delayed',
    },
    recurring: {
        label: 'Recurring',
        value: 'recurring',
    },
});
const swiftTransferChargeBearers = asEnum({
    our: {
        label: 'Ours',
        value: 'ours',
    },
    shared: {
        label: 'Shared',
        value: 'shared',
    },
    theirs: {
        label: 'Theirs',
        value: 'theirs',
    },
});
const transactionCancellationReasons = asLocalizedEnum('transactionCancellationReasons', {
    insufficientFunds: {
        value: 'insufficient_funds',
        label: 'Insufficient Funds',
    },
    aml: {
        value: 'aml_flagged',
        label: 'AML',
    },
    destinationCannotAccept: {
        value: 'destination_cannot_accept',
        label: 'Destination cannot Accept New Transactions',
    },
    newTransactionNotAllowed: {
        value: 'new_transactions_not_allowed',
        label: 'New Transactions Are Not Allowed',
    },
    other: {
        value: 'other',
        label: 'Other',
    },
    rejectedBySignatories: {
        value: 'rejected_by_signatories',
        label: 'Rejected By Signatories',
    },
    clientRequest: {
        value: 'client_request',
        label: 'Client request',
    },
    notInLineWithInternalPolicy: {
        value: 'not_in_line_with_internal_policy',
        label: 'Not in line with internal policy',
    },
    dueToRestrictedOrForbiddenCountry: {
        value: 'due_to_restricted_or_forbidden_country',
        label: 'Due to restricted or forbidden country',
    },
    theBeneficiaryBankIsLocationInARestrictedOrForbiddenCountry: {
        value: 'the_beneficiary_bank_is_location_in_a_restricted_or_forbidden_country',
        label: ' The beneficiary / beneficiary bank is located in a restricted or forbidden country',
    },
    unableToApply: {
        value: 'unable_to_apply',
        label: 'Unable to apply',
    },
    theRequestedInformationWasNotReceivedByTheDeadline: {
        value: 'the_requested_information_was_not_received_by_the_deadline',
        label: 'The requested information was not received by the given deadline',
    },
    incorrectInvalidAccount: {
        value: 'incorrect_invalide_account',
        label: 'Incorrect / Invalid Account',
    },
    incompletePaymentInformation: {
        value: 'incomplete_payment_information',
        label: 'Incomplete payment information',
    },
});
const transactionReturnReasons = asLocalizedEnum('transactionReturnReasons', {
    fraud: {
        value: 'fraud',
        label: 'Due To Fraud Detection',
        gpiReason: RejectReturnReason.MS03,
    },
    aml: {
        value: 'aml_flagged',
        label: 'AML Flagged',
        gpiReason: RejectReturnReason.MS03,
    },
    beneficiaryNotFound: {
        value: 'beneficiary_not_found',
        label: 'Beneficiary Account Not Found',
        gpiReason: RejectReturnReason.AC01,
    },
    duplicate: {
        value: 'duplicate',
        label: 'Duplicate Transaction',
        gpiReason: RejectReturnReason.DUPL,
    },
    other: {
        value: 'other',
        label: 'Other',
        gpiReason: RejectReturnReason.MS03,
    },
    returnRequested: {
        value: 'return_requested',
        label: 'Return Requested By Counter Party',
        gpiReason: RejectReturnReason.FOCR,
    },
});
const transactionPriorities = asEnum({
    standard: {
        value: 'standard',
        label: 'Standard',
    },
    express: {
        value: 'express',
        label: 'Express',
    },
});
const transactionCardFilters = asEnum({
    onlyCards: {
        label: 'onlyCards',
        value: 'onlyCards',
    },
    excludeCards: {
        label: 'excludeCards',
        value: 'excludeCards',
    },
});
const batchPaymentStatuses = asEnum({
    pendingExecutionSignatures: {
        label: 'Pending Execution Signatures',
        value: 'pendingExecutionSignatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    signed: {
        label: 'Signed',
        value: 'signed',
        labelIndicator: LabelIndicator.INFO,
    },
    executed: {
        label: 'Executed',
        value: 'executed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    cancelled: {
        label: 'Cancelled',
        value: 'cancelled',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    executedWithFailure: {
        label: 'Executed With Failure',
        value: 'executedWithFailure',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const paymentRails = asEnum({
    internal: {
        label: 'Internal',
        value: 'INTERNAL',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    sic: {
        label: 'SIC',
        value: 'SIC',
        labelIndicator: LabelIndicator.INFO,
    },
    euroSic: {
        label: 'EUROSIC',
        value: 'EUROSIC',
        labelIndicator: LabelIndicator.INFO,
    },
    sepa: {
        label: 'SEPA',
        value: 'SEPA',
        labelIndicator: LabelIndicator.INFO,
    },
    sepaInstant: {
        label: 'SEPA Instant',
        value: 'SEPA_INSTANT',
        labelIndicator: LabelIndicator.INFO,
    },
    sepaDirectDebit: {
        label: 'SEPA Direct Debit',
        value: 'SEPA_DIRECT_DEBIT',
        labelIndicator: LabelIndicator.INFO,
    },
    target2: {
        label: 'Target 2',
        value: 'TARGET2',
        labelIndicator: LabelIndicator.INFO,
    },
    bacs: {
        label: 'BACS',
        value: 'BACS',
        labelIndicator: LabelIndicator.INFO,
    },
    fasterPayment: {
        label: 'Faster Payment',
        value: 'FASTER_PAYMENT',
        labelIndicator: LabelIndicator.INFO,
    },
    visaB2B: {
        label: 'VISA B2B',
        value: 'VISA_B2B',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'visab2b',
    },
    visaDA: {
        label: 'VISA Direct Account',
        value: 'VISA_DA',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'visada',
    },
    debitCard: {
        label: 'Debit Card',
        value: 'DEBIT_CARD',
        labelIndicator: LabelIndicator.INFO,
    },
    cardTopUp: {
        label: 'Card Top Up',
        value: 'CARD_TOP_UP',
        labelIndicator: LabelIndicator.INFO,
    },
    swiftGeneric: {
        label: 'Swift',
        value: 'SWIFT',
        labelIndicator: LabelIndicator.INFO,
    },
    klarXCurrency: {
        label: 'Klar X Currency',
        value: 'klarXCurrency',
        labelIndicator: LabelIndicator.INFO,
    },
    jpmEU: {
        label: 'JPM EU',
        value: 'JPM_EU',
        labelIndicator: LabelIndicator.INFO,
    },
    jpmUK: {
        label: 'JPM UK',
        value: 'JPM_UK',
        labelIndicator: LabelIndicator.INFO,
    },
    jpmUS: {
        label: 'JPM US',
        value: 'JPM_US',
        labelIndicator: LabelIndicator.INFO,
    },
    signature: {
        label: 'Signature',
        value: 'SIGNATURE',
        labelIndicator: LabelIndicator.INFO,
    },
    jpmIntl: {
        label: 'JPM Intl',
        value: 'JPM_INTL',
        labelIndicator: LabelIndicator.INFO,
    },
    jpmLocalPay: {
        label: 'JPM Local Pay',
        value: 'JPM_LOCAL_PAY',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'jpm',
    },
    jpmWireCross: {
        label: 'JPM Wire Cross',
        value: 'JPM_WIRE_CROSS',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'jpm',
    },
    bankFrick: {
        label: 'Bank Frick',
        value: 'BANK_FRICK',
        labelIndicator: LabelIndicator.INFO,
    },
    pagonxt: {
        label: 'PagoNXT',
        value: 'PAGONXT',
        labelIndicator: LabelIndicator.INFO,
    },
    pagonxtCross: {
        label: 'PagoNXT FX',
        value: 'PAGONXT_CROSS',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'pagonxt',
    },
    terrapay: {
        label: 'Terrapay',
        value: 'terrapay',
        labelIndicator: LabelIndicator.INFO,
        fxService: 'terrapay',
    },
    tldr: {
        label: 'Targeted Local Disbursement/Remittance',
        value: 'tldr',
        labelIndicator: LabelIndicator.INFO,
    },
    crypto: {
        label: 'Wallet',
        value: 'CRYPTO',
        labelIndicator: LabelIndicator.INFO,
    },
});
const fxTradeStatuses = asEnum({
    rejected: {
        label: 'Rejected',
        value: 'rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    filled: {
        label: 'Filled',
        value: 'filled',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    partially_filled: {
        label: 'Partially Filled',
        value: 'partially_filled',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    requested: {
        label: 'Requested',
        value: 'requested',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    accepted: {
        label: 'Accepted',
        value: 'accepted',
        labelIndicator: LabelIndicator.WARNING,
    },
});
const transactionRecallStatuses = asEnum({
    rejected: {
        label: 'Rejected',
        value: 'rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    requested: {
        label: 'Requested',
        value: 'requested',
        labelIndicator: LabelIndicator.WARNING,
    },
    accepted: {
        label: 'Accepted',
        value: 'accepted',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const transactionCumulativeReviewStatuses = asEnum({
    none: {
        label: 'None',
        value: 'none',
        labelIndicator: LabelIndicator.INFO,
    },
    pending: {
        label: 'Pending',
        value: 'pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    reviewed: {
        label: 'Reviewed',
        value: 'reviewed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const transactionServiceDeskSources = asEnum({
    jira: {
        label: 'Jira',
        value: 'jira',
    },
    freshDesk: {
        label: 'Fresh Desk',
        value: 'freshDesk',
    },
});
const transactionRequestStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingExecutionSignatures: {
        label: 'Pending Execution Signatures',
        value: 'pending_execution_signatures',
        labelIndicator: LabelIndicator.WARNING,
    },
    readyForSending: {
        value: 'ready_for_sending',
        label: 'Ready for Sending',
        labelIndicator: LabelIndicator.INFO,
    },
    processing: {
        value: 'processing',
        label: 'Processing',
        labelIndicator: LabelIndicator.WARNING,
    },
    cancelled: {
        value: 'cancelled',
        label: 'Cancelled',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    completed: {
        value: 'completed',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    pendingAml: {
        label: 'Pending AML',
        value: 'pending_aml',
        labelIndicator: LabelIndicator.WARNING,
    },
});

const swiftMessageStatuses = asEnum({
    pendingReview: {
        value: 'pending_review',
        label: 'Pending Review',
        labelIndicator: LabelIndicator.WARNING,
    },
    processed: {
        value: 'processed',
        label: 'Processed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    autoProcessingFailed: {
        value: 'auto_processing_failed',
        label: 'Auto processing Failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    system: {
        value: 'system',
        label: 'System',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    sentToAutoClient: {
        value: 'sent_to_auto_client',
        label: 'Sent To Auto Client',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    deliveredToAutoClient: {
        value: 'delivered_to_auto_client',
        label: 'Deliver To Auto Client',
        labelIndicator: LabelIndicator.WARNING,
    },
    sentByAutoClient: {
        value: 'sent_by_auto_client',
        label: 'Sent By Auto Client',
        labelIndicator: LabelIndicator.WARNING,
    },
    rejectedByAutoClient: {
        value: 'rejected_by_auto-client',
        label: 'Rejected By Auto Client',
        labelIndicator: LabelIndicator.ERROR,
    },
    networkAcknowledged: {
        value: 'network_acknowledged',
        label: 'Network Acknowledged',
        labelIndicator: LabelIndicator.WARNING,
    },
    networkRejected: {
        value: 'network_rejected',
        label: 'Network Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    deliveredToReceiver: {
        value: 'delivered_to_receiver',
        label: 'Delivered To Receiver',
        labelIndicator: LabelIndicator.WARNING,
    },
    deliveryIssues: {
        value: 'delivery_issues',
        label: 'Delivery Issues',
        labelIndicator: LabelIndicator.WARNING,
    },
    queuedForEmission: {
        value: 'queued_for_emission',
        label: 'Queued For Emission',
        labelIndicator: LabelIndicator.WARNING,
    },
    acceptedByReceiver: {
        value: 'accepted_by_receiver',
        label: 'Accepted By Receiver',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejectedByReceiver: {
        value: 'rejected_by_receiver',
        label: 'Rejected By Receiver',
        labelIndicator: LabelIndicator.ERROR,
    },
    cancellationPending: {
        value: 'cancellation_pending',
        label: 'Cancellation Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    cancellationRejected: {
        value: 'cancellation_rejected',
        label: 'Cancellation Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    cancellationRequested: {
        value: 'cancellation_requested',
        label: 'Cancellation Requested',
        labelIndicator: LabelIndicator.WARNING,
    },
    cancelled: {
        value: 'cancelled',
        label: 'Cancelled',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    returned: {
        value: 'returned',
        label: 'Returned',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    returnPending: {
        value: 'return_pending',
        label: 'Return Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    returnRejected: {
        value: 'return_rejected',
        label: 'Return Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    possibleDuplicate: {
        value: 'possible_duplicate',
        label: 'Possible Duplicate',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const swiftMessageDirection = asEnum({
    incoming: {
        value: 'incoming',
        label: 'Inbound',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    outgoing: {
        value: 'outgoing',
        label: 'Outbound',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const swiftMessageFileLogStatuses = asEnum({
    processed: {
        label: 'Processed',
        value: 'processed',
    },
    notProcessed: {
        label: 'Not Processed',
        value: 'not_processed',
    },
});
const swiftMessageAcknowledgementStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending Follow up',
        labelIndicator: LabelIndicator.INFO,
    },
    completed: {
        value: 'completed',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    completedManually: {
        value: 'completed_manually',
        label: 'Completed (manually)',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});

const feeTypes = asEnum({
    per_unit_fixed: {
        label: 'Per Unit Fixed',
        value: 'per_unit_fixed',
    },
    recurring_fixed: {
        label: 'Recurring Fixed',
        value: 'recurring_fixed',
    },
    per_unit_variable: {
        label: 'Per Unit Variable',
        value: 'per_unit_variable',
    },
    recurring_variable: {
        label: 'Recurring Variable',
        value: 'recurring_variable',
    },
    per_unit_fixed_conditional: {
        label: 'Per Unit Fixed Conditional',
        value: 'per_unit_fixed_conditional',
    },
    recurring_fixed_conditional: {
        label: 'Recurring Fixed Conditional',
        value: 'recurring_fixed_conditional',
    },
    per_unit_variable_conditional: {
        label: 'Per Unit Variable Conditional',
        value: 'per_unit_variable_conditional',
    },
    recurring_variable_conditional: {
        label: 'Recurring Variable Conditional',
        value: 'recurring_variable_conditional',
    },
});
const feeCategoryTypes = asEnum({
    account: {
        label: 'Accounts',
        value: 'account',
    },
    payment: {
        label: 'Payments',
        value: 'payment',
    },
    investigation_recall_payment: {
        label: 'Investigation Recall Payment',
        value: 'investigation_recall_payment',
    },
    negative_interest: {
        label: 'Negative Interest',
        value: 'negative_interest',
    },
    compliance_check: {
        label: 'Compliance Check',
        value: 'compliance_check',
    },
    correction_cancellation: {
        label: 'Correction Cancellation',
        value: 'correction_cancellation',
    },
    fx_payment: {
        label: 'FX Payment',
        value: 'fx_payment',
    },
    fixed_card: {
        label: 'Fixed Card',
        value: 'fixed_card',
    },
    variable_card: {
        label: 'Variable Card',
        value: 'variable_card',
    },
});
const feeSubcategoryTypes = asEnum({
    personal_account: {
        label: 'Personal Account',
        value: 'personal_account',
        parents: ['account'],
    },
    corporate_account: {
        label: 'Corporate Account',
        value: 'corporate_account',
        parents: ['account'],
    },
    statements_references: {
        label: 'Statements References',
        value: 'statements_references',
        parents: ['account'],
    },
    other_services: {
        label: 'Other Services',
        value: 'other_services',
        parents: ['account'],
    },
    within_bank: {
        label: 'Within Bank',
        value: 'within_bank',
        parents: ['payment'],
    },
    incoming_transfer: {
        label: 'Incoming Transfer',
        value: 'incoming_transfer',
        parents: ['payment'],
    },
    outgoing_transfer: {
        label: 'Outgoing Transfer',
        value: 'outgoing_transfer',
        parents: ['payment'],
    },
    investigation_request: {
        label: 'Investigation Request',
        value: 'investigation_request',
        parents: ['investigation_recall_payment'],
    },
    recall_request: {
        label: 'Recall Request',
        value: 'recall_request',
        parents: ['investigation_recall_payment'],
    },
    refusal: {
        label: 'Refusal',
        value: 'refusal',
        parents: ['investigation_recall_payment'],
    },
    complement: {
        label: 'Complement',
        value: 'complement',
        parents: ['investigation_recall_payment'],
    },
    negative_interest: {
        label: 'Negative Interest',
        value: 'negative_interest',
        parents: ['negative_interest'],
    },
    compliance_check: {
        label: 'Compliance Check',
        value: 'compliance_check',
        parents: ['compliance_check'],
    },
    correction_cancellation: {
        label: 'Correction Cancellation',
        value: 'correction_cancellation',
        parents: ['correction_cancellation'],
    },
    fx: {
        label: 'FX',
        value: 'fx',
        parents: ['fx_payment'],
    },
    fixed_card: {
        label: 'Fixed Card',
        value: 'fixed_card',
        parents: ['fixed_card'],
    },
    unjustified_claim: {
        label: 'Unjustified Claim',
        value: 'unjustified_claim',
        parents: ['fixed_card'],
    },
    card_payment: {
        label: 'Card Payment',
        value: 'card_payment',
        parents: ['variable_card'],
    },
});
const feeGroupStatuses = asEnum({
    current: {
        label: 'Current',
        value: 'current',
    },
    obsolete: {
        label: 'Obsolete',
        value: 'obsolete',
    },
});
const feeGroupUnits = asEnum({
    page: {
        label: 'Page',
        value: 'page',
    },
    sms: {
        label: 'SMS',
        value: 'sms',
    },
    action: {
        label: 'Action',
        value: 'action',
    },
    timeframe: {
        label: 'Timeframe',
        value: 'timeframe',
    },
    document: {
        label: 'Document',
        value: 'document',
    },
});
const fees = asEnum({
    personal_account_maintenance: {
        label: 'Personal Account Maintenance',
        value: 'personal_account_maintenance',
        parents: ['recurring_fixed', 'personal_account'],
        reportLabel: 'User account maintenance',
    },
    new_user: {
        label: 'New User',
        value: 'new_user',
        parents: ['per_unit_fixed', 'personal_account'],
        reportLabel: 'Registration of a new user (after account opening)',
    },
    user_legitimation: {
        label: 'Legitimation of new User',
        value: 'user_legitimation',
        parents: ['per_unit_fixed', 'personal_account'],
        reportLabel: 'Legitimation of a user (after account opening) including applicable third-party charges.',
    },
    change_user_rights: {
        label: 'Change of User Rights',
        value: 'change_user_rights',
        parents: ['per_unit_fixed', 'personal_account'],
        reportLabel: 'Change of user access rights',
    },
    lock_user_access: {
        label: 'Lock User Access',
        value: 'lock_user_access',
        parents: ['per_unit_fixed', 'personal_account'],
        reportLabel: 'Locking user access',
    },
    mobile_tan_sms: {
        label: 'Mobile TAN (SMS)',
        value: 'mobile_tan_sms',
        parents: ['per_unit_fixed', 'personal_account'],
        reportLabel: 'mobileTAN by SMS (aggregated at the end of the month)',
    },
    contract_activation: {
        label: 'Contract Activation',
        value: 'contract_activation',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Contract activation',
    },
    account_activation: {
        label: 'Account Activation',
        value: 'account_activation',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Account activation',
    },
    corporate_account_maintenance: {
        label: 'Corporate Account Maintenance',
        value: 'corporate_account_maintenance',
        parents: ['recurring_fixed', 'corporate_account'],
        reportLabel: 'Account maintenance¹',
    },
    virtual_iban_maintenance: {
        label: 'Virtual IBAN Maintenance',
        value: 'virtual_iban_maintenance',
        parents: ['recurring_fixed', 'corporate_account'],
        reportLabel: 'Virtual IBAN maintenance',
    },
    virtual_iban_issuance: {
        label: 'Virtual IBAN Issuance',
        value: 'virtual_iban_issuance',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Virtual IBAN issuance',
    },
    virtual_iban_amendment_termination: {
        label: 'Virtual IBAN Amendment/Termination',
        value: 'virtual_iban_amendment_termination',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Virtual IBAN amendment/termination',
    },
    dormant_account_maintenance: {
        label: 'Dormant Account Maintenance',
        value: 'dormant_account_maintenance',
        parents: ['recurring_fixed', 'corporate_account'],
        reportLabel: 'Lack of contact account maintenance²',
    },
    additional_currency_account_activation: {
        label: 'Additional Currency Account Activation',
        value: 'additional_currency_account_activation',
        parents: ['per_unit_fixed', 'corporate_account'],
    },
    additional_currency_account_maintenance: {
        label: 'Additional Currency Account Maintenance',
        value: 'additional_currency_account_maintenance',
        parents: ['recurring_fixed', 'corporate_account'],
    },
    account_termination: {
        label: 'Account Termination',
        value: 'account_termination',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Account termination',
    },
    account_details_update: {
        label: 'Account Details Update',
        value: 'account_details_update',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Contract detail update³',
    },
    online_account_statement: {
        label: 'Online Account Statement',
        value: 'online_account_statement',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: 'Online account statement',
    },
    certified_account_statement_current_year: {
        label: 'Certified Account Statement Current Year',
        value: 'certified_account_statement_current_year',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: 'Account statement for a period within the current calendar year confirmed by Bivial',
    },
    certified_account_statement_previous_year: {
        label: 'Certified Account Statement Previous Year',
        value: 'certified_account_statement_previous_year',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: 'Account statement for a period in the previous calendar years confirmed by Bivial',
    },
    reference_letter: {
        label: 'Reference Letter (Optional)',
        value: 'reference_letter',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: "Reference letter (subject to Bivial's consent to context)",
    },
    customer_info_from_customer_auditor: {
        label: 'Customer Info from Customer auditor',
        value: 'customer_info_from_customer_auditor',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: "Information about the customer at the request of customer's auditor",
    },
    copies_of_payment_documents: {
        label: 'Copies of Payment Documents',
        value: 'copies_of_payment_documents',
        parents: ['per_unit_fixed', 'statements_references'],
        reportLabel: 'Copies of payment documents (payment orders, SWIFT, etc.)',
    },
    bank_confirmation_on_customer_request: {
        label: 'Bank Confirmation on Customer request',
        value: 'bank_confirmation_on_customer_request',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Bank confirmation upon customer request',
    },
    balance_confirmation_on_customer_request: {
        label: 'Balance Confirmation on Customer request',
        value: 'balance_confirmation_on_customer_request',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Balance confirmation letter upon customer request',
    },
    courier_mail: {
        label: 'Courier mail',
        value: 'courier_mail',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Courier mail',
    },
    minimum_turnover: {
        label: 'Minimum Turnover',
        value: 'minimum_turnover',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Minimum turnover fee - Month 4+',
    },
    apostille_statements: {
        label: 'Apostille on Statements',
        value: 'apostille_statements',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: "Apostille on statements, references and documents issued by Bivial (subject to Bivial's consent)",
    },
    issue_copies_business_transactions: {
        label: 'Issue Copies of Business Transactions',
        value: 'issue_copies_business_transactions',
        parents: ['per_unit_fixed', 'other_services'],
    },
    transfer_between_own_accounts: {
        label: 'Transfer between Customer Accounts',
        value: 'transfer_between_own_accounts',
        parents: ['per_unit_variable', 'within_bank'],
        reportLabel: "Between individual's Bivial accounts",
    },
    transfer_between_other_accounts: {
        label: 'Transfer between Other Accounts',
        value: 'transfer_between_other_accounts',
        parents: ['per_unit_variable', 'within_bank'],
        reportLabel: "Between Bivial customers' accounts",
    },
    incoming_chf: {
        label: 'Incoming CHF Credit Transfer',
        value: 'incoming_chf',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_eur: {
        label: 'Incoming EUR (Intl) Credit Transfer',
        value: 'incoming_eur',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_eur_sepa: {
        label: 'Incoming EUR (SEPA) Credit Transfer',
        value: 'incoming_eur_sepa',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_eur_sepa_sdd: {
        label: 'Incoming EUR (SEPA Direct Debit) Credit Transfer',
        value: 'incoming_eur_sepa_sdd',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    rejected_incoming_eur_sepa_sdd: {
        label: 'Rejected Incoming EUR (SEPA Direct Debit) Credit Transfer',
        value: 'rejected_incoming_eur_sepa_sdd',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_eur_sepa_instant: {
        label: 'Incoming EUR (SEPA Instant) Credit Transfer',
        value: 'incoming_eur_sepa_instant',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_gbp_faster_payment: {
        label: 'Incoming GBP (Faster Payment) Credit Transfer',
        value: 'incoming_gbp_faster_payment',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_gbp_bacs: {
        label: 'Incoming GBP Credit Transfer',
        value: 'incoming_gbp_bacs',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_usd: {
        label: 'Incoming USD Credit Transfer',
        value: 'incoming_usd',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_other: {
        label: 'Incoming Other Currency Credit Transfer',
        value: 'incoming_other',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    outgoing_standard_chf: {
        label: 'Outgoing Standard CHF Transfer',
        value: 'outgoing_standard_chf',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_express_chf: {
        label: 'Outgoing Express CHF Transfer',
        value: 'outgoing_express_chf',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_eur_sepa: {
        label: 'Outgoing Standard EUR Transfer (SEPA)',
        value: 'outgoing_standard_eur_sepa',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_express_eur_sepa: {
        label: 'Outgoing Express EUR Transfer (SEPA)',
        value: 'outgoing_express_eur_sepa',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_eur_target2: {
        label: 'Outgoing Standard EUR Transfer (TARGET2)',
        value: 'outgoing_standard_eur_target2',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_express_eur_target2: {
        label: 'Outgoing Express EUR Transfer (TARGET2)',
        value: 'outgoing_express_eur_target2',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_usd: {
        label: 'Outgoing Standard USD Transfer',
        value: 'outgoing_standard_usd',
        parents: ['per_unit_variable_conditional', 'outgoing_transfer'],
    },
    outgoing_express_usd: {
        label: 'Outgoing Express USD Transfer',
        value: 'outgoing_express_usd',
        parents: ['per_unit_variable_conditional', 'outgoing_transfer'],
    },
    outgoing_eur_transfer_sepa_instant: {
        label: 'Outgoing EUR SEPA Instant Transfer',
        value: 'outgoing_eur_transfer_sepa_instant',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    outgoing_standard_gbp_faster_payment: {
        label: 'Outgoing Standard GBP (Faster Payment) Transfer',
        value: 'outgoing_standard_gbp_faster_payment',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    outgoing_standard_gbp_bacs: {
        label: 'Outgoing Standard GBP Transfer',
        value: 'outgoing_standard_gbp_bacs',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    outgoing_tldr: {
        label: 'Outgoing TLDR (Targeted Local Disbursement/Remittance)',
        value: 'outgoing_tldr',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_other: {
        label: 'Outgoing Standard Other Currency Transfer',
        value: 'outgoing_standard_other',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_express_other: {
        label: 'Outgoing Express Other Currency Transfer',
        value: 'outgoing_express_other',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    investigation_sepa: {
        label: 'Investigation Request on SEPA',
        value: 'investigation_sepa',
        parents: ['per_unit_fixed', 'investigation_request'],
    },
    investigation_swift: {
        label: 'Investigation Request on SWIFT',
        value: 'investigation_swift',
        parents: ['per_unit_fixed', 'investigation_request'],
    },
    recall_sepa: {
        label: 'Recall Bank Transfer on SEPA',
        value: 'recall_sepa',
        parents: ['per_unit_fixed', 'recall_request'],
    },
    recall_swift: {
        label: 'Recall Bank Transfer on SWIFT',
        value: 'recall_swift',
        parents: ['per_unit_fixed', 'recall_request'],
    },
    legitimate_refusal: {
        label: 'Legitimate Refusal',
        value: 'legitimate_refusal',
        parents: ['per_unit_fixed', 'refusal'],
        reportLabel: 'Payment from Bivial',
    },
    complement_incomplete_order: {
        label: 'Complement of Incomplete Request (SWIFT amendment)',
        value: 'complement_incomplete_order',
        parents: ['per_unit_fixed', 'complement'],
    },
    negative_interest_chf: {
        label: 'Negative Interest CHF',
        value: 'negative_interest_chf',
        parents: ['recurring_variable', 'negative_interest'],
    },
    negative_interest_eur: {
        label: 'Negative Interest EUR',
        value: 'negative_interest_eur',
        parents: ['recurring_variable', 'negative_interest'],
    },
    negative_interest_usd: {
        label: 'Negative Interest USD',
        value: 'negative_interest_usd',
        parents: ['recurring_variable', 'negative_interest'],
    },
    negative_interest_gbp: {
        label: 'Negative Interest GBP',
        value: 'negative_interest_gbp',
        parents: ['recurring_variable', 'negative_interest'],
    },
    negative_interest_other: {
        label: 'Negative Interest Other',
        value: 'negative_interest_other',
        parents: ['recurring_variable', 'negative_interest'],
    },
    third_party_request: {
        label: 'Third Party Request (Optional)',
        value: 'third_party_request',
        parents: ['per_unit_fixed', 'compliance_check'],
    },
    payment_correction_cancellation: {
        label: 'Payment From/To Bank Correction, Cancellation or Investigation',
        value: 'payment_correction_cancellation',
        parents: ['per_unit_fixed', 'correction_cancellation'],
        reportLabel: 'Payment to/from Bivial',
    },
    fx: {
        label: 'FX From/To',
        value: 'fx',
        parents: ['per_unit_variable', 'fx'],
    },
    fx_markup: {
        label: 'FX Markup',
        value: 'fx_markup',
        parents: ['per_unit_variable', 'fx'],
    },
    card_issue: {
        label: 'Card Issue',
        value: 'card_issue',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Card issuance',
    },
    card_maintenance: {
        label: 'Card Maintenance',
        value: 'card_maintenance',
        parents: ['recurring_fixed', 'fixed_card'],
        reportLabel: 'Card maintenance, per month, per card',
    },
    inactive_card_maintenance: {
        label: 'Inactive Card Maintenance',
        value: 'inactive_card_maintenance',
        parents: ['recurring_fixed', 'fixed_card'],
    },
    card_reissue: {
        label: 'Card Reissue, Renewal or Replacement',
        value: 'card_reissue',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Card reissue/renewal/replacement',
    },
    pin_change: {
        label: 'Pin Change',
        value: 'pin_change',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'PIN change',
    },
    online_card_statement: {
        label: 'Online Card Statement',
        value: 'online_card_statement',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Online card account statement',
    },
    certified_card_statement: {
        label: 'Certified Card Statement',
        value: 'certified_card_statement',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Card account statements confirmed by Bivial',
    },
    card_operation: {
        label: 'Card Activation, Blocking and Balance',
        value: 'card_operation',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Card activation, blocking and balance request by SMS',
    },
    balance_inquiry_atm: {
        label: 'Balance Inquiry in ATM',
        value: 'balance_inquiry_atm',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Balance inquiry at ATM',
    },
    card_pin_unblock: {
        label: 'Card and Pin Unblocking',
        value: 'card_pin_unblock',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Card unblocking/PIN unblocking',
    },
    sms_notification_on_card_tx: {
        label: 'SMS Notifications on Card Transactions',
        value: 'sms_notification_on_card_tx',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'SMS notifications on card transactions',
    },
    review_unjustified_claim: {
        label: 'Review of Unjustified Claim',
        value: 'review_unjustified_claim',
        parents: ['per_unit_fixed', 'fixed_card'],
        reportLabel: 'Review of unjustified claim',
    },
    card_payment: {
        label: 'Card Payment',
        value: 'card_payment',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Review of unjustified claim',
    },
    card_sms_tan: {
        label: 'SMS TAN for Card',
        value: 'card_sms_tan',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'SMS TAN',
    },
    review_of_unjustified_claim_manual: {
        label: 'Review of Unjustified Claim (Manual)',
        value: 'review_of_unjustified_claim_manual',
        parents: ['per_unit_fixed', 'fixed_card'],
    },
    atm_withdrawal: {
        label: 'ATM withdrawal (Intl)',
        value: 'atm_withdrawal',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Cash withdrawal international',
    },
    atm_withdrawal_ch: {
        label: 'ATM withdrawal (CH)',
        value: 'atm_withdrawal_ch',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Cash withdrawal in Switzerland',
    },
    atm_withdrawal_eu: {
        label: 'ATM withdrawal (EU)',
        value: 'atm_withdrawal_eu',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Cash withdrawal Euro area',
    },
    purchase: {
        label: 'Purchase (Intl)',
        value: 'purchase',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Card payments international',
    },
    purchase_ch: {
        label: 'Purchase (CH)',
        value: 'purchase_ch',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Card payments in Switzerland',
    },
    purchase_eu: {
        label: 'Purchase (EU)',
        value: 'purchase_eu',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Card payments Euro area',
    },
    purchase_online: {
        label: 'Purchase (Online)',
        value: 'purchase_online',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Card payments online',
    },
    cashback_basic: {
        label: 'Cashback (Basic)',
        value: 'cashback_basic',
        parents: ['per_unit_variable', 'card_payment'],
    },
    contract_termination: {
        label: 'Contract Termination',
        value: 'contract_termination',
        parents: ['per_unit_fixed', 'corporate_account'],
        reportLabel: 'Contract cancellation/termination of relationship',
    },
    fx_markup_cards: {
        label: 'FX Mark Cards',
        value: 'fx_markup_cards',
        parents: ['per_unit_variable', 'card_payment'],
        reportLabel: 'Foreign exchange markup',
    },
    correction_for_inbound_payment: {
        label: 'Correction for inbound mismatch',
        value: 'correction_for_inbound_payment',
        parents: ['per_unit_fixed', 'incoming_transfer'],
        reportLabel: 'Correction for Inbound Currency mismatch',
    },
    administration_fee_for_video_verification: {
        label: 'Administration fee for video verification',
        value: 'administration_fee_for_video_verification',
        parents: ['per_unit_fixed', 'other_services'],
    },
    minimum_turnover_month_1: {
        label: 'Minimum Turnover Month 1',
        value: 'minimum_turnover_month_1',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Minimum turnover fee - Month 1',
    },
    minimum_turnover_month_2: {
        label: 'Minimum Turnover Month 2',
        value: 'minimum_turnover_month_2',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Minimum turnover fee - Month 2',
    },
    minimum_turnover_month_3: {
        label: 'Minimum Turnover Month 3',
        value: 'minimum_turnover_month_3',
        parents: ['per_unit_fixed', 'other_services'],
        reportLabel: 'Minimum turnover fee - Month 3',
    },
    negative_fee: {
        label: 'Credit',
        value: 'negative_fee',
        parents: ['per_unit_fixed', 'other_services'],
    },
    swift_statement_delivery: {
        label: 'Swift Statement Delivery',
        value: 'swift_statement_delivery',
        parents: ['per_unit_fixed', 'other_services'],
    },
    swift_pain_setup: {
        label: 'Swift Payment Initiation Setup',
        value: 'swift_pain_setup',
        parents: ['per_unit_fixed', 'other_services'],
    },
    swift_pain_messaging: {
        label: 'Swift Payment Initiation Messaging',
        value: 'swift_pain_messaging',
        parents: ['per_unit_fixed', 'other_services'],
    },
    corporate_account_maintenance_other_currencies: {
        label: 'Corporate Account Maintenance Other Currencies',
        value: 'corporate_account_maintenance_other_currencies',
        parents: ['recurring_fixed', 'corporate_account'],
        reportLabel: ['Other Currencies', { text: '9', sup: true }, ' account maintenance'],
    },
    incoming_other_no_cross: {
        label: 'Incoming Other Currency Credit Transfer',
        value: 'incoming_other_no_cross',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    incoming_standard_local_ach: {
        label: 'Incoming Standard Local ACH',
        value: 'incoming_standard_local_ach',
        parents: ['per_unit_fixed', 'incoming_transfer'],
    },
    outgoing_standard_other_no_cross: {
        label: 'Outgoing Standard Other Currency Transfer',
        value: 'outgoing_standard_other_no_cross',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    negative_interest_jpy: {
        label: 'Negative Interest JPY',
        value: 'negative_interest_jpy',
        parents: ['recurring_variable', 'negative_interest'],
    },
    other: {
        label: 'Other',
        value: 'other',
        parents: ['per_unit_fixed', 'other_services'],
    },
    outgoing_standard_local_ach: {
        label: 'Outgoing Standard Local Ach',
        value: 'outgoing_standard_local_ach',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_cross_jpy: {
        label: 'Outgoing Standard Cross JPY',
        value: 'outgoing_standard_cross_jpy',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_cross_ils: {
        label: 'Outgoing Standard Cross ILS',
        value: 'outgoing_standard_cross_ils',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    outgoing_standard_cross_zar: {
        label: 'Outgoing Standard Cross Zar',
        value: 'outgoing_standard_cross_zar',
        parents: ['per_unit_fixed', 'outgoing_transfer'],
    },
    urgent_withdrawal_guaranteed: {
        label: 'Urgent Withdrawal',
        value: 'urgent_withdrawal_guaranteed',
        parents: ['per_unit_variable', 'within_bank'],
    },
    outgoing_our_charges: {
        label: 'Guarantee OUR Charges on Outgoing Transfer',
        value: 'outgoing_our_charges',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    direct_debit_dispute: {
        label: 'Direct Debit Dispute',
        value: 'direct_debit_dispute',
        parents: ['per_unit_fixed', 'investigation_request'],
    },
    incoming_wallet_transfer: {
        label: 'Incoming Wallet Transfer',
        value: 'incoming_wallet_transfer',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    outgoing_wallet_transfer: {
        label: 'Outgoing Wallet Transfer',
        value: 'outgoing_wallet_transfer',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    card_top_up: {
        label: 'Incoming Card Top-up',
        value: 'card_top_up',
        parents: ['per_unit_variable', 'incoming_transfer'],
    },
    card_top_up_reversal: {
        label: 'Card Top-up Reversal',
        value: 'card_top_up_reversal',
        parents: ['per_unit_variable', 'outgoing_transfer'],
    },
    transaction_network_cost: {
        label: 'Network Fee',
        value: 'transaction_network_cost',
        parents: ['per_unit_variable', 'incoming_transfer', 'outgoing_transfer'],
    },
});
const feeDefaults = asEnum({
    personal_account_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    new_user: {
        is_amount_percentage: false,
        fixed_amount: 40,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    user_legitimation: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    change_user_rights: {
        is_amount_percentage: false,
        fixed_amount: 10,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    lock_user_access: {
        is_amount_percentage: false,
        fixed_amount: 10,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    mobile_tan_sms: {
        is_amount_percentage: false,
        fixed_amount: 0.15,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'sms',
        currency: 'CHF',
    },
    account_activation: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    corporate_account_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    dormant_account_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 200,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    additional_currency_account_activation: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    additional_currency_account_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    account_termination: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    account_details_update: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    online_account_statement: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    certified_account_statement_current_year: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'page',
        currency: 'CHF',
    },
    certified_account_statement_previous_year: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'page',
        currency: 'CHF',
    },
    reference_letter: {
        is_amount_percentage: false,
        fixed_amount: 150,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    customer_info_from_customer_auditor: {
        is_amount_percentage: false,
        fixed_amount: 150,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    copies_of_payment_documents: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 10,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'document',
        currency: 'CHF',
    },
    bank_confirmation_on_customer_request: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    balance_confirmation_on_customer_request: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    courier_mail: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    apostille_statements: {
        is_amount_percentage: false,
        fixed_amount: 90,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'document',
        currency: 'CHF',
    },
    issue_copies_business_transactions: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 1,
        unit: 'document',
        currency: 'CHF',
    },
    transfer_between_own_accounts: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    transfer_between_other_accounts: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_chf: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_eur: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_usd: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_other: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_standard_chf: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_express_chf: {
        is_amount_percentage: false,
        fixed_amount: 25,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_standard_eur_sepa: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_express_eur_sepa: {
        is_amount_percentage: false,
        fixed_amount: 25,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_standard_eur_target2: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_express_eur_target2: {
        is_amount_percentage: false,
        fixed_amount: 25,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_standard_usd: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.1,
        is_minimum_percentage: false,
        minimum: 100,
        is_maximum_percentage: false,
        maximum: 400,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'USD',
    },
    outgoing_express_usd: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.12,
        is_minimum_percentage: false,
        minimum: 150,
        is_maximum_percentage: false,
        maximum: 450,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'USD',
    },
    outgoing_standard_other: {
        is_amount_percentage: false,
        fixed_amount: 70,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_express_other: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    investigation_sepa: {
        is_amount_percentage: false,
        fixed_amount: 75,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'EUR',
    },
    investigation_swift: {
        is_amount_percentage: false,
        fixed_amount: 75,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    recall_sepa: {
        is_amount_percentage: false,
        fixed_amount: 75,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'EUR',
    },
    recall_swift: {
        is_amount_percentage: false,
        fixed_amount: 75,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    legitimate_refusal: {
        is_amount_percentage: false,
        fixed_amount: 2,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    complement_incomplete_order: {
        is_amount_percentage: false,
        fixed_amount: 75,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    negative_interest_chf: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.5,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 12,
        unit: 'action',
        currency: 'CHF',
    },
    negative_interest_eur: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.5,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 12,
        unit: 'action',
        currency: 'EUR',
    },
    negative_interest_usd: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    negative_interest_other: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    third_party_request: {
        is_amount_percentage: false,
        fixed_amount: 100,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    payment_correction_cancellation: {
        is_amount_percentage: false,
        fixed_amount: 70,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    fx: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.05,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_issue: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    inactive_card_maintenance: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 1,
        unit: 'action',
        currency: 'CHF',
    },
    card_reissue: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    review_of_unjustified_claim_manual: {
        is_amount_percentage: false,
        fixed_amount: 65,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    atm_withdrawal: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    purchase: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    pin_change: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    online_card_statement: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    certified_card_statement: {
        is_amount_percentage: false,
        fixed_amount: 5,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'page',
        currency: 'CHF',
    },
    card_operation: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    balance_inquiry_atm: {
        is_amount_percentage: false,
        fixed_amount: 2,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_pin_unblock: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    sms_notification_on_card_tx: {
        is_amount_percentage: false,
        fixed_amount: 0.15,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'sms',
        currency: 'CHF',
    },
    review_unjustified_claim: {
        is_amount_percentage: false,
        fixed_amount: 65,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_payment: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_top_up: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 1,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_top_up_reversal: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    card_sms_tan: {
        is_amount_percentage: false,
        fixed_amount: 0.15,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'sms',
        currency: 'CHF',
    },
    urgent_withdrawal_guaranteed: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.1,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_our_charges: {
        is_amount_percentage: false,
        fixed_amount: 50,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_wallet_transfer: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.5,
        is_minimum_percentage: false,
        minimum: 25,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_wallet_transfer: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.5,
        is_minimum_percentage: false,
        minimum: 25,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    incoming_eur_sepa_sdd: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    rejected_incoming_eur_sepa_sdd: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    outgoing_tldr: {
        is_amount_percentage: true,
        fixed_amount: 0,
        amount: 0.2,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        base_amount: 2,
        unit: 'action',
        currency: 'CHF',
    },
    swift_statement_delivery: {
        is_amount_percentage: false,
        fixed_amount: 0.1,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    swift_pain_setup: {
        is_amount_percentage: false,
        fixed_amount: 2500,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    swift_pain_messaging: {
        is_amount_percentage: false,
        fixed_amount: 0.1,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: true,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
    transaction_network_cost: {
        is_amount_percentage: false,
        fixed_amount: 0,
        amount: 0,
        is_minimum_percentage: false,
        minimum: 0,
        is_maximum_percentage: false,
        maximum: 0,
        is_recurring: false,
        recurring_period: 0,
        unit: 'action',
        currency: 'CHF',
    },
});
const successFeeStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    payable: {
        value: 'payable',
        label: 'Payable',
    },
    notPayable: {
        value: 'notPayable',
        label: 'Not Payable',
    },
    paid: {
        value: 'paid',
        label: 'Paid',
    },
});
const payoutSchedules = asLocalizedEnum('payoutSchedules', {
    daily: {
        value: 'daily',
        label: 'Daily',
    },
    weekly: {
        value: 'weekly',
        label: 'Weekly',
    },
    monthly: {
        value: 'monthly',
        label: 'Monthly',
    },
});
const successFeePayoutStatuses = asEnum({
    pending: {
        value: 'pending',
        label: 'Pending',
    },
    pendingExecution: {
        value: 'pending_execution',
        label: 'Pending Execution',
    },
    completed: {
        value: 'completed',
        label: 'Completed',
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
    },
});

const issueCardRequestStatuses = asEnum({
    failed: {
        label: 'Failed',
        value: 'failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    pending: {
        label: 'Pending',
        value: 'pending',
        labelIndicator: LabelIndicator.INFO,
    },
    issued: {
        label: 'Issued',
        value: 'issued',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        label: 'Rejected',
        value: 'rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const cardStatuses = asEnum({
    pending: {
        label: 'Pending',
        value: 'pending',
    },
    active: {
        label: 'Active',
        value: 'active',
    },
    inActive: {
        label: 'InActive',
        value: 'inActive',
    },
    awaitingRenewal: {
        label: 'AwaitingRenewal',
        value: 'awaitingRenewal',
    },
    blocked: {
        label: 'Blocked',
        value: 'blocked',
    },
    closed: {
        label: 'Closed',
        value: 'closed',
    },
    closing: {
        label: 'Closing',
        value: 'closing',
    },
    created: {
        label: 'Created',
        value: 'created',
    },
    dispatched: {
        label: 'Dispatched',
        value: 'dispatched',
    },
    expired: {
        label: 'Expired',
        value: 'expired',
    },
    ordered: {
        label: 'Ordered',
        value: 'ordered',
    },
    personalized: {
        label: 'Personalized',
        value: 'personalized',
    },
    rejected: {
        label: 'Rejected',
        value: 'rejected',
    },
});

const economicProfileSourceFundsTypes = asEnum({
    uboInvestments: {
        value: 'ubo_investments',
        label: 'UBO Investments',
        type: ['legalEntity'],
    },
    businessIncome: {
        value: 'business_income',
        label: 'Business Income',
        type: ['legalEntity'],
    },
    borrowedFunds: {
        value: 'borrowed_funds',
        label: 'Borrowed Funds',
        type: ['legalEntity'],
    },
    other: {
        value: 'other',
        label: 'Other',
        type: ['legalEntity'],
    },
    salary: {
        value: 'salary',
        label: 'Salary',
        type: ['individual'],
    },
    invoicedWork: {
        value: 'invoiced_work',
        label: 'Invoiced work',
        type: ['individual'],
    },
    dividends: {
        value: 'dividends',
        label: 'Dividends/Capital withdrawals from owned business',
        type: ['individual'],
    },
    notOwnDividends: {
        value: 'not_own_dividends',
        label: 'Dividends/interest not from own business',
        type: ['individual'],
    },
    sellingPersonalAssets: {
        value: 'selling_personal_assets',
        label: 'Selling Personal Assets',
        type: ['individual'],
    },
    gifts: {
        value: 'gifts',
        label: 'Gifts',
        type: ['individual'],
    },
    inheritances: {
        value: 'inheritances',
        label: 'Inheritances',
        type: ['individual'],
    },
    loans: {
        value: 'loans',
        label: 'Loans',
        type: ['individual'],
    },
    retirementFunds: {
        value: 'retirement_funds',
        label: 'Retirement funds',
        type: ['individual'],
    },
    rentalIncome: {
        value: 'Rental_income',
        label: 'Rental Income',
        type: ['individual'],
    },
    onlinePlatforms: {
        value: 'online_platforms',
        label: 'Online Platforms (e.g. Social Media)',
        type: ['individual'],
    },
    lotteryWinnings: {
        value: 'lottery_winnings',
        label: 'Lottery Winnings',
        type: ['individual'],
    },
    gamblingWinnings: {
        value: 'gambling_winnings',
        label: 'Gambling Winnings',
        type: ['individual'],
    },
    otherInvestmentActivity: {
        value: 'other_investment_activity',
        label: 'Other Investment Activity',
        type: ['individual'],
    },
});
const economicProfileAverageSizeTypes = asEnum({
    upToHundred: {
        value: 'up_to_hundred',
        label: 'up to 100,000.00',
        numericValue: 100000,
        from: 0,
        to: 100000,
    },
    upToFiveHundred: {
        value: 'up_to_five_hundred',
        label: 'up to 500,000.00',
        numericValue: 500000,
        from: 100001,
        to: 500000,
    },
    upToMillion: {
        value: 'up_to_million',
        label: 'up to 1,000,000.00',
        numericValue: 1000000,
        from: 500001,
        to: 1000000,
    },
    aboveMillion: {
        value: 'above_million',
        label: 'above 1,000,000.00',
        numericValue: 1500000,
        from: 1000001,
        to: 10000000000,
    },
    lessThanFiftyThousand: {
        value: 'less_than_fifty_thousand',
        label: '< 50,000',
        numericValue: 50000,
        from: 0,
        to: 49999,
    },
    fiftyToHundredFiftyThousand: {
        value: 'fifty_to_hundred_fifty_thousand',
        label: '50,000 - 150,000',
        numericValue: 150000,
        from: 50000,
        to: 150000,
    },
    hundredFiftyToThreeHundredThousand: {
        value: 'hundred_fifty_to_three_hundred_thousand',
        label: '150,000 - 300,000',
        numericValue: 300000,
        from: 150001,
        to: 300000,
    },
    threeHundredToFiveHundredThousand: {
        value: 'three_hundred_to_five_hundred_thousand',
        label: '300,000 - 500,000',
        numericValue: 500000,
        from: 300001,
        to: 500000,
    },
    fiveHundredToSevenHundredFiftyThousand: {
        value: 'five_hundred_to_seven_hundred_fifty_thousand',
        label: '500,000 - 750,000',
        numericValue: 750000,
        from: 500001,
        to: 750000,
    },
    sevenHundredFiftyThousandToOneMill: {
        value: 'seven_hundred_fifty_thousand_to_million',
        label: '750,000 - 1,000,000',
        numericValue: 1000000,
        from: 750001,
        to: 1000000,
    },
    oneToTwoMillion: {
        value: 'one_to_two_million',
        label: '1,000,000 - 2,000,000',
        numericValue: 2000000,
        from: 1000001,
        to: 2000000,
    },
    twoToFiveMillion: {
        value: 'two_to_five_million',
        label: '2,000,000 - 5,000,000',
        numericValue: 5000000,
        from: 2000001,
        to: 5000000,
    },
    aboveFiveMillion: {
        value: 'above_five_million',
        label: '> 5,000,000',
        numericValue: 5500000,
        from: 5000001,
        to: 10000000000,
    },
    upToThreeThousand: {
        value: 'up_to_three_thousand',
        label: '0 - 3,000',
        numericValue: 3000,
        from: 0,
        to: 3000,
    },
    threeToTenThousand: {
        value: 'three_to_ten_thousand',
        label: '3,000 - 10,000',
        numericValue: 10000,
        from: 3001,
        to: 10000,
    },
    moreThanTenThousand: {
        value: 'more_than_ten_thousand',
        label: '10,000+',
        numericValue: 10500,
        from: 10001,
        to: 10000000000,
    },
});
const economicProfileTransactionSourceDestinationTypes = asEnum({
    paymentsGoods: {
        value: 'payments_goods',
        label: 'Payments for goods and services',
        source: true,
        destination: true,
    },
    administrationFees: {
        value: 'administration_fees',
        label: 'Administration fees',
        source: true,
        destination: true,
    },
    payroll: {
        value: 'payroll',
        label: 'Payroll',
        source: false,
        destination: true,
    },
    fxOperations: {
        value: 'fx_operations',
        label: 'FX Operations',
        source: true,
        destination: true,
    },
    cryptoOperations: {
        value: 'crypto_operations',
        label: 'Crypto Operations',
        source: true,
        destination: true,
    },
    other: {
        value: 'other',
        label: 'Other',
        source: true,
        destination: true,
    },
});
const economicProfileInboundSourceTypes = pickBy_1(economicProfileTransactionSourceDestinationTypes, (e) => e.source);
const economicProfileOutboundDestinationTypes = pickBy_1(economicProfileTransactionSourceDestinationTypes, (e) => e.destination);
const anticipatedAccountActivities = asEnum({
    B2B: {
        value: 'B2B',
        label: 'B2B (Business-to-Business)',
        disabled: true,
    },
    B2C: {
        value: 'B2C',
        label: 'Payments from/to Retail Customers',
        disabled: false,
    },
    B2B_B2C: {
        value: 'B2B_B2C',
        label: 'B2B & B2C',
        disabled: true,
    },
    C2B: {
        value: 'C2B',
        label: 'C2B (Client-to-Business)',
        disabled: true,
    },
    B2B2C: {
        value: 'B2B2C',
        label: 'Settlements from Payment Providers (Retail End Customers)',
        disabled: false,
    },
    C2B2B: {
        value: 'C2B2B',
        label: 'C2B2B (Client-to-Business-to-Business)',
        disabled: true,
    },
    corporateExpenses: {
        value: 'corporateExpenses',
        label: 'Corporate/Business Transactional Banking',
        disabled: false,
    },
    crypto2Fiat2Crypto: {
        value: 'crypto2Fiat2Crypto',
        label: 'Crypto2Fiat2Crypto',
        disabled: true,
    },
});
const economicProfileProducts = asEnum({
    iban: {
        value: 'iban',
        label: 'IBAN',
        disabled: false,
    },
    virtualIban: {
        value: 'virtual_iban',
        label: 'Virtual IBAN',
        disabled: false,
    },
    cryptocurrencyWallet: {
        value: 'cryptocurrency_wallet',
        label: 'Cryptocurrency Wallet',
        disabled: true,
    },
    corporateCards: {
        value: 'corporate_cards',
        label: 'Corporate Cards',
        disabled: false,
    },
    paymentProcessing: {
        value: 'payment_processing',
        label: 'Payment Processing',
        disabled: false,
    },
});
const economicProfileEmploymentStatus = asEnum({
    businessOwner: {
        value: 'business_owner',
        label: 'Business Owner',
    },
    employee: {
        value: 'employee',
        label: 'Employee',
    },
    selfEmployedSoleTrader: {
        value: 'self_employed_sole_trader',
        label: 'Self-employed/Sole-Trader',
    },
    contractorFreelancer: {
        value: 'contractor_freelancer',
        label: 'Contractor/Freelancer',
    },
    unemployed: {
        value: 'unemployed',
        label: 'Unemployed',
    },
});
const economicProfileAccountBalance = asEnum({
    upToTenThousand: {
        value: 'up_to_ten_thousand',
        label: '0 - 10,000',
    },
    tenToHundrerdThousand: {
        value: 'ten_to_hundrerd_thousand',
        label: '10,000 - 100,000',
    },
    moreThanHundrerdThousand: {
        value: 'more_than_hundrerd_thousand',
        label: '100,000+',
    },
});

const emailCategoriesTypes = asLocalizedEnum('emailCategoriesTypes', {
    essentials: {
        value: 'essentials',
        label: 'Essentials',
        description: 'Essential Notifications',
        emailTypes: [
            'NotifyOldEmailOnEmailChange',
            'EmailConfirmationTemplate',
            'EmailConfirmationWithDigitToken',
            'GenerateSecurityCode',
            'IndividualPasswordChanged',
            'AuthorizedPersonInvitation',
            'NewDocumentToReview',
            'NewLoginFromUnUsualLocationOrDevice',
            'OnBoardingInvitationTemplate',
            'PasswordRecoveredContent',
            'PasswordRecoveryContent',
            'SomeoneTriedToSignUpWithEmailAddress',
            'SuccessfulApplicationSubmission',
            'ContractIsLive',
            'IssueNewCard',
            'SendPlainEmail',
            'UserPasswordResetToken',
            'LeadAssignmentContent',
        ],
        mandatory: true,
    },
    newActionNotifications: {
        value: 'new_action_notifications',
        label: 'New Action Notifications',
        description: 'New Action Notifications',
        emailTypes: ['ActionSignatureInvitation'],
        mandatory: false,
    },
    contractUpdateNotifications: {
        value: 'contract_update_notifications',
        label: 'Contract Update Notifications',
        description: 'All Contract Update Notifications',
        emailTypes: ['ContractChangesApproved', 'ContractProfileChangesApproved', 'IncompleteApplication'],
        mandatory: false,
    },
    appointmentNotifications: {
        value: 'appointment_notifications',
        label: 'Appointment Notifications',
        description: 'Appointment Related Notifications',
        emailTypes: [
            'VerificationAppointment',
            'VerificationAppointmentIn30Mins',
            'VerificationAppointmentIsMissed',
            'VerificationAppointmentStartsSoon',
        ],
        mandatory: false,
    },
    paymentUpdateNotifications: {
        value: 'payment_update_notifications',
        label: 'Payment Related Notifications',
        description: 'Payment Related Notifications',
        emailTypes: ['NewInBoundPayment', 'NewOutBoundPayment'],
        mandatory: false,
    },
    debitCardUpdateNotifications: {
        value: 'debit_card_update_notifications',
        label: 'Debit Card Update Notifications',
        description: 'Debit Card Changes Related Notifications',
        emailTypes: [
            'CardFrozen',
            'CardSpendingLimitsApproaching',
            'CardSpendingLimitsChanged',
            'CardSpendingLimitsReached',
            'CardTerminated',
        ],
        mandatory: false,
    },
    actionStatusUpdateNotifications: {
        value: 'action_status_update_notifications',
        label: 'Action Status Update Notifications',
        description: 'Action Status Update Notifications',
        emailTypes: ['ActionRejected', 'ActionApproved', 'ActionSigned', 'ActionStatusChanged'],
        mandatory: false,
    },
});

const smsCategoriesTypes = asLocalizedEnum('smsCategoriesTypes', {
    essentials: {
        value: 'essentials',
        label: 'Essentials',
        description: 'Essential Notifications',
        smsTypes: [
            'NotifyOldSMSOnSMSChange',
            'SMSConfirmationTemplate',
            'SMSConfirmationWithDigitToken',
            'GenerateSecurityCode',
            'IndividualPasswordChanged',
            'NewLoginFromUnUsualLocationOrDevice',
            'SomeoneTriedToSignUpWithSMSAddress',
            'IssueNewCard',
            'SendPlainSMS',
            'UserPasswordResetToken',
        ],
        mandatory: true,
    },
    paymentUpdateNotifications: {
        value: 'payment_update_notifications',
        label: 'Payment Related Notifications',
        description: 'Payment Related Notifications',
        smsTypes: ['NewInBoundPayment', 'NewOutBoundPayment', 'CardPaymentFailureNotification'],
        mandatory: false,
    },
    debitCardUpdateNotifications: {
        value: 'debit_card_update_notifications',
        label: 'Debit Card Update Notifications',
        description: 'Debit Card Changes Related Notifications',
        smsTypes: [
            'CardFrozen',
            'CardSpendingLimitsApproaching',
            'CardSpendingLimitsChanged',
            'CardSpendingLimitsReached',
            'CardTerminated',
        ],
        mandatory: false,
    },
});

const graphqlSubscriptionMessages = asEnum({
    contractUpdated: {
        value: 'CONTRACT_UPDATED',
    },
    newFXQuote: {
        value: 'NEW_FX_QUOTE',
    },
});

const emailEnquiryTypes = asLocalizedEnum('emailEnquiryTypes', {
    generalEnquiries: {
        value: 'general_enquiries',
        label: 'General Inquiries',
        description: 'General Inquiries',
        emails: ['support@bivial.com'],
    },
    introducingPartner: {
        value: 'introducing_partner',
        label: 'Introducing Partner',
        description: 'Interested in becoming an Introducing Partner',
        emails: ['partnerships@bivial.com'],
    },
    klarpayCorporateAccount: {
        value: 'klarpay_corporate_account',
        label: 'Klarpay Corporate Account',
        description: 'Interested in opening a Bivial Corporate Account',
        emails: ['sales@bivial.com'],
    },
    fraudScam: {
        value: 'fraud_scam',
        label: 'Fraud or Scam',
        description: 'Report Fraud or Scam',
        emails: ['support@bivial.com'],
    },
});

const twoFAMethods = asEnum({
    sms: {
        value: 'sms',
        label: 'SMS or Phone Call',
    },
    totp: {
        value: 'totp',
        label: 'Time Based One Time Password',
    },
    mobile: {
        value: 'mobile',
        label: 'Mobile',
    },
});

const preAssessmentStatuses = asEnum({
    new: {
        label: 'New',
        value: 'new',
        labelIndicator: LabelIndicator.INFO,
    },
    pending: {
        label: 'Pending',
        value: 'pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    handled: {
        label: 'Handled',
        value: 'handled',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    duplicate: {
        label: 'Duplicate',
        value: 'duplicate',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});
const businessRegion = asEnum({
    Eea: {
        value: 'Eea',
        label: 'EEA',
    },
    NorthAmerica: {
        value: 'NorthAmerica',
        label: 'North America',
    },
    SouthAmerica: {
        value: 'SouthAmerica',
        label: 'South America',
    },
    Asia: {
        value: 'Asia',
        label: 'Asia',
    },
    Africa: {
        value: 'Africa',
        label: 'Africa',
    },
    Australia: {
        value: 'Australia',
        label: 'Australia',
    },
    Cis: {
        value: 'Cis',
        label: 'CIS',
    },
    UK: {
        value: 'UK',
        label: 'UK',
    },
});
const relevantCredentialOnFilesBillingSalesMethodTypes = asEnum({
    recurring: {
        value: 'recurring',
        label: 'Recurring',
    },
    unscheduled: {
        value: 'unscheduled',
        label: 'Unscheduled',
    },
    cardHolderInitiated: {
        value: 'cardHolderInitiated',
        label: 'Card Holder Initiated (CIT)',
    },
});
const integrationTypeRequiredTypes = asEnum({
    payabl: {
        value: 'embeddedPaymentPage',
        label: 'Embedded Payment Page',
    },
    gateway: {
        value: 'gateway',
        label: 'Gateway/ Server-to-server',
    },
});
const dssComplianceTypes = asEnum({
    own: {
        value: 'own',
        label: 'Own',
    },
    from3rdParty: {
        value: 'from3rdParty',
        label: 'From 3rd Party',
    },
});

const vibanNameMismatchResolutions = asEnum({
    accept: {
        label: 'Accept',
        value: 'accept',
    },
    pending: {
        label: 'Pending',
        value: 'pending',
    },
    reject: {
        label: 'Reject',
        value: 'reject',
    },
});

const approvalRequestTypes = asEnum({
    accountClosureFundRemittance: {
        value: 'account_closure_fund_remittance',
        label: 'Account Closure Fund Remittance',
    },
    manualAccountBooking: {
        value: 'manual_account_booking',
        label: 'Manual Account Booking',
    },
    cardTransactionAdjustment: {
        value: 'card_transaction_adjustment',
        label: 'Card Transaction Adjustment',
    },
    feeReversal: {
        value: 'fee_reversal',
        label: 'Fee Reversal',
    },
    voidTransaction: {
        value: 'void_transaction',
        label: 'Void Transaction',
    },
});
const approvalRequestStatuses = asEnum({
    accept: {
        value: 'accept',
        label: 'Accept',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    reject: {
        value: 'reject',
        label: 'Reject',
        labelIndicator: LabelIndicator.ERROR,
    },
    failed: {
        value: 'failed',
        label: 'Failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    draft: {
        value: 'draft',
        label: 'Draft',
        labelIndicator: LabelIndicator.INFO,
    },
});
const userApprovalRequestStatuses = asEnum({
    accept: {
        value: 'accept',
        label: 'Accept',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    reject: {
        value: 'reject',
        label: 'Reject',
        labelIndicator: LabelIndicator.ERROR,
    },
});
const approvalRequestEntities = asEnum({
    account: {
        value: 'account',
        label: 'Account',
    },
    contract: {
        value: 'contract',
        label: 'Contract',
    },
    transaction: {
        value: 'transaction',
        label: 'Transaction',
    },
});

const contractRiskCategories = asEnum({
    direct_ownership_by_nps_single_sh_ubo: {
        value: 'direct_ownership_by_nps_single_sh_ubo',
        label: 'Direct Ownership by NPs - Single SH/UBO',
    },
    direct_ownership_by_nps_multiple_sh_ubo: {
        value: 'direct_ownership_by_nps_multiple_sh_ubo',
        label: 'Direct Ownership by NPs - Multiple SH/UBO',
    },
    vertical_group_structure_2_3_entities: {
        value: 'vertical_group_structure_2_3_entities',
        label: 'Vertical Group Structure - 2 to 3 Entities',
    },
    vertical_group_structure_3_4_entities: {
        value: 'vertical_group_structure_3_4_entities',
        label: 'Vertical Group Structure - 3 to 4 Entities',
    },
    vertical_group_structure_more_than_5_entities: {
        value: 'vertical_group_structure_more_than_5_entities',
        label: 'Vertical Group Structure - 5 or More Entities',
    },
    horizontal_group_structure_3_entities: {
        value: 'horizontal_group_structure_3_entities',
        label: 'Horizontal Group Structure - 3 Entities',
    },
    horizontal_group_structure_3_4_entities: {
        value: 'horizontal_group_structure_3_4_entities',
        label: 'Horizontal Group Structure - 3 to 4 Entities',
    },
    horizontal_group_structure_more_than_5_entities: {
        value: 'horizontal_group_structure_more_than_5_entities',
        label: 'Horizontal Group Structure - 5 or More Entities',
    },
    hybrid_group_structure_4_entities: {
        value: 'hybrid_group_structure_4_entities',
        label: 'Hybrid Group Structure - 4 Entities',
    },
    hybrid_group_structure_more_than_5_entities: {
        value: 'hybrid_group_structure_more_than_5_entities',
        label: 'Hybrid Group Structure - 5 or More Entities',
    },
    nominee_trustee_ownership_ubo_identifiable: {
        value: 'nominee_trustee_ownership_ubo_identifiable',
        label: 'Nominee/Trustee Ownership - UBO Identifiable',
    },
    nominee_trustee_ownership_ubo_not_identifiable: {
        value: 'nominee_trustee_ownership_ubo_not_identifiable',
        label: 'Nominee/Trustee Ownership - UBO Not Identifiable',
    },
});

const kycMeasures = asEnum({
    notAvailable: {
        value: 'notAvailable',
        label: 'N/A',
    },
    noTool: {
        value: 'noTool',
        label: 'No tool',
    },
    pep: {
        value: 'pep',
        label: 'PEP',
    },
    pepSanctions: {
        value: 'pepSanctions',
        label: 'PEP, sanctions',
    },
    pepSanctionsAdverseMedia: {
        value: 'pepSanctionsAdverseMedia',
        label: 'PEP, sanctions, adverse media',
    },
    pepSanctionsAdverseMediaOther: {
        value: 'pepSanctionsAdverseMediaOther',
        label: 'PEP, sanctions, adverse media, other lists',
    },
});
const riskCalculatorProducts = asEnum({
    ibanRetailB2B: {
        value: 'ibanRetailB2B',
        label: 'IBAN - B2B2C (Corporate Client Settlements)',
        product: economicProfileProducts.iban,
        activity: anticipatedAccountActivities.B2B2C,
    },
    ibanRetailB2C: {
        value: 'ibanRetailB2C',
        label: 'IBAN - B2C (Retail Client Settlements)',
        product: economicProfileProducts.iban,
        activity: anticipatedAccountActivities.B2C,
    },
    ibanCorporateOnly: {
        value: 'ibanCorporateOnly',
        label: 'IBAN - Corporate Expenses Only',
        product: economicProfileProducts.iban,
        activity: anticipatedAccountActivities.corporateExpenses,
    },
    virtualIbansB2B: {
        value: 'virtualIbansB2B',
        label: 'Virtual IBAN - B2B2C (Corporate Client Settlements)',
        product: economicProfileProducts.virtualIban,
        activity: anticipatedAccountActivities.B2B2C,
    },
    virtualIbansB2C: {
        value: 'virtualIbansB2C',
        label: 'Virtual IBAN - B2C (Retail Client Settlements)',
        product: economicProfileProducts.virtualIban,
        activity: anticipatedAccountActivities.B2C,
    },
    virtualIbansCorporateOnly: {
        value: 'virtualIbansCorporateOnly',
        label: 'Virtual IBAN - Corporate Expenses Only',
        product: economicProfileProducts.virtualIban,
        activity: anticipatedAccountActivities.corporateExpenses,
    },
    corporateCards: {
        value: 'corporateCards',
        label: 'Corporate cards',
        product: economicProfileProducts.corporateCards,
    },
    cryptocurrencyWallets: {
        value: 'cryptocurrencyWallets',
        label: 'Cryptocurrency wallets',
        product: economicProfileProducts.cryptocurrencyWallet,
    },
    paymentProcessing: {
        value: 'paymentProcessing',
        label: 'Payment processing',
        product: economicProfileProducts.paymentProcessing,
    },
});
const riskCalculatorFinancialStatements = asEnum({
    notProvided: {
        value: 'notProvided',
        label: 'Not provided',
    },
    providedUnaudited: {
        value: 'providedUnaudited',
        label: 'Provided Unaudited',
    },
    willBeProvidedAudited: {
        value: 'willBeProvidedAudited',
        label: 'Will be provided audited upon the deadline set by law',
    },
    providedAudited: {
        value: 'providedAudited',
        label: 'Provided Audited',
    },
    willBeProvidedUnaudited: {
        value: 'willBeProvidedUnaudited',
        label: 'Will be provided unaudited upon the deadline set by law',
    },
});
const riskClassificationStatuses = asEnum({
    reviewed: {
        value: 'reviewed',
        label: 'Reviewed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    pending: {
        value: 'pending',
        label: 'Pending',
        labelIndicator: LabelIndicator.WARNING,
    },
    final: {
        value: 'final',
        label: 'Final',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});

const paymentMethods = asEnum({
    card: {
        label: 'Credit/Debit Card',
        value: 'card',
        externalValue: 1,
    },
    localPaymentMethods: {
        label: 'Local payment methods',
        value: 'localPaymentMethods',
        externalValue: 5,
    },
    amex: {
        label: 'American Express cards',
        value: 'amex',
        externalValue: 11,
    },
    directBankTransfer: {
        label: 'Direct Bank Transfer (Sofort)',
        value: 'directBankTransfer',
        externalValue: 17,
    },
    bitcoin: {
        label: 'Bitcoin',
        value: 'bitcoin',
        externalValue: 18,
    },
    trustly: {
        label: 'Trustly',
        value: 'trustly',
        externalValue: 116,
    },
    paypal: {
        label: 'Paypal',
        value: 'paypal',
        externalValue: 117,
    },
    epsGiropay: {
        label: 'EPS & Giropay',
        value: 'epsGiropay',
        externalValue: 118,
    },
    przelewy24: {
        label: 'Przelewy24',
        value: 'przelewy24',
        externalValue: 120,
    },
    refund: {
        label: 'Refund',
        value: 'refund',
        externalValue: 0,
    },
    oct: {
        label: 'Original Credit Transfer',
        value: 'oct',
        externalValue: 0,
    },
});
const paymentStatuses = asEnum({
    new: {
        label: 'New',
        value: 'new',
    },
    pending: {
        label: 'Pending',
        value: 'pending',
    },
    completed: {
        label: 'Completed',
        value: 'completed',
    },
    failed: {
        label: 'Failed',
        value: 'failed',
    },
});
const paymentTypes = asEnum({
    transaction: {
        label: 'Transaction',
        value: 'transaction',
    },
    settlement: {
        label: 'Settlement',
        value: 'settlement',
    },
});
const paymentCredentialsStatuses = asEnum({
    pendingActivation: {
        label: 'Pending Activation',
        value: 'pending_activation',
        labelIndicator: LabelIndicator.INFO,
    },
    active: {
        label: 'Active',
        value: 'active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    suspended: {
        label: 'Suspended',
        value: 'suspended',
        labelIndicator: LabelIndicator.WARNING,
    },
    blocked: {
        label: 'Blocked',
        value: 'blocked',
        labelIndicator: LabelIndicator.ERROR,
    },
});
var Payment3DS;
(function (Payment3DS) {
    Payment3DS["Nnon3d"] = "non3d";
    Payment3DS["Try3d"] = "try3d";
    Payment3DS["Always3d"] = "always3d";
    Payment3DS["AuthenticatedOnly"] = "authenticated_only";
})(Payment3DS || (Payment3DS = {}));

const tagTypes = asEnum({
    contract: {
        value: 'contract',
        label: 'Contract',
    },
    transaction: {
        value: 'transaction',
        label: 'Transaction',
    },
    document: {
        value: 'document',
        label: 'Document',
    },
    account: {
        value: 'account',
        label: 'Account',
    },
    individual: {
        value: 'individual',
        label: 'Individual',
    },
});

const reportTypes = asEnum({
    crs: {
        value: 'crs',
        label: 'CRS Report',
    },
    fatca: {
        value: 'fatca',
        label: 'FATCA Report',
    },
    depositGuaranteed: {
        value: 'depositGuaranteed',
        label: 'Deposit Guaranteed Reports',
    },
});

const directDebitMandateStatus = asEnum({
    new: { value: 'new', label: 'New', labelIndicator: LabelIndicator.WARNING },
    pending: { value: 'pending', label: 'Pending', labelIndicator: LabelIndicator.WARNING },
    approved: { value: 'approved', label: 'Approved', labelIndicator: LabelIndicator.SUCCESS },
    oneOfExecuted: { value: 'one_of_executed', label: 'One-of Mandate executed', labelIndicator: LabelIndicator.WARNING },
    rejected: { value: 'rejected_by_client', label: 'Rejected by client', labelIndicator: LabelIndicator.ERROR },
    rejectedByAgent: { value: 'rejected_by_agent', label: 'Rejected', labelIndicator: LabelIndicator.ERROR },
});
const directDebitDisputeStatus = asEnum({
    new: {
        value: 'new',
        label: 'New',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    pendingBackOffice: {
        value: 'pending_back_office',
        label: 'Pending Investigation',
        labelIndicator: LabelIndicator.WARNING,
    },
    rejectedByBackOffice: {
        value: 'rejected_by_back_office',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    sent: {
        value: 'sent',
        label: 'Completed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
});
const directDebitExecutionStatus = asEnum({
    new: {
        value: 'pending_signature',
        label: 'Pending Signature',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    signed: {
        value: 'signed',
        label: 'Signed',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    pending: {
        value: 'pending',
        label: 'Pending Execution',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingDispatch: {
        value: 'pending_dispatch',
        label: 'Pending Dispatch',
        labelIndicator: LabelIndicator.WARNING,
    },
    dispatched: {
        value: 'dispatched',
        label: 'Dispatched',
        labelIndicator: LabelIndicator.INFO,
    },
    executed: {
        value: 'executed',
        label: 'Executed',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    reverted: {
        value: 'reverted',
        label: 'Reverted',
        labelIndicator: LabelIndicator.WARNING,
    },
});

const priorities = asEnum({
    highest: {
        value: 'highest',
        label: 'Highest',
    },
    high: {
        value: 'high',
        label: 'High',
    },
    medium: {
        value: 'medium',
        label: 'Medium',
    },
    low: {
        value: 'low',
        label: 'Low',
    },
    lowest: {
        value: 'lowest',
        label: 'Lowest',
    },
});

const products = asEnum({
    cards: {
        label: 'Debit Cards',
        value: 'cards',
    },
    cryptocurrencyWallets: {
        label: 'Cryptocurrency wallets',
        value: 'cryptocurrency_wallets',
    },
    ibanRetailB2B: {
        label: 'IBAN - Retail - B2B',
        value: 'iban_retail_b2b',
    },
    ibanCorporateOnly: {
        label: 'IBAN - Corporate Only',
        value: 'iban_corporate_only',
    },
    ibanRetailB2C: {
        label: 'IBAN - Retail - B2C',
        value: 'iban_retail_b2c',
    },
    ibanB2B2CCorporateClientSettlements: {
        label: 'IBAN - B2B2C (Corporate Client Settlements)',
        value: 'iban_b2b2c_corporate_client_settlements',
    },
    ibanB2CRetailClientSettlements: {
        label: 'IBAN - B2C (Retail Client Settlements)',
        value: 'iban_b2c_retail_client_settlements',
    },
    virtualIbanCorporateOnly: {
        label: 'Virtual IBAN - Corporate Only',
        value: 'virtual_iban_corporate_only',
    },
    virtualIbanB2B: {
        label: 'Virtual IBAN - B2B',
        value: 'virtual_iban_b2b',
    },
    virtualIbanB2C: {
        label: 'Virtual IBAN - B2C',
        value: 'virtual_iban_b2c',
    },
    virtualIbanB2B2CCorporateClientSettlements: {
        label: 'Virtual IBAN - B2B2C (Corporate Client Settlements)',
        value: 'virtual_iban_b2b2c_corporate_client_settlements',
    },
    virtualIbanB2CRetailClientSettlements: {
        label: 'Virtual IBAN - B2C (Retail Client Settlements)',
        value: 'virtual_iban_b2c_retail_client_settlements',
    },
    virtualIbanCorporateExpensesOnly: {
        label: 'Virtual IBAN - Corporate Expenses Only',
        value: 'virtual_iban_corporate_expenses_only',
    },
});

const noticeTypes = asEnum({
    success: {
        value: 'success',
        label: 'Success',
    },
    info: {
        value: 'info',
        label: 'Info',
    },
    warning: {
        value: 'warning',
        label: 'Warning',
    },
    error: {
        value: 'error',
        label: 'Alert',
    },
});

const reminderNotificationTypes = asEnum({
    slack: {
        value: 'slack',
        label: 'Slack',
    },
    email: {
        value: 'email',
        label: 'Email',
    },
});
const reminderNotificationChannel = asEnum({
    personal: {
        value: 'personal',
        label: 'Personal',
    },
    channel: {
        value: 'channel',
        label: 'Channel',
    },
});
const reminderEntities = asEnum({
    contract: {
        value: 'contract',
        label: 'Contract',
    },
    transaction: {
        value: 'transaction',
        label: 'Transaction',
    },
    individual: {
        value: 'individual',
        label: 'Individual',
    },
    account: {
        value: 'account',
        label: 'Account',
    },
    document: {
        value: 'document',
        label: 'Document',
    },
});

const p2pTransactionPurposes = asLocalizedEnum('p2pTransactionPurposes', {
    businessProfitsToParents: {
        value: 'Business Profits to Parents',
        label: 'Business Profits to Parents',
    },
    businessTravel: {
        value: 'Business Travel',
        label: 'Business Travel',
    },
    familyMaintenance: {
        value: 'Family Maintenance',
        label: 'Family Maintenance',
    },
    salary: {
        value: 'Salary',
        label: 'Salary',
    },
    savings: {
        value: 'Savings',
        label: 'Savings',
    },
    medicalExpenses: {
        value: 'Medical Expenses',
        label: 'Medical Expenses',
    },
    tuitionFees: {
        value: 'Tuition Fees',
        label: 'Tuition Fees',
    },
    educationSupport: {
        value: 'Education Support',
        label: 'Education Support',
    },
    gift: {
        value: 'Gift',
        label: 'Gift',
    },
    homeImprovement: {
        value: 'Home Improvement',
        label: 'Home Improvement',
    },
    debtRepayment: {
        value: 'Debt Settlement',
        label: 'Debt Settlement',
    },
    realEstate: {
        value: 'Real Estate',
        label: 'Real Estate',
    },
    taxes: {
        value: 'Taxes',
        label: 'Taxes',
    },
});
const p2pSourceOfFunds = asLocalizedEnum('p2pSourceOfFunds', {
    salary: {
        value: 'Salary',
        label: 'Salary',
    },
    savings: {
        value: 'Savings',
        label: 'Savings',
    },
    lottery: {
        value: 'Lottery',
        label: 'Lottery',
    },
    loan: {
        value: 'Loan',
        label: 'Loan',
    },
    businessIncome: {
        value: 'Business Income',
        label: 'Business Income',
    },
    others: {
        value: 'Others',
        label: 'Others',
    },
});
const p2pRelationships = asLocalizedEnum('p2pRelationships', {
    father: {
        value: 'Father',
        label: 'Father',
    },
    mother: {
        value: 'Mother',
        label: 'Mother',
    },
    spouse: {
        value: 'Spouse',
        label: 'Spouse',
    },
    son: {
        value: 'Son',
        label: 'Son',
    },
    daughter: {
        value: 'Daughter',
        label: 'Daughter',
    },
    brother: {
        value: 'Brother',
        label: 'Brother',
    },
    sister: {
        value: 'Sister',
        label: 'Sister',
    },
    friend: {
        value: 'Friend',
        label: 'Friend',
    },
    employer: {
        value: 'Employer',
        label: 'Employer',
    },
    colleague: {
        value: 'Colleague',
        label: 'Colleague',
    },
    self: {
        value: 'Self',
        label: 'Self',
    },
    guardian: {
        value: 'Guardian',
        label: 'Guardian',
    },
    husband: {
        value: 'Husband',
        label: 'Husband',
    },
    wife: {
        value: 'Wife',
        label: 'Wife',
    },
    employee: {
        value: 'Employee',
        label: 'Employee',
    },
    inLaws: {
        value: 'In-Laws',
        label: 'In-Laws',
    },
    cousin: {
        value: 'Cousin',
        label: 'Cousin',
    },
    partners: {
        value: 'Partners',
        label: 'Partners',
    },
    aunt: {
        value: 'Aunt',
        label: 'Aunt',
    },
    uncle: {
        value: 'Uncle',
        label: 'Uncle',
    },
    bankNotes: {
        value: 'Bank Notes',
        label: 'Bank Notes',
    },
    ownAccount: {
        value: 'Own Account',
        label: 'Own Account',
    },
    sponsor: {
        value: 'Sponsor',
        label: 'Sponsor',
    },
    director: {
        value: 'Director',
        label: 'Director',
    },
    authorizedSignatory: {
        value: 'Authorized Signatory',
        label: 'Authorized Signatory',
    },
    corporateRepresentative: {
        value: 'Corporate Representative',
        label: 'Corporate Representative',
    },
    owner: {
        value: 'Owner',
        label: 'Owner',
    },
    brotherInLaw: {
        value: 'Brother-in-law',
        label: 'Brother-in-law',
    },
    business: {
        value: 'Business',
        label: 'Business',
    },
    child: {
        value: 'Child',
        label: 'Child',
    },
    corporate: {
        value: 'Corporate',
        label: 'Corporate',
    },
    daughterInLaw: {
        value: 'Daughter-in-law',
        label: 'Daughter-in-law',
    },
    family: {
        value: 'Family',
        label: 'Family',
    },
    fatherInLaw: {
        value: 'Father-in-law',
        label: 'Father-in-law',
    },
    friendFather: {
        value: "Friend's Father",
        label: "Friend's Father",
    },
    friendMother: {
        value: "Friend's Mother",
        label: "Friend's Mother",
    },
    grandDaughter: {
        value: 'Grand Daughter',
        label: 'Grand Daughter',
    },
    grandFather: {
        value: 'Grand Father',
        label: 'Grand Father',
    },
    grandMother: {
        value: 'Grand Mother',
        label: 'Grand Mother',
    },
    grandSon: {
        value: 'Grand Son',
        label: 'Grand Son',
    },
    motherInLaw: {
        value: 'Mother-in-law',
        label: 'Mother-in-law',
    },
    neighbour: {
        value: 'Neighbour',
        label: 'Neighbour',
    },
    nephew: {
        value: 'Nephew',
        label: 'Nephew',
    },
    niece: {
        value: 'Niece',
        label: 'Niece',
    },
    parent: {
        value: 'Parent',
        label: 'Parent',
    },
    relative: {
        value: 'Relative',
        label: 'Relative',
    },
    sisterInLaw: {
        value: 'Sister-in-law',
        label: 'Sister-in-law',
    },
    sonInLaw: {
        value: 'Son-in-law',
        label: 'Son-in-law',
    },
    stepChild: {
        value: 'Step Child',
        label: 'Step Child',
    },
});
const p2bTransactionPurposes = asLocalizedEnum('p2bTransactionPurposes', {
    advancedGoodsPayments: {
        value: 'Advanced Goods Payments',
        label: 'Advanced Goods Payments',
    },
    businessProfitsToParents: {
        value: 'Business profits to Parents',
        label: 'Business profits to Parents',
    },
    businessTravel: {
        value: 'Business Travel',
        label: 'Business Travel',
    },
    charitableDonation: {
        value: 'Charitable Donation',
        label: 'Charitable Donation',
    },
    conferenceOrTrainingFee: {
        value: 'Conference or Training Fee',
        label: 'Conference or Training Fee',
    },
    employeeCompensation: {
        value: 'Employee Compensation',
        label: 'Employee Compensation',
    },
    eventOrCompetitionParticipationExpenses: {
        value: 'Events or Competition Participation Expenses',
        label: 'Events or Competition Participation Expenses',
    },
    exportGoodsPayments: {
        value: 'Export Goods Payments',
        label: 'Export Goods Payments',
    },
    goodsAndServices: {
        value: 'Goods and Services',
        label: 'Goods and Services',
    },
    goodsExported: {
        value: 'Goods Exported',
        label: 'Goods Exported',
    },
    loanRepayment: {
        value: 'Loan Repayment',
        label: 'Loan Repayment',
    },
    otherBusiness: {
        value: 'Other Business',
        label: 'Other Business',
    },
    otherBusinessServices: {
        value: 'Other Business Services',
        label: 'Other Business Services',
    },
    rentPropertyExpenses: {
        value: 'Rent Property Expenses',
        label: 'Rent Property Expenses',
    },
    salaryPayment: {
        value: 'Salary Payment',
        label: 'Salary Payment',
    },
    softwareExport: {
        value: 'Software Export',
        label: 'Software Export',
    },
    travelCostAccomodationCost: {
        value: 'Travel Cost Accomodation Cost',
        label: 'Travel Cost Accomodation Cost',
    },
    travelExpenses: {
        value: 'Travel Expenses',
        label: 'Travel Expenses',
    },
});
const p2bSourceOfFunds = asLocalizedEnum('p2bSourceOfFunds', {
    salary: {
        value: 'Salary',
        label: 'Salary',
    },
    savings: {
        value: 'Savings',
        label: 'Savings',
    },
    lottery: {
        value: 'Lottery',
        label: 'Lottery',
    },
    loan: {
        value: 'Loan',
        label: 'Loan',
    },
    businessIncome: {
        value: 'Business Income',
        label: 'Business Income',
    },
    businessProfit: {
        value: 'Business Profit',
        label: 'Business Profit',
    },
    settlement: {
        value: 'Settlement',
        label: 'Settlement',
    },
    others: {
        value: 'Others',
        label: 'Others',
    },
});
const b2pTransactionPurposes = asLocalizedEnum('b2pTransactionPurposes', {
    advancedGoodsPayments: {
        value: 'Advanced Goods Payments',
        label: 'Advanced Goods Payments',
    },
    businessProfitsToParents: {
        value: 'Business profits to Parents',
        label: 'Business profits to Parents',
    },
    businessTravel: {
        value: 'Business Travel',
        label: 'Business Travel',
    },
    charitableDonation: {
        value: 'Charitable Donation',
        label: 'Charitable Donation',
    },
    conferenceOrTrainingFee: {
        value: 'Conference or Training Fee',
        label: 'Conference or Training Fee',
    },
    employeeCompensation: {
        value: 'Employee Compensation',
        label: 'Employee Compensation',
    },
    eventOrCompetitionParticipationExpenses: {
        value: 'Events or Competition Participation Expenses',
        label: 'Events or Competition Participation Expenses',
    },
    exportGoodsPayments: {
        value: 'Export Goods Payments',
        label: 'Export Goods Payments',
    },
    goodsAndServices: {
        value: 'Goods and Services',
        label: 'Goods and Services',
    },
    goodsExported: {
        value: 'Goods Exported',
        label: 'Goods Exported',
    },
    loanRepayment: {
        value: 'Loan Repayment',
        label: 'Loan Repayment',
    },
    otherBusiness: {
        value: 'Other Business',
        label: 'Other Business',
    },
    otherBusinessServices: {
        value: 'Other Business Services',
        label: 'Other Business Services',
    },
    rentPropertyExpenses: {
        value: 'Rent Property Expenses',
        label: 'Rent Property Expenses',
    },
    salaryPayment: {
        value: 'Salary Payment',
        label: 'Salary Payment',
    },
    softwareExport: {
        value: 'Software Export',
        label: 'Software Export',
    },
    travelCostAccomodationCost: {
        value: 'Travel Cost Accomodation Cost',
        label: 'Travel Cost Accomodation Cost',
    },
    travelExpenses: {
        value: 'Travel Expenses',
        label: 'Travel Expenses',
    },
});
const b2pSourceOfFunds = asLocalizedEnum('b2pSourceOfFunds', {
    salary: {
        value: 'Salary',
        label: 'Salary',
    },
    savings: {
        value: 'Savings',
        label: 'Savings',
    },
    lottery: {
        value: 'Lottery',
        label: 'Lottery',
    },
    loan: {
        value: 'Loan',
        label: 'Loan',
    },
    businessIncome: {
        value: 'Business Income',
        label: 'Business Income',
    },
    businessProfit: {
        value: 'Business Profit',
        label: 'Business Profit',
    },
    settlement: {
        value: 'Settlement',
        label: 'Settlement',
    },
    others: {
        value: 'Others',
        label: 'Others',
    },
});
const b2bTransactionPurposes = asLocalizedEnum('b2bTransactionPurposes', {
    advancedGoodsPayments: {
        value: 'Advanced Goods Payments',
        label: 'Advanced Goods Payments',
    },
    businessProfitsToParents: {
        value: 'Business profits to Parents',
        label: 'Business profits to Parents',
    },
    businessTravel: {
        value: 'Business Travel',
        label: 'Business Travel',
    },
    charitableDonation: {
        value: 'Charitable Donation',
        label: 'Charitable Donation',
    },
    conferenceOrTrainingFee: {
        value: 'Conference or Training Fee',
        label: 'Conference or Training Fee',
    },
    employeeCompensation: {
        value: 'Employee Compensation',
        label: 'Employee Compensation',
    },
    eventOrCompetitionParticipationExpenses: {
        value: 'Events or Competition Participation Expenses',
        label: 'Events or Competition Participation Expenses',
    },
    exportGoodsPayments: {
        value: 'Export Goods Payments',
        label: 'Export Goods Payments',
    },
    goodsAndServices: {
        value: 'Goods and Services',
        label: 'Goods and Services',
    },
    goodsExported: {
        value: 'Goods Exported',
        label: 'Goods Exported',
    },
    loanRepayment: {
        value: 'Loan Repayment',
        label: 'Loan Repayment',
    },
    otherBusiness: {
        value: 'Other Business',
        label: 'Other Business',
    },
    otherBusinessServices: {
        value: 'Other Business Services',
        label: 'Other Business Services',
    },
    rentPropertyExpenses: {
        value: 'Rent Property Expenses',
        label: 'Rent Property Expenses',
    },
    salaryPayment: {
        value: 'Salary Payment',
        label: 'Salary Payment',
    },
    softwareExport: {
        value: 'Software Export',
        label: 'Software Export',
    },
    travelCostAccomodationCost: {
        value: 'Travel Cost Accomodation Cost',
        label: 'Travel Cost Accomodation Cost',
    },
    travelExpenses: {
        value: 'Travel Expenses',
        label: 'Travel Expenses',
    },
});
const b2bSourceOfFunds = asLocalizedEnum('b2bSourceOfFunds', {
    salary: {
        value: 'Salary',
        label: 'Salary',
    },
    savings: {
        value: 'Savings',
        label: 'Savings',
    },
    lottery: {
        value: 'Lottery',
        label: 'Lottery',
    },
    loan: {
        value: 'Loan',
        label: 'Loan',
    },
    businessIncome: {
        value: 'Business Income',
        label: 'Business Income',
    },
    businessProfit: {
        value: 'Business Profit',
        label: 'Business Profit',
    },
    settlement: {
        value: 'Settlement',
        label: 'Settlement',
    },
    others: {
        value: 'Others',
        label: 'Others',
    },
});
const allTerraPaySourceOfFunds = {
    ...p2pSourceOfFunds,
    ...p2bSourceOfFunds,
    ...b2pSourceOfFunds,
    ...b2bSourceOfFunds,
};
const allTerraPayTransactionPurposes = {
    ...p2pTransactionPurposes,
    ...p2bTransactionPurposes,
    ...b2pTransactionPurposes,
    ...b2bTransactionPurposes,
};
const allTerraPayRelationships = {
    ...p2pRelationships,
};

const chains = asEnum({
    mainnet: { label: 'Mainnet', value: 'mainnet', nativeCurrency: 'ETH' },
    sepolia: { label: 'Sepolia', value: 'sepolia', nativeCurrency: 'ETH', isTestnet: true },
});
const coins = asEnum({
    ETH: {
        label: 'ETH',
        value: 'ETH',
        chains: {
            sepolia: {
                contract: 'native',
                coinspaidSymbol: 'ETH',
                b2c2Symbol: 'ETH',
                decimals: 18,
                name: 'Sepolia',
            },
            mainnet: {
                contract: 'native',
                coinspaidSymbol: 'ETH',
                b2c2Symbol: 'ETH',
                decimals: 18,
                name: 'Ethereum',
            },
        },
    },
    USDT: {
        label: 'USDT',
        value: 'USDT',
        chains: {
            sepolia: {
                contract: '0x7169d38820dfd117c3fa1f22a697dba58d90ba06',
                balanceSlot: '0x2',
                coinspaidSymbol: null,
                b2c2Symbol: 'UST',
                decimals: 6,
                name: 'Sepolia',
            },
            mainnet: {
                contract: '0xdAC17F958D2ee523a2206206994597C13D831ec7',
                balanceSlot: '0x2',
                b2c2Symbol: 'UST',
                coinspaidSymbol: null,
                decimals: 6,
                name: 'Ethereum',
            },
        },
    },
    USDC: {
        label: 'USDC',
        value: 'USDC',
        chains: {
            sepolia: {
                contract: '0x1c7d4b196cb0c7b01d743fbc6116a902379c7238',
                balanceSlot: '0x9',
                coinspaidSymbol: 'USDC',
                b2c2Symbol: 'USC',
                decimals: 6,
                name: 'Sepolia',
            },
            mainnet: {
                contract: '0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48',
                balanceSlot: '0x9',
                coinspaidSymbol: 'USDC',
                b2c2Symbol: 'USC',
                decimals: 6,
                name: 'Ethereum',
            },
        },
    },
});

const apiUserStatuses = asEnum({
    active: {
        value: 'active',
        label: 'Active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    deactivated: {
        value: 'deactivated',
        label: 'Deactivated',
        labelIndicator: LabelIndicator.ERROR,
    },
});

const claimsRecallRequestsTypes = asEnum({
    recallRequest: {
        value: 'recall_request',
        label: 'Recall Request',
    },
    claimNonReceipt: {
        value: 'claim_non_receipt',
        label: 'Claim Non Receipt',
    },
});
const claimsRecallRequestsStatuses = asEnum({
    pendingResponse: {
        value: 'pending_response',
        label: 'Pending Response',
        labelIndicator: LabelIndicator.INFO,
    },
    pendingProcessing: {
        value: 'pending_processing',
        label: 'Pending Processing',
        labelIndicator: LabelIndicator.WARNING,
    },
    responseFailed: {
        value: 'response_failed',
        label: 'Response Failed',
        labelIndicator: LabelIndicator.ERROR,
    },
    accepted: {
        value: 'accepted',
        label: 'Accepted',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    rejected: {
        value: 'rejected',
        label: 'Rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    cancelled: {
        value: 'cancelled',
        label: 'Cancelled',
        labelIndicator: LabelIndicator.DEFAULT,
    },
});

const supportedNetworks = asEnum({
    mainnet: {
        value: 'mainnet',
        label: 'Ethereum mainnet',
        network: 'mainnet',
        test: false,
        chainId: 1,
    },
    sepolia: {
        value: 'sepolia',
        label: 'Sepolia',
        network: 'sepolia',
        test: true,
        chainId: 11155111,
    },
});
const walletStatuses = asEnum({
    pendingConfirmation: {
        label: 'Pending Private Key',
        value: 'pending_confirmation',
        labelIndicator: LabelIndicator.INFO,
    },
    verified: {
        label: 'Connected & Verified',
        value: 'verified',
        labelIndicator: LabelIndicator.INFO,
    },
    pendingSignatures: {
        label: 'Pending Signatures',
        value: 'pending_signatures',
        labelIndicator: LabelIndicator.INFO,
    },
    pendingApproval: {
        label: 'Pending Approval',
        value: 'pending_approval',
        labelIndicator: LabelIndicator.INFO,
    },
    active: {
        label: 'Active',
        value: 'active',
        labelIndicator: LabelIndicator.SUCCESS,
    },
    disconnected: {
        label: 'Disconnected',
        value: 'disconnected',
        labelIndicator: LabelIndicator.DEFAULT,
    },
    rejected: {
        label: 'Rejected',
        value: 'rejected',
        labelIndicator: LabelIndicator.ERROR,
    },
    suspended: {
        label: 'Suspended',
        value: 'suspended',
        labelIndicator: LabelIndicator.WARNING,
    },
    pendingReConfirmation: {
        label: 'Pending Re-Activation',
        value: 'pending_re_confirmation',
        labelIndicator: LabelIndicator.INFO,
    },
});
const walletActions = asEnum({
    verify: {
        value: 'VERIFY',
        currentState: 'pending_confirmation',
    },
    create: {
        value: 'CREATE',
        currentState: 'verified',
    },
    sign: {
        value: 'SIGN',
        currentState: 'pending_signtures',
    },
    approve: {
        value: 'APPROVE',
        currentState: 'pending_approval',
    },
    disconnect: {
        value: 'DISCONNECT',
    },
    connect: {
        value: 'CONNECT',
        currentState: 'disconnected',
    },
    reject: {
        value: 'REJECT',
    },
    activate: {
        value: 'ACTIVATE',
        currentState: 'rejected',
    },
    revert: {
        value: 'REVERT',
        currentState: 'active',
    },
    suspend: {
        value: 'SUSPEND',
    },
    reactivate: {
        value: 'REACTIVATE',
    },
});
const walletCheckStatuses = asEnum({
    low: {
        value: 'Low',
        label: 'Low',
        canTransact: true,
        askForDocuments: false,
        labelIndicator: LabelIndicator.SUCCESS,
    },
    medium: {
        value: 'Medium',
        label: 'Medium',
        canTransact: true,
        askForDocuments: false,
        labelIndicator: LabelIndicator.WARNING,
    },
    high: {
        value: 'High',
        label: 'High',
        canTransact: true,
        askForDocuments: true,
        labelIndicator: LabelIndicator.WARNING,
    },
    severe: {
        value: 'Severe',
        label: 'Severe',
        canTransact: false,
        askForDocuments: false,
        labelIndicator: LabelIndicator.ERROR,
    },
});
const allowedCryptoPayments = asEnum({
    all: {
        value: 'all',
        label: 'All',
    },
    onRamp: {
        value: 'on_ramp',
        label: 'On-Ramp',
    },
    offRamp: {
        value: 'off_ramp',
        label: 'Off-Ramp',
    },
    none: {
        value: 'none',
        label: 'None',
    },
});

const surveyQuestionTypes = asEnum({
    input: {
        value: 'input',
        label: 'Input',
    },
    radio: {
        value: 'radio',
        label: 'Radio',
    },
    checkBox: {
        value: 'check_box',
        label: 'Check Box',
    },
    select: {
        value: 'select',
        label: 'Select',
    },
});

const screenId = asEnum({
    home: {
        label: 'Home',
        value: 'home',
    },
    twoFa: {
        label: '2fa',
        value: '2fa',
    },
    phoneVerification: {
        label: 'PhoneVerification',
        value: 'phoneVerification',
    },
    pendingActions: {
        label: 'PendingActions',
        value: 'pendingActions',
    },
});

export { ChargeBearer, LabelIndicator, OrderDirections, Payment3DS, PaymentScenario, RejectReturnReason, SettlementMethod, TrackerEvent, TransactionStatus, TransactionStatusReason, UBOStakeTypes, accountClosureReasons, accountNoTypes, accountQRBillTypes, accountStatementTypes, accountStatuses, accountTypes, actionRejectionReasons, actionStatuses, actionTypes, activityLogGraphqlTypes, activityLogObjectTypes, activityLogOrigins, activityLogTypes, agentTypes, allTerraPayRelationships, allTerraPaySourceOfFunds, allTerraPayTransactionPurposes, allowedCryptoPayments, anticipatedAccountActivities, apiErrors, apiUserStatuses, appointmentStatuses, approvalRequestEntities, approvalRequestStatuses, approvalRequestTypes, authorizedPersonStatuses, b2bSourceOfFunds, b2bTransactionPurposes, b2pSourceOfFunds, b2pTransactionPurposes, backgroundJobs, batchPaymentStatuses, businessCategoriesTypes, businessCategoryQuestions, businessRegion, businessTypeRiskCategories, cardProductTypes, cardStatuses, chains, checkResultStatuses, checkTypes, claimsRecallRequestsStatuses, claimsRecallRequestsTypes, clientCategories, clientGBGTypes, clientNoticeAcknowledgementTypes, clientNoticeTypes, clientPotentialLevels, clientTypes, closedContractStatusReasons, coins, communicationStatuses, companies, companyTypes, contractClosureReasons, contractContactTypes, contractInformationRequestStatuses, contractInformationRequestTypes, contractOwnershipTransferStatuses, contractRiskCategories, contractRiskProfiles, contractStatuses, contractTermStatuses, contractTypes, conversionStatuses, countries, countrySupportedCurrencies, currencies, dashboardDocumentTypes, directDebitDisputeStatus, directDebitExecutionStatus, directDebitMandateStatus, directorRoles, directorSigningRights, documentOrigins, documentRejectionReasons, documentRelatedEntityTypes, documentStatuses, documentTranslationTypes, documentTypes, documentUserFilters, dssComplianceTypes, economicProfileAccountBalance, economicProfileAverageSizeTypes, economicProfileEmploymentStatus, economicProfileInboundSourceTypes, economicProfileOutboundDestinationTypes, economicProfileProducts, economicProfileSourceFundsTypes, economicProfileTransactionSourceDestinationTypes, emailCategoriesTypes, emailEnquiryTypes, errors, feeCategoryTypes, feeDefaults, feeGroupStatuses, feeGroupUnits, feeSubcategoryTypes, feeTypes, fees, fileBasedPainChannels, fileBasedPainStatuses, flowDirection, fundTypes, fundingCategories, fxTradeStatuses, gdcNationalIDHints, genders, generalDocumentTypes, gpiTransactionStatus, graphqlSubscriptionMessages, helpOptions, inactivityFeeTypes, individualContractOnboardingRequiredChecks, individualContractRoles, individualVerificationMedium, industries, integrationTypeRequiredTypes, internalDocumentTypes, internationalCurrencies, issueCardRequestStatuses, jobActions, jobStatuses, jobTypes, keyWith, kycMeasures, kycRejectionReasons, kycStatuses, languages, languagesWithVariation, ledgerTransactionStatuses, ledgerTransactionTypes, ledgerTypes, limitedAccessRights, locales, minimumTurnOverFeeTypes, monitoringAlertPriorities, monitoringAlertScenarios, monitoringAlertStatuses, nationalities, newAccountCurrencies, noticeTypes, orderDirections, p2bSourceOfFunds, p2bTransactionPurposes, p2pRelationships, p2pSourceOfFunds, p2pTransactionPurposes, passwordErrors, paymentCredentialsStatuses, paymentMethods, paymentRails, paymentStatuses, paymentTypes, payoutSchedules, phoneTypes, phoneVerificationTypes, preAssessmentStatuses, priorities, processDocumentResults, processProfileChangeResults, products, profileChangeStatuses, proofOfFundsDocumentTypes, proofOfIdentityDocumentTypes, proofOfResidencyDocumentTypes, regions, relevantCredentialOnFilesBillingSalesMethodTypes, reminderEntities, reminderNotificationChannel, reminderNotificationTypes, reportTypes, riskCalculatorFinancialStatements, riskCalculatorProducts, riskCategories, riskClassificationStatuses, riskSubCategories, salvStatuses, sanctionedIndustries, screenId, securityTokenTypes, signableNotices, signatoryRights, signatureStatuses, smsCategoriesTypes, spendingLimitIntervals, spendingLimitStatuses, spendingLimitTypes, successFeePayoutStatuses, successFeeStatuses, supportedNetworks, surveyQuestionTypes, suspendedContractStatusReasons, swiftMessageAcknowledgementStatuses, swiftMessageDirection, swiftMessageFileLogStatuses, swiftMessageStatuses, swiftTransferChargeBearers, swiftTransferRecipientTypes, tagTypes, themePreferenceOptions, transactionCancellationReasons, transactionCardFilters, transactionCumulativeReviewStatuses, transactionEntryTypes, transactionExecutionTypes, transactionPriorities, transactionRecallStatuses, transactionRequestStatuses, transactionReturnReasons, transactionServiceDeskSources, transactionStatuses, transactionTypes, twoFAMethods, uboLegalEntityTypes, uboStakeTypes, uboTypes, underMonitoringReasons, unset, userApprovalRequestStatuses, userDepartments, vibanNameMismatchResolutions, videoVerificationStatuses, viewerTypes, walletActions, walletCheckStatuses, walletStatuses, whitelabels, yesNo };
